(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6106],{

/***/ 41154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A9": function() { return /* binding */ safeUrl; },
/* harmony export */   "Qs": function() { return /* binding */ parseTourLink; },
/* harmony export */   "nA": function() { return /* binding */ checkIsFavourite; }
/* harmony export */ });
/* unused harmony export capitalizeFirstLetter */
var parseTourLink = function(link, slug) {
    var linkSlug = link.replace(/(.+\/)|(\?.+)/g, "");
    if (slug && linkSlug !== slug) return false;
    var res = new URLSearchParams(link.replace(/(.+\?)/, "?"));
    return {
        s: res.get("s"),
        x: Number(res.get("x")),
        y: Number(res.get("y"))
    };
};
var checkIsFavourite = function() {
    var products = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], product = arguments.length > 1 ? arguments[1] : void 0, mode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (mode === 0) {
        return products === null || products === void 0 ? void 0 : products.find(function(id) {
            return id === (product === null || product === void 0 ? void 0 : product.id);
        });
    }
    return products === null || products === void 0 ? void 0 : products.find(function(id) {
        return id === (product === null || product === void 0 ? void 0 : product.eCommerceProductId);
    });
};
var capitalizeFirstLetter = function(str) {
    if (!str) return null;
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var safeUrl = function(url) {
    if (!url.includes("http")) return "http://".concat(url);
    return url;
};


/***/ }),

/***/ 66725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ dLog; }
/* harmony export */ });


var colors = "#556b2f,#a0522d,#483d8b,#008000,#008b8b,#9acd32,#00008b,#7f007f,#8fbc8f,#b03060,#ff4500,#ff8c00,#ffd700,#7cfc00,#8a2be2,#00ff7f,#dc143c,#00ffff,#00bfff,#f4a460,#0000ff,#b0c4de,#ff00ff,#1e90ff,#90ee90,#ff1493,#ee82ee,#ffe4b5,#ffb6c1".split(",");
var components = {};
var cr = function() {
    return Math.random() * (255 - 1) + 1;
};
var showRenderStats = function() {
    var componentsMap = Object.keys(components).map(function(key) {
        return _object_spread_props(_object_spread({}, components[key]), {
            name: key
        });
    }).sort(function(comp1, comp2) {
        return comp1.i > comp2 ? 1 : comp1 === comp2 ? 0 : -1;
    });
    componentsMap.forEach(function(comp) {
        console.log("%c render_d ".concat(comp.name, " ").concat(comp.i), "color:white;background:".concat(comp.color, ";"));
    });
};
var stopLogs = true;
if (false) {}
var dLog = function(componentName) {
    if (false) {}
};


/***/ }),

/***/ 98144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ storage; }
/* harmony export */ });
var storage = function(key) {
    var get = function() {
        var serializedValue = localStorage.getItem(key);
        if (serializedValue !== null) {
            return JSON.parse(serializedValue);
        }
        return null;
    };
    var set = function(value) {
        var serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
    };
    return {
        get: get,
        set: set
    };
};



/***/ }),

/***/ 59524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IW": function() { return /* binding */ PolygonActionAction; },
/* harmony export */   "fD": function() { return /* binding */ PolygonAction; },
/* harmony export */   "l3": function() { return /* binding */ PolygonActionMode; },
/* harmony export */   "mg": function() { return /* binding */ Polygon; },
/* harmony export */   "zS": function() { return /* binding */ PolygonActionType; }
/* harmony export */ });
/* unused harmony export PolygonActionRes */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);

var PolygonActionType;
(function(PolygonActionType) {
    PolygonActionType["None"] = "none";
    PolygonActionType["Text"] = "text";
    PolygonActionType["Image"] = "image";
    PolygonActionType["Music"] = "music";
    PolygonActionType["Video"] = "video";
    PolygonActionType["Iframe"] = "iframe";
    PolygonActionType["Tab"] = "tab";
    PolygonActionType["Panorama"] = "panorama";
    PolygonActionType["Menu"] = "menu";
    PolygonActionType["Treedis"] = "treedis";
    PolygonActionType["Matterport"] = "matterport";
    PolygonActionType["MatterportInstant"] = "matterport-instant";
})(PolygonActionType || (PolygonActionType = {}));
var PolygonActionAction;
(function(PolygonActionAction) {
    PolygonActionAction["Click"] = "click";
    PolygonActionAction["Hover"] = "hover";
})(PolygonActionAction || (PolygonActionAction = {}));
var PolygonActionRes;
(function(PolygonActionRes) {
    PolygonActionRes["Percentage"] = "percentage";
    PolygonActionRes["Pixels"] = "pixels";
})(PolygonActionRes || (PolygonActionRes = {}));
var PolygonActionMode;
(function(PolygonActionMode) {
    PolygonActionMode["Ecommerce"] = "ecommerce";
    PolygonActionMode["Game"] = "game";
    PolygonActionMode["VS"] = "vs";
})(PolygonActionMode || (PolygonActionMode = {}));
var PolygonAction = function PolygonAction() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, PolygonAction);
    this.id = model.id;
    this.polygonId = model.polygonId || "";
    this.mode = model.mode || PolygonActionMode.VS;
    this.type = model.type || PolygonActionType.None;
    this.action = model.action || PolygonActionAction.Click;
    this.url = model.url || "";
    this.text = model.text || "";
    this.resolution = model.resolution || PolygonActionRes.Percentage;
    this.width = model.width || 80;
    this.height = model.height || 80;
    this.resolutionMobile = model.resolutionMobile || PolygonActionRes.Percentage;
    this.widthMobile = model.widthMobile || 80;
    this.heightMobile = model.heightMobile || 80;
    this.panoramaId = model.panoramaId || null;
    this.menuId = model.menuId || null;
    this.subMenuId = model.subMenuId || null;
    this.subSubMenuId = model.subSubMenuId || null;
    this.gameBackpack = model.gameBackpack || false;
    this.fullscreen = model.fullscreen || false;
    this.autoPlay = model.autoPlay || false;
};
var Polygon = function Polygon() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Polygon);
    var ref;
    this.id = model.id;
    this.title = model.title || "";
    this.tourId = model.tourId;
    this.scaleX = model.scaleX || 1;
    this.scaleY = model.scaleY || 1;
    this.scaleZ = model.scaleZ || 1;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.active = typeof model.active === "boolean" ? model.active : true;
    this.uuid = model.uuid || null;
    this.colorDefault = model.colorDefault || "#ea475c";
    this.colorHover = model.colorHover || "#FFFFFF";
    this.colorClick = model.colorClick || "#ea475c";
    this.opacityDefault = model.opacityDefault >= 0 ? model.opacityDefault : 0.2;
    this.opacityHover = model.opacityHover >= 0 ? model.opacityHover : 0.4;
    this.opacityClick = model.opacityClick >= 0 ? model.opacityClick : 0.5;
    this.edgesOpacityDefault = model.edgesOpacityDefault >= 0 ? model.edgesOpacityDefault : 0.5;
    this.edgesOpacityHover = model.edgesOpacityHover >= 0 ? model.edgesOpacityHover : 0.7;
    this.edgesOpacityClick = model.edgesOpacityClick >= 0 ? model.edgesOpacityClick : 0.8;
    this.sweep_uuid = model.sweep_uuid || null;
    this.sweepUuid = model.sweep_uuid || null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.products = ((ref = model.products) === null || ref === void 0 ? void 0 : ref.length) > 0 ? model.products.map(function(item) {
        return item.id;
    }) : [];
    this.polygonsActions = model.polygonsActions || [];
};


/***/ }),

/***/ 98472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ad": function() { return /* binding */ SceneComponent; }
/* harmony export */ });
/* unused harmony exports ComponentInteractionType, PointerButton, PointerButtonMask, PointerDevice, KeyState, Keys */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);



/**
 * The base of all `SceneComponent` created with the sdk.
 * All properties of this class are always available to all components generated through the sdk.
 * These properties should all be considered reserved and should not be overwritten by the subclass.
 */ var SceneComponentPrivate = function SceneComponentPrivate() {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SceneComponentPrivate);
};
var SceneComponent = /*#__PURE__*/ function(SceneComponentPrivate) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(SceneComponent, SceneComponentPrivate);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(SceneComponent);
    function SceneComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SceneComponent);
        return _super.apply(this, arguments);
    }
    return SceneComponent;
}(SceneComponentPrivate);
var ComponentInteractionType;
(function(ComponentInteractionType) {
    ComponentInteractionType[/** CLICK events */ "CLICK"] = "INTERACTION.CLICK";
    ComponentInteractionType[/** HOVER events */ "HOVER"] = "INTERACTION.HOVER";
    ComponentInteractionType[/** DRAG events (mousedown then move) */ "DRAG"] = "INTERACTION.DRAG";
    ComponentInteractionType["DRAG_BEGIN"] = "INTERACTION.DRAG_BEGIN";
    ComponentInteractionType["DRAG_END"] = "INTERACTION.DRAG_END";
    ComponentInteractionType["POINTER_MOVE"] = "INTERACTION.POINTER_MOVE";
    ComponentInteractionType["POINTER_BUTTON"] = "INTERACTION.POINTER_BUTTON";
    ComponentInteractionType["SCROLL"] = "INTERACTION.SCROLL";
    ComponentInteractionType["KEY"] = "INTERACTION.KEY";
    ComponentInteractionType["LONG_PRESS_START"] = "INTERACTION.LONG_PRESS_START";
    ComponentInteractionType["LONG_PRESS_END"] = "INTERACTION.LONG_PRESS_END";
    ComponentInteractionType["MULTI_SWIPE"] = "INTERACTION.MULTI_SWIPE";
    ComponentInteractionType["MULTI_SWIPE_END"] = "INTERACTION.MULTI_SWIPE_END";
    ComponentInteractionType["PINCH"] = "INTERACTION.PINCH";
    ComponentInteractionType["PINCH_END"] = "INTERACTION.PINCH_END";
    ComponentInteractionType["ROTATE"] = "INTERACTION.ROTATE";
    ComponentInteractionType["ROTATE_END"] = "INTERACTION.ROTATE_END";
})(ComponentInteractionType || (ComponentInteractionType = {}));
var ComponentOutputReserved = function ComponentOutputReserved() {
    "use strict";
    _class_call_check(this, ComponentOutputReserved);
};
var ComponentOut = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(ComponentOutputReserved) {
    "use strict";
    _inherits(ComponentOut, ComponentOutputReserved);
    var _super = _create_super(ComponentOut);
    function ComponentOut() {
        _class_call_check(this, ComponentOut);
        return _super.apply(this, arguments);
    }
    return ComponentOut;
}(ComponentOutputReserved)));
var PointerButton;
(function(PointerButton) {
    PointerButton[PointerButton["PRIMARY"] = 0] = "PRIMARY";
    PointerButton[PointerButton["MIDDLE"] = 1] = "MIDDLE";
    PointerButton[PointerButton["SECONDARY"] = 2] = "SECONDARY";
    PointerButton[PointerButton["BACK"] = 3] = "BACK";
    PointerButton[PointerButton["FORWARD"] = 4] = "FORWARD";
    PointerButton[PointerButton["COUNT"] = 5] = "COUNT";
})(PointerButton || (PointerButton = {}));
var PointerButtonMask;
(function(PointerButtonMask) {
    PointerButtonMask[PointerButtonMask["NONE"] = 0] = "NONE";
    PointerButtonMask[PointerButtonMask["PRIMARY"] = 1 << PointerButton.PRIMARY] = "PRIMARY";
    PointerButtonMask[PointerButtonMask["SECONDARY"] = 1 << PointerButton.SECONDARY] = "SECONDARY";
    PointerButtonMask[PointerButtonMask["MIDDLE"] = 1 << PointerButton.MIDDLE] = "MIDDLE";
    PointerButtonMask[PointerButtonMask["BACK"] = 1 << PointerButton.BACK] = "BACK";
    PointerButtonMask[PointerButtonMask["FORWARD"] = 1 << PointerButton.FORWARD] = "FORWARD";
    PointerButtonMask[PointerButtonMask["ALL"] = (1 << PointerButton.COUNT) - 1] = "ALL";
})(PointerButtonMask || (PointerButtonMask = {}));
var PointerDevice;
(function(PointerDevice) {
    PointerDevice["MOUSE"] = "mouse";
    PointerDevice["TOUCH"] = "touch";
    PointerDevice["PEN"] = "pen";
    PointerDevice["GAMEPAD"] = "gamepad";
})(PointerDevice || (PointerDevice = {}));
var KeyState;
(function(KeyState) {
    KeyState[KeyState["DOWN"] = 0] = "DOWN";
    KeyState[KeyState["PRESSED"] = 1] = "PRESSED";
    KeyState[KeyState["UP"] = 2] = "UP";
})(KeyState || (KeyState = {}));
var Keys;
(function(Keys) {
    Keys[Keys["ESCAPE"] = 27] = "ESCAPE";
    Keys[Keys["ZERO"] = 48] = "ZERO";
    Keys[Keys["ONE"] = 49] = "ONE";
    Keys[Keys["TWO"] = 50] = "TWO";
    Keys[Keys["THREE"] = 51] = "THREE";
    Keys[Keys["FOUR"] = 52] = "FOUR";
    Keys[Keys["FIVE"] = 53] = "FIVE";
    Keys[Keys["SIX"] = 54] = "SIX";
    Keys[Keys["SEVEN"] = 55] = "SEVEN";
    Keys[Keys["EIGHT"] = 56] = "EIGHT";
    Keys[Keys["NINE"] = 57] = "NINE";
    Keys[Keys["LEFTARROW"] = 37] = "LEFTARROW";
    Keys[Keys["UPARROW"] = 38] = "UPARROW";
    Keys[Keys["RIGHTARROW"] = 39] = "RIGHTARROW";
    Keys[Keys["DOWNARROW"] = 40] = "DOWNARROW";
    Keys[Keys["TAB"] = 9] = "TAB";
    Keys[Keys["A"] = 65] = "A";
    Keys[Keys["B"] = 66] = "B";
    Keys[Keys["C"] = 67] = "C";
    Keys[Keys["D"] = 68] = "D";
    Keys[Keys["E"] = 69] = "E";
    Keys[Keys["F"] = 70] = "F";
    Keys[Keys["G"] = 71] = "G";
    Keys[Keys["H"] = 72] = "H";
    Keys[Keys["I"] = 73] = "I";
    Keys[Keys["J"] = 74] = "J";
    Keys[Keys["K"] = 75] = "K";
    Keys[Keys["L"] = 76] = "L";
    Keys[Keys["M"] = 77] = "M";
    Keys[Keys["N"] = 78] = "N";
    Keys[Keys["O"] = 79] = "O";
    Keys[Keys["P"] = 80] = "P";
    Keys[Keys["Q"] = 81] = "Q";
    Keys[Keys["R"] = 82] = "R";
    Keys[Keys["S"] = 83] = "S";
    Keys[Keys["T"] = 84] = "T";
    Keys[Keys["U"] = 85] = "U";
    Keys[Keys["V"] = 86] = "V";
    Keys[Keys["W"] = 87] = "W";
    Keys[Keys["X"] = 88] = "X";
    Keys[Keys["Y"] = 89] = "Y";
    Keys[Keys["Z"] = 90] = "Z";
    Keys[Keys["SPACE"] = 32] = "SPACE";
    Keys[Keys["RETURN"] = 13] = "RETURN";
    Keys[Keys["DELETE"] = 46] = "DELETE";
    Keys[Keys["BACKSPACE"] = 8] = "BACKSPACE";
    Keys[Keys["SEMICOLON"] = 186] = "SEMICOLON";
    Keys[Keys["PLUSEQUALS"] = 187] = "PLUSEQUALS";
    Keys[Keys["DASHUNDERSCORE"] = 189] = "DASHUNDERSCORE";
    Keys[Keys["OPENBRACKET"] = 219] = "OPENBRACKET";
    Keys[Keys["SHIFT"] = 16] = "SHIFT";
    Keys[Keys["ALT"] = 18] = "ALT";
    Keys[Keys["CONTROL"] = 17] = "CONTROL";
})(Keys || (Keys = {}));


/***/ }),

/***/ 15864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GF": function() { return /* binding */ TourVSImageRotation; },
/* harmony export */   "Gu": function() { return /* binding */ LoadingState; },
/* harmony export */   "IG": function() { return /* binding */ VSInteractionType; },
/* harmony export */   "OV": function() { return /* binding */ VSVideoType; },
/* harmony export */   "Up": function() { return /* binding */ TourVideo; },
/* harmony export */   "Z5": function() { return /* binding */ TourImageAction; },
/* harmony export */   "aS": function() { return /* binding */ TourImageActionRes; },
/* harmony export */   "oP": function() { return /* binding */ TourImage; },
/* harmony export */   "q8": function() { return /* binding */ TourVSHtml; },
/* harmony export */   "rx": function() { return /* binding */ TourImageActionType; },
/* harmony export */   "zB": function() { return /* binding */ TourObject; }
/* harmony export */ });
/* unused harmony exports VSObject, VSImage, VSHtml, VSVideo */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _components_util_all__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40488);

// eslint-disable-next-line max-classes-per-file

var TourImageActionType;
(function(TourImageActionType) {
    TourImageActionType["None"] = "none";
    TourImageActionType["Text"] = "text";
    TourImageActionType["Image"] = "image";
    TourImageActionType["Music"] = "music";
    TourImageActionType["Video"] = "video";
    TourImageActionType["Iframe"] = "iframe";
    TourImageActionType["Tab"] = "tab";
    TourImageActionType["Panorama"] = "panorama";
    TourImageActionType["Menu"] = "menu";
    TourImageActionType["Treedis"] = "treedis";
    TourImageActionType["ExperiencePopUp"] = "experiencePopUp";
})(TourImageActionType || (TourImageActionType = {}));
var TourVSImageRotation;
(function(TourVSImageRotation) {
    TourVSImageRotation["Vertical"] = "vertical";
    TourVSImageRotation["Horizontal"] = "horizontal";
})(TourVSImageRotation || (TourVSImageRotation = {}));
var TourImageAction;
(function(TourImageAction) {
    TourImageAction["Click"] = "click";
    TourImageAction["Hover"] = "hover";
})(TourImageAction || (TourImageAction = {}));
var LoadingState;
(function(LoadingState) {
    LoadingState["Idle"] = "Idle";
    LoadingState["Loaded"] = "Loaded";
    LoadingState["Loading"] = "Loading";
    LoadingState["Error"] = "Error";
})(LoadingState || (LoadingState = {}));
var TourImageActionRes;
(function(TourImageActionRes) {
    TourImageActionRes["Percentage"] = "percentage";
    TourImageActionRes["Pixels"] = "pixels";
})(TourImageActionRes || (TourImageActionRes = {}));
var VSInteractionType;
(function(VSInteractionType) {
    VSInteractionType[/** CLICK events */ "CLICK"] = "INTERACTION.CLICK";
    VSInteractionType[/** HOVER events */ "HOVER"] = "INTERACTION.HOVER";
    VSInteractionType[/** DRAG events (mousedown then move) */ "DRAG"] = "INTERACTION.DRAG";
    VSInteractionType["DRAG_BEGIN"] = "INTERACTION.DRAG_BEGIN";
    VSInteractionType["DRAG_END"] = "INTERACTION.DRAG_END";
    VSInteractionType["POINTER_MOVE"] = "INTERACTION.POINTER_MOVE";
    VSInteractionType["POINTER_BUTTON"] = "INTERACTION.POINTER_BUTTON";
    VSInteractionType["SCROLL"] = "INTERACTION.SCROLL";
    VSInteractionType["KEY"] = "INTERACTION.KEY";
    VSInteractionType["LONG_PRESS_START"] = "INTERACTION.LONG_PRESS_START";
    VSInteractionType["LONG_PRESS_END"] = "INTERACTION.LONG_PRESS_END";
    VSInteractionType["MULTI_SWIPE"] = "INTERACTION.MULTI_SWIPE";
    VSInteractionType["MULTI_SWIPE_END"] = "INTERACTION.MULTI_SWIPE_END";
    VSInteractionType["PINCH"] = "INTERACTION.PINCH";
    VSInteractionType["PINCH_END"] = "INTERACTION.PINCH_END";
    VSInteractionType["ROTATE"] = "INTERACTION.ROTATE";
    VSInteractionType["ROTATE_END"] = "INTERACTION.ROTATE_END";
})(VSInteractionType || (VSInteractionType = {}));
var VSObject = function VSObject() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _class_call_check(this, VSObject);
    this.id = model.id || null;
    this.title = model.title || null;
    this.url = model.url || null;
    this.materialUrl = model.materialUrl || null;
    this.fileName = model.fileName || null;
    this.scaleX = model.scaleX || 0.01;
    this.scaleY = model.scaleY || 0.01;
    this.scaleZ = model.scaleZ || 0.01;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.tourId = model.tourId || null;
    this.image = model.image || null;
    this.category = model.category || null;
    this.copyright = model.copyright || null;
    this.isDefault = model.isDefault || false;
    this.updatedAt = model.updatedAt || null;
    this.isGLTF = model.isGLTF || false;
};
var TourObject = function TourObject() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourObject);
    this.id = model.id || null;
    this.vsObjectId = model.vsObjectId || null;
    this.uuid = model.uuid || null;
    this.scaleX = model.scaleX || 0.01;
    this.scaleY = model.scaleY || 0.01;
    this.scaleZ = model.scaleZ || 0.01;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.details = Object.assign(model.vsObject || {});
    this.updatedAt = model.updatedAt || null;
    this.active = typeof model.active === "boolean" ? model.active : true;
    this.enableHoverAnimation = typeof model.enableHoverAnimation === "boolean" ? model.enableHoverAnimation : false;
    this.hideOnAnimationFinished = typeof model.hideOnAnimationFinished === "boolean" ? model.hideOnAnimationFinished : false;
    this.floor = typeof model.floor === "number" ? model.floor : null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.sweepUuid = model.sweep_uuid || null;
    this.animated = model.animated;
    this.loop = model.loop || false;
    this.toursVSImages = model.toursVSImages;
    var _renderRange;
    this.renderRange = (_renderRange = model.renderRange) !== null && _renderRange !== void 0 ? _renderRange : null;
    var _startAnimationDistance;
    this.startAnimationDistance = (_startAnimationDistance = model.startAnimationDistance) !== null && _startAnimationDistance !== void 0 ? _startAnimationDistance : null;
};
var VSImage = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function VSImage() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, VSImage);
        this.id = model.id || null;
        this.title = model.title || null;
        this.url = model.url || null;
        this.scaleX = model.scaleX || 0.1;
        this.scaleY = model.scaleY || 0.1;
        this.scaleZ = 0;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.tourId = model.tourId || null;
        this.image = model.image || null;
        this.updatedAt = model.updatedAt || null;
        this.isDefault = false;
        this.isVSImage = true;
    }
    var _proto = VSImage.prototype;
    _proto.getURL = function getURL() {
        var url = "".concat("https://cdn.treedis.com").concat(this.url).concat(getVersion(new Date()));
        if (this.url.includes("http")) {
            url = this.url;
        }
        return url;
    };
    return VSImage;
}()));
var TourImage = /*#__PURE__*/ function() {
    "use strict";
    function TourImage() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourImage);
        this.id = model.id || null;
        this.vsImageId = model.vsImageId || null;
        this.toursVSObjectId = model.toursVSObjectId || null;
        this.uuid = model.uuid || null;
        this.width = model.width;
        this.height = model.height;
        this.scaleX = model.scaleX || 0.1;
        this.scaleY = model.scaleY || 0.1;
        this.scaleZ = 0;
        this.positionX = model.positionX || 0;
        this.positionY = model.positionY || 0;
        this.positionZ = model.positionZ || 0;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.details = Object.assign(model.vsImage || {});
        this.updatedAt = model.updatedAt || null;
        this.isVSImage = true;
        this.active = typeof model.active === "boolean" ? model.active : true;
        this.enableAnimation = typeof model.enableAnimation === "boolean" ? model.enableAnimation : false;
        this.enableHoverAnimation = typeof model.enableHoverAnimation === "boolean" ? model.enableHoverAnimation : false;
        this.animationPulse = typeof model.animationPulse === "boolean" ? model.animationPulse : false;
        this.animationUpDown = typeof model.animationUpDown === "boolean" ? model.animationUpDown : false;
        this.animationFlip = typeof model.animationFlip === "boolean" ? model.animationFlip : false;
        this.effectOpacity = typeof model.effectOpacity === "boolean" ? model.effectOpacity : false;
        this.effectStopAnimation = typeof model.effectStopAnimation === "boolean" ? model.effectStopAnimation : false;
        this.effectHide = typeof model.effectHide === "boolean" ? model.effectHide : false;
        var _renderRange;
        this.renderRange = (_renderRange = model.renderRange) !== null && _renderRange !== void 0 ? _renderRange : null;
        var _startAnimationDistance;
        this.startAnimationDistance = (_startAnimationDistance = model.startAnimationDistance) !== null && _startAnimationDistance !== void 0 ? _startAnimationDistance : null;
        // actions
        this.actionType = model.actionType || TourImageActionType.None;
        this.action = model.action || TourImageAction.Click;
        this.actionURL = model.actionURL || null;
        this.text = model.text || null;
        this.popupTitle = model.popupTitle || null;
        this.actionRes = model.actionRes || TourImageActionRes.Percentage;
        this.actionWidth = model.actionWidth || 80;
        this.actionHeight = model.actionHeight || 60;
        this.actionResMobile = model.actionResMobile || TourImageActionRes.Percentage;
        this.actionWidthMobile = model.actionWidthMobile || 82;
        this.actionHeightMobile = model.actionHeightMobile || 47;
        this.panoramaId = model.panoramaId || null;
        this.menuId = model.menuId || null;
        this.subMenuId = model.subMenuId || null;
        this.subSubMenuId = model.subSubMenuId || null;
        this.floor = typeof model.floor === "number" ? model.floor : null;
        this.sweepUuid = model.sweep_uuid || null;
        this.srX = model.srX || 0;
        this.srY = model.srY || 0;
        this.srZ = model.srZ || 0;
        this.rotation = model.rotation || TourVSImageRotation.Vertical;
        this.backgroundColor = model.backgroundColor || "#000000";
        this.backgroundOpacity = model.backgroundOpacity || 0.7;
        this.textColor = model.textColor || "#ffffff";
        this.buttonColor = model.buttonColor || "#ffffff";
    }
    var _proto = TourImage.prototype;
    _proto.getURL = function getURL() {
        var url = "".concat("https://cdn.treedis.com").concat(this.details.url).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        // if (this.isVSImage && this.actionType === TourImageActionType.ExperiencePopUp) {
        //   return '/play_experience.svg';
        // }
        if (this.details.url.includes("http")) {
            url = this.details.url;
        }
        return url;
    };
    return TourImage;
}();
var VSHtml = function VSHtml() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _class_call_check(this, VSHtml);
    this.id = model.id || null;
    this.title = model.title || null;
    this.url = model.url || null;
    this.scaleX = model.scaleX || 0.1;
    this.scaleY = model.scaleY || 0.1;
    this.scaleZ = model.scaleZ || 0.1;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.tourId = model.tourId || null;
    this.image = model.image || null;
    this.updatedAt = model.updatedAt || null;
    this.isVSHtml = true;
};
var TourVSHtml = function TourVSHtml() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourVSHtml);
    this.id = model.id || null;
    this.vsHtmlId = model.vsHtmlId || null;
    this.uuid = model.uuid || null;
    this.scaleX = model.scaleX || 0.1;
    this.scaleY = model.scaleY || 0.1;
    this.scaleZ = model.scaleZ || 0.1;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.details = Object.assign(model.vsHtml || {});
    this.updatedAt = model.updatedAt || null;
    this.isVSHtml = true;
    this.active = true;
    this.floor = typeof model.floor === "number" ? model.floor : null;
    this.sweepUuid = model.sweep_uuid || null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.node = model.node;
};
var VSVideoType;
(function(VSVideoType) {
    VSVideoType["Local"] = "local";
    VSVideoType["Vimeo"] = "vimeo";
})(VSVideoType || (VSVideoType = {}));
var VSVideo = /*#__PURE__*/ function() {
    "use strict";
    function VSVideo() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, VSVideo);
        this.id = model.id || null;
        this.title = model.title || "";
        this.url = model.url || "";
        this.type = model.type || VSVideoType.Local;
        this.width = model.width || 2;
        this.height = model.height || 2;
        this.scaleX = model.scaleX || 1;
        this.scaleY = model.scaleY || 1;
        this.scaleZ = model.scaleZ || 1;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.tourId = model.tourId || null;
        this.image = model.image || null;
        this.greenScreenEnabled = typeof model.greenScreenEnabled === "boolean" ? model.greenScreenEnabled : false;
        this.greenScreenColor = model.greenScreenColor;
        this.updatedAt = model.updatedAt || null;
        this.isDefault = false;
        this.isVSImage = false;
        this.isVSVideo = true;
    }
    var _proto = VSVideo.prototype;
    _proto.getVideoURL = function getVideoURL() {
        if (!this.url) return "";
        var url = "".concat("https://cdn.treedis.com").concat(this.url).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.url.includes("http")) {
            url = this.url;
        }
        return url;
    };
    _proto.getURL = function getURL() {
        if (!this.image) return "";
        var image = "".concat("https://cdn.treedis.com").concat(this.image).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.image.includes("http")) {
            image = this.image;
        }
        return image;
    };
    return VSVideo;
}();
var TourVideo = /*#__PURE__*/ function() {
    "use strict";
    function TourVideo() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourVideo);
        this.id = model.id || null;
        this.vsVideoId = model.vsVideoId || null;
        this.uuid = model.uuid || null;
        this.tourId = model.tourId || null;
        this.scaleX = model.scaleX || 1;
        this.scaleY = model.scaleY || 1;
        this.scaleZ = model.scaleZ || 1;
        this.positionX = model.positionX || 0;
        this.positionY = model.positionY || 0;
        this.positionZ = model.positionZ || 0;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.details = Object.assign(model.vsVideo || model.details || new VSVideo());
        this.updatedAt = model.updatedAt || null;
        this.isVSImage = false;
        this.isVSVideo = true;
        this.enableHoverAnimation = typeof model.enableHoverAnimation === "boolean" ? model.enableHoverAnimation : false;
        this.animationPulse = typeof model.animationPulse === "boolean" ? model.animationPulse : false;
        this.animationUpDown = typeof model.animationUpDown === "boolean" ? model.animationUpDown : false;
        this.animationFlip = typeof model.animationFlip === "boolean" ? model.animationFlip : false;
        this.effectOpacity = typeof model.effectOpacity === "boolean" ? model.effectOpacity : false;
        this.effectStopAnimation = typeof model.effectStopAnimation === "boolean" ? model.effectStopAnimation : false;
        this.effectHide = typeof model.effectHide === "boolean" ? model.effectHide : false;
        this.active = typeof model.active === "boolean" ? model.active : true;
        this.sweep_uuid = model.sweep_uuid || null;
        this.sweepUuid = model.sweep_uuid || null;
        this.srX = model.srX || 0;
        this.srY = model.srY || 0;
        this.srZ = model.srZ || 0;
        this.floor = typeof model.floor === "number" ? model.floor : null;
        this.autoplay = typeof model.autoplay === "boolean" ? model.autoplay : true;
        this.loop = typeof model.loop === "boolean" ? model.loop : true;
        var _renderRange;
        this.renderRange = (_renderRange = model.renderRange) !== null && _renderRange !== void 0 ? _renderRange : null;
        var _startAnimationDistance;
        this.startAnimationDistance = (_startAnimationDistance = model.startAnimationDistance) !== null && _startAnimationDistance !== void 0 ? _startAnimationDistance : null;
    }
    var _proto = TourVideo.prototype;
    _proto.getVideoURL = function getVideoURL() {
        if (!this.details || !this.details.url) return "";
        var url = "".concat("https://cdn.treedis.com").concat(this.details.url).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.details.url.includes("http")) {
            url = this.details.url;
        }
        return url;
    };
    _proto.getURL = function getURL() {
        if (!this.details || !this.details.image) return "";
        var image = "".concat("https://cdn.treedis.com").concat(this.details.image).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.details.image.includes("http")) {
            image = this.details.image;
        }
        return image;
    };
    return TourVideo;
}();


/***/ }),

/***/ 20594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ VSSettings; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);

var VSSettings = function VSSettings() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, VSSettings);
    this.id = model.id;
    this.tourId = model.tourId;
    this.ambientLight = model.ambientLight * 1.3 || 9.5;
    this.pointLight = model.pointLight * 1.3 || 33 * 3;
    this.lightHeight = model.lightHeight * 5 || 75 * 0.5;
    this.shadowIntensity = model.shadowIntensity >= 0 ? model.shadowIntensity : 0.2;
    this.lightAngle = model.lightAngle || 0;
    this.updatedAt = model.updatedAt;
};


/***/ }),

/***/ 97387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WV": function() { return /* binding */ AVATAR_ROTATION_SPEED; },
/* harmony export */   "iG": function() { return /* binding */ AVATAR_CIRCLE_RADIUS; },
/* harmony export */   "lZ": function() { return /* binding */ AVATAR_ANIMATION_BLENDING; },
/* harmony export */   "pK": function() { return /* binding */ DEFAULT_AVATARS; },
/* harmony export */   "qE": function() { return /* binding */ Avatar; },
/* harmony export */   "rQ": function() { return /* binding */ AVATAR_WALKING_SPEED; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14293);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_0__);


var DEFAULT_AVATARS = [
    "https://static.treedis.com/avatars/62cd861b48960be56eae26b8.glb",
    "https://static.treedis.com/avatars/62f3ae0a3e172e00542676ec.glb",
    "https://static.treedis.com/avatars/635fcfdb41d7a22057ef1495.glb",
    "https://static.treedis.com/avatars/63626a6efff3a4d4797dae05.glb",
    "https://static.treedis.com/avatars/63626a94fff3a4d4797dae46.glb",
    "https://static.treedis.com/avatars/63626accfff3a4d4797daeb5.glb",
    "https://static.treedis.com/avatars/63626adffff3a4d4797daee4.glb",
    "https://static.treedis.com/avatars/63626b6e52b953b7b71fce6a.glb",
    "https://static.treedis.com/avatars/63626bb152b953b7b71fcef0.glb",
    "https://static.treedis.com/avatars/63626bd552b953b7b71fcf39.glb",
    "https://static.treedis.com/avatars/63626c8a52b953b7b71fd044.glb",
    "https://static.treedis.com/avatars/636269effff3a4d4797dad1f.glb",
    "https://static.treedis.com/avatars/6317163a666e9239d9c635cf.glb",
    "https://static.treedis.com/avatars/63171619666e9239d9c63168.glb", 
];
var AVATAR_CIRCLE_RADIUS = 0.65;
var AVATAR_WALKING_SPEED = 1.5; // Avatar speed in m/s
var AVATAR_ROTATION_SPEED = 0.5; // Avatar rotation speed
var AVATAR_ANIMATION_BLENDING = 0.2; // How smooth avatar animations transition between each other
var Avatar = function Avatar() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Avatar);
    this.name = model.name || "";
    this.bodyType = model.bodyType;
    this.url = model.url;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.quaternionX = model.quaternionX || 0;
    this.quaternionY = model.quaternionY || 0;
    this.quaternionZ = model.quaternionZ || 0;
    this.quaternionW = model.quaternionW || 0;
    this.uuid = model.uuid || null;
    this.color = model.color || "0xEA475C";
    this.muted = lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default()(model.muted) || model.muted;
    this.visible = typeof model.visible === "boolean" ? model.visible : true;
    this.degree = model.degree || null;
};


/***/ }),

/***/ 71425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ AvatarPredictor; },
/* harmony export */   "v": function() { return /* binding */ AUPredictorQuality; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _quarkworks_inc_avatar_webkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9995);




var AUPredictorQuality;
(function(AUPredictorQuality) {
    AUPredictorQuality["Low"] = "low";
    AUPredictorQuality["High"] = "high";
})(AUPredictorQuality || (AUPredictorQuality = {}));
var AvatarPredictor = /*#__PURE__*/ function() {
    "use strict";
    function AvatarPredictor(config) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, AvatarPredictor);
        this.predictor = new _quarkworks_inc_avatar_webkit__WEBPACK_IMPORTED_MODULE_1__/* .AUPredictor */ .SM({
            apiToken: "fbd204a7-318e-4dd3-86e0-e6d524fc3f98",
            shouldMirrorOutput: false,
            fps: 30,
            predictionQuality: config.predictionQuality || AUPredictorQuality.Low
        });
    }
    var _proto = AvatarPredictor.prototype;
    _proto.start = function start(stream, cb) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, hasVideoTrack;
            return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        hasVideoTrack = stream === null || stream === void 0 ? void 0 : (ref = stream.getTracks) === null || ref === void 0 ? void 0 : ref.call(stream).some(function(track) {
                            return track.kind === "video";
                        });
                        if (hasVideoTrack) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("Video track not found.");
                    case 4:
                        _ctx.next = 6;
                        return _this.predictor.start({
                            stream: stream
                        });
                    case 6:
                        _this.predictor.dataStream.subscribe(cb);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.stop = function stop() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.predictor.stop();
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return AvatarPredictor;
}();


/***/ }),

/***/ 8267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lZ": function() { return /* reexport */ Avatar/* AVATAR_ANIMATION_BLENDING */.lZ; },
  "iG": function() { return /* reexport */ Avatar/* AVATAR_CIRCLE_RADIUS */.iG; },
  "WV": function() { return /* reexport */ Avatar/* AVATAR_ROTATION_SPEED */.WV; },
  "rQ": function() { return /* reexport */ Avatar/* AVATAR_WALKING_SPEED */.rQ; },
  "qE": function() { return /* reexport */ Avatar/* Avatar */.qE; },
  "KP": function() { return /* reexport */ AvatarPredictor/* AvatarPredictor */.K; },
  "bB": function() { return /* reexport */ avatarComponentType; },
  "Sr": function() { return /* reexport */ makeAvatarComponent; }
});

// UNUSED EXPORTS: AvatarComponent, DEFAULT_AVATARS

// EXTERNAL MODULE: ./_models/virtualStaging/avatar/AvatarPredictor.ts
var AvatarPredictor = __webpack_require__(71425);
// EXTERNAL MODULE: ./_models/virtualStaging/avatar/Avatar.tsx
var Avatar = __webpack_require__(97387);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@quarkworks-inc/avatar-webkit/dist/index.modern.js
var index_modern = __webpack_require__(9995);
// EXTERNAL MODULE: ./_models/virtualStaging/VSObject.tsx
var VSObject = __webpack_require__(15864);
;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/utils/emojiKeyMap.ts
var emojiKeyMap = {
    mouthOpen: "mouthOpen",
    mouthSmile: "mouthSmile",
    eyesClosed: "eyesClosed",
    eyesLookUp: "eyesLookUp",
    eyesLookDown: "eyesLookDown",
    eyeBlinkLeft: "eyeBlink_L",
    eyeBlinkRight: "eyeBlink_R",
    eyeSquintLeft: "eyeSquint_L",
    eyeSquintRight: "eyeSquint_R",
    eyeWideLeft: "eyeWide_L",
    eyeWideRight: "eyeWide_R",
    jawForward: "jawForward",
    jawLeft: "jawLeft",
    jawRight: "jawRight",
    jawOpen: "jawOpen",
    mouthClose: "mouthClose",
    mouthFunnel: "mouthFunnel",
    mouthPucker: "mouthPucker",
    mouthLeft: "mouthLeft",
    mouthRight: "mouthRight",
    // mouthSmileLeft: 'mouthSmileLeft',
    mouthSmileLeft: "mouthSmile_L",
    mouthSmileRight: "mouthSmile_R",
    mouthFrownLeft: "mouthFrown_L",
    mouthFrownRight: "mouthFrown_R",
    mouthDimpleLeft: "mouthDimple_L",
    mouthDimpleRight: "mouthDimple_R",
    mouthStretchLeft: "mouthStretch_L",
    mouthStretchRight: "mouthStretch_R",
    mouthRollLower: "mouthRollLower",
    mouthRollUpper: "mouthRollUpper",
    mouthShrugLower: "mouthShrugLower",
    mouthShrugHigher: "mouthShrugHigher",
    mouthPressLeft: "mouthPress_L",
    mouthPressRight: "mouthPress_R",
    mouthLowerDownLeft: "mouthLowerDown_L",
    mouthLowerDownRight: "mouthLowerDown_R",
    mouthUpperUpLeft: "mouthUpperUp_L",
    mouthUpperUpRight: "mouthUpperUp_R",
    browDownLeft: "browDown_L",
    browDownRight: "browDown_R",
    browInnerUp: "browInnerUp",
    browOuterUpLeft: "browOuterUp_L",
    browOuterUpRight: "browOuterUp_R",
    cheekPuff: "cheekPuff",
    cheekSquintLeft: "cheekSquint_L",
    cheekSquintRight: "cheekSquint_R",
    noseSneerLeft: "noseSneer_L",
    noseSneerRight: "noseSneer_R",
    tongueOut: "tongueOut",
    mouthShrugUpper: "mouthShrugUpper",
    eyeLookInLeft: "eyeLookIn_L",
    eyeLookInRight: "eyeLookIn_R",
    eyeLookOutLeft: "eyeLookOut_L",
    eyeLookOutRight: "eyeLookOut_R",
    eyeLookUpLeft: "eyeLookUp_L",
    eyeLookUpRight: "eyeLookUp_R",
    eyeLookDownLeft: "eyeLookDown_L",
    eyeLookDownRight: "eyeLookDown_R"
}; // mouthOpen: 0
 // mouthSmile: 1

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/utils/helper.ts
var findObject3DChildByName = function(object, name) {
    return object.children.find(function(child) {
        return child.name === name;
    });
};
var setMorphTarget = function(mesh, key, value) {
    if (!mesh) return;
    var idx = mesh.morphTargetDictionary[key];
    if (!idx) return;
    mesh.morphTargetInfluences[idx] = value;
};

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/utils/index.ts



// EXTERNAL MODULE: ./_models/virtualStaging/Scene.component.tsx
var Scene_component = __webpack_require__(98472);
;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/AbstractAvatar.ts







var AbstractAvatar = /*#__PURE__*/ function(SceneComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AbstractAvatar, SceneComponent);
    var _super = (0,_create_super/* default */.Z)(AbstractAvatar);
    function AbstractAvatar() {
        (0,_class_call_check/* default */.Z)(this, AbstractAvatar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.id = null;
        _this.root = null;
        _this.pivot = null;
        _this.label = null;
        _this.labelSize = [
            0,
            0
        ];
        _this.model = null;
        _this.inputs = {
            color: 0xff0033,
            label: "User",
            bodyType: null,
            url: null,
            uuid: null,
            visible: true,
            sweep: null
        };
        _this.outputs = {
            loadingState: VSObject/* LoadingState.Idle */.Gu.Idle
        };
        _this.getPosition = function() {
            return _this.model.position;
        };
        _this.loadAsync = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(THREE, url) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(url.includes(".gltf") || url.includes(".glb"))) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                                var loader = new THREE.GLTFLoader();
                                loader.load(url, function(gltf) {
                                    return resolve(gltf);
                                }, function() {
                                    return null;
                                }, function(err) {
                                    return reject(err);
                                });
                            }));
                        case 2:
                            if (!url.includes(".fbx")) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                                var loader = new THREE.FBXLoader();
                                loader.load(url, function(model) {
                                    return resolve(model);
                                }, function() {
                                    return null;
                                }, function(err) {
                                    return reject(err);
                                });
                            }));
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(THREE, url) {
                return _ref.apply(this, arguments);
            };
        }();
        return _this;
    }
    var _proto = AbstractAvatar.prototype;
    _proto.initRoot = function initRoot() {
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.pivot = new THREE.Object3D();
        this.root.add(this.pivot);
        this.outputs.objectRoot = this.root;
    };
    _proto.initLabel = function initLabel() {
        this.label = this.makeLabel(this.inputs.label, {
            fontsize: 48,
            borderColor: {
                r: 255,
                g: 255,
                b: 255,
                a: 0.7
            },
            backgroundColor: {
                r: 255,
                g: 255,
                b: 255,
                a: 0.8
            },
            borderThickness: 8
        });
        if (this.inputs.bodyType === "fullbody") {
            this.label.rotateX(Math.PI / 2);
            this.label.position.setY(-0.05);
            this.label.position.setZ(2.3);
            this.pivot.add(this.label);
        } else {
            this.label.position.setY(0.83);
            this.pivot.add(this.label);
        }
        if (this.root && this.root.parent) {
            this.root.parent.visible = this.inputs.visible;
        }
    };
    _proto.getLabelSize = function getLabelSize() {
        return this.labelSize;
    };
    _proto.makeLabel = function makeLabel(message, parameters) {
        var THREE = this.context.three;
        if (parameters === undefined) parameters = {};
        var fontface = parameters.hasOwnProperty("fontface") ? parameters.fontface : "Arial";
        var fontsize = parameters.hasOwnProperty("fontsize") ? parameters.fontsize : 18;
        var borderThickness = parameters.hasOwnProperty("borderThickness") ? parameters.borderThickness : 4;
        var borderColor = parameters.hasOwnProperty("borderColor") ? parameters.borderColor : {
            r: 0,
            g: 0,
            b: 0,
            a: 1.0
        };
        var backgroundColor = parameters.hasOwnProperty("backgroundColor") ? parameters.backgroundColor : {
            r: 255,
            g: 255,
            b: 255,
            a: 1.0
        };
        var textColor = parameters.hasOwnProperty("textColor") ? parameters.textColor : {
            r: 0,
            g: 0,
            b: 0,
            a: 1.0
        };
        var canvas = document.createElement("canvas");
        var context = canvas.getContext("2d");
        context.font = "Bold ".concat(fontsize, "px ").concat(fontface);
        var metrics = context.measureText(message);
        var textWidth = metrics.width;
        context.fillStyle = "rgba(".concat(backgroundColor.r, ",").concat(backgroundColor.g, ",").concat(backgroundColor.b, ",").concat(backgroundColor.a, ")");
        context.strokeStyle = "rgba(".concat(borderColor.r, ",").concat(borderColor.g, ",").concat(borderColor.b, ",").concat(borderColor.a, ")");
        context.lineWidth = borderThickness;
        var rectW = (textWidth + borderThickness) * 1.1;
        var rectH = fontsize * 1.4 + borderThickness;
        this.roundRect(context, borderThickness / 2, borderThickness / 2, rectW, rectH, 8);
        context.fillStyle = "rgba(".concat(textColor.r, ", ").concat(textColor.g, ", ").concat(textColor.b, ", 1.0)");
        context.fillText(message, borderThickness, fontsize + borderThickness);
        // crop exactly the rectangle size
        var label = this.crop(canvas, 0, 0, rectW + borderThickness, rectH + borderThickness);
        var texture = new THREE.Texture(label);
        texture.needsUpdate = true;
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.encoding = THREE.sRGBEncoding;
        texture.repeat.set(1, 1);
        var planeWidth = label.width / 1000; // scaling down
        var planeHeight = label.height / 1000;
        // need for dynamic mute button positioning
        this.labelSize = [
            planeWidth,
            planeHeight
        ];
        var plane = this.makePlane(planeWidth, planeHeight, texture);
        plane.scale.set(1, 1, 1);
        return plane;
    };
    // function for drawing rounded rectangles
    // eslint-disable-next-line class-methods-use-this
    _proto.roundRect = function roundRect(ctx, x, y, w, h, r) {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.lineTo(x + w - r, y);
        ctx.quadraticCurveTo(x + w, y, x + w, y + r);
        ctx.lineTo(x + w, y + h - r);
        ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
        ctx.lineTo(x + r, y + h);
        ctx.quadraticCurveTo(x, y + h, x, y + h - r);
        ctx.lineTo(x, y + r);
        ctx.quadraticCurveTo(x, y, x + r, y);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
    };
    _proto.makePlane = function makePlane(width, height, texture) {
        var THREE = this.context.three;
        var geometry = new THREE.PlaneGeometry(width, height, 10, 10);
        var material = new THREE.MeshBasicMaterial({
            map: texture,
            side: THREE.DoubleSide,
            blending: THREE.NormalBlending,
            transparent: true
        });
        return new THREE.Mesh(geometry, material);
    };
    // eslint-disable-next-line class-methods-use-this
    _proto.crop = function crop(can, x, y, w, h) {
        // get your canvas and a context for it
        var ctx = can.getContext("2d");
        // get the image data you want to keep.
        var imageData = ctx.getImageData(x, y, w * 2, h);
        // create a new cavnas same as clipped size and a context
        var newCan = document.createElement("canvas");
        newCan.width = w - x;
        newCan.height = h - y;
        var newCtx = newCan.getContext("2d");
        // put the clipped image on the new canvas.
        newCtx.putImageData(imageData, 0, 0);
        return newCan;
    };
    _proto.loadAnimation = function loadAnimation(THREE, url) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", _this.loadAsync(THREE, url));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.loadModel = function loadModel(THREE, url) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var modelData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.loadAsync(THREE, url);
                    case 2:
                        modelData = _ctx.sent;
                        modelData.scene.position.set(0, 0, 0);
                        return _ctx.abrupt("return", modelData.scene);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return AbstractAvatar;
}(Scene_component/* SceneComponent */.Ad);
/* harmony default export */ var component_AbstractAvatar = (AbstractAvatar);

// EXTERNAL MODULE: ./node_modules/three/examples/jsm/libs/tween.module.min.js
var tween_module_min = __webpack_require__(27970);
;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/Avatar.component.tsx






/* eslint-disable no-prototype-builtins */ 





var AvatarComponent = /*#__PURE__*/ function(AbstractAvatar) {
    "use strict";
    (0,_inherits/* default */.Z)(AvatarComponent, AbstractAvatar);
    var _super = (0,_create_super/* default */.Z)(AvatarComponent);
    function AvatarComponent() {
        (0,_class_call_check/* default */.Z)(this, AvatarComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.animationActions = [];
        _this.activeAnimation = null;
        // instantly teleport avatar to position on first avatar_move event
        _this.avatarHasMoved = false;
        _this.setMorphTarget = function(mesh, key, value) {
            if (!mesh) return;
            var idx = mesh.morphTargetDictionary[key];
            if (!idx) return;
            mesh.morphTargetInfluences[idx] = value;
        };
        return _this;
    }
    var _proto = AvatarComponent.prototype;
    _proto.onInit = function onInit() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, THREE, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        console.log("init", _this.outputs.loadingState, _this.inputs);
                        if ((ref = _this.inputs.url) === null || ref === void 0 ? void 0 : ref.length) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        _this.outputs.loadingState = VSObject/* LoadingState.Loading */.Gu.Loading;
                        THREE = _this.context.three;
                        _this.initRoot();
                        _this.root.visible = false;
                        _ctx.next = 10;
                        return _this.loadModel(THREE, _this.inputs.url);
                    case 10:
                        _this.model = _ctx.sent;
                        ;
                        ref1 = (0,_sliced_to_array/* default */.Z)(_this.model.children, 1), _this.avatarRoot = ref1[0], ref1;
                        _this.faceNode = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Head");
                        _this.teethNode = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Teeth");
                        _this.wolf3DAvatar = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Avatar");
                        _this.mixer = new THREE.AnimationMixer(_this.wolf3DAvatar);
                        if (!(_this.inputs.bodyType === "fullbody")) {
                            _ctx.next = 23;
                            break;
                        }
                        _ctx.next = 20;
                        return _this.initAnimations();
                    case 20:
                        _this.root.parent.position.y = 0;
                        _this.pivot.rotation.set(-Math.PI / 2, 0, 0);
                        _this.model.scale.set(1.1, 1.1, 1.1);
                    case 23:
                        _this.model.traverse(function(object) {
                            object.frustumCulled = false;
                        });
                        _this.pivot.add(_this.model);
                        _this.initLabel();
                        _this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.initAnimations = function initAnimations() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var THREE, idleAnimation, walkingAnimation, idleAnimationAction, walkingAnimationAction;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        THREE = _this.context.three;
                        _ctx.next = 3;
                        return _this.loadAnimation(THREE, "../../Idle.fbx");
                    case 3:
                        idleAnimation = _ctx.sent;
                        idleAnimation.animations[0].name = "idle";
                        _ctx.next = 7;
                        return _this.loadAnimation(THREE, "../../Walking.fbx");
                    case 7:
                        walkingAnimation = _ctx.sent;
                        walkingAnimation.animations[0].name = "walking";
                        idleAnimationAction = _this.mixer.clipAction(idleAnimation.animations[0]);
                        walkingAnimationAction = _this.mixer.clipAction(walkingAnimation.animations[0]);
                        _this.animationActions.push(idleAnimationAction);
                        _this.animationActions.push(walkingAnimationAction);
                        console.log("Avatar: ".concat(_this.inputs.label, "\n Animations loaded, initializing 'idle' state..."), _this.animationActions, _this);
                        _this.fadeInAnimation("idle");
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.fadeInAnimation = function fadeInAnimation(clipName) {
        var animation = this.animationActions.find(function(action) {
            return action.getClip().name === clipName;
        });
        if (animation) {
            if (animation === this.activeAnimation) {
                return;
            }
            if (this.activeAnimation) this.activeAnimation.fadeOut(Avatar/* AVATAR_ANIMATION_BLENDING */.lZ);
            console.log("Avatar: ".concat(this.inputs.label, "\n Animation ").concat(animation._clip.name, " start, last active animation is ").concat(this.activeAnimation ? this.activeAnimation._clip.name : "null"), animation);
            animation.reset().fadeIn(Avatar/* AVATAR_ANIMATION_BLENDING */.lZ).play();
            this.activeAnimation = animation;
        }
    };
    _proto.moveToPos = function moveToPos(target, qt, onStart, onComplete) {
        var distance = this.root.parent.position.distanceTo(target);
        if (this.avatarHasMoved) {
            var _this = this;
            var tween = new tween_module_min/* TWEEN.Tween */.w.Tween(this.root.parent.position).to({
                x: target.x,
                y: 0,
                z: target.z
            }, distance / (Avatar/* AVATAR_WALKING_SPEED */.rQ / 1000)).onStart(function() {
                _this.fadeInAnimation("walking");
                if (onStart) onStart(tween);
            }).onComplete(function() {
                _this.fadeInAnimation("idle");
                if (onComplete) onComplete(tween);
            }).onUpdate(function() {
                _this.root.quaternion.set(qt.x, qt.y, qt.z, qt.w);
            }).start();
        } else {
            this.root.parent.position.set(target.x, 0, target.z);
            this.root.visible = true;
            this.avatarHasMoved = true;
        }
    };
    _proto.rotateTo = function rotateTo(target, onStart, onComplete) {
        var _this = this;
        var alpha = {
            current: 0
        };
        var tween = new tween_module_min/* TWEEN.Tween */.w.Tween(alpha).to({
            current: 1
        }, 1000 * Avatar/* AVATAR_ROTATION_SPEED */.WV).onStart(function() {
            if (onStart) onStart(tween);
        }).onUpdate(function() {
            _this.root.quaternion.slerpQuaternions(_this.root.quaternion, target, alpha.current);
        }).onComplete(function() {
            if (onComplete) onComplete(tween);
        }).start();
    };
    _proto.onDestroy = function onDestroy() {
        if (this.label) {
            this.label.geometry.dispose();
            this.label.material.dispose();
        }
    };
    _proto.onTick = function onTick(tickDelta) {
        if (this.mixer) {
            this.mixer.update(tickDelta / 1000);
        }
    // super.onTick(tickDelta);
    };
    // called back when any inputs properties change
    _proto.onInputsUpdated = function onInputsUpdated() {
        if (this.outputs.loadingState !== VSObject/* LoadingState.Loading */.Gu.Loading) this.onInit();
    };
    _proto.updateFromResults = function updateFromResults(prediction) {
        if (!this.model) return;
        // this.updateMorphTargets(prediction.blendShapes);
        this.updateHeadRotation(-prediction.rotation.pitch, -prediction.rotation.yaw, -prediction.rotation.roll);
        this.updatePosition(prediction.transform.x, prediction.transform.y, prediction.transform.z);
    };
    // @ts-ignore morph targets are not currently used
    _proto.updateMorphTargets = function updateMorphTargets(blendShapes) {
        for(var key in blendShapes){
            // RPM uses the ARKit key convention ("mouthSmileLeft" as opposed to "mouthSmile_L")
            var arKitKey = index_modern/* BlendShapeKeys.toARKitConvention */.lN.toARKitConvention(key);
            // Need to set all morphtargets for both meshes
            // ex. only setting jaw open for wolf3DAvatar will result in the mesh mouth opening but not the bones movingss1
            this.setMorphTarget(this.faceNode, arKitKey, blendShapes[key]);
            this.setMorphTarget(this.teethNode, arKitKey, blendShapes[key]);
            this.setMorphTarget(this.wolf3DAvatar, arKitKey, blendShapes[key]);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this
    _proto.updateHeadRotation = function updateHeadRotation(pitch, yaw, roll) {
        // Inverse yaw & roll effects for yourself to give mirror effect
        this.pivot.rotation.set(pitch, yaw, roll);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this
    _proto.updatePosition = function updatePosition(x, y, z) {
    // const SCALE = 0.2;
    // const Y_OFFSET = 0;
    // this.avatarRoot?.position.set(x * SCALE, Y_OFFSET + y * SCALE, z);
    };
    return AvatarComponent;
}(component_AbstractAvatar);
var avatarComponentType = "mp.avatarComponent";
var makeAvatarComponent = function() {
    return new AvatarComponent();
};

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/index.ts





/***/ }),

/***/ 83680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);
/* harmony import */ var _API__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2300);






var API_VERSION = "v1";
var PREFIX = "".concat(API_VERSION, "/admin/tour/");
var PUBLIC_PREFIX = "".concat(API_VERSION, "/public");
var GAME_PREFIX = "".concat(API_VERSION, "/admin/game");
var TreedisAdminDAO = /*#__PURE__*/ function(API) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(TreedisAdminDAO, API);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(TreedisAdminDAO);
    function TreedisAdminDAO() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, TreedisAdminDAO);
        var _this;
        _this = _super.call(this);
        var parent = _this.public;
        _this.public = {
            /** Virtual Staging */ getTourVSObjects: function(tourId) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(tourId, "/vstaging")
                }, options));
            },
            getTourVSImages: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/vstaging-images")
                }, options));
            },
            getTourVSHtmls: function(slug) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/vstaging-html")
                }, options));
            },
            getVSSettings: function(tourId) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(tourId, "/vs-settings")
                }, options));
            },
            getPolygons: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/polygons")
                }, options));
            },
            getTourVSVideos: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/vstaging-videos")
                }, options));
            },
            getFRFloors: function(slug) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.get((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PREFIX).concat(slug, "/vs-settings/frfloors")
                }, options));
            },
            /** Game * */ saveAnalytics: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(GAME_PREFIX, "/analytic/save")
                }, options));
            },
            createPaymentSecret: function() {
                var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
                return parent.post((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    url: "".concat(PUBLIC_PREFIX, "/payment/secret")
                }, options));
            }
        };
        return _this;
    }
    return TreedisAdminDAO;
}(_API__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var DAO = new TreedisAdminDAO().public;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
/* harmony default export */ __webpack_exports__["Z"] = (DAO);


/***/ }),

/***/ 79575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BZ": function() { return /* binding */ getVSItems; },
/* harmony export */   "QM": function() { return /* binding */ getSweepIndex; },
/* harmony export */   "Uv": function() { return /* binding */ getSweeps; },
/* harmony export */   "VB": function() { return /* binding */ getDuplicates; },
/* harmony export */   "lB": function() { return /* binding */ getFloorPlans; }
/* harmony export */ });
/* unused harmony exports getPolygons, getTourVSObjects, getTourVSImages, getTourVSVideos, getTourVSHtmls, getTourVSSettings */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80250);
/* harmony import */ var _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83680);
/* harmony import */ var _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15864);
/* harmony import */ var _models_virtualStaging_VSSettings__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20594);
/* harmony import */ var _models_virtualStaging_Polygon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59524);








var getFloorPlans = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var res;
        return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getFloorPlans */ .Z.getFloorPlans({
                        id: id
                    });
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", (res === null || res === void 0 ? void 0 : res.floorPlans) || []);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getFloorPlans(id) {
        return _ref.apply(this, arguments);
    };
}();
var getDuplicates = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var res;
        return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getDuplicates */ .Z.getDuplicates(id);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", (res === null || res === void 0 ? void 0 : res.duplicates) || []);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getDuplicates(id) {
        return _ref.apply(this, arguments);
    };
}();
var getPolygons = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        var res;
        return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getPolygons */ .Z.getPolygons(slug);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPolygons(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getSweeps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(matterId, slug) {
        var res;
        return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (matterId) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", []);
                case 2:
                    _ctx.next = 4;
                    return _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSweeps */ .Z.getSweeps({
                        matterId: matterId,
                        slug: slug
                    });
                case 4:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", (res === null || res === void 0 ? void 0 : res.sweeps) || []);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSweeps(matterId, slug) {
        return _ref.apply(this, arguments);
    };
}();
var getSweepIndex = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(matterId, slug, sweepId) {
        var ref, res;
        return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!(!matterId || !sweepId)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", -1);
                case 3:
                    _ctx.next = 5;
                    return _api_TreedisPublicDAO__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSweepIndex */ .Z.getSweepIndex({
                        matterId: matterId,
                        slug: slug,
                        sweepId: sweepId
                    });
                case 5:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.sweepIndex) + 1 || -1);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSweepIndex(matterId, slug, sweepId) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSObjects = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var res;
        return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getTourVSObjects */ .Z.getTourVSObjects(id);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.tourVSObjects);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTourVSObjects(id) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSImages = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        var res;
        return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getTourVSImages */ .Z.getTourVSImages(slug);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.tourVSImages);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTourVSImages(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSVideos = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        var res;
        return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getTourVSVideos */ .Z.getTourVSVideos(slug);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTourVSVideos(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSHtmls = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        var res;
        return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getTourVSHtmls */ .Z.getTourVSHtmls(slug);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTourVSHtmls(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getTourVSSettings = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var res;
        return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _api_TreedisAdminDAO__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getVSSettings */ .Z.getVSSettings(id);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res === null || res === void 0 ? void 0 : res.vsSettings);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTourVSSettings(id) {
        return _ref.apply(this, arguments);
    };
}();
var getVSItems = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(isMatterportLink, param) {
        var slug, id, ref, polygons, vsObjectsRes, vsImages, vsSettings, tourVideosData, vsHtmls, tourVideos, tourImages, tourHtmls, vsObjects;
        return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    slug = param.slug, id = param.id;
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
                    _ctx.next = 4;
                    return Promise.all([
                        !isMatterportLink ? getPolygons(slug) : Promise.resolve(null),
                        !isMatterportLink ? getTourVSObjects(id) : Promise.resolve(null),
                        !isMatterportLink ? getTourVSImages(slug) : Promise.resolve(null),
                        !isMatterportLink ? getTourVSSettings(id) : Promise.resolve(null),
                        !isMatterportLink ? getTourVSVideos(slug) : Promise.resolve(null),
                        !isMatterportLink ? getTourVSHtmls(slug) : Promise.resolve(null), 
                    ]);
                case 4:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 6);
                    polygons = ref[0];
                    vsObjectsRes = ref[1];
                    vsImages = ref[2];
                    vsSettings = ref[3];
                    tourVideosData = ref[4];
                    vsHtmls = ref[5];
                    tourVideos = (tourVideosData || []).map(function(item) {
                        return new _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_3__/* .TourVideo */ .Up(item);
                    });
                    tourImages = (vsImages === null || vsImages === void 0 ? void 0 : vsImages.map(function(item) {
                        return new _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_3__/* .TourImage */ .oP(item);
                    })) || [];
                    tourHtmls = (vsHtmls === null || vsHtmls === void 0 ? void 0 : vsHtmls.map(function(item) {
                        return new _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_3__/* .TourVSHtml */ .q8(item);
                    })) || [];
                    vsObjects = (vsObjectsRes || []).map(function(item) {
                        return new _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_3__/* .TourObject */ .zB(item);
                    }).concat(tourImages).concat(tourHtmls).concat(tourVideos);
                    return _ctx.abrupt("return", {
                        polygons: polygons ? polygons.map(function(polygon) {
                            return new _models_virtualStaging_Polygon__WEBPACK_IMPORTED_MODULE_4__/* .Polygon */ .mg(polygon);
                        }) : [],
                        vsSettings: new _models_virtualStaging_VSSettings__WEBPACK_IMPORTED_MODULE_7__/* .VSSettings */ .E(vsSettings || {}),
                        vsObjects: vsObjects
                    });
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getVSItems(isMatterportLink, _) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 16304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BaseTour; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var src_class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var src_inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var src_instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var src_create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 328 modules
var dist = __webpack_require__(78734);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./node_modules/three/examples/jsm/libs/tween.module.min.js
var tween_module_min = __webpack_require__(27970);
// EXTERNAL MODULE: ./_models/Agent.tsx
var Agent = __webpack_require__(2828);
// EXTERNAL MODULE: ./_models/Game.tsx
var Game = __webpack_require__(81766);
// EXTERNAL MODULE: ./_models/game/GameBook.ts
var GameBook = __webpack_require__(97741);
// EXTERNAL MODULE: ./_models/Menu.tsx
var Menu = __webpack_require__(78073);
// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
// EXTERNAL MODULE: ./_models/virtualStaging/avatar/index.ts + 5 modules
var virtualStaging_avatar = __webpack_require__(8267);
;// CONCATENATED MODULE: ./_models/virtualStaging/FRFloor.tsx

var FRFloor = function FRFloor() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,src_class_call_check/* default */.Z)(this, FRFloor);
    this.id = model.id || null;
    this.tourId = model.tourId;
    this.floor = model.floor;
    this.active = typeof model.active === "boolean" ? model.active : true;
    this.updatedAt = model.updatedAt;
    this.position = model.position;
    this.sweeps = model.sweeps || [];
};

;// CONCATENATED MODULE: ./_models/virtualStaging/helper.ts
var getAspectRatio = function(src) {
    return new Promise(function(resolve) {
        var img = document.createElement("img");
        img.src = src;
        img.onload = function() {
            img.style.visibility = "hidden";
            document.body.appendChild(img);
            resolve([
                img.clientWidth,
                img.clientHeight
            ]);
            document.body.removeChild(img);
        };
    });
};
/**
 * Calculate x and y in circle's circumference
 * @param {number} r - The circle's radius
 * @param {number} angle - The angle in degrees
 * @param {number} cx - The circle's origin x
 * @param {number} cz - The circle's origin z
 * @returns {Array[number,number]} The calculated x and y
 */ // eslint-disable-next-line class-methods-use-this
var pointsOnCircle2D = function(r, angle, cx, cz) {
    var a = angle * (Math.PI / 180); // convert from degrees to radians
    var x = cx + r * Math.cos(a);
    var z = cz + r * Math.sin(a);
    return [
        x,
        z
    ];
};


// EXTERNAL MODULE: ./_models/virtualStaging/Polygon.tsx
var Polygon = __webpack_require__(59524);
// EXTERNAL MODULE: ./_models/virtualStaging/Scene.component.tsx
var Scene_component = __webpack_require__(98472);
// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
;// CONCATENATED MODULE: ./_models/virtualStaging/VideoRenderer.component.tsx









var LoadingState;
(function(LoadingState) {
    LoadingState["Idle"] = "Idle";
    LoadingState["Loaded"] = "Loaded";
    LoadingState["Loading"] = "Loading";
    LoadingState["Error"] = "Error";
})(LoadingState || (LoadingState = {}));
var DEFAULT_WIDTH = 1;
// const DEFAULT_RADIUS = 0.1;
var VideoRenderer = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(SceneComponent) {
    "use strict";
    _inherits(VideoRenderer, SceneComponent);
    var _super = _create_super(VideoRenderer);
    function VideoRenderer() {
        _class_call_check(this, VideoRenderer);
        var _this;
        _this = _super.apply(this, arguments);
        _this.root = null;
        _this.pivot = null;
        _this.plane = null;
        _this.backSidePlane = null;
        _this.playBtn = null;
        _this.muteBtn = null;
        _this.aspect = 1.77;
        _this.aspectHeight = DEFAULT_WIDTH / _this.aspect;
        _this.hasPlayPermission = false;
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        _this.destroyButton = function() {};
        _this.inputs = {
            src: null,
            muted: true,
            loop: true,
            autoplay: true,
            visible: true,
            playsInline: true,
            localRotation: {
                x: 0,
                y: 0,
                z: 0
            },
            skipRender: false,
            width: DEFAULT_WIDTH
        };
        _this.outputs = {
            texture: null,
            loadingState: LoadingState.Idle
        };
        var _obj;
        // setting which events are compatible with the component
        _this.events = (_obj = {}, _define_property(_obj, ComponentInteractionType.CLICK, true), _define_property(_obj, ComponentInteractionType.HOVER, true), _define_property(_obj, ComponentInteractionType.DRAG, false), _obj);
        _this.getSize = function() {
            return [
                _this.inputs.width,
                _this.aspectHeight
            ];
        };
        return _this;
    }
    var _proto = VideoRenderer.prototype;
    _proto.onInit = function onInit() {
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.pivot = new THREE.Object3D();
        this.outputs.objectRoot = this.root;
        if (this.inputs.visible) {
            // setting the collider to add the click event
            this.outputs.collider = this.root;
        }
        this.root.add(this.pivot);
    };
    _proto.onInputsUpdated = function onInputsUpdated() {
        try {
            var _this = this;
            if (this.inputs.skipRender) {
                var localRotation = this.inputs.localRotation;
                this.root.rotation.set(localRotation.x, localRotation.y, localRotation.z);
                return;
            }
            this.releaseTexture();
            var THREE = this.context.three;
            if (!this.inputs.src) {
                this.video.src = "";
                this.outputs.loadingState = LoadingState.Idle;
                return;
            }
            this.outputs.loadingState = LoadingState.Loading;
            if (_instanceof(this.inputs.src, HTMLVideoElement)) {
                this.video = this.inputs.src;
            } else {
                this.video = this.createVideoElement();
                if (typeof this.inputs.src === "string") {
                    this.video.src = this.inputs.src;
                } else {
                    this.video.srcObject = this.inputs.src;
                }
                this.video.load();
            }
            var onCanPlay = function() {
                var ref, ref1, ref2;
                var videoElement = _this.video;
                var audioDataNotPresented = (videoElement === null || videoElement === void 0 ? void 0 : videoElement.webkitAudioDecodedByteCount) === 0 || (videoElement === null || videoElement === void 0 ? void 0 : videoElement.mozHasAudio) === false || (videoElement === null || videoElement === void 0 ? void 0 : (ref = videoElement.audioTracks) === null || ref === void 0 ? void 0 : ref.length) === 0;
                if (audioDataNotPresented) {
                    if (_this.destroyButton && typeof _this.destroyButton === "function") {
                        _this.destroyButton();
                    }
                }
                _this.video.removeEventListener("canplaythrough", onCanPlay);
                var _video = _this.video, videoWidth = _video.videoWidth, videoHeight = _video.videoHeight;
                if (!videoWidth || !videoHeight) {
                    // return console.debug('Unable to get video resolution.');
                    throw new Error("Unable to get video resolution.");
                }
                _this.aspect = videoWidth / videoHeight;
                _this.aspectHeight = _this.inputs.width / _this.aspect;
                var geometry = new THREE.PlaneGeometry(_this.inputs.width, _this.aspectHeight);
                // TODO: finish with rounded rectangle
                // https://threejs.org/examples/#webgl_geometry_shapes - rounded rect shape
                // const geometry = this.makeRoundedRect(
                //   0,
                //   0,
                //   this.inputs.width,
                //   this.aspectHeight,
                //   this.inputs.useRadius ? DEFAULT_RADIUS : 0,
                // );
                _this.texture = new THREE.VideoTexture(_this.video);
                _this.texture.encoding = THREE.sRGBEncoding;
                _this.texture.minFilter = THREE.LinearFilter;
                _this.texture.magFilter = THREE.LinearFilter;
                _this.texture.format = THREE.RGBAFormat;
                _this.texture.wrapS = THREE.ClampToEdgeWrapping; // THREE.RepeatWrapping
                _this.texture.wrapT = THREE.ClampToEdgeWrapping; // THREE.RepeatWrapping
                _this.texture.repeat.set(1, 1);
                var material = new THREE.MeshBasicMaterial({
                    map: _this.texture,
                    blending: THREE.NormalBlending,
                    transparent: true,
                    visible: _this.inputs.visible
                });
                var backSideMaterial = new THREE.MeshBasicMaterial({
                    side: THREE.DoubleSide,
                    color: 0x000000,
                    transparent: false,
                    visible: _this.inputs.visible,
                    polygonOffset: true,
                    polygonOffsetUnits: -4
                });
                _this.plane = new THREE.Mesh(geometry, material);
                (ref1 = _this.pivot) === null || ref1 === void 0 ? void 0 : ref1.add(_this.plane);
                // fixing plane the position
                // this.plane.position.set(
                //   -((this.inputs.width * this.aspect) / 2),
                //   -(this.aspectHeight / 2),
                //   0,
                // );
                // this.plane.scale.set(
                //   this.aspect,
                //   1,
                //   1,
                // );
                _this.backSidePlane = new THREE.Mesh(geometry, backSideMaterial);
                _this.backSidePlane.position.set(0, 0, -0.01);
                (ref2 = _this.pivot) === null || ref2 === void 0 ? void 0 : ref2.add(_this.backSidePlane);
                // fixing plane the position
                // this.backSidePlane.position.set(
                //   -((this.inputs.width * this.aspect) / 2),
                //   -(this.aspectHeight / 2),
                //   -0.01,
                // );
                var localRotation = _this.inputs.localRotation;
                _this.root.rotation.set(localRotation.x, localRotation.y, localRotation.z);
                _this.outputs.texture = _this.texture;
                _this.outputs.loadingState = LoadingState.Loaded;
                if (_this.inputs.autoplay) {
                    var _this1 = _this;
                    var interval = setInterval(_async_to_generator(regeneratorRuntime.mark(function _callee() {
                        return regeneratorRuntime.wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    _ctx.prev = 0;
                                    _ctx.next = 3;
                                    return _this1.video.play();
                                case 3:
                                    clearInterval(interval);
                                    _ctx.next = 9;
                                    break;
                                case 6:
                                    _ctx.prev = 6;
                                    _ctx.t0 = _ctx["catch"](0);
                                    console.error(_ctx.t0);
                                case 9:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee, null, [
                            [
                                0,
                                6
                            ]
                        ]);
                    })), 1000);
                }
            };
            var onError = function() {
                _this.video.removeEventListener("error", onError);
                _this.outputs.loadingState = LoadingState.Error;
            };
            this.video.addEventListener("canplaythrough", onCanPlay);
            this.video.addEventListener("error", onError);
            if (DeviceManager.isIOS()) {
                var _this1 = this;
                this.video.addEventListener("pause", function() {
                    // mute and play the video in case the browser stopped it
                    // i.e. Safari stops the video if the other one was unmuted
                    if (_this1.video.paused && _this1.hasPlayPermission) {
                        _this1.toggleMute();
                    }
                }, false);
            }
        } catch (e) {
            console.error("[VideoRenderer]:", e);
            this.outputs.loadingState = LoadingState.Error;
        }
    };
    _proto.onDestroy = function onDestroy() {
        this.releaseTexture();
        if (this.playBtn) {
            var ref;
            (ref = this.playBtn.parent) === null || ref === void 0 ? void 0 : ref.remove(this.playBtn);
            this.playBtn.material.dispose();
            this.playBtn.geometry.dispose();
            this.playBtn = null;
        }
        if (this.muteBtn) {
            var ref1;
            (ref1 = this.muteBtn.parent) === null || ref1 === void 0 ? void 0 : ref1.remove(this.muteBtn);
            this.muteBtn.material.dispose();
            this.muteBtn.geometry.dispose();
            this.muteBtn = null;
        }
    };
    _proto.isMuted = function isMuted() {
        return this.video.muted;
    };
    _proto.toggleMute = function toggleMute(muted) {
        var value = typeof muted === "boolean" ? muted : !this.video.muted;
        if (!this.video) return;
        this.video.muted = value;
        if (DeviceManager.isIOS() && !value && !this.hasPlayPermission) {
            // Safari support the autoplay unmute only after user interacts with Treedis website (not iframe)
            // https://developer.apple.com/documentation/webkit/delivering_video_content_for_safari#3030259
            var overlay = document.createElement("div");
            overlay.setAttribute("id", "video-overlay");
            overlay.style.width = "100vw";
            overlay.style.height = "100vh";
            overlay.style.zIndex = "9999";
            overlay.style.position = "fixed";
            overlay.style.top = "0";
            overlay.style.left = "0";
            var _this = this;
            var handler = function() {
                var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee() {
                    var hasOverlay;
                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                hasOverlay = document.getElementById("video-overlay");
                                if (hasOverlay) {
                                    _ctx.next = 3;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 3:
                                document.body.removeChild(overlay);
                                overlay.removeEventListener("click", handler);
                                overlay.removeEventListener("mouseup", handler);
                                overlay.removeEventListener("mousemove", handler);
                                overlay.removeEventListener("touchstart", handler);
                                overlay.removeEventListener("touchmove", handler);
                                _this.hasPlayPermission = true;
                                _ctx.next = 12;
                                return _this.video.play();
                            case 12:
                                // in case with iOS Safari browser, the video is muted at the moment (read the link below)
                                // https://developer.apple.com/documentation/webkit/delivering_video_content_for_safari#3030259
                                //
                                // so, we need to unmute it and display the current state
                                _this.video.muted = false;
                            case 13:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function handler() {
                    return _ref.apply(this, arguments);
                };
            }();
            overlay.addEventListener("click", handler);
            overlay.addEventListener("mousedown", handler);
            overlay.addEventListener("mousemove", handler);
            overlay.addEventListener("touchstart", handler);
            overlay.addEventListener("touchmove", handler);
            document.body.append(overlay);
        } else {
            this.video.play().catch(function(e) {
                console.error(e);
            });
        }
    };
    _proto.releaseTexture = function releaseTexture() {
        if (this.texture) {
            this.outputs.texture = null;
            this.outputs.loadingState = LoadingState.Idle;
            this.texture.dispose();
        }
        if (this.video) {
            this.video.pause();
            this.video.src = "";
        }
        if (this.plane) {
            var ref;
            (ref = this.plane.parent) === null || ref === void 0 ? void 0 : ref.remove(this.plane);
            this.plane.material.dispose();
            this.plane.geometry.dispose();
            this.plane = null;
        }
        if (this.backSidePlane) {
            var ref1;
            (ref1 = this.backSidePlane.parent) === null || ref1 === void 0 ? void 0 : ref1.remove(this.backSidePlane);
            this.backSidePlane.material.dispose();
            this.backSidePlane.geometry.dispose();
            this.backSidePlane = null;
        }
    };
    _proto.createVideoElement = function createVideoElement() {
        var _inputs = this.inputs, muted = _inputs.muted, loop = _inputs.loop, autoplay = _inputs.autoplay, playsInline = _inputs.playsInline;
        var video = document.createElement("video");
        video.crossOrigin = "anonymous";
        video.autoplay = Boolean(autoplay);
        video.muted = Boolean(muted);
        video.loop = Boolean(loop);
        video.playsInline = Boolean(playsInline);
        return video;
    };
    return VideoRenderer;
}(SceneComponent)));
var videoRendererType = "treedis.videoRenderer";
function makeVideoRenderer() {
    return new VideoRenderer();
}

// EXTERNAL MODULE: ./_models/virtualStaging/VSObject.tsx
var VSObject = __webpack_require__(15864);
// EXTERNAL MODULE: ./_models/virtualStaging/LoadingQueue.ts + 1 modules
var LoadingQueue = __webpack_require__(44041);
// EXTERNAL MODULE: ./_models/virtualStaging/VSSettings.tsx
var VSSettings = __webpack_require__(20594);
;// CONCATENATED MODULE: ./components/util/sdk/mattertag/data.ts



/**
 * Merge tags from matterport and treedis
 * @param matterTags
 * @param treedisTags
 */ var getAllTags = function(matterTags, treedisTags) {
    var allTags = new Map();
    var matterTagsArray = [];
    matterTags.forEach(function(t) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        var index = treedisTags.findIndex(function(item) {
            return t.sid === (item === null || item === void 0 ? void 0 : item.sid);
        });
        var found = index === -1 ? null : treedisTags[index];
        var media;
        if (t.media) {
            media = t.media;
        }
        var tag = Object.assign(cloneDeep_default()(found) || {}, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            title: found && found.title && found.title.length ? found.title : t.label,
            positionX: (found === null || found === void 0 ? void 0 : found.positionX) ? found.positionX : t === null || t === void 0 ? void 0 : (ref = t.position) === null || ref === void 0 ? void 0 : ref.x,
            positionY: (found === null || found === void 0 ? void 0 : found.positionY) ? found.positionY : t === null || t === void 0 ? void 0 : (ref1 = t.position) === null || ref1 === void 0 ? void 0 : ref1.y,
            positionZ: (found === null || found === void 0 ? void 0 : found.positionZ) ? found.positionZ : t === null || t === void 0 ? void 0 : (ref2 = t.position) === null || ref2 === void 0 ? void 0 : ref2.z,
            stemVectorX: (found === null || found === void 0 ? void 0 : found.stemVectorX) && (found === null || found === void 0 ? void 0 : found.svXEnabled) ? found.stemVectorX : (t === null || t === void 0 ? void 0 : (ref3 = t.stem) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.direction) === null || ref4 === void 0 ? void 0 : ref4.x) || 0,
            stemVectorY: (found === null || found === void 0 ? void 0 : found.stemVectorY) && (found === null || found === void 0 ? void 0 : found.svYEnabled) ? found.stemVectorY : (t === null || t === void 0 ? void 0 : (ref5 = t.stem) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.direction) === null || ref6 === void 0 ? void 0 : ref6.y) || 0.3,
            stemVectorZ: (found === null || found === void 0 ? void 0 : found.stemVectorZ) && (found === null || found === void 0 ? void 0 : found.svZEnabled) ? found.stemVectorZ : (t === null || t === void 0 ? void 0 : (ref7 = t.stem) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.direction) === null || ref8 === void 0 ? void 0 : ref8.z) || 0,
            iconColor: found ? found.iconColor : t.color,
            opacity: found ? found.opacity : 100,
            mpTitle: found ? found.mpTitle : true,
            mpTooltip: found ? found.mpTooltip : true,
            mpNavigation: found ? found.mpNavigation : true,
            whiteCircle: found ? found.whiteCircle : false,
            transparentBackground: found ? found.transparentBackground : false,
            id: (found === null || found === void 0 ? void 0 : found.id) || t.sid || t.defaultSid
        }, t), {
            media: media,
            description: (found === null || found === void 0 ? void 0 : (ref9 = found.description) === null || ref9 === void 0 ? void 0 : ref9.length) ? found.description : t.description,
            enabled: found && typeof found.enabled === "boolean" ? found.enabled : false,
            customIcon: found ? found.customIcon : false
        }));
        if (found) {
            tag.modifiedTag = true; //flag that tag has been modified through treedis
        } else {
            matterTagsArray.push(tag);
        }
        treedisTags[index] = tag;
    });
    treedisTags.concat(matterTagsArray).forEach(function(tag) {
        allTags.set(tag.sid, cloneDeep_default()(tag));
    });
    return allTags;
};

;// CONCATENATED MODULE: ./components/util/sdk/mattertag/index.ts


var matterTags = new Map();
var Mattertag = function Mattertag() {
    "use strict";
    (0,src_class_call_check/* default */.Z)(this, Mattertag);
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
Mattertag.subscribe = function(param, subscriber) {
    var mpSdk = param.mpSdk, mpTags = param.mpTags, treedisTags = param.treedisTags;
    if (!mpTags) return subscriber(new Map());
    // eslint-disable-next-line array-callback-return
    Object.keys(mpTags).map(function(idx) {
        matterTags.set(idx, mpTags[idx]);
    });
    var matterportTags = Object.values(mpTags);
    var allTags = getAllTags(matterportTags, treedisTags);
    subscriber(allTags);
// let addedMatterportTags = false;
// mpSdk.Mattertag.data.subscribe({
//   onAdded: (idx, item) => {
//     if (addedMatterportTags) {
//       // Added Transient Tag
//     } else {
//       // Added Matterport Tag
//       matterTags.set(idx, item);
//     }
//   },
//   onCollectionUpdated: (collection) => {
//     if (addedMatterportTags) return;
//     // Matterport tags finished initially adding
//     addedMatterportTags = true;
//     const matterportTags = Object.values(collection);
//     const allTags = getAllTags(matterportTags, treedisTags);
//     subscriber(allTags);
//   },
// });
};
Mattertag.getMatterTags = function() {
    return matterTags;
};

// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
// EXTERNAL MODULE: ./utils/index.ts + 7 modules
var utils = __webpack_require__(58104);
// EXTERNAL MODULE: ./components/common/CookieConsent.tsx
var CookieConsent = __webpack_require__(72789);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./components/util/analytic.ts
var analytic = __webpack_require__(83784);
// EXTERNAL MODULE: ./components/util/popups.ts
var popups = __webpack_require__(62818);
// EXTERNAL MODULE: ./components/util/sdk.ts + 2 modules
var sdk = __webpack_require__(68687);
// EXTERNAL MODULE: ./components/util/socket.ts
var socket = __webpack_require__(13607);
// EXTERNAL MODULE: ./components/util/styles.ts
var styles = __webpack_require__(24069);
// EXTERNAL MODULE: ./components/util/index.ts + 6 modules
var util = __webpack_require__(66870);
// EXTERNAL MODULE: ./components/tour/regular/bottomBar/SoundControls.tsx
var SoundControls = __webpack_require__(67644);
// EXTERNAL MODULE: ./components/tour/regular/fullScreen/FullScreen.tsx
var FullScreen = __webpack_require__(44);
// EXTERNAL MODULE: ./components/ticketingNew/components/InfoModal.tsx + 1 modules
var InfoModal = __webpack_require__(47887);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
;// CONCATENATED MODULE: ./components/tour/components/SetDataToRecoil.tsx




var SetDataToRecoil = function(props) {
    var translation = props.translation, tourConfigsInput = props.tourConfigsInput;
    var ref = (0,react.useState)(false), inited = ref[0], setInited = ref[1];
    var setTranslation = (0,store/* useSetRecoilState */.Zl)(store/* translationDataState */.Jv);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* tourConfigsState */.Uq), 2), tourConfigs = ref1[0], setTourConfigs = ref1[1];
    (0,react.useEffect)(function() {
        if (!inited) {
            if (translation && Object.keys(translation).length > 0) {
                setTranslation(translation);
                setTourConfigs((0,_object_spread/* default */.Z)({}, tourConfigs, tourConfigsInput));
                setInited(true);
            }
        }
    }, [
        translation
    ]);
    return null;
};
/* harmony default export */ var components_SetDataToRecoil = (SetDataToRecoil);

// EXTERNAL MODULE: ./api/TreedisAdminDAO.ts
var TreedisAdminDAO = __webpack_require__(83680);
// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(14293);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
;// CONCATENATED MODULE: ./_models/game/GameAnalytic.ts


var GameAnalytic = function GameAnalytic(model) {
    "use strict";
    (0,src_class_call_check/* default */.Z)(this, GameAnalytic);
    this.id = model.id || null;
    this.name = model.name || null;
    this.startDateTime = model.startDateTime || null;
    this.country = model.country || null;
    this.point = !isNil_default()(model.point) ? model.point : null;
    this.time = !isNil_default()(model.time) ? model.time : null;
    this.completed = model.completed || false;
    this.gameId = model.gameId || null;
    this.rating = !isNil_default()(model.rating) ? model.rating : null;
};

;// CONCATENATED MODULE: ./components/tour/game/services/GameAnalyticService.ts






var GameAnalyticService = /*#__PURE__*/ function() {
    "use strict";
    function GameAnalyticService(gameId) {
        var _this = this;
        (0,src_class_call_check/* default */.Z)(this, GameAnalyticService);
        this.analytic = new GameAnalytic({
            gameId: gameId,
            country: "",
            startDateTime: new Date()
        });
        window.addEventListener("beforeunload", function() {
            return _this.update();
        });
    }
    var _proto = GameAnalyticService.prototype;
    _proto.getTime = function getTime() {
        return this.analytic.time;
    };
    _proto.setTime = function setTime(time) {
        this.analytic.time = time;
    };
    _proto.getPoint = function getPoint() {
        return this.analytic.point;
    };
    _proto.setPoint = function setPoint(point) {
        this.analytic.point = point;
    };
    _proto.update = function update() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var obj, newAnalytic, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        obj = (0,_object_spread/* default */.Z)({}, data);
                        if (obj.id) delete obj.id;
                        newAnalytic = new GameAnalytic((0,_object_spread/* default */.Z)({}, _this.analytic, obj));
                        _ctx.next = 5;
                        return _this.saveAnalytics(newAnalytic);
                    case 5:
                        res = _ctx.sent;
                        if (res) {
                            _this.analytic = new GameAnalytic(res.data);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    // eslint-disable-next-line class-methods-use-this
    _proto.saveAnalytics = function saveAnalytics(analytic) {
        return TreedisAdminDAO/* default.saveAnalytics */.Z.saveAnalytics(analytic);
    };
    return GameAnalyticService;
}();


;// CONCATENATED MODULE: ./components/tour/regular/loadTourIframe/LoadTourIframe.tsx




var LoadTourIframe = function(param) {
    var mesurementsOn = param.mesurementsOn, iframeStyle = param.iframeStyle, iframeUrl = param.iframeUrl, isFullScreen = param.isFullScreen, iframeId = param.iframeId, cb = param.cb;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Frame */.RQ, {
        elementId: iframeId,
        iframeUrl: iframeUrl,
        className: classnames_default()("showcase", deviceManager/* default.isMobile */.Z.isMobile() && !isFullScreen && mesurementsOn && "mesurements-mobile-not-fullscreen"),
        style: iframeStyle,
        handleRef: cb
    });
};
/* harmony default export */ var loadTourIframe_LoadTourIframe = (LoadTourIframe);

// EXTERNAL MODULE: ./api/queries.ts
var queries = __webpack_require__(79575);
;// CONCATENATED MODULE: ./components/tour/afterSweepInit.ts







var afterSweepsInit = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var sweeps, matterId, slug, iframeUrl, setData, cb, floors, isMatterportLink, frFloorsRes, actualMatterId, deprecatedSweeps;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    sweeps = param.sweeps, matterId = param.matterId, slug = param.slug, iframeUrl = param.iframeUrl, setData = param.setData, cb = param.cb;
                    if (!(sweeps === null || sweeps === void 0 ? void 0 : sweeps.length)) {
                        _ctx.next = 18;
                        break;
                    }
                    floors = [];
                    isMatterportLink = (0,util/* getQueryVariable */.Dv)(iframeUrl, "m") !== matterId;
                    if (isMatterportLink) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.next = 7;
                    return TreedisAdminDAO/* default.getFRFloors */.Z.getFRFloors(slug);
                case 7:
                    _ctx.t0 = _ctx.sent;
                    _ctx.next = 11;
                    break;
                case 10:
                    _ctx.t0 = {
                        data: []
                    };
                case 11:
                    frFloorsRes = _ctx.t0;
                    // using sweep.floor_position to get the floor height position
                    sweeps.forEach(function(sweep) {
                        var ref;
                        if (!floors[sweep.floor_index]) {
                            var frFloor = frFloorsRes === null || frFloorsRes === void 0 ? void 0 : frFloorsRes.data.find(function(i) {
                                return i.floor === sweep.floor_index;
                            });
                            var floor = {
                                floor: sweep.floor_index,
                                position: sweep.floor_position
                            };
                            floors[sweep.floor_index] = frFloor ? new FRFloor((0,_object_spread/* default */.Z)({}, frFloor, floor)) : new FRFloor(floor);
                        }
                        (ref = floors[sweep.floor_index].sweeps) === null || ref === void 0 ? void 0 : ref.push(sweep);
                    });
                    actualMatterId = (0,util/* getQueryVariable */.Dv)(iframeUrl, "m") || matterId;
                    _ctx.next = 16;
                    return (0,queries/* getSweeps */.Uv)(String(actualMatterId), slug);
                case 16:
                    deprecatedSweeps = _ctx.sent;
                    setData({
                        floors: floors,
                        deprecatedSweeps: deprecatedSweeps
                    });
                case 18:
                    cb();
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function afterSweepsInit(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/tour/calculateLocation.ts
function calculateLocation(sweep) {
    if (this.state.panoramaOn) return false;
    var px = this.state.mapWalkerX;
    var py = this.state.mapWalkerY;
    var minimaps = this.state.minimaps;
    var selectedMinimap = this.state.selectedMinimap;
    var tour = this.state.tour;
    if (tour.minimap && minimaps.length > 0 && minimaps[selectedMinimap] && tour.originX != null && tour.originY != null && tour.width != null && tour.height != null && tour.ppm != null) {
        var _selectedMinimap = minimaps[selectedMinimap], hotspots = _selectedMinimap.hotspots, custom = _selectedMinimap.custom;
        var foundHotspot = null;
        hotspots.forEach(function(hotspot) {
            if (hotspot.scanId === sweep.sid) {
                hotspot.active = true;
                foundHotspot = hotspot;
            } else {
                hotspot.active = false;
            }
        });
        if (foundHotspot) {
            px = foundHotspot.x;
            py = foundHotspot.y;
        } else if (!custom) {
            var ref, ref1;
            px = (((ref = sweep.position) === null || ref === void 0 ? void 0 : ref.x) + tour.originX * -1) * tour.ppm / tour.width * 100;
            py = 100 + (((ref1 = sweep.position) === null || ref1 === void 0 ? void 0 : ref1.z) + tour.originY) * tour.ppm / tour.height * 100;
        }
    }
    return {
        px: px,
        py: py,
        minimaps: minimaps
    };
}

;// CONCATENATED MODULE: ./components/tour/renderButtonBg.tsx





function renderButtonBg() {
    var _state = this.state, tour = _state.tour, room = _state.room, menuOpen = _state.menuOpen, host = _state.host, translation = _state.translation, tourEmail = _state.tourEmail, tourType = _state.tourType, MenuHintOn = _state.MenuHintOn, getInTouchHintOn = _state.getInTouchHintOn, appointmentsHintOn = _state.appointmentsHintOn, menuSettings = _state.menuSettings;
    var menuOpenForDevice = !!(deviceManager/* default.isMobile */.Z.isMobile() ? tour.menuAlwaysOpenMobile : tour.menuAlwaysOpenDesktop);
    var showExpand = !this.state.menuOpened && !tour.menuOnStart;
    var showCustomButton = tour.customButton && tour.customButtonIcon && tourType === Tour/* TourType.Regular */.v.Regular;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonBg */.g2, {
                chatToken: room,
                menu: {
                    menuEnabled: tour.menuEnabled
                },
                toggleNav: this.toggleNav.bind(this),
                handleCustomButton: this.handleCustomButton,
                showExpand: showExpand,
                toggleAppointmentsModal: this.toggleAppointmentsModal,
                appointmentsHintOn: appointmentsHintOn,
                toggleContactPopup: util/* toggleContactPopup.bind */.OZ.bind(this),
                tourEmail: tourEmail,
                getInTouchHintOn: getInTouchHintOn,
                MenuHintOn: MenuHintOn,
                showCustomButton: showCustomButton,
                translation: translation,
                tourType: tourType,
                menuOpen: menuOpen,
                tour: tour,
                host: host,
                menuOpenForDevice: menuOpenForDevice,
                menuColors: menuSettings ? {
                    fon: menuSettings.menuBgColor,
                    searchButtonColor: menuSettings.searchButtonColor,
                    active: "",
                    text: "",
                    openedMenuColor: ""
                } : undefined
            }),
            this.injectBottomBg()
        ]
    });
}

;// CONCATENATED MODULE: ./utils/randomNumberId.ts
var randomNumberId = function() {
    var nr = String(Math.random()).split(".")[1];
    if (Number(nr)) {
        return Number(nr);
    }
    return Math.random();
};

;// CONCATENATED MODULE: ./components/tour/getIframeStyle.ts
var getIframeStyle = function(param) {
    var tour = param.tour, activeSweepGroup = param.activeSweepGroup, sweepGroups = param.sweepGroups;
    var iframeStyle = {};
    if (tour) {
        var brightness = tour.brightness === 1 ? "" : "brightness(".concat(tour.brightness, ")");
        var saturation = tour.saturation === 1 ? "" : "saturate(".concat(tour.saturation, ")");
        var contrast = tour.contrast === 1 ? "" : "contrast(".concat(tour.contrast, ")");
        iframeStyle = {
            filter: "".concat(brightness, " ").concat(saturation, " ").concat(contrast)
        };
        if (activeSweepGroup) {
            var sweepGroup = sweepGroups.find(function(sg) {
                return sg.id === activeSweepGroup;
            });
            if (sweepGroup) {
                var hasColorSettings = sweepGroup.brightness !== 1 || sweepGroup.saturation !== 1 || sweepGroup.contrast !== 1;
                if (hasColorSettings) {
                    var sweepBrightness = sweepGroup.brightness === 1 ? "" : "brightness(".concat(sweepGroup.brightness, ")");
                    var sweepSaturation = sweepGroup.saturation === 1 ? "" : "saturate(".concat(sweepGroup.saturation, ")");
                    var sweepContrast = sweepGroup.contrast === 1 ? "" : "contrast(".concat(sweepGroup.contrast, ")");
                    iframeStyle = {
                        filter: "".concat(sweepBrightness, " ").concat(sweepSaturation, " ").concat(sweepContrast)
                    };
                }
            }
        }
    }
    return iframeStyle;
};

;// CONCATENATED MODULE: ./components/tour/logoutHandler.ts




var logoutHandler = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var ticket, ticketingOrderedTicket;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ticket = param.ticket, ticketingOrderedTicket = param.ticketingOrderedTicket;
                    if (!(ticket && ticketingOrderedTicket && ticketingOrderedTicket.ticketType === "tourByYourself")) {
                        _ctx.next = 4;
                        break;
                    }
                    _ctx.next = 4;
                    return TreedisPublicDAO/* default.logoutTicket */.Z.logoutTicket({
                        ticketId: ticketingOrderedTicket === null || ticketingOrderedTicket === void 0 ? void 0 : ticketingOrderedTicket.id,
                        deviceId: (0,utils/* getDeviceFingerprint */.UI)()
                    });
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function logoutHandler(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/tour/stopApp.ts
var stopApp = function() {
    console.log("[reload] BaseTour.stopApp");
    window.location.reload();
};

;// CONCATENATED MODULE: ./components/tour/getUrlVariables.ts

var getUrlVariables = function(url, iframeUrl) {
    var id = (0,util/* getQueryVariable */.Dv)(url, "m");
    var iframeId = (0,util/* getQueryVariable */.Dv)(iframeUrl, "m");
    var start = (0,util/* getQueryVariable */.Dv)(url, "start");
    // normal
    var sr = (0,util/* getQueryVariable */.Dv)(url, "sr"); // rotation
    var ss = (0,util/* getQueryVariable */.Dv)(url, "ss"); // sweep
    // floor plan or dollhouse
    var sm = (0,util/* getQueryVariable */.Dv)(url, "sm"); // mode
    var sz = (0,util/* getQueryVariable */.Dv)(url, "sz"); // zoom
    var sp = (0,util/* getQueryVariable */.Dv)(url, "sp"); // position
    var linkData = start ? JSON.parse(String(start)) : false;
    var rand = Math.floor(Math.random() * 1000000 + 1);
    var linkDataShort = sr && ss ? {
        sr: sr.split(","),
        ss: parseInt(String(ss), 10)
    } : false;
    if (!linkDataShort) linkDataShort = sp && sr && sm ? {
        sm: parseInt(sm, 10),
        sr: sr.split(","),
        sp: sp.split(","),
        sz: sz ? parseFloat(String(sz)) : null
    } : false;
    return {
        id: id,
        iframeId: iframeId,
        linkData: linkData,
        rand: rand,
        linkDataShort: linkDataShort
    };
};

;// CONCATENATED MODULE: ./components/tour/addPinnedVideoFunc.ts

var addPinnedVideoFunc = function(p, pinnedVideosData, cb) {
    try {
        var ref;
        if (((ref = p.track) === null || ref === void 0 ? void 0 : ref.kind) === "video") {
            var pinnedVideos = (0,_to_consumable_array/* default */.Z)(pinnedVideosData);
            var index = pinnedVideos.findIndex(function(i) {
                return i.sid === p.sid;
            });
            var dominantIndex = pinnedVideos.findIndex(function(i) {
                return i.pinned === true;
            });
            if (dominantIndex >= 0) {
                var dominantSpeaker = pinnedVideos[dominantIndex];
                // replace the dominant speaker, first remove it
                if (dominantSpeaker.sid !== p.sid) {
                    pinnedVideos.splice(dominantIndex, 1);
                }
            }
            if (index >= 0) {
                pinnedVideos[index] = p;
            } else {
                pinnedVideos.push(p);
            }
            cb(pinnedVideos);
        }
    } catch (e) {
        console.error(e);
    }
};

;// CONCATENATED MODULE: ./components/tour/takePositionData.ts


var takePositionData = function(param) {
    var slug = param.slug, matterId = param.matterId, sweep = param.sweep, rotation = param.rotation;
    var segmants = window.location.href.split("/");
    var id = segmants[segmants.length - 1].split("?")[0];
    if (slug === id || matterId === id) {
        (0,util_all/* copyToClipboard */.vQ)((0,util_all/* buildLink */.DF)(sweep, rotation));
        react_toastify_esm/* toast.success */.Am.success("Copied current position");
    } else {
        react_toastify_esm/* toast.error */.Am.error("Cannot copy position in a tour that was reached through the menu, please go to this tour page directly and copy positions from there using CTRL+Y");
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(94556);
;// CONCATENATED MODULE: ./components/tour/components/CrashScreen/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  font-family: 'Roboto';\n  font-size: 16px;\n  color: white;\n  width: 100vw;\n  height: 100vh;\n  margin: 0;\n  z-index: 999;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  background: #333;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: url('/crash.svg');\n  background-size: cover;\n  height: 12.5em;\n  width: 12.5em;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 50px auto 0 auto;\n  max-width: 700px;\n  text-align: center;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 3em;\n  line-height: 116.7%;\n  text-align: center;\n  color: #ffffff;\n  margin: 0 auto 30px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  font-size: 1.25em;\n  padding: 0 50px;\n  margin-bottom: 30px;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1em;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  & > button {\n    margin-right: 1.25em;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 6px 16px;\n  min-height: 40px;\n  background: rgba(107, 107, 107, 0.01);\n  border: 1px solid #ffffff;\n  border-radius: 4px;\n  color: white;\n\n  & > i {\n    margin-right: 0.2em;\n  }\n\n  &:hover {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__Wrapper",
    componentId: "sc-e36e8c17-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n    font-size: 12px;\n    height: calc(var(--vh, 1vh) * 100);\n  ";
});
var ImageBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__ImageBlock",
    componentId: "sc-e36e8c17-1"
})(_templateObject1());
var TextBlockWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__TextBlockWrap",
    componentId: "sc-e36e8c17-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n      margin-top: 20px;\n      ".concat(!theme.device.landscape && "max-width: 320px;", "\n    ");
});
var TitleText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__TitleText",
    componentId: "sc-e36e8c17-3"
})(_templateObject3());
var DescriptionText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__DescriptionText",
    componentId: "sc-e36e8c17-4"
})(_templateObject4());
var ButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__ButtonWrap",
    componentId: "sc-e36e8c17-5"
})(_templateObject5());
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styled__Button",
    componentId: "sc-e36e8c17-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./components/tour/components/CrashScreen/index.tsx


var defaultTranslation = {
    crashScreenTitle: "Seems like something isn't working",
    crashScreenDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    crashScreenRestoreBtn: "Restore",
    crashScreenRefreshBtn: "Reload"
};
var CrashScreen = function(param) {
    var show = param.show, onRestore = param.onRestore, backgroundImage = param.backgroundImage;
    var refresh = function() {
        window.location.reload();
    };
    if (!show) return null;
    var crashScreenTitle = defaultTranslation.crashScreenTitle, crashScreenRestoreBtn = defaultTranslation.crashScreenRestoreBtn, crashScreenRefreshBtn = defaultTranslation.crashScreenRefreshBtn, crashScreenDescription = defaultTranslation.crashScreenDescription;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        backgroundImage: backgroundImage,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextBlockWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleText, {
                        className: "titleText",
                        children: crashScreenTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionText, {
                        children: crashScreenDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonWrap, {
                children: [
                    onRestore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        className: "mb-2",
                        onClick: onRestore,
                        children: crashScreenRestoreBtn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        className: "mb-2",
                        onClick: refresh,
                        children: crashScreenRefreshBtn
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CrashScreen = (CrashScreen);

// EXTERNAL MODULE: ./_models/Tag.tsx
var Tag = __webpack_require__(42725);
// EXTERNAL MODULE: ./components/common/LoadingProgress/index.tsx + 1 modules
var LoadingProgress = __webpack_require__(3403);
// EXTERNAL MODULE: ./components/tour/game/ClipScreen/index.tsx + 2 modules
var ClipScreen = __webpack_require__(82107);
// EXTERNAL MODULE: ./units/index.ts + 32 modules
var units = __webpack_require__(19326);
// EXTERNAL MODULE: ./hooks/index.ts + 4 modules
var hooks = __webpack_require__(19004);
// EXTERNAL MODULE: ./components/tour/game/GameLockPathModal/index.tsx + 1 modules
var GameLockPathModal = __webpack_require__(56703);
;// CONCATENATED MODULE: ./components/tour/game/RegularPaths/index.tsx







/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable no-console */ 






var RegularPaths = function(param) {
    var showcase = param.showcase, gamePaths = param.gamePaths, allTags = param.allTags, polygons = param.polygons, vsObjects = param.vsObjects, sweeps = param.sweeps, clickedElement = param.clickedElement, translationGo = param.translationGo, gameId = param.gameId, onAction = param.onAction, isRtl = param.isRtl;
    var ref;
    var ref1 = (0,react.useState)(null), lockPath = ref1[0], setLockPath = ref1[1];
    var currentPathStep = (0,react.useRef)(null);
    var paths = (0,react.useRef)(new Map());
    var ref2 = (0,react.useState)(false), isFinish = ref2[0], setIsFinish = ref2[1];
    var ref3 = (0,react.useState)(false), isEnablePreviousStep = ref3[0], setIsEnablePreviousStep = ref3[1];
    (0,react.useEffect)(function() {
        var ref, ref1;
        if ((currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.triggerItem) !== -1 && (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.triggerType)) {
            setIsEnablePreviousStep(lockPath === null || lockPath === void 0 ? void 0 : lockPath.previousStep);
        } else {
            setIsEnablePreviousStep(false);
        }
    }, [
        currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current
    ]);
    (0,hooks/* useGlobalDOMEvents */.AG)({
        keyup: function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(ev) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(ev.code === "Space")) {
                                _ctx.next = 3;
                                break;
                            }
                            _ctx.next = 3;
                            return handleNextStep();
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(ev) {
                return _ref.apply(this, arguments);
            };
        }()
    }, [
        vsObjects,
        allTags
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var goToNextStep = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, nextStepId, ref2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        nextStepId = currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : (ref1 = ref.next) === null || ref1 === void 0 ? void 0 : ref1.id;
                        if (nextStepId && paths.current.has(nextStepId)) {
                            ;
                            currentPathStep.current = paths === null || paths === void 0 ? void 0 : (ref2 = paths.current) === null || ref2 === void 0 ? void 0 : ref2.get(nextStepId);
                        } else {
                            setIsFinish(true);
                        }
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function goToNextStep() {
            return _ref.apply(this, arguments);
        };
    }();
    var goToPreviousStep = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, prevStepId, ref2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        prevStepId = currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : (ref1 = ref.prev) === null || ref1 === void 0 ? void 0 : ref1.id;
                        if (prevStepId) {
                            ;
                            currentPathStep.current = paths === null || paths === void 0 ? void 0 : (ref2 = paths.current) === null || ref2 === void 0 ? void 0 : ref2.get(prevStepId);
                        } else {
                            setIsEnablePreviousStep(false);
                        }
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function goToPreviousStep() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (gamePaths) {
            setLockPath(gamePaths);
        }
    }, [
        gamePaths
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (clickedElement && (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.locationItem.toString()) === clickedElement.id.toString() && (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.locationType) === clickedElement.type) {
            goToNextStep();
        }
    }, [
        clickedElement
    ]);
    var createPath = function(items, triggerType, triggerItem) {
        var ref;
        var step = lockPath === null || lockPath === void 0 ? void 0 : (ref = lockPath.paths) === null || ref === void 0 ? void 0 : ref.find(function(path) {
            return path.triggerType === triggerType && path.triggerItem === triggerItem;
        });
        if (!step) return items;
        var next = lockPath.paths.find(function(path) {
            return path.triggerType === step.locationType && path.triggerItem === step.locationItem;
        });
        var prev = lockPath.paths.find(function(path) {
            return path.locationType === step.triggerType && path.locationItem === step.triggerItem;
        });
        if (!triggerType) {
            currentPathStep.current = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, step), {
                prev: prev || null,
                next: next && next.id !== step.id ? next : null
            });
        }
        items.set(step.id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, step), {
            prev: prev || null,
            next: next && next.id !== step.id ? next : null
        }));
        return next && !items.get(next.id) ? createPath(items, next.triggerType, next.triggerItem) : items;
    };
    var rotateCameraTo = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(t) {
            var THREE, l, d, a, r, o, s, u, f, p, m, b, h, g;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,dist/* iTHREE */.Sc)();
                    case 3:
                        THREE = _ctx.sent;
                        l = function(value) {
                            return value * Math.PI / 180;
                        };
                        d = new THREE.Vector3(0, 0, -1);
                        _ctx.next = 8;
                        return showcase.mpSDK.Camera.getPose();
                    case 8:
                        a = _ctx.sent;
                        r = new THREE.Euler(l(a.rotation.x), l(a.rotation.y), 0, "XYZ");
                        o = d.clone().applyEuler(r);
                        s = new THREE.Vector3(a.position.x, a.position.y, a.position.z);
                        u = t.clone();
                        f = o.clone().normalize();
                        p = u.clone().sub(s).normalize();
                        m = new THREE.Vector3(f.x, 0, f.z);
                        b = new THREE.Vector3(p.x, 0, p.z);
                        h = m.angleTo(b);
                        g = f.x * p.z - f.z * p.x < 0 ? -1 : 1;
                        _ctx.next = 21;
                        return showcase.mpSDK.Camera.rotate(180 * h / Math.PI * g);
                    case 21:
                        _ctx.next = 26;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    23
                ]
            ]);
        }));
        return function rotateCameraTo(t) {
            return _ref.apply(this, arguments);
        };
    }();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var moveToPathStepElement = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(type, value) {
            var pathSweep, obj, allTagsArray, ref, THREE, transitionType;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        pathSweep = sweeps.find(function(sweep) {
                            var ref;
                            return (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.sweepUuid) === sweep.uuid;
                        });
                        ;
                        _ctx.t0 = type;
                        _ctx.next = _ctx.t0 === GameBook/* ChapterType.Tag */._U.Tag ? 5 : _ctx.t0 === GameBook/* ChapterType.Polygon */._U.Polygon ? 8 : _ctx.t0 === GameBook/* ChapterType.VSImage */._U.VSImage ? 10 : _ctx.t0 === GameBook/* ChapterType.VSVideo */._U.VSVideo ? 12 : _ctx.t0 === GameBook/* ChapterType.VSItem */._U.VSItem ? 14 : 16;
                        break;
                    case 5:
                        allTagsArray = Array.from(allTags, function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), v = _param[1];
                            return v;
                        });
                        obj = allTagsArray.find(function(item) {
                            return value === (item === null || item === void 0 ? void 0 : item.id) || value === (item === null || item === void 0 ? void 0 : item.defaultSid) || value === (item === null || item === void 0 ? void 0 : item.sid);
                        });
                        return _ctx.abrupt("break", 17);
                    case 8:
                        obj = polygons.find(function(item) {
                            return value === item.id;
                        });
                        return _ctx.abrupt("break", 17);
                    case 10:
                        obj = vsObjects.find(function(item) {
                            return (0,src_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP) && value === item.id;
                        });
                        return _ctx.abrupt("break", 17);
                    case 12:
                        obj = vsObjects.find(function(item) {
                            return (0,src_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up) && value === item.id;
                        });
                        return _ctx.abrupt("break", 17);
                    case 14:
                        obj = vsObjects.find(function(item) {
                            return (0,src_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && value === item.id;
                        });
                        return _ctx.abrupt("break", 17);
                    case 16:
                        return _ctx.abrupt("break", 17);
                    case 17:
                        if (!(obj && pathSweep)) {
                            _ctx.next = 27;
                            break;
                        }
                        ;
                        _ctx.next = 21;
                        return (0,dist/* iTHREE */.Sc)();
                    case 21:
                        THREE = _ctx.sent;
                        transitionType = (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.transitionType) || Game/* GameLockPathTransitionType.INSTANT */.KO.INSTANT;
                        _ctx.next = 25;
                        return showcase.mpSDK.Sweep.moveTo(pathSweep.uuid, {
                            transition: showcase.mpSDK.Sweep.Transition[transitionType === null || transitionType === void 0 ? void 0 : transitionType.toUpperCase()]
                        });
                    case 25:
                        _ctx.next = 27;
                        return rotateCameraTo(new THREE.Vector3(obj.positionX, obj.positionY, obj.positionZ));
                    case 27:
                        return _ctx.abrupt("return", obj);
                    case 28:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function moveToPathStepElement(type, value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNextStep = (0,react.useCallback)((0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, ref1, vsElement;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return moveToPathStepElement(currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.locationType, currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.locationItem);
                case 3:
                    vsElement = _ctx.sent;
                    if (lockPath === null || lockPath === void 0 ? void 0 : lockPath.autoOpenDestination) {
                        onAction(vsElement, currentPathStep.current.locationType);
                    }
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        moveToPathStepElement
    ]);
    var handlePreviousStep = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, vsElement;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return goToPreviousStep();
                    case 3:
                        _ctx.next = 5;
                        return moveToPathStepElement(currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.locationType, currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.locationItem);
                    case 5:
                        vsElement = _ctx.sent;
                        if (lockPath === null || lockPath === void 0 ? void 0 : lockPath.autoOpenDestination) {
                            onAction(vsElement, currentPathStep.current.locationType);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePreviousStep() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var ref;
        if (lockPath && !((ref = paths.current) === null || ref === void 0 ? void 0 : ref.size)) {
            paths.current = createPath(new Map(), null, -1);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lockPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current) && !isFinish && lockPath && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameLockPathModal/* GameLockPathModal */.S, {
            isRtl: isRtl,
            pathLockId: lockPath === null || lockPath === void 0 ? void 0 : lockPath.id,
            gameId: gameId,
            pathSettings: lockPath.pathSetting,
            handleNextStep: handleNextStep,
            handlePreviousStep: handlePreviousStep,
            translationGo: translationGo,
            description: currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.description,
            isEnablePreviousStep: isEnablePreviousStep && lockPath.previousStep
        })
    });
};

// EXTERNAL MODULE: ./components/tour/game/GameBookHandle/index.tsx + 40 modules
var GameBookHandle = __webpack_require__(25406);
// EXTERNAL MODULE: ./_helpers/renderDebug.ts
var renderDebug = __webpack_require__(66725);
// EXTERNAL MODULE: ./_helpers/storage.ts
var storage = __webpack_require__(98144);
// EXTERNAL MODULE: ./components/types.ts
var types = __webpack_require__(31828);
// EXTERNAL MODULE: ./components/tour/regular/menu/menuService.ts
var menuService = __webpack_require__(45019);
;// CONCATENATED MODULE: ./utils/getRPMModelId.ts
var getRPMModelId = function(url) {
    return url.substring(url.lastIndexOf("/") + 1).split(".glb").at(0);
};

;// CONCATENATED MODULE: ./utils/getProjectedQuaternion.ts
var getProjectedQuaternion = function(pos, target, axisVec, THREE) {
    var dir = new THREE.Vector3();
    dir.subVectors(target, pos).normalize();
    dir.projectOnPlane(axisVec);
    var mx = new THREE.Matrix4().lookAt(dir, new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 1, 0));
    return new THREE.Quaternion().setFromRotationMatrix(mx);
};

;// CONCATENATED MODULE: ./components/tour/BaseTour.tsx













/* eslint-disable no-return-await */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable class-methods-use-this */ /* eslint-disable no-unused-expressions */ /* eslint-disable @typescript-eslint/no-shadow */ /* eslint-disable radix */ /* eslint-disable no-nested-ternary */ /* eslint-disable no-empty */ /* eslint-disable consistent-return */ /* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable @typescript-eslint/no-empty-function */ /* eslint-disable no-console */ /* eslint-disable react/no-unused-state */ 



































































var ExperiencePopUp = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1606).then(__webpack_require__.bind(__webpack_require__, 61606));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61606)
            ];
        }
    },
    ssr: false
});
var Qualtrics = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7749).then(__webpack_require__.bind(__webpack_require__, 27749));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27749)
            ];
        }
    },
    ssr: false
});
var IntroScreen = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 284).then(__webpack_require__.bind(__webpack_require__, 284));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(284)
            ];
        }
    },
    ssr: false
});
var Sweep = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(5908)]).then(__webpack_require__.bind(__webpack_require__, 75908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75908)
            ];
        }
    },
    ssr: false
});
var Share = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5290).then(__webpack_require__.bind(__webpack_require__, 95290));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95290)
            ];
        }
    },
    ssr: false
});
var Login = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4207).then(__webpack_require__.bind(__webpack_require__, 14207));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14207)
            ];
        }
    },
    ssr: false
});
var MenuWithSidebarState = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(522), __webpack_require__.e(4904), __webpack_require__.e(3003)]).then(__webpack_require__.bind(__webpack_require__, 43003));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43003)
            ];
        }
    },
    ssr: false
});
var Terms = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 117).then(__webpack_require__.bind(__webpack_require__, 90117));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90117)
            ];
        }
    },
    ssr: false
});
var Help = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9493).then(__webpack_require__.bind(__webpack_require__, 49493));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49493)
            ];
        }
    },
    ssr: false
});
var Ad = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5579).then(__webpack_require__.bind(__webpack_require__, 15579));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15579)
            ];
        }
    },
    ssr: false
});
var CollectLeadsForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5137).then(__webpack_require__.bind(__webpack_require__, 45137));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45137)
            ];
        }
    },
    ssr: false
});
var RenderTicketingContent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1449).then(__webpack_require__.bind(__webpack_require__, 31449));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31449)
            ];
        }
    },
    ssr: false
});
var IntroPopup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(522), __webpack_require__.e(7311), __webpack_require__.e(614), __webpack_require__.e(9963), __webpack_require__.e(1604)]).then(__webpack_require__.bind(__webpack_require__, 39963)).then(function(res) {
        return res.IntroPopup;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39963)
            ];
        }
    },
    ssr: false
});
var TicketingRouter = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1607), __webpack_require__.e(4762), __webpack_require__.e(7361)]).then(__webpack_require__.bind(__webpack_require__, 17361));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17361)
            ];
        }
    },
    ssr: false
});
var SketchfabPopup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7441), __webpack_require__.e(378)]).then(__webpack_require__.bind(__webpack_require__, 10378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10378)
            ];
        }
    },
    ssr: false
});
var Minimap = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5995), __webpack_require__.e(7268)]).then(__webpack_require__.bind(__webpack_require__, 7268));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7268)
            ];
        }
    },
    ssr: false
});
var Panorama = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9991).then(__webpack_require__.bind(__webpack_require__, 29991));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29991)
            ];
        }
    },
    ssr: false
});
var ContactPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1055).then(__webpack_require__.bind(__webpack_require__, 11055));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11055)
            ];
        }
    },
    ssr: false
});
var ExternalPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3777).then(__webpack_require__.bind(__webpack_require__, 93777));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93777)
            ];
        }
    },
    ssr: false
});
var PanoPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6484).then(__webpack_require__.bind(__webpack_require__, 66484));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66484)
            ];
        }
    },
    ssr: false
});
var PathFinderPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4889).then(__webpack_require__.bind(__webpack_require__, 4889));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4889)
            ];
        }
    },
    ssr: false
});
var TagsPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6099).then(__webpack_require__.bind(__webpack_require__, 56099));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56099)
            ];
        }
    },
    ssr: false
});
var VSActionsPopup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5935), __webpack_require__.e(7691)]).then(__webpack_require__.bind(__webpack_require__, 67691));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67691)
            ];
        }
    },
    ssr: false
});
var Countdown = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5360).then(__webpack_require__.bind(__webpack_require__, 45360));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45360)
            ];
        }
    },
    ssr: false
});
var MessengerCustomerChat = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9538).then(__webpack_require__.bind(__webpack_require__, 89538));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89538)
            ];
        }
    },
    ssr: false
});
var MemoizedVideo = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(522), __webpack_require__.e(8635), __webpack_require__.e(1607), __webpack_require__.e(6050), __webpack_require__.e(9413), __webpack_require__.e(640)]).then(__webpack_require__.bind(__webpack_require__, 30640));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30640)
            ];
        }
    },
    ssr: false
});
var Appointment = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5391).then(__webpack_require__.bind(__webpack_require__, 75391));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75391)
            ];
        }
    },
    ssr: false
});
var BottomBarWithRecoil = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4610).then(__webpack_require__.bind(__webpack_require__, 24610));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24610)
            ];
        }
    },
    ssr: false
});
var DEFAULT_VS_SENSOR_RADIUS = deviceManager/* default.isMobile */.Z.isMobile() ? 25 : 25;
var BaseTour = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,src_inherits/* default */.Z)(BaseTour, PureComponent);
    var _super = (0,src_create_super/* default */.Z)(BaseTour);
    function BaseTour(props, tourType) {
        (0,src_class_call_check/* default */.Z)(this, BaseTour);
        var _this;
        _this = _super.call(this, props);
        _this.ticketValidSweepsHistory = [];
        _this.ticketTimeout = null;
        _this.messengerQ = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "messenger");
        _this.defaultSweep = null;
        _this.avatarNodes = new Map();
        _this.playAudioTimeout = null;
        _this.mainContainerWaitingForPlay = false;
        _this.pose = {};
        _this.floor = new FRFloor({
            floor: 0,
            position: null
        });
        _this.messenger = parseInt(_this.messengerQ === false ? "1" : _this.messengerQ, 10);
        _this.visibleTags = {};
        _this.hiddenTags = {};
        _this.modelNodes = [];
        _this.vsObjects = [];
        _this.isMobile = deviceManager/* default.isMobile */.Z.isMobile();
        _this.avatarDegree = null;
        _this.connectedAvatarsLastSweep = [] // previous sweep for all other avatars in tour
        ;
        _this.connectedAvatarsTweens = [] // amount of active animations for all other avatars in tour
        ;
        _this.camera = null;
        _this.isShadowEnabled = false;
        _this.gameAnalytic = null;
        _this.animate = function() {
            requestAnimationFrame(_this.animate);
            tween_module_min/* TWEEN.update */.w.update();
        };
        _this.didAvatarSweepChange = function(avatarId, newSweepId) {
            var shouldAnimationPlay;
            var avatarLastSweepIndex = _this.connectedAvatarsLastSweep.findIndex(function(obj) {
                return obj && obj.id === avatarId;
            });
            if (avatarLastSweepIndex !== -1) {
                var targetAvatarLastSweep = _this.connectedAvatarsLastSweep[avatarLastSweepIndex];
                shouldAnimationPlay = targetAvatarLastSweep.sweepId !== newSweepId;
                _this.connectedAvatarsLastSweep[avatarLastSweepIndex].sweepId = newSweepId;
            } else {
                shouldAnimationPlay = true;
                _this.connectedAvatarsLastSweep.push({
                    id: avatarId,
                    sweepId: newSweepId
                });
            }
            return shouldAnimationPlay;
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getCameraRotation = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        return _ctx.abrupt("return", {
                            rotation: (ref = _this1.camera) === null || ref === void 0 ? void 0 : ref.rotation,
                            quaternion: (ref1 = _this1.camera) === null || ref1 === void 0 ? void 0 : ref1.quaternion
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        _this.renderCrashScreen = function() {
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_CrashScreen, {
                show: _this.state.crashScreen,
                backgroundImage: "".concat("https://cdn.treedis.com", "/tours/").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : ref.id, "/images/").concat((ref1 = _this.state.tour) === null || ref1 === void 0 ? void 0 : ref1.mainImage)
            });
        };
        _this.showTicketTimeIsOutPopup = function() {
            _this.setState({
                infoModalData: {
                    mode: InfoModal/* EInfoModal.timeIsUp */.Y.timeIsUp,
                    onRequestClose: function() {
                        stopApp();
                    }
                }
            });
        };
        _this.showTicketRestrictedAreaPopup = function(param) {
            var sweepThatCauseTicketRestriction = param.sweepThatCauseTicketRestriction, reelThatCauseTicketRestriction = param.reelThatCauseTicketRestriction;
            _this.setState({
                infoModalData: {
                    mode: InfoModal/* EInfoModal.restrictedArea */.Y.restrictedArea,
                    onRequestClose: function() {
                        if (sweepThatCauseTicketRestriction) _this.goToPreviousValidSweep();
                    },
                    sweepThatCauseTicketRestriction: sweepThatCauseTicketRestriction,
                    reelThatCauseTicketRestriction: reelThatCauseTicketRestriction
                }
            });
        };
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.goToPreviousValidSweep = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, THREE;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if ((ref = _this2.ticketValidSweepsHistory) === null || ref === void 0 ? void 0 : ref.length) {
                            THREE = _this2.THREE;
                            _this2.moveToSweep(_this2.ticketValidSweepsHistory[_this2.ticketValidSweepsHistory.length - 1], new THREE.Euler());
                        } else {
                            stopApp();
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        _this.ticketUpdateSweepLoc = function(nextSweep) {
            var ref, ref1, ref2, ref3;
            if (((ref = _this.state.tour) === null || ref === void 0 ? void 0 : ref.ticket) && ((ref1 = _this.state) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticketing) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticketingOrderedTicket) === null || ref3 === void 0 ? void 0 : ref3.ticketType) === "tourByYourself") {
                var ref4;
                var ticketingTourTicket = _this.state.ticketing.ticketingTourTicket;
                var allowedSweeps = ticketingTourTicket.selectedSweeps ? ticketingTourTicket.selectedSweeps[(ref4 = _this.state.tour) === null || ref4 === void 0 ? void 0 : ref4.slug] : [];
                if (allowedSweeps.includes(nextSweep)) {
                    _this.ticketValidSweepsHistory.push(nextSweep);
                } else {
                    _this.showTicketRestrictedAreaPopup({
                        sweepThatCauseTicketRestriction: nextSweep
                    });
                }
            }
        };
        var _this3 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onPlayClick = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var _state, tour, showIntro, _$tourType, showcaseLoaded;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _state = _this3.state, tour = _state.tour, showIntro = _state.showIntro, _$tourType = _state.tourType, showcaseLoaded = _state.showcaseLoaded;
                            _ctx.prev = 1;
                            _this3.setState({
                                showIntroScreenSpinner: true
                            });
                            if (!((tour === null || tour === void 0 ? void 0 : tour.id) && (tour === null || tour === void 0 ? void 0 : tour.collectLeads) && _$tourType !== Tour/* TourType.Game */.v.Game)) {
                                _ctx.next = 17;
                                break;
                            }
                            _ctx.prev = 4;
                            (0,analytic/* sendToGA */.o$)("event", {
                                eventCategory: "Lead",
                                eventAction: "submit",
                                eventLabel: "entry"
                            });
                            if (Tour/* TourType.Game */.v.Game === _$tourType) {
                                _this3.handleGameStartOnIntroModal(data.name);
                            }
                            if (showIntro) {
                                _this3.setState({
                                    showIntroScreen: false
                                }, function() {
                                    _this3.processTourMusic(tour);
                                // this.handleToggleMusic();
                                });
                            } else {
                                _this3.setState({
                                    showIntroScreen: false,
                                    forcePlayGameIntro: true
                                }, function() {
                                    if (!_this3.state.showIntro && !_this3.state.showIntroScreen && _this3.state.showcaseLoaded) {
                                        _this3.processTourMusic(tour);
                                    // this.handleToggleMusic();
                                    // this.tourAudio.play();
                                    }
                                });
                            }
                            _ctx.next = 10;
                            return (0,util_all/* fetchData */.rQ)("public/setTourLead", "POST", (0,_object_spread/* default */.Z)({
                                tourId: tour.id
                            }, data));
                        case 10:
                            _ctx.next = 12;
                            return _this3.handleCollectLeadsSubmit(data);
                        case 12:
                            _ctx.next = 17;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](4);
                            console.error(_ctx.t0.message);
                        case 17:
                            if (Tour/* TourType.Game */.v.Game === _$tourType) {
                                _this3.handleGameStartOnIntroModal(data.name);
                            }
                            if (showIntro) {
                                _this3.setState({
                                    showIntroScreen: false
                                }, function() {
                                    if (showcaseLoaded) {
                                        // this.processTourMusic(tour);
                                        _this3.handleToggleMusic();
                                    }
                                });
                            } else {
                                _this3.setState({
                                    showIntroScreen: false,
                                    forcePlayGameIntro: true
                                }, function() {
                                    if (showcaseLoaded) {
                                        _this3.processTourMusic(tour);
                                    // this.handleToggleMusic();
                                    // this.tourAudio.play();
                                    }
                                });
                            }
                            (0,analytic/* sendToGA */.o$)("event", {
                                eventCategory: "IntroScreen",
                                eventAction: "click",
                                eventLabel: "introButton"
                            });
                        case 20:
                            _ctx.prev = 20;
                            _this3.setState({
                                showIntroScreenSpinner: false
                            });
                            return _ctx.finish(20);
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        ,
                        20,
                        23
                    ],
                    [
                        4,
                        14
                    ]
                ]);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this4 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleCollectLeadsSubmit = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var _state, tour, tourEmail;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _state = _this4.state, tour = _state.tour, tourEmail = _state.tourEmail;
                            _ctx.next = 3;
                            return TreedisPublicDAO/* default.sendEmail */.Z.sendEmail({
                                data: {
                                    to: tourEmail && tourEmail.leadForms || tour.client && tour.client.email,
                                    params: Object.assign(data, {
                                        tour: tour.title,
                                        userId: tour.userId,
                                        link: window.location.href
                                    })
                                }
                            });
                        case 3:
                            _this4.loadData(tour);
                            _this4.setState({
                                showCollectLeadsModal: false
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.onTicketLoginSuccess = function(tour, ticketing) {
            var ticketingOrderedTicket = ticketing.ticketingOrderedTicket, ticketingTourTicket = ticketing.ticketingTourTicket;
            var ticketLimitMs = ticketingTourTicket.duration * 60 * 1000;
            var ticketSpentFromLogin = Number(new Date(ticketingOrderedTicket.loginDate)) ? Date.now() - Number(new Date(ticketingOrderedTicket.loginDate)) : 0;
            var ticketTimeLeft = ticketLimitMs - ticketSpentFromLogin;
            // set time is up timeout with popup
            if (ticketTimeLeft > 0) {
                react_toastify_esm/* toast.success */.Am.success("logged in");
                setTimeout(_this.showTicketTimeIsOutPopup, ticketTimeLeft);
                _this.setState({
                    ticketTimeLeftMs: ticketTimeLeft,
                    ticketingOpen: false,
                    tour: tour,
                    ticketing: ticketing
                });
                _this.loadData(tour);
                _this.setWhiteLabel(tour);
                socket/* default.emit */.Z.emit("ticketing_login", {
                    ticketingOrderedTicket: ticketingOrderedTicket,
                    deviceId: (0,utils/* getDeviceFingerprint */.UI)(),
                    reel: tour.slug
                });
            } else {
                react_toastify_esm/* toast.error */.Am.error("wrong ticket time left");
                _this.showTicketTimeIsOutPopup();
            }
        };
        _this.handleTicketingReel = function(reel) {
            try {
                if (_this.state.ticketing && reel.type === "treedis") {
                    var url = new URL(reel.url);
                    var urlPathnameArr = url.pathname.split("/");
                    if (urlPathnameArr[1] === "tour") socket/* default.emit */.Z.emit("ticketing_reel", {
                        reel: urlPathnameArr[2]
                    });
                }
            } catch (err) {
                console.warn("handleTicketingReel", err);
            }
        };
        var _this5 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getTour = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var id, _changeMenu, changeMenu, _changeMinimap, changeMinimap, _changePanorama, changePanorama, _url, url, _hideIntroScreen, hideIntroScreen, tourData, ref, ref1, ref2, ref3, ref4, data, ref5, tour, tGen, tour1, ticket, iframeId, s, x, y, menuOpenForDevice;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            id = param.id, _changeMenu = param.changeMenu, changeMenu = _changeMenu === void 0 ? true : _changeMenu, _changeMinimap = param.changeMinimap, changeMinimap = _changeMinimap === void 0 ? true : _changeMinimap, _changePanorama = param.changePanorama, changePanorama = _changePanorama === void 0 ? true : _changePanorama, _url = param.url, url = _url === void 0 ? null : _url, _hideIntroScreen = param.hideIntroScreen, hideIntroScreen = _hideIntroScreen === void 0 ? false : _hideIntroScreen, tourData = param.tourData;
                            _this5.setState({
                                showcaseLoaded: !changeMenu
                            });
                            _ctx.prev = 2;
                            ;
                            _this5.loadingQueue.setLoadingQueueProgress(90, 100);
                            _ctx.t0 = tourData;
                            if (_ctx.t0) {
                                _ctx.next = 10;
                                break;
                            }
                            _ctx.next = 9;
                            return TreedisPublicDAO/* default.getTour */.Z.getTour({
                                data: {
                                    id: id,
                                    mode: _this5.state.tourType,
                                    excludeTranslation: true
                                }
                            });
                        case 9:
                            _ctx.t0 = _ctx.sent;
                        case 10:
                            data = _ctx.t0;
                            _this5.loadingQueue.setLoadingQueueProgress(85, 100);
                            if (data.tour) {
                                _ctx.next = 15;
                                break;
                            }
                            react_toastify_esm/* toast.error */.Am.error("Couldn't find this tour in our databases");
                            return _ctx.abrupt("return");
                        case 15:
                            if (data.tour.fontFamily) {
                                document.documentElement.style.setProperty("--custom-font-family", "".concat(data.tour.fontFamily));
                            }
                            _this5.setWhiteLabel(data.tour);
                            _this5.initTourInfo(data.tour.id);
                            if (data.tour.menuEnabled) {
                                (0,menuService/* fetchMenuData */.g)(data.tour.id).then(function(data) {
                                    _this5.setState({
                                        menuSettings: data.menuSettings,
                                        menus: data.menus
                                    });
                                });
                            }
                            if ((data === null || data === void 0 ? void 0 : (ref = data.tour) === null || ref === void 0 ? void 0 : ref.languageCode) === 51 || (data === null || data === void 0 ? void 0 : (ref1 = data.tour) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.initialDuplicates) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && ((ref4 = data === null || data === void 0 ? void 0 : (ref3 = data.tour) === null || ref3 === void 0 ? void 0 : ref3.initialDuplicates[0]) === null || ref4 === void 0 ? void 0 : ref4.languageCode) === "fr") {
                                window.localStorage.setItem("rightPriceSymbol", "1");
                            } else {
                                window.localStorage.removeItem("rightPriceSymbol");
                            }
                            if (!(data.ticketing && !_this5.state.iframeUrl)) {
                                _ctx.next = 24;
                                break;
                            }
                            {
                                ;
                                tour = new Tour/* Tour */.Oj(data.tour);
                                tGen = data === null || data === void 0 ? void 0 : (ref5 = data.ticketing) === null || ref5 === void 0 ? void 0 : ref5.ticketingGeneral;
                                // if (this.state.game) this.loadData(data.tour);
                                _this5.setState({
                                    tour: tour,
                                    ticketingOpen: true,
                                    ticketing: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.ticketing), {
                                        ticketingGeneral: (tGen === null || tGen === void 0 ? void 0 : tGen.length) ? tGen[0] : tGen
                                    }),
                                    tourLoaded: true
                                });
                            }
                            _ctx.next = 44;
                            break;
                        case 24:
                            if (!(data.tour.collectLeads && !data.tour.introScreen && !_this5.state.iframeUrl)) {
                                _ctx.next = 28;
                                break;
                            }
                            {
                                tour1 = new Tour/* Tour */.Oj(data.tour);
                                _this5.setState({
                                    tour: tour1,
                                    showCollectLeadsModal: true
                                });
                            }
                            _ctx.next = 44;
                            break;
                        case 28:
                            if (!url) {
                                _ctx.next = 43;
                                break;
                            }
                            if (data.ticketing && _this5.state.iframeUrl) {
                                ticket = new URLSearchParams(window.location.search).get("ticket");
                                if (!ticket || ticket.length === 0) window.location.href = window.location.href.replace(/tour.*/, "tour/".concat(data.tour.slug));
                            }
                            iframeId = (0,util_all/* getQueryVariable */.Dv)(_this5.state.iframeUrl, "m");
                            s = (0,util_all/* getQueryVariable */.Dv)(url, "s");
                            x = (0,util_all/* getQueryVariable */.Dv)(url, "x");
                            y = (0,util_all/* getQueryVariable */.Dv)(url, "y");
                            if (iframeId !== data.tour.matterId) {
                                _this5.setState({
                                    isChangeIframe: true
                                });
                            }
                            if (hideIntroScreen) {
                                data.tour.introScreen = null;
                            }
                            if (!(iframeId == data.tour.matterId && s && x && y)) {
                                _ctx.next = 43;
                                break;
                            }
                            menuOpenForDevice = _this5.state.tourType === Tour/* TourType.Regular */.v.Regular && !!(deviceManager/* default.isMobile */.Z.isMobile() ? data.tour.menuAlwaysOpenMobile : data.tour.menuAlwaysOpenDesktop);
                            _this5.setState({
                                menuOpen: changeMenu ? menuOpenForDevice : _this5.state.menuOpen,
                                showcaseLoaded: true
                            });
                            if (!_this5.showcase.App.Phase.PLAYING.includes(_this5.state.appState)) {
                                _ctx.next = 42;
                                break;
                            }
                            _ctx.next = 42;
                            return _this5.moveToSweep(String(s), {
                                x: parseFloat(x),
                                y: parseFloat(y)
                            });
                        case 42:
                            return _ctx.abrupt("return");
                        case 43:
                            _this5.loadData(data.tour, changeMenu, changeMinimap, changePanorama, url);
                        case 44:
                            _ctx.next = 49;
                            break;
                        case 46:
                            _ctx.prev = 46;
                            _ctx.t1 = _ctx["catch"](2);
                            console.error(_ctx.t1.message);
                        case 49:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        46
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.initTourInfo = function(id) {
            (0,util_all/* fetchData */.rQ)("public/getTranslations/".concat(id), "GET").then(function(data) {
                _this.setState({
                    translation: data.translations
                });
            }).catch(function(err) {
                console.error(err.message);
            });
            (0,util_all/* fetchData */.rQ)("public/getEmails/".concat(id), "GET").then(function(data) {
                _this.setState({
                    tourEmail: data.emails
                });
            }).catch(function(err) {
                console.error(err.message);
            });
        };
        _this.getTagIconId = function(tag) {
            var iconName = tag.iconFile || (tag.customIcon === "null" || tag.customIcon === null ? null : tag.customIcon);
            var iconSid = tag.sid;
            if (iconName && iconSid) {
                return "".concat(iconName, "_").concat(iconSid);
            }
            return null;
        };
        var _this6 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addMattertag = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tag) {
                var sid, media, rgb, addDetails, addRes;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            sid = null;
                            _ctx.prev = 1;
                            ;
                            if (tag.media) {
                                media = {
                                    src: tag.media.src,
                                    type: "mattertag.media.".concat(tag.media.type.toLowerCase())
                                };
                            }
                            rgb = util_all/* hexToRgb */.oo(tag.iconColor);
                            addDetails = {
                                label: tag.title,
                                description: tag.description,
                                anchorPosition: {
                                    x: tag.positionX,
                                    y: tag.positionY,
                                    z: tag.positionZ
                                },
                                stemVector: {
                                    x: tag.stemVectorX || 0,
                                    y: tag.stemVectorY == null ? 0.3 : tag.stemVectorY,
                                    z: tag.stemVectorZ || 0
                                },
                                color: {
                                    r: rgb.r / 255,
                                    g: rgb.g / 255,
                                    b: rgb.b / 255
                                },
                                iconId: _this6.getTagIconId(tag),
                                media: media
                            };
                            _ctx.next = 8;
                            return _this6.showcase.Mattertag.add(addDetails).catch(function(e) {
                                console.error(e);
                            });
                        case 8:
                            addRes = _ctx.sent;
                            if (!(addRes && addRes[0])) {
                                _ctx.next = 14;
                                break;
                            }
                            // eslint-disable-next-line prefer-destructuring
                            tag.sid = addRes[0];
                            _ctx.next = 13;
                            return _this6.editTagMedia(tag);
                        case 13:
                            return _ctx.abrupt("return", tag.sid);
                        case 14:
                            _ctx.next = 19;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](1);
                            console.error(_ctx.t0);
                        case 19:
                            return _ctx.abrupt("return", sid);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        16
                    ]
                ]);
            }));
            return function(tag) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this7 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.registerIcon = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var iconId, url;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            iconId = param.iconId, url = param.url;
                            _ctx.next = 3;
                            return _this7.showcase.Mattertag.registerIcon(iconId, url).catch(function(e) {
                                console.error(e);
                            });
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this8 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.editTagMedia = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tag) {
                var tour, label, description, media, size;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            tour = _this8.state.tour;
                            if (tag) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 3:
                            if (!(tag.opacity !== null && typeof tag.opacity === "number")) {
                                _ctx.next = 6;
                                break;
                            }
                            _ctx.next = 6;
                            return _this8.showcase.Mattertag.editOpacity(tag.sid, tag.opacity / 100).catch(function(e) {
                                console.error(e);
                            });
                        case 6:
                            label = tag.mpTitle ? tag.title : "";
                            description = tag.description;
                            if (!(tag.embedMedia && tag.enabled)) {
                                _ctx.next = 20;
                                break;
                            }
                            media = null;
                            size = _this8.isMobile ? {
                                w: tag.widthMobile || 300,
                                h: tag.heightMobile || 400
                            } : {
                                w: tag.width || 700,
                                h: tag.height || 500
                            };
                            if (tag.type === Tag/* TagType.Image */.Qy.Image) {
                                media = {
                                    type: _this8.showcase.Mattertag.MediaType.PHOTO,
                                    src: "".concat("https://cdn.treedis.com", "/tours/").concat(tour === null || tour === void 0 ? void 0 : tour.id, "/tags/").concat(tag.url)
                                };
                            }
                            if (tag.type === Tag/* TagType.Gallery */.Qy.Gallery) {
                            // TODO
                            }
                            if (tag.type === Tag/* TagType.Video */.Qy.Video) {
                                if ((0,util_all/* isVimeoUrl */.QD)(tag.url) && deviceManager/* default.isChrome */.Z.isChrome() && !deviceManager/* default.isIOS */.Z.isIOS()) {
                                    // FullScreen mode for this condition is not allow
                                    _this8.showcase.Mattertag.injectHTML(tag.sid, '<iframe\n              id="tagvideo"\n              allowFullScreen\n              allow="autoplay; fullscreen"\n              src='.concat((0,util_all/* getVideoLink */.rp)(tag.url, {
                                        autoplay: tag.autoPlay
                                    }), ' \n              frameBorder="0"\n              style="width: 100%;height: 95%;position: fixed;"\n              scrolling="no"\n            ></iframe>'));
                                } else {
                                    media = {
                                        type: _this8.showcase.Mattertag.MediaType.VIDEO,
                                        src: tag.url
                                    };
                                }
                            }
                            if (tag.type === Tag/* TagType.Iframe */.Qy.Iframe) {
                                _this8.showcase.Mattertag.injectHTML(tag.sid, "<iframe src=".concat(tag.url, ' style="width: 100%; height: 100vh"></iframe>'), {
                                    size: size
                                });
                            }
                            if (tag.type === Tag/* TagType.Text */.Qy.Text) {
                                _this8.showcase.Mattertag.injectHTML(tag.sid, "<div>".concat(tag.text, "</div>"), {
                                    size: size
                                });
                            }
                            _ctx.next = 18;
                            return _this8.showcase.Mattertag.editBillboard(tag.sid, {
                                label: label,
                                description: description,
                                media: media
                            }).catch(console.error);
                        case 18:
                            _ctx.next = 22;
                            break;
                        case 20:
                            _ctx.next = 22;
                            return _this8.showcase.Mattertag.editBillboard(tag.sid, {
                                label: label,
                                description: description
                            }).catch(console.error);
                        case 22:
                            _ctx.next = 24;
                            return _this8.showcase.Mattertag.preventAction(tag.sid, {
                                // prevent opening: true/false
                                opening: !tag.mpTooltip,
                                navigating: !tag.mpNavigation
                            }).catch(console.error);
                        case 24:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(tag) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this9 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.editMattertag = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tag) {
                var iconId, rgb;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            iconId = _this9.getTagIconId(tag);
                            if (!iconId) {
                                _ctx.next = 7;
                                break;
                            }
                            _ctx.next = 5;
                            return _this9.showcase.Mattertag.editIcon(tag.sid, iconId).catch(function(e) {
                                console.error(e);
                            });
                        case 5:
                            _ctx.next = 9;
                            break;
                        case 7:
                            _ctx.next = 9;
                            return _this9.showcase.Mattertag.resetIcon(tag.sid).catch(function(e) {
                                console.error(e);
                            });
                        case 9:
                            if (!(tag.iconColor && /#\w*/i.test(tag.iconColor))) {
                                _ctx.next = 13;
                                break;
                            }
                            rgb = util_all/* hexToRgb */.oo(tag.iconColor);
                            _ctx.next = 13;
                            return _this9.showcase.Mattertag.editColor(tag.sid, {
                                r: rgb.r / 255,
                                g: rgb.g / 255,
                                b: rgb.b / 255
                            }).catch(console.error);
                        case 13:
                            _ctx.next = 15;
                            return _this9.editTagMedia(tag);
                        case 15:
                            _ctx.next = 20;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error(_ctx.t0);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }));
            return function(tag) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this10 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.processTags = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_tags) {
                var loadedMattertags, allTags, promises;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loadedMattertags = Mattertag.getMatterTags();
                            allTags = _this10.state.allTags;
                            promises = _tags.map(function() {
                                var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tag) {
                                    var editedTag, foundAddTag;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                editedTag = (0,_object_spread/* default */.Z)({}, tag);
                                                if (!(editedTag.modifiedTag && loadedMattertags.has(tag.sid))) {
                                                    _ctx.next = 6;
                                                    break;
                                                }
                                                _ctx.next = 4;
                                                return _this10.editMattertag(editedTag);
                                            case 4:
                                                allTags.set(editedTag.sid, editedTag);
                                                return _ctx.abrupt("return");
                                            case 6:
                                                if (!(!editedTag.modifiedTag && !loadedMattertags.has(tag.sid))) {
                                                    _ctx.next = 15;
                                                    break;
                                                }
                                                foundAddTag = Array.from(allTags, function(param) {
                                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                                    return value;
                                                }).find(function(item) {
                                                    return item.id === tag.id && item.added;
                                                });
                                                if (foundAddTag) {
                                                    _ctx.next = 15;
                                                    break;
                                                }
                                                editedTag.defaultSid = editedTag.sid;
                                                allTags.delete(editedTag.sid);
                                                _ctx.next = 13;
                                                return _this10.addMattertag(editedTag);
                                            case 13:
                                                editedTag.sid = _ctx.sent;
                                                editedTag.added = true;
                                            case 15:
                                                allTags.set(editedTag.sid, editedTag);
                                            case 16:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(tag) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                            _ctx.next = 5;
                            return Promise.all(promises);
                        case 5:
                            return _ctx.abrupt("return", allTags);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(_tags) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this11 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initTags = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_tags) {
                var _loop, tagsSize, i, registerIconsPromises, updatedTags;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _loop = function(i) {
                                var tag = _tags[i];
                                var iconId = _this11.getTagIconId(tag);
                                if (iconId && !_this11.tagIcons.some(function(icon) {
                                    return (icon === null || icon === void 0 ? void 0 : icon.iconId) === iconId;
                                })) {
                                    var tagIconUrl = void 0;
                                    if (tag.iconFile) {
                                        if (tag.iconFile.startsWith("http")) {
                                            tagIconUrl = "".concat(tag.iconFile);
                                        } else {
                                            tagIconUrl = "".concat("https://cdn.treedis.com", "/tours/").concat(tag.tourId, "/tags/icons/").concat(tag.iconFile);
                                        }
                                    } else if (tag.customIcon) {
                                        tagIconUrl = "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(tag.customIcon, "?hex=").concat(encodeURIComponent(tag.iconColor), "&circle=").concat(tag.whiteCircle);
                                    }
                                    _this11.tagIcons.push({
                                        iconId: iconId,
                                        url: tagIconUrl
                                    });
                                }
                            };
                            if (_tags.length) {
                                _ctx.next = 5;
                                break;
                            }
                            _this11.setState({
                                loadingTags: false
                            });
                            return _ctx.abrupt("return", _tags);
                        case 5:
                            tagsSize = _tags.length;
                            _this11.tagIcons = [];
                            for(i = 0; i < tagsSize; i += 1)_loop(i);
                            registerIconsPromises = _this11.tagIcons.map(_this11.registerIcon);
                            _ctx.next = 11;
                            return Promise.all(registerIconsPromises);
                        case 11:
                            _ctx.next = 13;
                            return _this11.processTags(_tags);
                        case 13:
                            updatedTags = _ctx.sent;
                            return _ctx.abrupt("return", updatedTags);
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error(_ctx.t0);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }));
            return function(_tags) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.toggleVisibleTags = function(tags, isVisible) {
            var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
            tags.forEach(function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_tag) {
                    var sid, mpTooltip, mpNavigation, src, preventOpening, preventNavigating;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                sid = _tag.sid, mpTooltip = _tag.mpTooltip, mpNavigation = _tag.mpNavigation;
                                if (sid) {
                                    _ctx.next = 3;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 3:
                                if (!(isVisible && _this1.visibleTags[sid])) {
                                    _ctx.next = 5;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 5:
                                if (isVisible) _this1.visibleTags[sid] = true;
                                else _this1.visibleTags[sid] = false;
                                if (!(!isVisible && _this1.hiddenTags[sid])) {
                                    _ctx.next = 8;
                                    break;
                                }
                                return _ctx.abrupt("return");
                            case 8:
                                if (!isVisible) _this1.hiddenTags[sid] = true;
                                else _this1.hiddenTags[sid] = false;
                                if (_tag.type === Tag/* TagType.Music */.Qy.Music && !isVisible) {
                                    src = "".concat("https://cdn.treedis.com", "/tours/").concat(_this1.state.tour.id, "/tags/").concat(_tag.url);
                                    if (_this1.tagAudio && _this1.tagAudio.src === src) {
                                        _this1.tagAudio.pause();
                                        _this1.tagAudio.src = "";
                                    }
                                }
                                _ctx.next = 12;
                                return _this1.showcase.Mattertag.editOpacity(sid, isVisible ? _tag.opacity / 100 : 0).catch(function(e) {
                                    return console.error(e);
                                });
                            case 12:
                                _ctx.next = 14;
                                return _this1.showcase.Mattertag.editPosition(sid, {
                                    anchorPosition: {
                                        x: _tag.positionX,
                                        y: _tag.positionY,
                                        z: _tag.positionZ
                                    },
                                    stemVector: {
                                        x: isVisible ? _tag.stemVectorX || 0 : 0,
                                        y: isVisible ? _tag.stemVectorY == null ? 0.3 : _tag.stemVectorY : 0,
                                        z: isVisible ? _tag.stemVectorZ || 0 : 0
                                    },
                                    floorIndex: _tag.floor
                                }).catch(function(e) {
                                    console.error("Error edit position with sid: ".concat(sid));
                                    console.error(e);
                                });
                            case 14:
                                preventOpening = isVisible ? !mpTooltip : true;
                                preventNavigating = isVisible ? !mpNavigation : true;
                                _ctx.next = 18;
                                return _this1.showcase.Mattertag.preventAction(sid, {
                                    opening: preventOpening,
                                    navigating: preventNavigating
                                }).catch(function(e) {
                                    return console.error(e);
                                });
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(_tag) {
                    return _ref.apply(this, arguments);
                };
            }());
        };
        _this.getSweepGroupPolygonIdsToHide = function() {
            var _state = _this.state, activeSweepGroup = _state.activeSweepGroup, sweepGroups = _state.sweepGroups, polygons = _state.polygons;
            if (!activeSweepGroup) return [];
            var activeSweepGroupObj = sweepGroups.filter(function(item) {
                return (item === null || item === void 0 ? void 0 : item.id) === activeSweepGroup;
            })[0];
            var activeSweepGroupVsElements = (activeSweepGroupObj === null || activeSweepGroupObj === void 0 ? void 0 : activeSweepGroupObj.vsElements) || [];
            var hidePolygons = activeSweepGroupObj.hidePolygons;
            var polygonIds = activeSweepGroupVsElements.reduce(function(acc, item) {
                if ((item === null || item === void 0 ? void 0 : item.type) === "vsPolygon") {
                    acc.push(item === null || item === void 0 ? void 0 : item.elementId);
                }
                return acc;
            }, []);
            if (!polygonIds.length && !hidePolygons) {
                return [];
            }
            return (polygons || []).reduce(function(acc, item) {
                if (hidePolygons || !polygonIds.includes(item.id) && polygonIds.length) {
                    acc.push(item.id);
                }
                return acc;
            }, []);
        };
        _this.filterPolygon = function() {
            var _state = _this.state, _$tourType = _state.tourType, polygons = _state.polygons;
            if (Tour/* TourType.Game */.v.Game === _$tourType) return;
            var sweepGroupElementIdsToHide = _this.getSweepGroupPolygonIdsToHide();
            polygons.forEach(function(polygon) {
                var isVisible = !sweepGroupElementIdsToHide.includes(polygon.id);
                polygon.active = isVisible;
            });
            var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
            _this.setState({
                polygons: polygons
            }, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _this1.renderPolygons();
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            })));
        };
        _this.filterTags = function() {
            var _state = _this.state, activeSweepGroup = _state.activeSweepGroup, sweepGroups = _state.sweepGroups, allTags = _state.allTags, _$tourType = _state.tourType, loadingTags = _state.loadingTags;
            if (Tour/* TourType.Game */.v.Game === _$tourType) return; // we skip filtering if it's game
            if (loadingTags || !sweepGroups.length) return;
            var activeGroup = Array.isArray(sweepGroups) ? sweepGroups.find(function(sg) {
                return sg.id === activeSweepGroup;
            }) : false;
            var tagsToRemove = [];
            var tagsToInit = [];
            if (allTags && allTags.size) {
                allTags.forEach(function(tag) {
                    var ref;
                    var found = activeGroup === null || activeGroup === void 0 ? void 0 : (ref = activeGroup.tags) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                        return item.tagSid === tag.sid || item.tagSid === tag.defaultSid;
                    });
                    if (!activeGroup) {
                        tagsToInit.push(tag);
                    } else if (found || !activeGroup.hideTags) {
                        tagsToInit.push(tag);
                    } else {
                        tagsToRemove.push(tag);
                    }
                });
            }
            _this.toggleVisibleTags(tagsToRemove, false);
            _this.toggleVisibleTags(tagsToInit, true);
        };
        var _this12 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleToggleMusic = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var forceMusicPause, otherPlaying, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        forceMusicPause = _args.length > 0 && _args[0] !== void 0 ? _args[0] : true, otherPlaying = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                        _ctx.prev = 1;
                        if (_this12.isTourReadyForAudio()) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (!_this12.tourAudio) {
                            _ctx.next = 17;
                            break;
                        }
                        _ctx.next = 7;
                        return _this12.pauseAllAudio("tourAudio");
                    case 7:
                        if (!_this12.tourAudio.paused) {
                            _ctx.next = 14;
                            break;
                        }
                        if (_this12.state.vsAudio) {
                            _this12.state.vsAudio.component.toggleMute();
                            _this12.state.vsAudio.btn.setActive(true);
                            _this12.setState({
                                vsAudio: null
                            });
                        }
                        _ctx.next = 11;
                        return _this12.tourAudio.play();
                    case 11:
                        _this12.setState({
                            mainPlaying: true,
                            otherPlaying: otherPlaying,
                            forceMusicPause: false,
                            tourMusicWasPaused: false
                        });
                        _ctx.next = 17;
                        break;
                    case 14:
                        _ctx.next = 16;
                        return _this12.tourAudio.pause();
                    case 16:
                        _this12.setState({
                            mainPlaying: false,
                            otherPlaying: otherPlaying,
                            forceMusicPause: forceMusicPause
                        });
                    case 17:
                        _ctx.next = 21;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t0 = _ctx["catch"](1);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    19
                ]
            ]);
        }));
        var _this13 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.changeFloor = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(floorIndex) {
                var _$all, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _$all = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                            _ctx.prev = 1;
                            _this13.setState({
                                panoramaOn: false
                            });
                            _ctx.next = 5;
                            return _this13.showCaseTemp.floor.changeFloor(floorIndex, _this13.state.tourPlaying, _$all);
                        case 5:
                            _ctx.next = 10;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](1);
                            console.error(_ctx.t0);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        7
                    ]
                ]);
            }));
            return function(floorIndex) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this14 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.playTour = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _this14.setState({
                            panoramaOn: false
                        });
                        _ctx.next = 4;
                        return _this14.showCaseTemp.tour.playTour(_this14.state.tourPlaying, _this14.state.reelStep);
                    case 4:
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        var _this15 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.changeViewMode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(mode) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _this15.setState({
                                panoramaOn: false
                            });
                            _ctx.next = 4;
                            return _this15.showCaseTemp.tour.changeViewMode(mode, _this15.state.tourPlaying);
                        case 4:
                            _ctx.next = 9;
                            break;
                        case 6:
                            _ctx.prev = 6;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error(_ctx.t0);
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        6
                    ]
                ]);
            }));
            return function(mode) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this16 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.measurementsMode = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _this16.showCaseTemp.tour.measurementsMode(_this16.state.tourPlaying);
                    case 3:
                        _ctx.next = 8;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error("Failed to change mode.");
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        _this.takePosition = function(event) {
            // ctrl+y
            if (event.ctrlKey && event.keyCode === 89) {
                var _state = _this.state, _tour = _state.tour, slug = _tour.slug, matterId = _tour.matterId;
                takePositionData({
                    slug: slug,
                    matterId: matterId,
                    sweep: _this.pose.sweep,
                    rotation: _this.pose.rotation
                });
            }
        };
        var _this17 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.closeTagPop = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _state, showcaseLoaded, host, room;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _state = _this17.state, showcaseLoaded = _state.showcaseLoaded, host = _state.host, room = _state.room;
                        if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                            socket/* default.emit */.Z.emit("close-tag");
                        }
                        _ctx.next = 4;
                        return _this17.resumeTourMusic();
                    case 4:
                        _this17.setState({
                            tagPopOn: false,
                            openedTag: null,
                            closedElementPopup: true
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        _this.closeConditionPopUp = function() {
            _this.setState({
                conditionPopUp: null
            }, function() {
                _this.resumeTourMusic();
            });
        };
        _this.closeGameLockPop = function(isCorrect) {};
        var _this18 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.changeTagIconAndColor = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tag, icon, color) {
                var iconId, iconUrl;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            iconId = "".concat(icon, "__").concat(Math.random());
                            iconUrl = "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(icon, "?hex=").concat(encodeURIComponent(color));
                            _ctx.next = 4;
                            return _this18.showcase.Mattertag.registerIcon(iconId, iconUrl).catch(function(e) {
                                console.error(e);
                            });
                        case 4:
                            _ctx.next = 6;
                            return _this18.showcase.Mattertag.editIcon(tag.sid, iconId).catch(function(e) {
                                console.error(e);
                            });
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(tag, icon, color) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.closePanoPop = function() {
            var _state = _this.state, showcaseLoaded = _state.showcaseLoaded, host = _state.host, room = _state.room;
            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                socket/* default.emit */.Z.emit("close-pano-pop");
            }
            _this.setState({
                panoPopOn: false,
                openedPanoHotspot: null
            });
        };
        _this.closeActionPop = function() {
            var _state = _this.state, sweepMusicWasPaused = _state.sweepMusicWasPaused, tourMusicWasPaused = _state.tourMusicWasPaused;
            if (_this.state.tourType === Tour/* TourType.Game */.v.Game) {
                if (sweepMusicWasPaused && _this.sweepAudio) {
                    _this.sweepAudio.play();
                    if (_this.sweepAudio.updateSubs) _this.sweepAudio.updateSubs();
                    _this.setState({
                        sweepMusicWasPaused: false,
                        otherPlaying: true
                    });
                } else if (tourMusicWasPaused) {
                    _this.resumeTourMusic();
                    _this.setState({
                        tourMusicWasPaused: false,
                        otherPlaying: false
                    });
                }
            }
            _this.setState({
                vsActionPopOn: false,
                closedElementPopup: true
            });
        };
        _this.closePathFinderPop = function() {
            _this.setState({
                showPathFinderPopup: false
            });
        };
        _this.showcaseLoad = function() {
            var ref, ref1;
            _this.showcaseLoader((ref = _this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK);
        };
        var _this19 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.moveModel = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(url) {
                var keepRotation, instant, THREE, ref, id, iframeId, linkData, rand, linkDataShort, q, quaternion, euler, rotation, xr, yr, zr, mode, position, euler1, rotation1, scanId, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            keepRotation = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false, instant = _args.length > 2 && _args[2] !== void 0 ? _args[2] : false;
                            _ctx.prev = 1;
                            THREE = _this19.THREE;
                            ref = getUrlVariables(url, _this19.state.iframeUrl), id = ref.id, iframeId = ref.iframeId, linkData = ref.linkData, rand = ref.rand, linkDataShort = ref.linkDataShort;
                            if (!linkData) {
                                _ctx.next = 18;
                                break;
                            }
                            q = linkData.camera_quaternion;
                            quaternion = new THREE.Quaternion(q.x, q.y, q.z, q.w);
                            euler = new THREE.Euler().setFromQuaternion(quaternion, "YXZ");
                            rotation = new THREE.Vector3(euler.x, euler.y, euler.z).multiplyScalar(180 / Math.PI); // @ts-ignore
                            if (keepRotation || linkData.showcase_sweep) {
                                rotation = _this19.pose.rotation;
                            }
                            if (!(id && iframeId && (id === null || id === void 0 ? void 0 : id.toLowerCase()) != (iframeId === null || iframeId === void 0 ? void 0 : iframeId.toLowerCase()))) {
                                _ctx.next = 14;
                                break;
                            }
                            {
                                _this19.iframe.removeEventListener("load", _this19.showcaseLoad);
                                _this19.iframe.addEventListener("load", _this19.showcaseLoad);
                                _this19.setState({
                                    iframeUrl: "".concat(url, "&qs=").concat(instant ? "1" : "0", "&play=1&newtags=1&refreshid=").concat(rand),
                                    panoramaOn: false
                                }, function() {
                                    if (_this19.state.room && _this19.state.host) {
                                        socket/* default.emit */.Z.emit("tour_load", {
                                            id: id,
                                            mp: true
                                        });
                                    }
                                });
                            }
                            _ctx.next = 16;
                            break;
                        case 14:
                            _ctx.next = 16;
                            return _this19.moveToSweep(linkData.scan_id, rotation, instant ? "INSTANT" : "FLY");
                        case 16:
                            _ctx.next = 45;
                            break;
                        case 18:
                            if (!linkDataShort) {
                                _ctx.next = 44;
                                break;
                            }
                            xr = parseFloat(linkDataShort.sr[0] || "0");
                            yr = parseFloat(linkDataShort.sr[1] || "0");
                            zr = parseFloat(linkDataShort.sr[2] || "0");
                            mode = linkDataShort.sm === 2 ? _this19.showCaseTemp.showcase.Mode.Mode.DOLLHOUSE : linkDataShort.sm === 3 ? _this19.showCaseTemp.showcase.Mode.Mode.FLOORPLAN : null;
                            position = null;
                            if (linkDataShort.sp) {
                                position = {
                                    x: parseFloat(linkDataShort.sp[0] || "0"),
                                    y: parseFloat(linkDataShort.sp[1] || "0"),
                                    z: parseFloat(linkDataShort.sp[2] || "0")
                                };
                            }
                            euler1 = new THREE.Euler().set(xr, yr, zr, "XYZ").reorder("YXZ");
                            rotation1 = new THREE.Vector3(euler1.x, euler1.y, euler1.z).multiplyScalar(180 / Math.PI); // @ts-ignore
                            rotation1.z = 0;
                            if (keepRotation) rotation1 = _this19.pose.rotation;
                            if (!(id && iframeId && id.toLowerCase() != iframeId.toLowerCase())) {
                                _ctx.next = 33;
                                break;
                            }
                            {
                                _this19.iframe.removeEventListener("load", _this19.showcaseLoad);
                                _this19.iframe.addEventListener("load", _this19.showcaseLoad);
                                _this19.setState({
                                    iframeUrl: "".concat(url, "&qs=").concat(instant ? "1" : "0", "&newtags=1&play=1&refreshid=").concat(rand),
                                    panoramaOn: false,
                                    activePano: null
                                }, function() {
                                    if (_this19.state.room && _this19.state.host) {
                                        socket/* default.emit */.Z.emit("tour_load", {
                                            id: id,
                                            mp: true
                                        });
                                    }
                                });
                            }
                            _ctx.next = 42;
                            break;
                        case 33:
                            if (!linkDataShort.ss) {
                                _ctx.next = 39;
                                break;
                            }
                            scanId = _this19.state.deprecatedSweeps[linkDataShort.ss - 1].sweep_uuid.replace(/-/g, "");
                            _ctx.next = 37;
                            return _this19.moveToSweep(scanId, rotation1, instant ? "INSTANT" : "FLY");
                        case 37:
                            _ctx.next = 42;
                            break;
                        case 39:
                            if (!(linkDataShort.sm && position)) {
                                _ctx.next = 42;
                                break;
                            }
                            _ctx.next = 42;
                            return _this19.showCaseTemp.showcase.Mode.moveTo(mode, (0,_object_spread/* default */.Z)({
                                position: position,
                                rotation: rotation1,
                                transition: instant ? _this19.showCaseTemp.showcase.Mode.TransitionType.INSTANT : _this19.showCaseTemp.showcase.Mode.TransitionType.FLY
                            }, linkDataShort.sz && {
                                zoom: linkDataShort.sz
                            }));
                        case 42:
                            _ctx.next = 45;
                            break;
                        case 44:
                            if (id && iframeId && id.toLowerCase() != iframeId.toLowerCase()) {
                                _this19.iframe.removeEventListener("load", _this19.showcaseLoad);
                                _this19.iframe.addEventListener("load", _this19.showcaseLoad);
                                // for no link data, just simple links
                                _this19.setState({
                                    iframeUrl: "".concat(url, "&qs=1&newtags=1&play=1&refreshid=").concat(rand),
                                    panoramaOn: false,
                                    activePano: null
                                }, function() {
                                    if (_this19.state.room && _this19.state.host) {
                                        socket/* default.emit */.Z.emit("tour_load", {
                                            id: id,
                                            mp: true
                                        });
                                    }
                                });
                            }
                        case 45:
                            _this19.setState({
                                overlayOn: false,
                                markerPopupOn: false,
                                panoramaOn: false
                            });
                            _ctx.next = 51;
                            break;
                        case 48:
                            _ctx.prev = 48;
                            _ctx.t0 = _ctx["catch"](1);
                            console.error(_ctx.t0);
                        case 51:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        48
                    ]
                ]);
            }));
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.markerClick = function(hotspot) {
            _this.setState({
                minimapOn: false
            }, function() {
                if (hotspot.type === "panorama") {
                    var _state = _this.state, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap;
                    minimaps[selectedMinimap].hotspots.map(function(h) {
                        hotspot.active = h.id === hotspot.id;
                        return hotspot;
                    });
                    _this.setState({
                        panoramaOn: true,
                        minimaps: minimaps,
                        activePano: hotspot.panoramaId,
                        mapWalkerX: hotspot.x,
                        mapWalkerY: hotspot.y
                    });
                    return;
                }
                if (!hotspot.external) {
                    _this.setState({
                        overlayOn: false
                    });
                    if (hotspot.url) {
                        var whiteLabelData = _this.state.whiteLabelData;
                        var url = hotspot.url;
                        var type = [
                            "my.treedis.com",
                            "test.treedis.com",
                            whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.domainUrl,
                            "localhost:"
                        ].find(function(item) {
                            return url.includes(item);
                        }) ? Menu/* MenuType.Treedis */.o.Treedis : Menu/* MenuType.Matterport */.o.Matterport;
                        _this.loadModel(null, url, type);
                    } else {
                        var ref, ref1;
                        var start = encodeURIComponent(JSON.stringify({
                            camera_mode: 1,
                            scan_id: hotspot.scanId,
                            showcase_sweep: hotspot.showcaseSweep,
                            camera_position: {
                                x: hotspot.positionX,
                                y: hotspot.positionY,
                                z: hotspot.positionZ
                            },
                            camera_quaternion: {
                                x: hotspot.rotationX,
                                y: hotspot.rotationY,
                                z: hotspot.rotationZ,
                                w: hotspot.rotationW
                            }
                        }));
                        _this.moveModel("/mp-sdk/".concat("3.1.76", "/showcase.html?applicationKey=").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK, "&m=").concat(_this.state.tour.matterId, "&start=").concat(start));
                    }
                } else {
                    _this.setState({
                        selectedMarker: {
                            url: hotspot.url,
                            external: hotspot.external
                        },
                        markerPopupOn: true,
                        overlayOn: true
                    });
                }
            });
        };
        _this.releaseLock = function() {
            _this.setState({
                lock: false
            });
        };
        _this.toggleAppointmentsModal = function() {
            _this.setState({
                appointmentsModal: !_this.state.appointmentsModal,
                appointmentsHintOn: false
            });
            _this.toggleExternalPopup();
        };
        _this.handleCustomButton = function() {
            var _state = _this.state, tour = _state.tour, externalPopupOn = _state.externalPopupOn;
            if (tour.customButtonOpenAs === Tour/* CustomButtonTypeOpenAsType.Tab */.Bg.Tab) {
                window.open(tour.customButtonUrl, "_blank");
                return;
            }
            if (externalPopupOn) return;
            _this.setState({
                externalPopupUrl: tour.customButtonUrl,
                externalPopupOn: true
            });
        };
        _this.toggleNav = function() {
            var _state = _this.state, menuOpen = _state.menuOpen, _tour = _state.tour, menuAlwaysOpenMobile = _tour.menuAlwaysOpenMobile, menuAlwaysOpenDesktop = _tour.menuAlwaysOpenDesktop, _$tourType = _state.tourType;
            var menuOpenForDevice = _$tourType === Tour/* TourType.Regular */.v.Regular && !!(deviceManager/* default.isMobile */.Z.isMobile() ? menuAlwaysOpenMobile : menuAlwaysOpenDesktop);
            _this.setState({
                menuOpen: menuOpenForDevice || !menuOpen,
                menuOpened: true,
                activeMenu: null,
                MenuHintOn: false
            });
        };
        _this.setBaseState = function(obj) {
            _this.setState(obj);
        };
        _this.disableContext = function(e) {
            e.preventDefault();
        };
        var _this20 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.processTourMusic = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tour) {
                var justInitTourAudio, currentFloor, isTourMusic, music, ref, ref1, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            justInitTourAudio = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                            currentFloor = _this20.state.currentFloor;
                            isTourMusic = false;
                            music = tour.musics.find(function(item) {
                                return item.floor === currentFloor + 1;
                            });
                            if (!music && tour.music) {
                                ;
                                music = {
                                    autoplay: tour.autoplayMusic,
                                    url: "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/music.mp3").concat(util_all/* getVersion */.bo(tour.updatedAt))
                                };
                                isTourMusic = music.url === ((ref = _this20.tourAudio) === null || ref === void 0 ? void 0 : ref.src);
                            }
                            _this20.setState({
                                interacted: true
                            });
                            if (!music) {
                                _ctx.next = 14;
                                break;
                            }
                            ;
                            if (!(((ref1 = _this20.tourAudio) === null || ref1 === void 0 ? void 0 : ref1.src) && isTourMusic)) {
                                _ctx.next = 10;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 10:
                            _ctx.next = 12;
                            return _this20.pauseAllAudio("tourAudio");
                        case 12:
                            _this20.createAudioStream("tourAudio", music.url, true);
                            // if (justInitTourAudio) return;
                            if (music.autoplay && !(tour.noAudioMode && _this20.state.room) && // in case of Intro Screen is enables, the music
                            // should play after user clicks on play button
                            !_this20.state.showIntroScreen) {
                                if (deviceManager/* default.supportsTouch */.Z.supportsTouch()) {
                                    _this20.setState({
                                        interacted: false
                                    });
                                    document.addEventListener("touchstart", function() {
                                        _this20.setState({
                                            interacted: true
                                        });
                                        _this20.playAudio();
                                    }, {
                                        once: true
                                    });
                                } else if (deviceManager/* default.isSafari */.Z.isSafari() && !deviceManager/* default.isChrome */.Z.isChrome()) {
                                    _this20.setState({
                                        interacted: false
                                    });
                                    document.addEventListener("click", function() {
                                        _this20.setState({
                                            interacted: true
                                        });
                                        _this20.playAudio();
                                    }, {
                                        once: true
                                    });
                                } else {
                                    _this20.playAudio();
                                }
                            }
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            // else {
            //   // added check for sweepAudio because it paused sweep audio when initial sweep had audio
            //   if (!this.sweepAudio) await this.pauseAllAudio();
            //   this.tagAudio = null;
            //   this.setState({ mainPlaying: false, otherPlaying: !!this.sweepAudio });
            // }
            }));
            return function(tour) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this21 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.pauseTourMusic = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this21.handleToggleMusic(false);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this22 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.resumeTourMusic = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _state, forceMusicPause, vsAudio;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _state = _this22.state, forceMusicPause = _state.forceMusicPause, vsAudio = _state.vsAudio;
                        if (_this22.isTourReadyForAudio()) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        if (!(_this22.tourAudio && _this22.tourAudio.paused && !_this22.tourAudio.ended && _this22.tourAudio.currentTime > 0 && !forceMusicPause && !vsAudio)) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 6;
                        return _this22.handleToggleMusic();
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this23 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.loadData = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tourData) {
                var changeMenu, changeMinimap, changePanorama, url, ref, ref1, tour, stateTour, _$tourType, matterStartLocation, s, x, y, ss, sr, m, matterId, addons, menuOpenForDevice, initialDuplicates, menuOpen, china, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            changeMenu = _args.length > 1 && _args[1] !== void 0 ? _args[1] : true, changeMinimap = _args.length > 2 && _args[2] !== void 0 ? _args[2] : true, changePanorama = _args.length > 3 && _args[3] !== void 0 ? _args[3] : true, url = _args.length > 4 && _args[4] !== void 0 ? _args[4] : null;
                            ;
                            tour = new Tour/* Tour */.Oj(tourData);
                            stateTour = _this23.state.tour;
                            _$tourType = _this23.state.tourType;
                            matterStartLocation = "";
                            if (!url) {
                                _ctx.next = 19;
                                break;
                            }
                            s = (0,util_all/* getQueryVariable */.Dv)(url, "s");
                            x = (0,util_all/* getQueryVariable */.Dv)(url, "x");
                            y = (0,util_all/* getQueryVariable */.Dv)(url, "y");
                            if (!(s && x && y)) {
                                _ctx.next = 17;
                                break;
                            }
                            _ctx.next = 13;
                            return (0,queries/* getSweepIndex */.QM)(tour.matterId, tour.slug, s);
                        case 13:
                            ss = _ctx.sent;
                            sr = "".concat(_this23.THREE.MathUtils.degToRad(x), ",").concat(_this23.THREE.MathUtils.degToRad(y));
                            if (sr && ss >= 0) {
                                matterStartLocation = "&ss=".concat(ss, "&sr=").concat(sr);
                            }
                            window.history.replaceState(null, "", _this23.buildLink(s, {
                                x: x,
                                y: y
                            }));
                        case 17:
                            _ctx.next = 20;
                            break;
                        case 19:
                            if (tour.ss && tour.sr) {
                                matterStartLocation = "&ss=".concat(tour.ss, "&sr=").concat(tour.sr);
                            }
                        case 20:
                            if (!changeMenu && stateTour) {
                                tour.reel = stateTour.reel;
                                tour.menuEnabled = stateTour.menuEnabled;
                                tour.menuAlwaysOpenMobile = stateTour.menuAlwaysOpenMobile;
                                tour.menuAlwaysOpenDesktop = stateTour.menuAlwaysOpenDesktop;
                            }
                            if (!changePanorama && stateTour) tour.panorama = stateTour.panorama;
                            if (!changeMinimap && stateTour) {
                                tour.originX = stateTour.originX;
                                tour.originY = stateTour.originY;
                                tour.height = stateTour.height;
                                tour.width = stateTour.width;
                                tour.ppm = stateTour.ppm;
                                tour.customMinimap = stateTour.customMinimap;
                                tour.minimap = true;
                            }
                            m = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "m");
                            matterId = m ? atob(decodeURIComponent(String(m))) : tour.matterId;
                            if (_this23.state.room) {
                                if (_this23.state.host) {
                                    socket/* default.emit */.Z.emit("tour_load", {
                                        id: matterId,
                                        mp: false
                                    });
                                } else if (matterId !== tour.matterId) {
                                    // if host uses a Tour Link, matterId should be updated with id of next tour
                                    matterId = tour.matterId;
                                }
                            }
                            addons = tour.getAddonsUrl();
                            if (tour.introScreen) {
                                addons = addons.replace(/qs=0/g, "qs=1");
                            }
                            menuOpenForDevice = _$tourType === Tour/* TourType.Regular */.v.Regular && !!(deviceManager/* default.isMobile */.Z.isMobile() ? tour.menuAlwaysOpenMobile : tour.menuAlwaysOpenDesktop);
                            if (!(tourData === null || tourData === void 0 ? void 0 : tourData.initialDuplicates)) {
                                _ctx.next = 33;
                                break;
                            }
                            _ctx.t0 = tourData.initialDuplicates;
                            _ctx.next = 36;
                            break;
                        case 33:
                            _ctx.next = 35;
                            return (ref = TreedisPublicDAO/* default.getDuplicates */.Z.getDuplicates(tour.parentId || tour.id)) === null || ref === void 0 ? void 0 : ref.duplicates;
                        case 35:
                            _ctx.t0 = _ctx.sent;
                        case 36:
                            initialDuplicates = _ctx.t0;
                            menuOpen = changeMenu ? _this23.state.room && !_this23.state.host ? false : tour.menuOnStart || menuOpenForDevice || false : _this23.state.menuOpen;
                            china = util_all/* getQueryVariable */.Dv(window.location.href, "china");
                            _this23.setState({
                                initialDuplicates: initialDuplicates,
                                menuOpen: menuOpen,
                                changeMenu: changeMenu,
                                tour: tour,
                                isVSEnabled: tour.enableVS,
                                allowGuestBeforeHost: tour.allowGuestBeforeHost,
                                showIntroScreen: !isEmpty_default()(tour.introScreen) && !tour.mpPasswordActive,
                                minimapVisible: tour.minimapVisible && !_this23.state.room && window.innerWidth > 768,
                                iframeUrl: "/mp-sdk/".concat("3.1.76", "/showcase").concat(china ? "-china" : "", ".html?applicationKey=").concat(tour === null || tour === void 0 ? void 0 : (ref1 = tour.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK, "&m=").concat(matterId).concat(addons).concat(matterStartLocation),
                                appointmentsHintOn: tour.appointmentTooltipOn,
                                MenuHintOn: tour.menuTooltipOn
                            }, function() {
                                if (_this23.iframe) {
                                    _this23.iframe.removeEventListener("load", _this23.showcaseLoad);
                                    _this23.iframe.addEventListener("load", _this23.showcaseLoad);
                                }
                                if (tour.disableContext) {
                                    document.addEventListener("contextmenu", _this23.disableContext);
                                }
                                (0,util_all/* fetchData */.rQ)("public/getAgentsContactForm/".concat(tour.id), "GET").then(function(data) {
                                    var agents = data.agents.map(function(a) {
                                        return new Agent/* Agent */.P(a.agent);
                                    });
                                    if (agents && agents.length) _this23.setState({
                                        agents: agents
                                    });
                                }).catch(function(err) {
                                    console.error(err.message);
                                });
                                if (tour.minimap && changeMinimap) {
                                    (0,util_all/* fetchData */.rQ)("public/getMinimaps", "POST", {
                                        id: tour.id
                                    }).then(function(data) {
                                        var minimaps = data.minimaps;
                                        _this23.setState({
                                            minimaps: minimaps
                                        });
                                    }).catch(function(err) {
                                        console.error(err.message);
                                    });
                                }
                                if (tour.panorama && changePanorama) {
                                    (0,util_all/* fetchData */.rQ)("public/getPanoramas", "POST", {
                                        id: tour.id
                                    }).then(function(data) {
                                        var panoramas = data.panoramas;
                                        var pano = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "pano");
                                        var pitch = parseInt(String((0,util_all/* getQueryVariable */.Dv)(window.location.href, "panoPitch"))) || 0;
                                        var yaw = parseInt(String((0,util_all/* getQueryVariable */.Dv)(window.location.href, "panoYaw"))) || 0;
                                        var hfov = parseInt(String((0,util_all/* getQueryVariable */.Dv)(window.location.href, "panoHfov"))) || 0;
                                        _this23.setState({
                                            panoramas: panoramas,
                                            activePano: pano && parseInt(String(pano)),
                                            panoramaOn: tour.panoramaStart || Boolean(pano),
                                            panoPose: {
                                                pitch: pitch,
                                                yaw: yaw,
                                                hfov: hfov
                                            }
                                        });
                                    }).catch(function(err) {
                                        console.error(err.message);
                                    });
                                }
                                TreedisPublicDAO/* default.getGroups */.Z.getGroups({
                                    id: tour.id
                                }).then(function(groupsData) {
                                    var ref;
                                    if (groupsData === null || groupsData === void 0 ? void 0 : (ref = groupsData.groups) === null || ref === void 0 ? void 0 : ref.length) _this23.setState({
                                        sweepGroups: groupsData === null || groupsData === void 0 ? void 0 : groupsData.groups
                                    });
                                });
                                if (tour.gameId) {
                                    (0,util_all/* fetchData */.rQ)("public/getGame", "POST", {
                                        id: tour.gameId
                                    }).then(function(data) {
                                        var ref;
                                        var game = new Game/* Game */.lA(data === null || data === void 0 ? void 0 : data.game);
                                        _this23.gameAnalytic = new GameAnalyticService(game.id);
                                        _this23.setState({
                                            showIntro: game.introClip && game.introClipUrl,
                                            gameLoaded: true,
                                            game: game,
                                            showBook: (game === null || game === void 0 ? void 0 : game.gameBookOn) && (game === null || game === void 0 ? void 0 : (ref = game.book) === null || ref === void 0 ? void 0 : ref.openByDefault)
                                        });
                                    }).catch(function(err) {
                                        var ref, ref1, ref2, ref3, ref4;
                                        if (err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.message) === null || ref2 === void 0 ? void 0 : ref2.includes("trial")) _this23.setState({
                                            gameTrialErr: err === null || err === void 0 ? void 0 : (ref3 = err.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.message
                                        });
                                        console.error(err.message);
                                    });
                                }
                            });
                        case 40:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(tourData) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.getProducts = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tourId, userId) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            return _ctx.abrupt("return", []);
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(tourId, userId) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.handleGameStartWithoutIntro = function() {
            var showcaseLoaded = _this.state.showcaseLoaded;
            if (showcaseLoaded) {
                _this.handleGameStart("", true);
            } else {
                setTimeout(_this.handleGameStartWithoutIntro, 500);
            }
        };
        var _this24 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.showcaseLoader = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(applicationKey) {
                var ref, ref1, ref2, ref3, ref4, urlParams, newModelSID, showcase, observerMPPassword, setTourBackground, starting;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            urlParams = new URLSearchParams((ref = _this24.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.location) === null || ref2 === void 0 ? void 0 : ref2.search);
                            newModelSID = urlParams.get("m");
                            if (!(newModelSID != (0,util_all/* getQueryVariable */.Dv)(_this24.state.iframeUrl, "m"))) {
                                _ctx.next = 7;
                                break;
                            }
                            _this24.setState({
                                iframeUrl: _this24.state.iframeUrl.replace(/(m=).*?(&)/, "$1" + newModelSID + "$2")
                            });
                            return _ctx.abrupt("return");
                        case 7:
                            _ctx.next = 9;
                            return (0,dist/* GetSDK */.xe)(_this24.iframe, {
                                applicationKey: applicationKey || "295ba0c0f04541318359a8e75af33043",
                                appDomain: "https://api.treedis.com" || 0,
                                version: "3.1.76",
                                logoUrl: ((ref3 = _this24.state.whiteLabelData) === null || ref3 === void 0 ? void 0 : ref3.active) ? (ref4 = _this24.state.whiteLabelData) === null || ref4 === void 0 ? void 0 : ref4.logo : "../../images/logo.png",
                                appAws: "https://cdn.treedis.com"
                            });
                        case 9:
                            showcase = _ctx.sent;
                            _ctx.next = 12;
                            return _this24.iframe.contentWindow.document.addEventListener("keydown", _this24.takePosition);
                        case 12:
                            observerMPPassword = (0,util/* setMPPasswordFormObserver */.v2)(_this24.iframe.contentWindow.document.body, function() {
                                _this24.iframe.style.zIndex = 999999;
                            }, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _this24.setState({
                                                waitLoadingPolygons: true
                                            });
                                            _this24.iframe.style.zIndex = "inherit";
                                        case 2:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })));
                            setTourBackground = function() {
                                var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(models, threeInstance) {
                                    var tour;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                tour = _this24.state.tour;
                                                if (tour === null || tour === void 0 ? void 0 : tour.background) {
                                                    _ctx.next = 3;
                                                    break;
                                                }
                                                return _ctx.abrupt("return");
                                            case 3:
                                                if (utils/* color.isHex */.$_.isHex(tour.background)) {
                                                    models[0].parent.children[1].material = new threeInstance.ShadowMaterial();
                                                    models[0].parent.background = new threeInstance.Color(tour.background);
                                                }
                                            case 4:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function setTourBackground(models, threeInstance) {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            _this24.showcase = showcase.showcase;
                            _this24.showCaseTemp = showcase;
                            _this24.loadedShowcaseHandler();
                            _this24.showCaseTemp.on(dist/* TourLoaderEventsType.LOADING */.$D.LOADING, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _this24.loadingQueue.setLoadingQueueProgress(80, 100);
                                            observerMPPassword && observerMPPassword.disconnect();
                                        case 2:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })));
                            starting = false;
                            _this24.showCaseTemp.on(dist/* TourLoaderEventsType.STARTING */.$D.STARTING, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                var models;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            starting = true;
                                            _ctx.next = 3;
                                            return _this24.showCaseTemp.showcase.Scene.query([
                                                "model"
                                            ]);
                                        case 3:
                                            models = _ctx.sent;
                                            _this24.camera = models[0].parent.children[0].camera;
                                            _ctx.next = 7;
                                            return _this24.showCaseTemp.scene.configureThreeInstance();
                                        case 7:
                                            _ctx.next = 9;
                                            return (0,dist/* iTHREE */.Sc)();
                                        case 9:
                                            _this24.THREE = _ctx.sent;
                                            setTourBackground(models, _this24.THREE);
                                            _this24.initStarting();
                                        case 12:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })));
                            _this24.showCaseTemp.on(dist/* TourLoaderEventsType.PLAYING */.$D.PLAYING, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                var ref, ref1, ref2, ref3, models, watchErrorElem;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            ;
                                            if (starting) {
                                                _ctx.next = 14;
                                                break;
                                            }
                                            _ctx.next = 4;
                                            return _this24.showCaseTemp.showcase.Scene.query([
                                                "model"
                                            ]);
                                        case 4:
                                            models = _ctx.sent;
                                            _this24.camera = models[0].parent.children[0].camera;
                                            _ctx.next = 8;
                                            return (0,dist/* iTHREE */.Sc)();
                                        case 8:
                                            _this24.THREE = _ctx.sent;
                                            setTourBackground(models, _this24.THREE);
                                            _ctx.next = 12;
                                            return _this24.showCaseTemp.scene.configureThreeInstance();
                                        case 12:
                                            _ctx.next = 14;
                                            return _this24.initStarting();
                                        case 14:
                                            _this24.initPlaying();
                                            _this24.initScene();
                                            _this24.initSweep();
                                            watchErrorElem = (ref = _this24.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.document) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.body) === null || ref3 === void 0 ? void 0 : ref3.querySelector("#error-container");
                                            (0,util/* setErrorObserver */.D2)(watchErrorElem, function(pageCrashed, observer) {
                                                _this24.setState({
                                                    crashScreen: pageCrashed
                                                });
                                                observer.disconnect();
                                            });
                                        case 19:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })));
                            _ctx.next = 26;
                            break;
                        case 23:
                            _ctx.prev = 23;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error(_ctx.t0);
                        case 26:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        23
                    ]
                ]);
            }));
            return function(applicationKey) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.filterSweepGroupVsElementsByTourVsElement = function(vsElements, vsElement) {
            var ref;
            if ((0,src_instanceof/* default */.Z)(vsElement, VSObject/* TourImage */.oP)) {
                var ref1;
                var vsImageIds = vsElements.filter(function(item) {
                    return item.type === "vsImage";
                }).map(function(param) {
                    var elementId = param.elementId;
                    return elementId;
                });
                if (!vsImageIds.length) return true;
                return !!vsImageIds.includes(vsElement === null || vsElement === void 0 ? void 0 : (ref1 = vsElement.details) === null || ref1 === void 0 ? void 0 : ref1.id);
            }
            if ((0,src_instanceof/* default */.Z)(vsElement, VSObject/* TourVideo */.Up)) {
                var ref2;
                var vsVideoIds = vsElements.filter(function(item) {
                    return item.type === "vsVideo";
                }).map(function(param) {
                    var elementId = param.elementId;
                    return elementId;
                });
                if (!vsVideoIds.length) return true;
                return !!vsVideoIds.includes(vsElement === null || vsElement === void 0 ? void 0 : (ref2 = vsElement.details) === null || ref2 === void 0 ? void 0 : ref2.id);
            }
            var vsObjectsIds = vsElements.filter(function(item) {
                return item.type === "vsObject";
            }).map(function(param) {
                var elementId = param.elementId;
                return elementId;
            });
            if (!vsObjectsIds.length) return true;
            return !!vsObjectsIds.includes(vsElement === null || vsElement === void 0 ? void 0 : (ref = vsElement.details) === null || ref === void 0 ? void 0 : ref.id);
        };
        _this.isGameTour = function() {
            var _state = _this.state, _$tourType = _state.tourType, tour = _state.tour;
            return _$tourType === Tour/* TourType.Game */.v.Game && tour.gameId;
        };
        _this.isSweepGroupVsVisible = function(vsElement, sweepGroupElementIdsToHide) {
            var ref;
            var _state = _this.state, activeSweepGroup = _state.activeSweepGroup, sweepGroups = _state.sweepGroups;
            if (sweepGroupElementIdsToHide.includes(vsElement === null || vsElement === void 0 ? void 0 : (ref = vsElement.details) === null || ref === void 0 ? void 0 : ref.id)) return false;
            var response = (sweepGroups || []).find(function(item) {
                return item.id === activeSweepGroup;
            });
            return _this.filterSweepGroupVsElementsByTourVsElement((response === null || response === void 0 ? void 0 : response.vsElements) || [], vsElement);
        };
        _this.hasSweepGroupElements = function() {
            var sweepGroups = _this.state.sweepGroups;
            var elementIds = sweepGroups.reduce(function(acc, param) {
                var _vsElements = param.vsElements, vsElements = _vsElements === void 0 ? [] : _vsElements;
                return acc.concat(vsElements);
            }, []).map(function(item) {
                return item === null || item === void 0 ? void 0 : item.elementId;
            });
            return elementIds.length > 0;
        };
        _this.sortVsItemsByType = function(vsItems) {
            var images = [];
            var videos = [];
            var objects = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // eslint-disable-next-line no-restricted-syntax
                for(var _iterator = vsItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    if ((item === null || item === void 0 ? void 0 : item.type) === "vsVideo") {
                        videos.push(item === null || item === void 0 ? void 0 : item.elementId);
                    }
                    if ((item === null || item === void 0 ? void 0 : item.type) === "vsImage") {
                        images.push(item === null || item === void 0 ? void 0 : item.elementId);
                    }
                    if ((item === null || item === void 0 ? void 0 : item.type) === "vsObject") {
                        objects.push(item === null || item === void 0 ? void 0 : item.elementId);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                images,
                videos,
                objects
            ];
        };
        _this.getSweepGroupElementIdsToHide = function() {
            var _state = _this.state, sweepGroups = _state.sweepGroups, activeSweepGroup = _state.activeSweepGroup;
            if (!activeSweepGroup) return [];
            var activeSweepGroupObj = sweepGroups.filter(function(item) {
                return (item === null || item === void 0 ? void 0 : item.id) === activeSweepGroup;
            })[0];
            var activeSweepGroupVsElements = activeSweepGroupObj === null || activeSweepGroupObj === void 0 ? void 0 : activeSweepGroupObj.vsElements;
            var hideVSImages = activeSweepGroupObj.hideVSImages, hideVSVideos = activeSweepGroupObj.hideVSVideos, hideVSObjects = activeSweepGroupObj.hideVSObjects;
            var ref = (0,_sliced_to_array/* default */.Z)(_this.sortVsItemsByType(activeSweepGroupVsElements), 3), tmp = ref[0], imageIds = tmp === void 0 ? [] : tmp, tmp1 = ref[1], videoIds = tmp1 === void 0 ? [] : tmp1, tmp2 = ref[2], objectIds = tmp2 === void 0 ? [] : tmp2;
            if (!imageIds.length && !videoIds.length && !objectIds.length && !hideVSImages && !hideVSVideos && !hideVSObjects) {
                return [];
            }
            return _this.vsObjects.map(function(item) {
                if ((0,src_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up) && (hideVSVideos || !videoIds.includes(item.vsVideoId) && videoIds.length)) {
                    return item.vsVideoId;
                }
                if ((0,src_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP) && (hideVSImages || !imageIds.includes(item.vsImageId) && imageIds.length)) {
                    return item.vsImageId;
                }
                if ((0,src_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && (hideVSObjects || !objectIds.includes(item.vsObjectId) && objectIds.length)) {
                    return item.vsObjectId;
                }
            }).filter(function(item) {
                return !!item;
            });
        };
        var _this25 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.renderVS = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(currentSweep) {
                var ref, ref1, ref2, _state, isVSVisible, tour, blockRender, THREE, pose, sweepGroupElementIdsToHide, filteredVsObjects;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _state = _this25.state, isVSVisible = _state.isVSVisible, tour = _state.tour;
                            blockRender = _this25.state.tourMode === _this25.showCaseTemp.showcase.Mode.Mode.OUTSIDE || currentSweep.mode === _this25.showCaseTemp.showcase.Mode.Mode.OUTSIDE || currentSweep.mode === _this25.showCaseTemp.showcase.Mode.Mode.TRANSITIONING || _this25.state.tourMode === _this25.showCaseTemp.showcase.Mode.Mode.TRANSITIONING;
                            if (!(!currentSweep || _this25.isGameTour() || blockRender)) {
                                _ctx.next = 5;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 5:
                            if (isVSVisible) {
                                _ctx.next = 8;
                                break;
                            }
                            _this25.loadingQueue.setFullLoadingQueueProgress();
                            return _ctx.abrupt("return");
                        case 8:
                            THREE = _this25.THREE;
                            pose = new THREE.Vector3(currentSweep === null || currentSweep === void 0 ? void 0 : (ref = currentSweep.position) === null || ref === void 0 ? void 0 : ref.x, currentSweep === null || currentSweep === void 0 ? void 0 : (ref1 = currentSweep.position) === null || ref1 === void 0 ? void 0 : ref1.y, currentSweep === null || currentSweep === void 0 ? void 0 : (ref2 = currentSweep.position) === null || ref2 === void 0 ? void 0 : ref2.z);
                            sweepGroupElementIdsToHide = _this25.getSweepGroupElementIdsToHide();
                            filteredVsObjects = _this25.vsObjects;
                            // if its a game we load everything regardless of radius or sensor.=
                            filteredVsObjects.forEach(function(vsObject) {
                                var ref;
                                var assetPose = new THREE.Vector3(vsObject.positionX, vsObject.positionY, vsObject.positionZ);
                                var distance = pose.distanceTo(assetPose);
                                var inRange = distance <= ((vsObject === null || vsObject === void 0 ? void 0 : vsObject.renderRange) || ((ref = _this25.state.tour) === null || ref === void 0 ? void 0 : ref.vsRenderRange) || DEFAULT_VS_SENSOR_RADIUS);
                                var startAnimationDistance = (vsObject === null || vsObject === void 0 ? void 0 : vsObject.startAnimationDistance) || tour.vsAnimationDistance;
                                var isVisibleVsItems = _this25.isSweepGroupVsVisible(vsObject, sweepGroupElementIdsToHide);
                                if (inRange && isVisibleVsItems) {
                                    _this25.loadingQueue.enqueue((0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                        var ref, ref1;
                                        return runtime_default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    ;
                                                    _ctx.next = 3;
                                                    return _this25.setVSVisible(vsObject, true);
                                                case 3:
                                                    if ((vsObject === null || vsObject === void 0 ? void 0 : vsObject.node) && (0,src_instanceof/* default */.Z)(vsObject, VSObject/* TourVideo */.Up) && vsObject.node.video) {
                                                        if (distance <= startAnimationDistance && vsObject.node.video.autoplay) {
                                                            if (vsObject.node.video.paused || !vsObject.node.isLoaded) {
                                                                vsObject.node.play();
                                                            }
                                                        } else if (distance > startAnimationDistance && vsObject.node.isLoaded && !vsObject.node.video.paused) {
                                                            ;
                                                            (ref1 = vsObject.node) === null || ref1 === void 0 ? void 0 : ref1.pause();
                                                        }
                                                    } else if ((vsObject === null || vsObject === void 0 ? void 0 : vsObject.node) && (((ref = vsObject.details) === null || ref === void 0 ? void 0 : ref.isGLTF) || (0,src_instanceof/* default */.Z)(vsObject, VSObject/* TourImage */.oP))) {
                                                        vsObject.node.animate = distance <= startAnimationDistance;
                                                    }
                                                    _this25.loadingQueue.dequeue();
                                                case 5:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    })));
                                } else if (vsObject.node) {
                                    _this25.setVSVisible(vsObject, false);
                                }
                            });
                            if (_this25.hasSweepGroupElements() && !filteredVsObjects.filter(function(vsObject) {
                                return _this25.isSweepGroupVsVisible(vsObject, sweepGroupElementIdsToHide);
                            }).length) {
                                _this25.loadingQueue.setFullLoadingQueueProgress();
                            }
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(currentSweep) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.handleShowNearestProduct = function(state) {
            _this.setState({
                isShowNearestProducts: state,
                nearestProducts: []
            });
        };
        var _this26 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initPlaying = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _state, tour, loadedOnce, iframeUrl, matterId, url, s, x, y, newState;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _state = _this26.state, tour = _state.tour, loadedOnce = _state.loadedOnce, iframeUrl = _state.iframeUrl;
                        _this26.setState({
                            appState: "playing"
                        });
                        matterId = (0,util_all/* getQueryVariable */.Dv)(iframeUrl, "m");
                        url = window.location.href;
                        s = (0,util_all/* getQueryVariable */.Dv)(url, "s");
                        x = (0,util_all/* getQueryVariable */.Dv)(url, "x");
                        y = (0,util_all/* getQueryVariable */.Dv)(url, "y");
                        if (s && x && y) {
                            // We move inside the tour
                            _this26.moveToSweep(String(s), {
                                x: parseFloat(x),
                                y: parseFloat(y)
                            });
                        }
                        if (!loadedOnce) {
                            (0,analytic/* startGA */.Rj)(tour, true);
                        }
                        newState = {
                            loadedOnce: true
                        };
                        // TODO:: Remove when Matterport will fix problem with current floor
                        if (matterId === "VE4rJCNFfba") newState.currentFloor = 1;
                        _this26.setState(newState, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            var ref, hash, polygons;
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        if (tour.addon_ts >= 0 && tour.mpPlay) {
                                            setTimeout(function() {
                                                _this26.playTour();
                                            }, tour.addon_ts * 1000);
                                        }
                                        _ctx.prev = 1;
                                        ;
                                        hash = window.location.hash.substring(1);
                                        if (hash) {
                                            _this26.loadModel(null, null, Menu/* MenuType.Product */.o.Product, hash, null);
                                        }
                                        // tourAudio not init when there is introClip, so we init it if there is
                                        if (_this26.isTourReadyForAudio()) {
                                            _this26.processTourMusic(tour, true);
                                        }
                                        polygons = _this26.state.polygons;
                                        if (!(((ref = _this26.vsObjects) === null || ref === void 0 ? void 0 : ref.length) > 0 || (polygons === null || polygons === void 0 ? void 0 : polygons.length) > 0 || (tour === null || tour === void 0 ? void 0 : tour.enableAvatar))) {
                                            _ctx.next = 11;
                                            break;
                                        }
                                        console.log("Configuring scene");
                                        _ctx.next = 11;
                                        return _this26.showCaseTemp.scene.configureScene({
                                            settings: _this26.state.vsSettings,
                                            onShadowEnabled: function(value) {
                                                _this26.isShadowEnabled = value;
                                            },
                                            onShadowNodeCreated: function(shadowNode) {
                                                _this26.shadowNode = shadowNode;
                                            },
                                            cb: function() {
                                                _this26.setState({
                                                    isVSReady: true
                                                }, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                                    var ref, ref1;
                                                    return runtime_default().wrap(function _callee$(_ctx) {
                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                            case 0:
                                                                ;
                                                                _ctx.next = 3;
                                                                return _this26.showCaseTemp.showcase.Scene.register(virtualStaging_avatar/* avatarComponentType */.bB, virtualStaging_avatar/* makeAvatarComponent */.Sr);
                                                            case 3:
                                                                if (!((polygons === null || polygons === void 0 ? void 0 : polygons.length) || ((ref = _this26.vsObjects) === null || ref === void 0 ? void 0 : ref.length))) {
                                                                    _ctx.next = 11;
                                                                    break;
                                                                }
                                                                ;
                                                                if (!(polygons === null || polygons === void 0 ? void 0 : polygons.length)) {
                                                                    _ctx.next = 8;
                                                                    break;
                                                                }
                                                                _ctx.next = 8;
                                                                return _this26.initPolygons();
                                                            case 8:
                                                                if (!((ref1 = _this26.vsObjects) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                                                                    _ctx.next = 11;
                                                                    break;
                                                                }
                                                                _ctx.next = 11;
                                                                return _this26.initVS();
                                                            case 11:
                                                                _ctx.next = 13;
                                                                return _this26.initAvatar();
                                                            case 13:
                                                            case "end":
                                                                return _ctx.stop();
                                                        }
                                                    }, _callee);
                                                })));
                                            }
                                        });
                                    case 11:
                                        _ctx.next = 16;
                                        break;
                                    case 13:
                                        _ctx.prev = 13;
                                        _ctx.t0 = _ctx["catch"](1);
                                        console.error(_ctx.t0);
                                    case 16:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    1,
                                    13
                                ]
                            ]);
                        })));
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this27 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initStarting = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _state, tour, _$tourType, showcaseLoaded, isChangeIframe, iframeUrl, showIntroScreen, isHideTags, condition, matterId, tagsRes, mpTags, treedisTags, isMatterportLink, ref, polygons, vsObjects, vsSettings, ref1, ref2, ref3, ref4, ref5, ref6, ref7, THREE, pose, isVisibleAsset;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _this27.setState({
                            appState: "starting"
                        });
                        _state = _this27.state, tour = _state.tour, _$tourType = _state.tourType, showcaseLoaded = _state.showcaseLoaded, isChangeIframe = _state.isChangeIframe, iframeUrl = _state.iframeUrl, showIntroScreen = _state.showIntroScreen;
                        isHideTags = tour.addon_hidetags;
                        condition = _$tourType === Tour/* TourType.Game */.v.Game ? true : !showcaseLoaded || isChangeIframe;
                        matterId = (0,util_all/* getQueryVariable */.Dv)(iframeUrl, "m");
                        if (condition) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 8:
                        _this27.yAxisVec3 = new _this27.THREE.Vector3(0, 1, 0);
                        _this27.loadingQueue.setLoadingQueueProgress(70, 100);
                        if (isHideTags) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 13;
                        return TreedisPublicDAO/* default.getTags */.Z.getTags({
                            matterId: matterId,
                            slug: matterId === tour.matterId ? tour.slug : null
                        });
                    case 13:
                        _ctx.t0 = _ctx.sent;
                        _ctx.next = 17;
                        break;
                    case 16:
                        _ctx.t0 = {};
                    case 17:
                        tagsRes = _ctx.t0;
                        if (isHideTags) {
                            _this27.setState({
                                loadingTags: false
                            });
                        }
                        mpTags = tagsRes === null || tagsRes === void 0 ? void 0 : tagsRes.matterTags;
                        treedisTags = tagsRes === null || tagsRes === void 0 ? void 0 : tagsRes.tags;
                        _this27.loadingQueue.setLoadingQueueProgress(60, 100);
                        isMatterportLink = (0,util_all/* getQueryVariable */.Dv)(_this27.state.iframeUrl, "m") !== tour.matterId;
                        _ctx.next = 25;
                        return (0,queries/* getVSItems */.BZ)(isMatterportLink, {
                            slug: tour.slug,
                            userId: tour.userId,
                            id: tour.id,
                            tourType: _$tourType
                        });
                    case 25:
                        ref = _ctx.sent;
                        polygons = ref.polygons;
                        vsObjects = ref.vsObjects;
                        vsSettings = ref.vsSettings;
                        _this27.loadingQueue.setLoadingQueueProgress(50, 100);
                        _this27.setState({
                            allTags: new Map(),
                            polygons: polygons,
                            vsSettings: vsSettings
                        }, function() {
                            Mattertag.subscribe({
                                mpSdk: _this27.showCaseTemp.showcase,
                                mpTags: mpTags,
                                treedisTags: treedisTags
                            }, function(allTags) {
                                _this27.setState({
                                    allTags: allTags
                                }, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                    var _$allTags, tags;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _$allTags = _this27.state.allTags;
                                                _ctx.next = 3;
                                                return _this27.initTags(Array.from(_$allTags.values()));
                                            case 3:
                                                tags = _ctx.sent;
                                                _this27.setState({
                                                    loadingTags: false,
                                                    allTags: tags
                                                }, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                                    return runtime_default().wrap(function _callee$(_ctx) {
                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                            case 0:
                                                                try {
                                                                    _this27.hiddenTags = {};
                                                                    _this27.visibleTags = {};
                                                                    _this27.filterTags();
                                                                } catch (err) {
                                                                    console.error(err);
                                                                }
                                                            case 1:
                                                            case "end":
                                                                return _ctx.stop();
                                                        }
                                                    }, _callee);
                                                })));
                                            case 5:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                })));
                            });
                            if (_$tourType === Tour/* TourType.Game */.v.Game && !tour.introScreen) {
                                _this27.handleGameStartWithoutIntro();
                            }
                            _this27.setState({
                                isChangeIframe: false,
                                showcaseLoaded: true
                            });
                        });
                        _this27.vsObjects = vsObjects.filter(function(obj) {
                            return obj.active;
                        }); // TODO: move to backend..
                        // if no VS objects, Media Images of Media Videos found - loadingQueueProgress is set to 100%
                        // to do not display the loading indicator for VS
                        if (!_this27.vsObjects.length || !showIntroScreen) {
                            // if there is no intro screen, we don't wait for VS!
                            _this27.loadingQueue.setFullLoadingQueueProgress();
                        } else if (_this27.pose) {
                            ;
                            THREE = _this27.THREE;
                            pose = new THREE.Vector3((ref1 = _this27.pose) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.position) === null || ref2 === void 0 ? void 0 : ref2.x, (ref3 = _this27.pose) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.position) === null || ref4 === void 0 ? void 0 : ref4.y, (ref5 = _this27.pose) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.position) === null || ref6 === void 0 ? void 0 : ref6.z);
                            isVisibleAsset = _this27.vsObjects.find(function(asset) {
                                var assetPose = new THREE.Vector3(asset.positionX, asset.positionY, asset.positionZ);
                                var distance = pose.distanceTo(assetPose);
                                return distance <= (tour.vsRenderRange || DEFAULT_VS_SENSOR_RADIUS);
                            });
                            if (!isVisibleAsset || ((ref7 = _this27.pose) === null || ref7 === void 0 ? void 0 : ref7.mode) === _this27.showCaseTemp.showcase.Mode.Mode.OUTSIDE) {
                                _this27.loadingQueue.setFullLoadingQueueProgress();
                            } else {
                                _this27.renderVS(_this27.pose);
                            }
                        }
                        _ctx.next = 38;
                        break;
                    case 35:
                        _ctx.prev = 35;
                        _ctx.t1 = _ctx["catch"](0);
                        console.error(_ctx.t1);
                    case 38:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    35
                ]
            ]);
        }));
        var _this28 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initSweep = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this28.showCaseTemp.sweep.subscribe(function(sweeps) {
                            _this28.setState({
                                sweeps: sweeps,
                                sweepsLoaded: true
                            }, function() {
                                return afterSweepsInit({
                                    sweeps: _this28.state.sweeps,
                                    matterId: _this28.state.tour.matterId,
                                    slug: _this28.state.tour.slug,
                                    iframeUrl: _this28.state.iframeUrl,
                                    setData: function(data) {
                                        _this28.setState(data);
                                    },
                                    cb: function() {
                                        var s = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "s");
                                        var x = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "x");
                                        var y = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "y");
                                        if (_this28.pose.mode === _this28.showCaseTemp.showcase.Mode.Mode.INSIDE && s && x && y) {
                                            if (_this28.state.sweeps.some(function(sweep) {
                                                return s === sweep.uuid;
                                            })) {
                                                _this28.moveToSweep(String(s), {
                                                    x: parseFloat(x),
                                                    y: parseFloat(y)
                                                });
                                            }
                                        }
                                    }
                                });
                            });
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this29 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initScene = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this29.showCaseTemp.tag.on(dist/* TagEventsType.OpenTagIframe */.Gc.OpenTagIframe, function(param) {
                            var event = param.event, tagId = param.tagId;
                            if (event === _this29.showCaseTemp.tags.matterTag.Event.CLICK) {
                                _this29.setState({
                                    clickedElement: {
                                        id: tagId,
                                        type: Game/* EntityType.Tag */.py.Tag
                                    }
                                });
                            }
                        });
                        _this29.showCaseTemp.scene.sceneObject.on(dist/* NodeEventsTypes.OBJECT_CLICK */.cA.OBJECT_CLICK, function(param) {
                            var data = param.data, eventData = param.eventData;
                            _this29.emitVSChangesFromHost({
                                data: data,
                                eventData: eventData,
                                type: VSObject/* VSInteractionType.CLICK */.IG.CLICK
                            });
                            if (_this29.state.tourType === Tour/* TourType.Game */.v.Game) {
                                _this29.openVsObjectIframe(data);
                            }
                            _this29.setState({
                                clickedElement: {
                                    id: data.id,
                                    type: Game/* EntityType.VSItem */.py.VSItem
                                }
                            });
                        });
                        _this29.showCaseTemp.scene.sceneImage.on(dist/* NodeEventsTypes.IMAGE_HOVER */.cA.IMAGE_HOVER, function(param) {
                            var eventData = param.eventData, data = param.data;
                            if (data.actionType === VSObject/* TourImageActionType.None */.rx.None) {
                                return;
                            }
                            _this29.emitVSChangesFromHost({
                                data: data,
                                eventData: eventData,
                                type: VSObject/* VSInteractionType.HOVER */.IG.HOVER
                            });
                            _this29.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                            if (data.action === VSObject/* TourImageAction.Hover */.Z5.Hover && eventData.hover) {
                                _this29.handleImageAction(data);
                            }
                        });
                        _this29.showCaseTemp.scene.sceneImage.on(dist/* NodeEventsTypes.IMAGE_CLICK */.cA.IMAGE_CLICK, function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                                var eventData, data, triggerVSAnimation;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            eventData = param.eventData, data = param.data;
                                            _this29.emitVSChangesFromHost({
                                                data: data,
                                                eventData: eventData,
                                                type: VSObject/* VSInteractionType.CLICK */.IG.CLICK
                                            });
                                            if (_this29.state.tourType === Tour/* TourType.Game */.v.Game) {
                                                _this29.openVsImageIframe(data);
                                            }
                                            triggerVSAnimation = function() {
                                                // handle trigger VS animation event
                                                if (data.toursVSObjectId) {
                                                    _this29.showCaseTemp.scene.sceneObject.assets.forEach(function(param) {
                                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), assetKey = _param[0], node = _param[1];
                                                        if (assetKey.id === data.toursVSObjectId) {
                                                            var _node = (0,_sliced_to_array/* default */.Z)(node, 2), component = _node[1];
                                                            component.toggleClipAnimation(true);
                                                        }
                                                    });
                                                }
                                            };
                                            if (!(!data.actionType || data.actionType === VSObject/* TourImageActionType.None */.rx.None)) {
                                                _ctx.next = 7;
                                                break;
                                            }
                                            // do not wait when the action starts playing, if the is no action
                                            triggerVSAnimation();
                                            return _ctx.abrupt("return");
                                        case 7:
                                            if (!(data.action === VSObject/* TourImageAction.Click */.Z5.Click)) {
                                                _ctx.next = 11;
                                                break;
                                            }
                                            _ctx.next = 10;
                                            return _this29.handleImageAction(data);
                                        case 10:
                                            // waiting for the action to start playing
                                            triggerVSAnimation();
                                        case 11:
                                            _this29.setState({
                                                clickedElement: {
                                                    id: data.id,
                                                    type: Game/* EntityType.VSImage */.py.VSImage
                                                }
                                            });
                                        case 12:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(_) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _this29.showCaseTemp.scene.sceneImage.on(dist/* NodeEventsTypes.AVATAR_BUTTON_HOVER */.cA.AVATAR_BUTTON_HOVER, function(param) {
                            var eventData = param.eventData;
                            _this29.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                        });
                        _this29.showCaseTemp.scene.scenePolygon.on(dist/* NodeEventsTypes.POLYGON_EVENTS */.cA.POLYGON_EVENTS, function(param) {
                            var type = param.type, component = param.component, eventData = param.eventData, data = param.data;
                            var handleAction = function(action, eventType, eventData) {
                                if (!action) {
                                    return;
                                }
                                if (action.type === Polygon/* PolygonActionType.None */.zS.None) {
                                    return;
                                }
                                if (action.action === Polygon/* PolygonActionAction.Hover */.IW.Hover && eventType === VSObject/* VSInteractionType.HOVER */.IG.HOVER && eventData.hover) {
                                    _this29.handlePolygonAction(action);
                                }
                                if (action.action === Polygon/* PolygonActionAction.Click */.IW.Click && eventType === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                                    _this29.handlePolygonAction(action);
                                }
                            };
                            var isGameTour = _this29.state.tourType === Tour/* TourType.Game */.v.Game && _this29.state.tour.gameId;
                            var isECommerceTour = _this29.state.tourType === Tour/* TourType.ECommerce */.v.ECommerce;
                            if (type === VSObject/* VSInteractionType.HOVER */.IG.HOVER) {
                                _this29.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                            }
                            if (type === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                                _this29.setState({
                                    clickedElement: {
                                        id: (data === null || data === void 0 ? void 0 : data.id) || (data === null || data === void 0 ? void 0 : data.id),
                                        type: Game/* EntityType.Polygon */.py.Polygon
                                    }
                                });
                            }
                            if (isGameTour) {
                                if (type === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                                    // @ts-ignore
                                    var result = _this29.handlePolygonLock && _this29.handlePolygonLock(data.id);
                                    _this29.unlockChapter && _this29.unlockChapter(data, GameBook/* ChapterType.Polygon */._U.Polygon);
                                    if (result) {
                                        var action = data.polygonsActions.find(function(i) {
                                            return i.mode === Polygon/* PolygonActionMode.VS */.l3.VS;
                                        });
                                        var polygonAction = new Polygon/* PolygonAction */.fD(action);
                                        handleAction(polygonAction, type, eventData);
                                        if (polygonAction.gameBackpack && !_this29.state.polygonsBackpack.find(function(param) {
                                            var id = param.id;
                                            return data.id === id;
                                        })) {
                                            _this29.setState({
                                                polygonsBackpack: [
                                                    data
                                                ].concat((0,_to_consumable_array/* default */.Z)(_this29.state.polygonsBackpack))
                                            });
                                        }
                                    } else if (result === undefined) {
                                        component.setSelection();
                                    }
                                }
                            } else if (isECommerceTour && data.products.length && type === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                                _this29.handlePolygonProduct && _this29.handlePolygonProduct(data);
                            } else {
                                var action1 = data.polygonsActions.find(function(i) {
                                    return i.mode === Polygon/* PolygonActionMode.VS */.l3.VS;
                                });
                                handleAction(new Polygon/* PolygonAction */.fD(action1), type, eventData);
                            }
                        });
                        _this29.showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.VIDEO_HOVER */.cA.VIDEO_HOVER, function(param) {
                            var data = param.data, eventData = param.eventData;
                            _this29.emitVSChangesFromHost({
                                data: data,
                                eventData: eventData,
                                type: VSObject/* VSInteractionType.HOVER */.IG.HOVER
                            });
                        });
                        _this29.showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.VIDEO_CLICK */.cA.VIDEO_CLICK, function(param) {
                            var data = param.data, eventData = param.eventData;
                            _this29.emitVSChangesFromHost({
                                data: data,
                                eventData: eventData,
                                type: VSObject/* VSInteractionType.CLICK */.IG.CLICK
                            });
                            if (_this29.state.tourType === Tour/* TourType.Game */.v.Game) {
                                _this29.openVsVideoIframe(data);
                            }
                            _this29.setState({
                                clickedElement: {
                                    id: data.id,
                                    type: Game/* EntityType.VSVideo */.py.VSVideo
                                }
                            });
                        });
                        _this29.showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.VIDEO_BUTTON_HOVER */.cA.VIDEO_BUTTON_HOVER, function(param) {
                            var eventData = param.eventData, data = param.data;
                            _this29.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                        });
                        _this29.showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.VIDEO_BUTTON_CLICK */.cA.VIDEO_BUTTON_CLICK, function(param) {
                            var eventData = param.eventData, data = param.data, component = param.component, muteBtnComponent = param.muteBtnComponent;
                            // console.log('aaa video button click - component.isMuted()', component.isMuted());
                            if (data.autoplay) {
                                if (component.isMuted()) {
                                    var audio = _this29.getOtherAudio();
                                    if (audio) {
                                        audio === null || audio === void 0 ? void 0 : audio.pause();
                                        _this29.setState({
                                            restoreAudio: audio
                                        });
                                    }
                                    _this29.setState({
                                        vsAudio: {
                                            component: component,
                                            btn: muteBtnComponent
                                        }
                                    });
                                } else if (_this29.state.restoreAudio) {
                                    _this29.state.restoreAudio.play();
                                    _this29.setState({
                                        restoreAudio: null,
                                        otherPlaying: true
                                    });
                                }
                                if (muteBtnComponent.isActive()) {
                                    var ref;
                                    var vsVideos = (ref = _this29.vsObjects) === null || ref === void 0 ? void 0 : ref.filter(function(obj) {
                                        var ref, ref1, ref2, ref3;
                                        return ((ref = obj.node) === null || ref === void 0 ? void 0 : ref.components) && ((ref2 = (ref1 = obj.node) === null || ref1 === void 0 ? void 0 : ref1.components[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.instance) === null || ref3 === void 0 ? void 0 : ref3.componentType) === videoRendererType;
                                    });
                                    vsVideos === null || vsVideos === void 0 ? void 0 : vsVideos.forEach(function(obj) {
                                        var ref;
                                        var ref1 = (0,_sliced_to_array/* default */.Z)((ref = obj.node) === null || ref === void 0 ? void 0 : ref.components, 2), vsVideo = ref1[0], muteBtn = ref1[1];
                                        if (!muteBtn.instance.active) {
                                            vsVideo.instance.video.muted = true;
                                            muteBtn.instance.active = true;
                                            muteBtn.instance.makeBtn(muteBtn.instance.inputs.src);
                                        }
                                    });
                                }
                                component.toggleMute();
                            } else if (data.node.video.paused) {
                                data.node.video.play();
                                data.node.video.muted = false;
                            } else {
                                data.node.video.pause();
                                data.node.video.muted = true;
                            }
                            muteBtnComponent.setActive(!muteBtnComponent.isActive());
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this30 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initObjectNode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(asset) {
                var node, isGameTour, ref;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            isGameTour = _this30.state.tourType === Tour/* TourType.Game */.v.Game && _this30.state.tour.gameId;
                            if (!(0,src_instanceof/* default */.Z)(asset, VSObject/* TourImage */.oP)) {
                                _ctx.next = 9;
                                break;
                            }
                            _ctx.next = 5;
                            return _this30.initImageNode(asset);
                        case 5:
                            node = _ctx.sent;
                            if (isGameTour && node && node.length === 2) node[1].animate = true;
                            _ctx.next = 27;
                            break;
                        case 9:
                            if (!(0,src_instanceof/* default */.Z)(asset, VSObject/* TourVideo */.Up)) {
                                _ctx.next = 17;
                                break;
                            }
                            ;
                            _ctx.next = 13;
                            return _this30.initVideoNode(asset);
                        case 13:
                            node = _ctx.sent;
                            if (isGameTour && node && node.length === 2) (ref = node[1].video) === null || ref === void 0 ? void 0 : ref.play();
                            _ctx.next = 27;
                            break;
                        case 17:
                            if (!(0,src_instanceof/* default */.Z)(asset, VSObject/* TourVSHtml */.q8)) {
                                _ctx.next = 23;
                                break;
                            }
                            _ctx.next = 20;
                            return _this30.initVSHtmlNode(asset);
                        case 20:
                            node = _ctx.sent;
                            _ctx.next = 27;
                            break;
                        case 23:
                            _ctx.next = 25;
                            return _this30.initNode(asset);
                        case 25:
                            node = _ctx.sent;
                            if (isGameTour && node && node.length === 2) node[1].animate = true;
                        case 27:
                            if (!(node && node.length === 2)) {
                                _ctx.next = 29;
                                break;
                            }
                            return _ctx.abrupt("return", node[1]);
                        case 29:
                            return _ctx.abrupt("return", null);
                        case 30:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(asset) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this31 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.setVSVisible = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(vsObject, visible) {
                var vsObjectType;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            if (!(visible && !vsObject.started)) {
                                _ctx.next = 8;
                                break;
                            }
                            vsObject.started = true; // we do it here because initObjectNode can take time
                            _ctx.next = 5;
                            return _this31.initObjectNode(vsObject);
                        case 5:
                            vsObject.node = _ctx.sent;
                            _ctx.next = 9;
                            break;
                        case 8:
                            if (!visible && vsObject.started && vsObject.node) {
                                vsObject.started = false;
                                vsObjectType = dist/* SceneInitEventsTypes.Object */.PS.Object;
                                if ((0,src_instanceof/* default */.Z)(vsObject, VSObject/* TourImage */.oP)) {
                                    vsObjectType = dist/* SceneInitEventsTypes.Image */.PS.Image;
                                } else if ((0,src_instanceof/* default */.Z)(vsObject, VSObject/* TourVideo */.Up)) {
                                    vsObjectType = dist/* SceneInitEventsTypes.Video */.PS.Video;
                                } else if ((0,src_instanceof/* default */.Z)(vsObject, VSObject/* TourVSHtml */.q8)) {
                                    vsObjectType = dist/* SceneInitEventsTypes.HTML */.PS.HTML;
                                }
                                _this31.showCaseTemp.scene.remove(vsObjectType, vsObject);
                            }
                        case 9:
                            _ctx.next = 14;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error(_ctx.t0.message);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }));
            return function(vsObject, visible) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.filterVsElementsByGameCondition = function() {
            var startGameHideConditions = _this.state.game.conditions.filter(function(condition) {
                return !condition.lock_ids.length && condition.conditionType === Game/* ConditionType.HIDE */.CP.HIDE;
            });
            var vsItemsToHide = [];
            var vsVideosToHide = [];
            var vsImagesToHide = [];
            var vsHTMLsToHide = [];
            var polygonsToHide = [];
            startGameHideConditions.forEach(function(condition) {
                if (condition.entity_type === Game/* EntityType.Polygon */.py.Polygon) {
                    polygonsToHide = (0,_to_consumable_array/* default */.Z)(polygonsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                } else if (condition.entity_type === Game/* EntityType.VSItem */.py.VSItem) {
                    vsItemsToHide = (0,_to_consumable_array/* default */.Z)(vsItemsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSVideo */.py.VSVideo) {
                    vsVideosToHide = (0,_to_consumable_array/* default */.Z)(vsVideosToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSImage */.py.VSImage) {
                    vsImagesToHide = (0,_to_consumable_array/* default */.Z)(vsImagesToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSHTML */.py.VSHTML) {
                    vsHTMLsToHide = (0,_to_consumable_array/* default */.Z)(vsHTMLsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                }
            });
            return {
                startGameHideConditions: startGameHideConditions,
                vsItemsToHide: vsItemsToHide,
                vsVideosToHide: vsVideosToHide,
                vsImagesToHide: vsImagesToHide,
                vsHTMLsToHide: vsHTMLsToHide
            };
        };
        var _this32 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initVS = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isVSReady, isGameTour, ref, vsImagesToHide, vsItemsToHide, vsVideosToHide, vsHTMLsToHide, filteredVsObjects;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        isVSReady = _this32.state.isVSReady;
                        isGameTour = _this32.state.tourType === Tour/* TourType.Game */.v.Game && _this32.state.tour.gameId;
                        if (isVSReady) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        if (isGameTour) {
                            ref = _this32.filterVsElementsByGameCondition(), vsImagesToHide = ref.vsImagesToHide, vsItemsToHide = ref.vsItemsToHide, vsVideosToHide = ref.vsVideosToHide, vsHTMLsToHide = ref.vsHTMLsToHide;
                            filteredVsObjects = _this32.vsObjects.filter(function(item) {
                                return (0,src_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP) && !vsImagesToHide.includes(item.id) || (0,src_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && !vsItemsToHide.includes(item.id) || (0,src_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up) && !vsVideosToHide.includes(item.id) || (0,src_instanceof/* default */.Z)(item, VSObject/* TourVSHtml */.q8) && !vsHTMLsToHide.includes(item.id);
                            });
                            filteredVsObjects.forEach(function(obj) {
                                _this32.loadingQueue.enqueue((0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.next = 2;
                                                return _this32.setVSVisible(obj, true);
                                            case 2:
                                                _this32.loadingQueue.dequeue();
                                            case 3:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                })));
                            });
                            if (filteredVsObjects.length === 0) {
                                _this32.loadingQueue.setFullLoadingQueueProgress();
                            }
                        } else {
                            _this32.renderVS(_this32.pose);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this33 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.stopVS = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        try {
                            _this33.vsObjects.map(function(asset) {
                                _this33.setVSVisible(asset, false);
                            });
                        } catch (e) {
                            console.error(e);
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this34 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initPolygons = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var promises, polygons;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        promises = _this34.state.polygons.map(function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
                                var node;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            if (item.active) {
                                                _ctx.next = 2;
                                                break;
                                            }
                                            return _ctx.abrupt("return", item);
                                        case 2:
                                            if (item.uuid) {
                                                _ctx.next = 9;
                                                break;
                                            }
                                            _ctx.next = 5;
                                            return _this34.initPolygonNode(item);
                                        case 5:
                                            node = _ctx.sent;
                                            _this34.modelNodes.push(node);
                                            item.uuid = node[0].obj3D.uuid;
                                            return _ctx.abrupt("return", item);
                                        case 9:
                                            return _ctx.abrupt("return", item);
                                        case 10:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(item) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _ctx.next = 3;
                        return Promise.all(promises);
                    case 3:
                        polygons = _ctx.sent;
                        if (_this34.state.waitLoadingPolygons) {
                            _this34.setState({
                                gameStatus: types/* GameStatus.Started */.XI.Started
                            });
                        }
                        if (!isEqual_default()(polygons, _this34.state.polygons)) {
                            _this34.setState({
                                polygons: polygons
                            });
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this35 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initNode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _this35.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Object */.PS.Object, data);
                        case 2:
                            res = _ctx.sent;
                            return _ctx.abrupt("return", res.length ? res : []);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this36 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initImageNode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _this36.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Image */.PS.Image, data);
                        case 2:
                            res = _ctx.sent;
                            if (res.length) {
                                _ctx.next = 5;
                                break;
                            }
                            return _ctx.abrupt("return", []);
                        case 5:
                            return _ctx.abrupt("return", res);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this37 = (0,_assert_this_initialized/* default */.Z)(_this);
        /*

  */ _this.initVideoNode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var options, elementType, VimeoVideo, vimeoVideo, res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            options = {
                                vimeoURL: "",
                                withButton: (0,_object_spread/* default */.Z)({
                                    mute: "/images/mute_icon.png",
                                    unMute: "/images/unmute_icon.png"
                                }, !data.autoplay && {
                                    play: "/images/play_icon.png",
                                    pause: "/images/pause_icon.png"
                                })
                            };
                            elementType = data.details.type;
                            if (!(elementType === VSObject/* VSVideoType.Vimeo */.OV.Vimeo && _this37.state.tour.clientId)) {
                                _ctx.next = 12;
                                break;
                            }
                            _ctx.next = 5;
                            return __webpack_require__.e(/* import() */ 1023).then(__webpack_require__.bind(__webpack_require__, 11023)).then(function(res) {
                                return res.default;
                            });
                        case 5:
                            VimeoVideo = _ctx.sent;
                            vimeoVideo = new VimeoVideo(VimeoVideo.parseVideoId(data.getVideoURL()));
                            _ctx.next = 9;
                            return vimeoVideo.loadFromVideoId(_this37.state.tour.clientId);
                        case 9:
                            _ctx.next = 11;
                            return TreedisPublicDAO/* default.getVimeoVideoUrl */.Z.getVimeoVideoUrl(vimeoVideo.getFileURL());
                        case 11:
                            options.vimeoURL = _ctx.sent;
                        case 12:
                            _ctx.next = 14;
                            return _this37.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Video */.PS.Video, data, options);
                        case 14:
                            res = _ctx.sent;
                            if (!(!res.length || res.length === 1)) {
                                _ctx.next = 17;
                                break;
                            }
                            return _ctx.abrupt("return", []);
                        case 17:
                            return _ctx.abrupt("return", res);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this38 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initVSHtmlNode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var res;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _this38.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.HTML */.PS.HTML, data);
                        case 2:
                            res = _ctx.sent;
                            if (!(!res.length || res.length === 1)) {
                                _ctx.next = 5;
                                break;
                            }
                            return _ctx.abrupt("return", []);
                        case 5:
                            return _ctx.abrupt("return", res);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this39 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initPolygonNode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _this39.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Polygon */.PS.Polygon, data);
                        case 2:
                            return _ctx.abrupt("return", _ctx.sent);
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this40 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initAvatarNode = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var avatar;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _this40.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Avatar */.PS.Avatar, data, {
                                host: _this40.state.host,
                                withButton: {
                                    mute: "/images/mute_icon.png",
                                    unMute: "/images/unmute_icon.png"
                                }
                            });
                        case 2:
                            avatar = _ctx.sent;
                            avatar[1].inputs.bodyType = data.bodyType;
                            return _ctx.abrupt("return", avatar);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this41 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleImageAction = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var _tour, noAudioMode, tourId, src, segments, id, tour, changeMinimap, ref, tourMusicWasPaused, sweepMusicWasPaused;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _tour = _this41.state.tour, noAudioMode = _tour.noAudioMode, tourId = _tour.id;
                            _ctx.t0 = data.actionType;
                            _ctx.next = _ctx.t0 === VSObject/* TourImageActionType.Tab */.rx.Tab ? 4 : _ctx.t0 === VSObject/* TourImageActionType.Music */.rx.Music ? 6 : _ctx.t0 === VSObject/* TourImageActionType.Video */.rx.Video ? 21 : _ctx.t0 === VSObject/* TourImageActionType.Treedis */.rx.Treedis ? 30 : _ctx.t0 === VSObject/* TourImageActionType.Menu */.rx.Menu ? 39 : _ctx.t0 === VSObject/* TourImageActionType.Panorama */.rx.Panorama ? 41 : _ctx.t0 === VSObject/* TourImageActionType.ExperiencePopUp */.rx.ExperiencePopUp ? 43 : 51;
                            break;
                        case 4:
                            if (data.action === VSObject/* TourImageAction.Hover */.Z5.Hover) {
                                window.open(data.actionURL);
                            } else if (data.action === VSObject/* TourImageAction.Click */.Z5.Click) {
                                window.open(data.actionURL);
                            }
                            return _ctx.abrupt("return");
                        case 6:
                            if (!(noAudioMode && _this41.state.room)) {
                                _ctx.next = 8;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 8:
                            src = "".concat("https://cdn.treedis.com", "/tours/").concat(_this41.state.tour.id, "/vsimages/").concat(data.actionURL);
                            if (!_this41.polygonAudio) {
                                _ctx.next = 12;
                                break;
                            }
                            if (!(_this41.polygonAudio.src === src && data.action === VSObject/* TourImageAction.Hover */.Z5.Hover)) {
                                _ctx.next = 12;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 12:
                            _ctx.next = 14;
                            return _this41.pauseAllAudio("polygonAudio");
                        case 14:
                            _ctx.next = 16;
                            return _this41.createAudioStream("polygonAudio", src, true);
                        case 16:
                            _this41.polygonAudio = _ctx.sent;
                            _ctx.next = 19;
                            return _this41.playContainerAudio("polygonAudio");
                        case 19:
                            _this41.setState({
                                mainPlaying: false,
                                otherPlaying: true
                            });
                            return _ctx.abrupt("return");
                        case 21:
                            data.actionURL = (0,util_all/* getVideoLink */.rp)(data.actionURL, {
                                mute: noAudioMode && _this41.state.room
                            });
                            if (!(_this41.state.tourType === Tour/* TourType.Game */.v.Game)) {
                                _ctx.next = 26;
                                break;
                            }
                            {
                                _this41.pauseTourMusic();
                            }
                            _ctx.next = 29;
                            break;
                        case 26:
                            _ctx.next = 28;
                            return _this41.pauseAllAudio();
                        case 28:
                            _this41.setState({
                                mainPlaying: false,
                                otherPlaying: false
                            });
                        case 29:
                            return _ctx.abrupt("break", 51);
                        case 30:
                            segments = data.actionURL.split("/");
                            id = segments[segments.length - 1].split("?")[0];
                            if (!(0,util_all/* getQueryVariable */.Dv)(data.actionURL, "m")) {
                                _ctx.next = 35;
                                break;
                            }
                            react_toastify_esm/* toast.error */.Am.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
                            return _ctx.abrupt("return");
                        case 35:
                            tour = _this41.state.tour;
                            changeMinimap = tour && !tour.customMinimap;
                            _this41.setState({
                                panoramaOn: false,
                                activePano: null
                            }, function() {
                                // false = dont change the menu/panorama
                                _this41.getTour({
                                    id: id,
                                    changeMenu: false,
                                    changeMinimap: changeMinimap,
                                    changePanorama: false,
                                    url: data.actionURL
                                });
                            });
                            return _ctx.abrupt("return");
                        case 39:
                            _this41.setState({
                                menuOpen: false,
                                activeMenu: null
                            }, function() {
                                _this41.setState({
                                    menuOpen: true,
                                    menuOpened: true,
                                    activeMenu: {
                                        id: data.menuId,
                                        subMenu: data.subMenuId,
                                        subSubMenu: data.subSubMenuId
                                    }
                                });
                            });
                            return _ctx.abrupt("return");
                        case 41:
                            _this41.setState({
                                activePano: data.panoramaId,
                                panoramaOn: true
                            });
                            return _ctx.abrupt("return");
                        case 43:
                            ;
                            tourMusicWasPaused = _this41.tourAudio && !_this41.tourAudio.ended && !_this41.tourAudio.paused;
                            sweepMusicWasPaused = _this41.sweepAudio && !_this41.sweepAudio.ended && !_this41.sweepAudio.paused;
                            _ctx.next = 48;
                            return _this41.pauseAllAudio();
                        case 48:
                            _this41.setState({
                                mainPlaying: false,
                                otherPlaying: false
                            });
                            // if (this.state.tourType === TourType.Game) {
                            //   await this.pauseTourMusic();
                            // } else {
                            //   await this.pauseAllAudio();
                            //   this.setState({ mainPlaying: false, otherPlaying: false });
                            // }
                            _this41.setState({
                                tourMusicWasPaused: tourMusicWasPaused,
                                sweepMusicWasPaused: sweepMusicWasPaused,
                                experiencePopUpIsOpen: true,
                                closedElementPopup: false,
                                experiencePopUpData: {
                                    title: data.popupTitle,
                                    url: data.actionURL,
                                    description: data.text,
                                    defaultImageUrl: data === null || data === void 0 ? void 0 : (ref = data.details) === null || ref === void 0 ? void 0 : ref.url,
                                    prefixImageUrl: "/tours/".concat(tourId, "/vsimages/"),
                                    rotation: data.rotation,
                                    backgroundColor: data.backgroundColor,
                                    backgroundOpacity: data.backgroundOpacity,
                                    textColor: data.textColor,
                                    buttonColor: data.buttonColor
                                }
                            });
                            return _ctx.abrupt("return");
                        case 51:
                            _this41.setState({
                                vsActionPopOn: true,
                                openedVSAction: data,
                                closedElementPopup: false
                            });
                        case 52:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.emitVSChangesFromHost = function(param) {
            var data = param.data, eventData = param.eventData, type = param.type;
            var _state = _this.state, showcaseLoaded = _state.showcaseLoaded, room = _state.room, host = _state.host;
            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host && _this.pose.mode === _this.showcase.Mode.Mode.INSIDE) {
                var key = data.vsImageId ? "vsImageId" : data.vsVideoId ? "vsVideoId" : data.vsObjectId ? "vsObjectId" : "";
                if (!key) return;
                var _obj;
                socket/* default.emit */.Z.emit("vs", (_obj = {}, (0,src_define_property/* default */.Z)(_obj, key, data.id), (0,src_define_property/* default */.Z)(_obj, "eventData", eventData), (0,src_define_property/* default */.Z)(_obj, "type", type), _obj));
            }
        };
        var _this42 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handlePolygonAction = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var _state, tour, _$tourType, noAudioMode, sweepAudioPlaying, tourAudioPlaying, src, segments, id, tour1, changeMinimap, ref, ref1, ref2, ref3;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _state = _this42.state, tour = _state.tour, _$tourType = _state.tourType;
                            noAudioMode = tour.noAudioMode;
                            if (_$tourType === Tour/* TourType.Game */.v.Game) {
                                sweepAudioPlaying = _this42.isPlaying(_this42.sweepAudio);
                                tourAudioPlaying = _this42.isPlaying(_this42.tourAudio);
                                if (sweepAudioPlaying) {
                                    _this42.setState({
                                        sweepMusicWasPaused: true
                                    });
                                } else if (tourAudioPlaying) {
                                    _this42.setState({
                                        tourMusicWasPaused: true
                                    });
                                }
                            }
                            _ctx.t0 = data.type;
                            _ctx.next = _ctx.t0 === Polygon/* PolygonActionType.Tab */.zS.Tab ? 6 : _ctx.t0 === Polygon/* PolygonActionType.Music */.zS.Music ? 8 : _ctx.t0 === Polygon/* PolygonActionType.Video */.zS.Video ? 23 : _ctx.t0 === Polygon/* PolygonActionType.Treedis */.zS.Treedis ? 28 : _ctx.t0 === Polygon/* PolygonActionType.Menu */.zS.Menu ? 37 : _ctx.t0 === Polygon/* PolygonActionType.Panorama */.zS.Panorama ? 39 : _ctx.t0 === Polygon/* PolygonActionType.Matterport */.zS.Matterport ? 41 : _ctx.t0 === Polygon/* PolygonActionType.MatterportInstant */.zS.MatterportInstant ? 44 : 47;
                            break;
                        case 6:
                            if (data.action !== Polygon/* PolygonActionAction.Hover */.IW.Hover) {
                                window.open(data.url);
                            }
                            return _ctx.abrupt("return");
                        case 8:
                            if (!(noAudioMode && _this42.state.room)) {
                                _ctx.next = 10;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 10:
                            src = "".concat("https://cdn.treedis.com", "/tours/").concat(_this42.state.tour.id, "/polygons/").concat(data.url);
                            if (!_this42.polygonAudio) {
                                _ctx.next = 14;
                                break;
                            }
                            if (!(_this42.polygonAudio.src === src && data.action === Polygon/* PolygonActionAction.Hover */.IW.Hover)) {
                                _ctx.next = 14;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 14:
                            _ctx.next = 16;
                            return _this42.pauseAllAudio("polygonAudio");
                        case 16:
                            _ctx.next = 18;
                            return _this42.createAudioStream("polygonAudio", src, true);
                        case 18:
                            _this42.polygonAudio = _ctx.sent;
                            _ctx.next = 21;
                            return _this42.playContainerAudio("polygonAudio");
                        case 21:
                            _this42.setState({
                                mainPlaying: false,
                                otherPlaying: true
                            });
                            return _ctx.abrupt("return");
                        case 23:
                            data.url = (0,util_all/* getVideoLink */.rp)(data.url, {
                                mute: noAudioMode && _this42.state.room,
                                autoplay: data.autoPlay ? 1 : 0
                            });
                            _ctx.next = 26;
                            return _this42.pauseAllAudio();
                        case 26:
                            _this42.setState({
                                mainPlaying: false,
                                otherPlaying: false
                            });
                            return _ctx.abrupt("break", 47);
                        case 28:
                            segments = data.url.split("/");
                            id = segments[segments.length - 1].split("?")[0];
                            if (!(0,util_all/* getQueryVariable */.Dv)(data.url, "m")) {
                                _ctx.next = 33;
                                break;
                            }
                            react_toastify_esm/* toast.error */.Am.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
                            return _ctx.abrupt("return");
                        case 33:
                            tour1 = _this42.state.tour;
                            changeMinimap = tour1 && !tour1.customMinimap;
                            _this42.setState({
                                panoramaOn: false,
                                activePano: null
                            }, function() {
                                // false = dont change the menu/panorama
                                _this42.getTour({
                                    id: id,
                                    changeMenu: false,
                                    changeMinimap: changeMinimap,
                                    changePanorama: false,
                                    url: data.url
                                });
                            });
                            return _ctx.abrupt("return");
                        case 37:
                            _this42.setState({
                                menuOpen: false,
                                activeMenu: {
                                    id: null,
                                    subMenu: null,
                                    subSubMenu: null
                                }
                            }, function() {
                                _this42.setState({
                                    menuOpen: true,
                                    menuOpened: true,
                                    activeMenu: {
                                        id: data.menuId,
                                        subMenu: data.subMenuId,
                                        subSubMenu: data.subSubMenuId
                                    }
                                });
                            });
                            return _ctx.abrupt("return");
                        case 39:
                            _this42.setState({
                                activePano: data.panoramaId,
                                panoramaOn: true
                            });
                            return _ctx.abrupt("return");
                        case 41:
                            ;
                            _this42.moveModel("/mp-sdk/".concat("3.1.76", "/showcase.html?applicationKey=").concat((ref = _this42.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat(util_all/* getAllQueryVariables */.i1(data.url)), false, false);
                            return _ctx.abrupt("return");
                        case 44:
                            ;
                            _this42.moveModel("/mp-sdk/".concat("3.1.76", "/showcase.html?applicationKey=").concat((ref2 = _this42.state.tour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.mpSDK).concat(util_all/* getAllQueryVariables */.i1(data.url)), false, true);
                            return _ctx.abrupt("return");
                        case 47:
                            _this42.setState({
                                vsActionPopOn: true,
                                closedElementPopup: false,
                                openedVSAction: new Polygon/* PolygonAction */.fD(data)
                            });
                        case 48:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.updateSweepLoc = function(nextSweep) {
            _this.ticketUpdateSweepLoc(nextSweep.sid);
            // if (this.pose?.mode && this.pose?.mode !== this.showCaseTemp.showcase.Mode.Mode.INSIDE) return;
            var _state = _this.state, tour = _state.tour, sweepGroups = _state.sweepGroups;
            (0,analytic/* sendToGA */.o$)("event", {
                eventCategory: "Sweep",
                eventAction: "move",
                eventLabel: nextSweep.sid
            });
            var activeSweepGroup = null;
            sweepGroups.forEach(function(group, i) {
                var ref;
                (ref = group.sweeps) === null || ref === void 0 ? void 0 : ref.forEach(function(sweep) {
                    if (sweep.uuid === nextSweep.sid) {
                        activeSweepGroup = group.id;
                    }
                });
            });
            _this.setState({
                activeSweepGroup: activeSweepGroup
            }, function() {
                _this.resumeMusicAfterSweepGroup();
                _this.filterTags();
                _this.filterPolygon();
            });
            if (tour.minimap) {
                var loc = _this.calculateLocation(nextSweep);
                if (!loc) return;
                _this.setState({
                    mapWalkerX: loc.px,
                    mapWalkerY: loc.py,
                    minimaps: loc.minimaps
                });
            }
        };
        _this.resumeMusicAfterSweepGroup = function() {
            var _state = _this.state, currentFloor = _state.currentFloor, tour = _state.tour, activeSweepGroup = _state.activeSweepGroup, forceMusicPause = _state.forceMusicPause, tagPopOn = _state.tagPopOn, openedTag = _state.openedTag;
            if (activeSweepGroup !== null) return;
            var music = tour.musics.find(function(item) {
                return item.floor === currentFloor + 1;
            });
            var autoplay = (music === null || music === void 0 ? void 0 : music.autoplay) || false;
            if (!music && tour.music) {
                autoplay = tour.autoplayMusic;
            }
            if (autoplay && !tour.noAudioMode && !forceMusicPause) {
                var ref;
                var vsVideos = (ref = _this.vsObjects) === null || ref === void 0 ? void 0 : ref.filter(function(obj) {
                    var ref, ref1, ref2, ref3;
                    return ((ref = obj.node) === null || ref === void 0 ? void 0 : ref.components) && ((ref2 = (ref1 = obj.node) === null || ref1 === void 0 ? void 0 : ref1.components[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.instance) === null || ref3 === void 0 ? void 0 : ref3.componentType) === videoRendererType;
                });
                var hasActiveVsVideo = vsVideos === null || vsVideos === void 0 ? void 0 : vsVideos.find(function(vsVideo) {
                    var ref, ref1;
                    var ref2 = (0,_sliced_to_array/* default */.Z)((ref = vsVideo.node) === null || ref === void 0 ? void 0 : ref.components, 1), videoBtn = ref2[0];
                    return !(videoBtn === null || videoBtn === void 0 ? void 0 : (ref1 = videoBtn.instance) === null || ref1 === void 0 ? void 0 : ref1.active);
                });
                if (!hasActiveVsVideo && !(tagPopOn && openedTag.type === "video") && _this.tourAudio) {
                    if (_this.isTourReadyForAudio()) {
                        _this.tourAudio.play();
                        _this.setState({
                            mainPlaying: true,
                            otherPlaying: false
                        });
                    }
                }
            }
        };
        _this.markMinimap = function(p) {
            var _state = _this.state, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap;
            if (!minimaps || minimaps.length === 0 || selectedMinimap === null) return;
            minimaps[selectedMinimap].hotspots.forEach(function(h) {
                if (h.type === "panorama" && h.panoramaId === p.id) {
                    _this.setState({
                        mapWalkerX: h.x,
                        mapWalkerY: h.y,
                        activePano: null
                    });
                }
            });
        };
        _this.isTourReadyForAudio = function() {
            var _state = _this.state, showIntro = _state.showIntro, showIntroScreen = _state.showIntroScreen, gameStatus = _state.gameStatus, _$tourType = _state.tourType, avatar = _state.avatar, tour = _state.tour, showcaseLoaded = _state.showcaseLoaded, room = _state.room;
            return !(!showcaseLoaded || // video tour, before avatar select
            (room && (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) && !(avatar === null || avatar === void 0 ? void 0 : avatar.imageUrl)) || // regular tour, before avatar select
            (!room && (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) && !(avatar === null || avatar === void 0 ? void 0 : avatar.url)) || showIntro || showIntroScreen || _$tourType === Tour/* TourType.Game */.v.Game && gameStatus === types/* GameStatus.NotStarted */.XI.NotStarted);
        };
        var _this43 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.playAudio = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ignoreTimeout, ref, ref1, ref2, videoPlaying, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ignoreTimeout = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false;
                        _ctx.prev = 1;
                        ;
                        videoPlaying = _this43.state.videoPlaying;
                        if (!(!ignoreTimeout && _this43.playAudioTimeout)) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        // if ((!ignoreTimeout && this.playAudioTimeout) || (tourType === TourType.Game && ![GameStatus.NotStarted, GameStatus.Started].includes(gameStatus))) return;
                        _this43.playAudioTimeout = null;
                        if (_this43.isTourReadyForAudio()) {
                            _ctx.next = 11;
                            break;
                        }
                        _this43.mainContainerWaitingForPlay = true;
                        _this43.playAudioTimeout = setTimeout(function() {
                            return _this43.playAudio(true);
                        }, 500);
                        return _ctx.abrupt("return", _this43.playAudioTimeout);
                    case 11:
                        _this43.mainContainerWaitingForPlay = false;
                        if (!(videoPlaying || _this43.sweepAudio && !((ref = _this43.sweepAudio) === null || ref === void 0 ? void 0 : ref.paused) || _this43.polygonAudio && !((ref1 = _this43.polygonAudio) === null || ref1 === void 0 ? void 0 : ref1.paused))) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 14:
                        if (!((ref2 = _this43.tourAudio) === null || ref2 === void 0 ? void 0 : ref2.paused)) {
                            _ctx.next = 21;
                            break;
                        }
                        _ctx.next = 17;
                        return _this43.pauseAllAudio("tourAudio");
                    case 17:
                        _this43.tourAudio.muted = false;
                        _ctx.next = 20;
                        return _this43.tourAudio.play();
                    case 20:
                        _this43.setState({
                            mainPlaying: true,
                            otherPlaying: false
                        });
                    case 21:
                        _ctx.next = 27;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error("Error start playAudio ".concat(_ctx.t0.message));
                        setTimeout(function() {
                            return _this43.playAudio(true);
                        }, 500);
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    23
                ]
            ]);
        }));
        var _this44 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.moveToSweep = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sweepId, rotation) {
                var transition, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            transition = _args.length > 2 && _args[2] !== void 0 ? _args[2] : "INSTANT";
                            if (!_this44.showCaseTemp) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return", _this44.showCaseTemp.showcase.Sweep.moveTo(sweepId, {
                                rotation: rotation,
                                transition: _this44.showCaseTemp.showcase.Sweep.Transition[transition]
                            }).then(function() {
                                if (_this44.state.tourType !== Tour/* TourType.Game */.v.Game) {
                                    window.history.replaceState(null, "", _this44.buildLink(sweepId, rotation));
                                }
                            }).catch(function(err) {
                                console.error(err.toString());
                            }));
                        case 3:
                            react_toastify_esm/* toast.error */.Am.error("Wait for the model to load");
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(sweepId, rotation) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this45 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.moveToStep = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(step) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!_this45.showCaseTemp) {
                                _ctx.next = 5;
                                break;
                            }
                            _ctx.next = 3;
                            return _this45.showCaseTemp.showcase.Tour.step(step).catch(function(err) {
                                console.error(err.toString());
                            });
                        case 3:
                            _ctx.next = 6;
                            break;
                        case 5:
                            {
                                react_toastify_esm/* toast.error */.Am.error("Wait for the model to load");
                            }
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(step) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.closeMenu = function() {
            _this.setState(_this.setState({
                menuOpen: false
            }));
        };
        var _this46 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.stopPolygons = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var polygons;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        polygons = _this46.state.polygons;
                        _ctx.t0 = _this46;
                        _ctx.next = 5;
                        return Promise.all(polygons.map(function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
                                var nodeIndex;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            if (item.active) {
                                                _ctx.next = 2;
                                                break;
                                            }
                                            return _ctx.abrupt("return", item);
                                        case 2:
                                            nodeIndex = _this46.modelNodes.findIndex(function(node) {
                                                var ref, ref1;
                                                return ((ref = node[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.obj3D) === null || ref1 === void 0 ? void 0 : ref1.uuid) === item.uuid;
                                            });
                                            if (nodeIndex >= 0) {
                                                _this46.modelNodes[nodeIndex][0].stop();
                                                item.uuid = null;
                                                _this46.modelNodes.splice(nodeIndex, 1);
                                            }
                                            return _ctx.abrupt("return", item);
                                        case 5:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(item) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                    case 5:
                        _ctx.t1 = _ctx.sent;
                        _ctx.t2 = {
                            polygons: _ctx.t1
                        };
                        _ctx.t0.setState.call(_ctx.t0, _ctx.t2);
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t3 = _ctx["catch"](0);
                        console.error(_ctx.t3);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        var _this47 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.renderPolygons = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var polygons;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        polygons = _this47.state.polygons;
                        _ctx.next = 4;
                        return Promise.all(polygons.map(function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
                                var node, nodeIndex;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            if (!item.active) {
                                                _ctx.next = 10;
                                                break;
                                            }
                                            if (item.uuid) {
                                                _ctx.next = 8;
                                                break;
                                            }
                                            _ctx.next = 4;
                                            return _this47.initPolygonNode(item);
                                        case 4:
                                            node = _ctx.sent;
                                            _this47.modelNodes.push(node);
                                            item.uuid = node[0].obj3D.uuid;
                                            return _ctx.abrupt("return", item);
                                        case 8:
                                            _ctx.next = 11;
                                            break;
                                        case 10:
                                            {
                                                nodeIndex = _this47.modelNodes.findIndex(function(node) {
                                                    var ref, ref1;
                                                    return ((ref = node[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.obj3D) === null || ref1 === void 0 ? void 0 : ref1.uuid) === item.uuid;
                                                });
                                                if (nodeIndex >= 0) {
                                                    _this47.modelNodes[nodeIndex][0].stop();
                                                    item.uuid = null;
                                                    _this47.modelNodes.splice(nodeIndex, 1);
                                                }
                                            }
                                        case 11:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(item) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                    case 4:
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        var _this48 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.toggleVS = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, _state, isVSEnabled, isVSVisible;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if ((ref = _this48.vsObjects) === null || ref === void 0 ? void 0 : ref.length) {
                            _ctx.next = 4;
                            break;
                        }
                        react_toastify_esm/* toast.error */.Am.error("There is no vsObjects to hide");
                        return _ctx.abrupt("return");
                    case 4:
                        _state = _this48.state, isVSEnabled = _state.isVSEnabled, isVSVisible = _state.isVSVisible;
                        _this48.setState({
                            isVSEnabled: !isVSEnabled,
                            isVSVisible: !isVSVisible
                        }, (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        if (!(isVSEnabled && isVSVisible)) {
                                            _ctx.next = 7;
                                            break;
                                        }
                                        _ctx.next = 3;
                                        return _this48.stopVS();
                                    case 3:
                                        _ctx.next = 5;
                                        return _this48.stopPolygons();
                                    case 5:
                                        _ctx.next = 11;
                                        break;
                                    case 7:
                                        _ctx.next = 9;
                                        return _this48.initVS();
                                    case 9:
                                        _ctx.next = 11;
                                        return _this48.initPolygons();
                                    case 11:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        _this.openVR = function() {
            var ref, ref1, ref2;
            var iframeVrButton = (ref = _this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.document) === null || ref2 === void 0 ? void 0 : ref2.querySelector(".bottom-controls .view-in-vr");
            if (iframeVrButton) iframeVrButton.click();
        };
        _this.isPlaying = function(audio) {
            // console.log('aaa audio.paused currentAudio', audio?.paused, audio?.currentAudio);
            // console.log(audio);
            // console.dir(audio);
            return audio && (audio === null || audio === void 0 ? void 0 : audio.currentTime) > 0 && !(audio === null || audio === void 0 ? void 0 : audio.paused) && !(audio === null || audio === void 0 ? void 0 : audio.ended) && (audio === null || audio === void 0 ? void 0 : audio.readyState) > 2;
        };
        var _this49 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleTogglePano = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _state, panoramaOn, showcaseLoaded, room, host, tourPlaying, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _state = _this49.state, panoramaOn = _state.panoramaOn, showcaseLoaded = _state.showcaseLoaded, room = _state.room, host = _state.host, tourPlaying = _state.tourPlaying;
                        if (!(!panoramaOn && tourPlaying)) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 4;
                        return _this49.showCaseTemp.showcase.Tour.stop();
                    case 4:
                        data = {
                            panoramaOn: !panoramaOn,
                            activePano: panoramaOn ? null : _this49.state.activePano
                        };
                        if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                            socket/* default.emit */.Z.emit("toggle-pano", data);
                        }
                        if (!_this49.state.lock) {
                            _this49.setState(data);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        var _this50 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.pauseAllAudio = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var type, withVsAudio, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        type = _args.length > 0 && _args[0] !== void 0 ? _args[0] : "", withVsAudio = _args.length > 1 && _args[1] !== void 0 ? _args[1] : true;
                        _ctx.prev = 1;
                        if (!(_this50.tourAudio && type !== "tourAudio")) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 5;
                        return _this50.tourAudio.pause();
                    case 5:
                        if (!(_this50.tagAudio && type !== "tagAudio")) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 8;
                        return _this50.tagAudio.pause();
                    case 8:
                        if (!(_this50.sweepAudio && type !== "sweepAudio")) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 11;
                        return _this50.sweepAudio.pause();
                    case 11:
                        if (!(_this50.polygonAudio && type !== "polygonAudio")) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 14;
                        return _this50.polygonAudio.pause();
                    case 14:
                        if (!(_this50.panoramaAudio && type !== "panoramaAudio")) {
                            _ctx.next = 17;
                            break;
                        }
                        _ctx.next = 17;
                        return _this50.panoramaAudio.pause();
                    case 17:
                        if (!(_this50.buttonAudio && type !== "buttonAudio")) {
                            _ctx.next = 20;
                            break;
                        }
                        _ctx.next = 20;
                        return _this50.buttonAudio.pause();
                    case 20:
                        // game tour
                        // if (this.selectItemMusicEffect && type !== 'selectItemMusicEffect') {
                        //   await this.selectItemMusicEffect?.pause();
                        // }
                        if (_this50.state.vsAudio && withVsAudio) {
                            _this50.state.vsAudio.component.toggleMute(true);
                            _this50.state.vsAudio.btn.setActive(true);
                            _this50.setState({
                                vsAudio: null
                            });
                        }
                        _this50.setState({
                            mainPlaying: false,
                            otherPlaying: false
                        });
                        _ctx.next = 26;
                        break;
                    case 24:
                        _ctx.prev = 24;
                        _ctx.t0 = _ctx["catch"](1);
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    24
                ]
            ]);
        }));
        _this.createAudioStream = function(type, src) {
            var clearPrev = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            if (clearPrev && _this[type]) {
                _this[type].src = "";
            }
            _this[type] = new Audio();
            _this[type].src = src;
            _this[type].autoplay = false;
            _this[type].muted = deviceManager/* default.isIOS */.Z.isIOS(); // iOS trick
            _this[type].load();
            return _this[type];
        };
        _this.getShareLocation = function() {
            var location = sdk/* getLocation.call */.k$.call((0,_assert_this_initialized/* default */.Z)(_this));
            var _state = _this.state, panoramaOn = _state.panoramaOn, panoramas = _state.panoramas;
            if (panoramaOn && (panoramas === null || panoramas === void 0 ? void 0 : panoramas.length) > 0 && _this.currentPanorama) {
                var pano = "pano=".concat(_this.currentPanorama.id);
                var panoPitch = "panoPitch=".concat(_this.panoPose.pitch);
                var panoYaw = "panoYaw=".concat(_this.panoPose.yaw);
                var panoHfov = "panoHfov=".concat(_this.panoPose.hfov);
                var query = "".concat(pano, "&").concat(panoPitch, "&").concat(panoYaw, "&").concat(panoHfov);
                if (location.split("?")[1]) {
                    location += "&".concat(query);
                } else {
                    location += "?".concat(query);
                }
            }
            return location;
        };
        _this.updatePanoRotation = function(north, pos, scene) {
            var _state = _this.state, room = _state.room, host = _state.host, lock = _state.lock, panoramas = _state.panoramas;
            if (room && socket/* default */.Z && socket/* default.connected */.Z.connected) {
                if (host) {
                    var pano = panoramas.find(function(p) {
                        return p.name === scene;
                    });
                    if ((pano === null || pano === void 0 ? void 0 : pano.id) === _this.currentPanorama.id) {
                        socket/* default.emit */.Z.emit("move-pano", {
                            panoPose: pos,
                            currentPanorama: _this.currentPanorama
                        });
                    }
                    util_all/* updatePanoRotation.call */.k.call((0,_assert_this_initialized/* default */.Z)(_this), north, pos);
                } else if (!lock) {
                    util_all/* updatePanoRotation.call */.k.call((0,_assert_this_initialized/* default */.Z)(_this), north, pos);
                }
            } else {
                util_all/* updatePanoRotation.call */.k.call((0,_assert_this_initialized/* default */.Z)(_this), north, pos);
            }
        };
        _this.handlePanoSceneChange = function(scene) {
            _this.currentPanorama = scene;
            var _state = _this.state, room = _state.room, showcaseLoaded = _state.showcaseLoaded, host = _state.host;
            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                socket/* default.emit */.Z.emit("move-pano", {
                    panoPose: {
                        pitch: 0,
                        yaw: 0,
                        hfov: 100
                    },
                    currentPanorama: scene
                });
            }
        };
        _this.handleGameStartOnIntroModal = function(username) {
            _this.handleGameStart(username, true);
        };
        var _this51 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addAvatar = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, myX, myZ, ref21, x, z, modelId, response, json;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            ref20 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, 180 + _this51.avatarDegree, data === null || data === void 0 ? void 0 : (ref = data.pose) === null || ref === void 0 ? void 0 : (ref1 = ref.position) === null || ref1 === void 0 ? void 0 : ref1.x, data === null || data === void 0 ? void 0 : (ref2 = data.pose) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.position) === null || ref3 === void 0 ? void 0 : ref3.z), 2), myX = ref20[0], myZ = ref20[1];
                            ref21 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, data.degree, myX, myZ), 2), x = ref21[0], z = ref21[1];
                            modelId = getRPMModelId(data.avatarUrl);
                            _ctx.next = 6;
                            return fetch("https://models.readyplayer.me/".concat(modelId, ".json"));
                        case 6:
                            response = _ctx.sent;
                            _ctx.next = 9;
                            return response.json();
                        case 9:
                            json = _ctx.sent;
                            _ctx.next = 12;
                            return _this51.onAddAvatar(new virtualStaging_avatar/* Avatar */.qE({
                                uuid: data.avatarId,
                                bodyType: json.bodyType,
                                name: data.name,
                                url: data.avatarUrl,
                                positionX: _this51.defaultSweep && _this51.defaultSweep.sid === _this51.state.currentSweep.sid ? x : _this51.defaultSweep.position.x,
                                positionY: (ref4 = data.pose) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.position) === null || ref5 === void 0 ? void 0 : ref5.y,
                                positionZ: _this51.defaultSweep && _this51.defaultSweep.sid === _this51.state.currentSweep.sid ? z : _this51.defaultSweep.position.z,
                                rotationX: (ref6 = data.pose) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.rotation) === null || ref7 === void 0 ? void 0 : ref7._x,
                                rotationY: (ref8 = data.pose) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.rotation) === null || ref9 === void 0 ? void 0 : ref9._y,
                                rotationZ: (ref10 = data.pose) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.rotation) === null || ref11 === void 0 ? void 0 : ref11._z,
                                quaternionX: (ref12 = data.pose) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.quaternion) === null || ref13 === void 0 ? void 0 : ref13._x,
                                quaternionY: (ref14 = data.pose) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.quaternion) === null || ref15 === void 0 ? void 0 : ref15._y,
                                quaternionZ: (ref16 = data.pose) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.quaternion) === null || ref17 === void 0 ? void 0 : ref17._z,
                                quaternionW: (ref18 = data.pose) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.quaternion) === null || ref19 === void 0 ? void 0 : ref19._w,
                                degree: data.degree
                            }));
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this52 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onAddAvatar = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var ref, avatarNode;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (_this52.avatarNodes.has(data.uuid)) {
                                _ctx.next = 12;
                                break;
                            }
                            ;
                            if (!data.positionX && !data.positionY && !data.positionZ) {
                                data.positionX = _this52.pose.position.x;
                                data.positionY = _this52.pose.position.y;
                                data.positionZ = _this52.pose.position.z;
                            }
                            _ctx.next = 5;
                            return _this52.initAvatarNode(data);
                        case 5:
                            avatarNode = _ctx.sent;
                            avatarNode[0].obj3D.position.set(data.positionX, data.positionY, data.positionZ);
                            avatarNode[0].obj3D.rotation.set(data.rotationX, data.rotationY, data.rotationZ);
                            avatarNode[0].obj3D.quaternion.set(data.quaternionX, data.quaternionY, data.quaternionZ, data.quaternionW);
                            (ref = avatarNode[0].obj3D.children[0]) === null || ref === void 0 ? void 0 : ref.rotation.set(0, Math.PI, 0);
                            if (avatarNode === null || avatarNode === void 0 ? void 0 : avatarNode.length) {
                                if (!(data === null || data === void 0 ? void 0 : data.muted)) {
                                    if (avatarNode[2]) {
                                        // changing state to !active if video is not muted
                                        avatarNode[2].setActive(!avatarNode[2].isActive());
                                    }
                                }
                                _this52.avatarNodes.set(data.uuid, avatarNode);
                            }
                            return _ctx.abrupt("return", avatarNode);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this53 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onRemoveAvatar = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(uuid) {
                var ref, avatar;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (_this53.avatarNodes.size) {
                                ref = (0,_sliced_to_array/* default */.Z)(_this53.avatarNodes.get(uuid), 1), avatar = ref[0];
                                if (avatar) {
                                    avatar.stop();
                                    _this53.avatarNodes.delete(uuid);
                                }
                            }
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(uuid) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.videoEndCall = function() {
            socket/* default.close */.Z.close();
            _this.setState({
                reelVideos: []
            });
        };
        _this.videoChangeTour = function(data) {
            var tour = _this.state.tour;
            var m = (0,util_all/* getQueryVariable */.Dv)(_this.state.iframeUrl, "m");
            if (data.id && data.id !== m) {
                if (data.mp) {
                    var ref;
                    _this.moveModel("/mp-sdk/".concat("3.1.76", "/showcase.html?applicationKey=").concat(tour === null || tour === void 0 ? void 0 : (ref = tour.user) === null || ref === void 0 ? void 0 : ref.mpSDK, "&m=").concat(data.id));
                } else {
                    _this.getTour({
                        id: data.id,
                        changeMenu: false,
                        changeMinimap: true,
                        changePanorama: false
                    });
                }
            }
        };
        _this.changeMuteStatus = function(name, muted) {
            var _state = _this.state, fullscreenVideo = _state.fullscreenVideo, pinnedVideos = _state.pinnedVideos, reelVideos = _state.reelVideos;
            var isReeled = reelVideos.findIndex(function(i) {
                return i.name === name;
            });
            var isPinned = pinnedVideos.findIndex(function(i) {
                return i.name === name;
            });
            var isFullscreen = (fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.name) === name;
            if (isFullscreen) {
                fullscreenVideo.muted = muted;
            } else if (isPinned >= 0) {
                pinnedVideos[isPinned].muted = muted;
                _this.addPinnedVideo(pinnedVideos[isPinned]);
            } else if (isReeled >= 0) {
                reelVideos[isReeled].muted = muted;
                _this.addVideoReel(reelVideos[isReeled]);
            }
        };
        var _this54 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addTrack = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(p) {
                var ref, ref1, _state, fullscreenVideo, pinnedVideos, audioEl, isFullscreen, isPinned;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            try {
                                ;
                                _state = _this54.state, fullscreenVideo = _state.fullscreenVideo, pinnedVideos = _state.pinnedVideos;
                                if (((ref = p.track) === null || ref === void 0 ? void 0 : ref.kind) === "audio" && !p.self) {
                                    audioEl = new Audio();
                                    audioEl.append(p.track.attach());
                                    audioEl.setAttribute("data-cy-audio-track-name", p.track.name);
                                    audioEl.setAttribute("data-cy-audio-track-sid", p.sid);
                                    document.body.appendChild(audioEl);
                                    if (!p.enabled) {
                                        audioEl.pause();
                                        _this54.changeMuteStatus(p.name, true);
                                    } else {
                                        _this54.changeMuteStatus(p.name, false);
                                    }
                                } else if (((ref1 = p.track) === null || ref1 === void 0 ? void 0 : ref1.kind) === "video") {
                                    isFullscreen = (fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.sid) === p.sid;
                                    isPinned = pinnedVideos.findIndex(function(i) {
                                        return i.sid === p.sid;
                                    });
                                    if (p.dominant) {
                                        _this54.setState({
                                            dominantSpeaker: p
                                        });
                                    } else if (isFullscreen) {
                                        _this54.setState({
                                            fullscreenVideo: p
                                        });
                                    } else if (isPinned >= 0) {
                                        // || p.track.name.includes('-screen')
                                        // we pin screen shares
                                        _this54.addPinnedVideo(p);
                                    } else {
                                        _this54.addVideoReel(p);
                                    }
                                }
                            } catch (e) {
                                console.error(e);
                            }
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(p) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this55 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.removeTrack = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sid) {
                var _state, fullscreenVideo, pinnedVideos, audioOnly, isFullscreen, isPinned;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            try {
                                _state = _this55.state, fullscreenVideo = _state.fullscreenVideo, pinnedVideos = _state.pinnedVideos, audioOnly = _state.audioOnly;
                                isFullscreen = (fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.sid) === sid;
                                isPinned = pinnedVideos.findIndex(function(i) {
                                    return i.sid === sid;
                                });
                                if (isFullscreen) {
                                    _this55.setState({
                                        fullscreenVideo: null
                                    });
                                } else if (isPinned >= 0) {
                                    _this55.removePinnedVideo(sid);
                                    if (audioOnly) _this55.removePinnedVideo("".concat(sid, "_video"));
                                } else {
                                    _this55.removeVideoReel(sid);
                                    if (audioOnly) _this55.removeVideoReel("".concat(sid, "_video"));
                                }
                            } catch (e) {
                                console.error(e);
                            }
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this56 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.updateAvatarsInList = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(name, avatarImage) {
                var reelVideos, index;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            if (avatarImage) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 3:
                            reelVideos = (0,_to_consumable_array/* default */.Z)(_this56.state.reelVideos);
                            index = reelVideos.findIndex(function(i) {
                                return i.name === name;
                            });
                            if (index >= 0 && !reelVideos[index].avatarImage) {
                                reelVideos[index] = Object.assign(reelVideos[index], {
                                    avatarImage: avatarImage
                                });
                                _this56.setState({
                                    reelVideos: reelVideos
                                });
                            }
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }));
            return function(name, avatarImage) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this57 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addVideoReel = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(p) {
                var ref, reelVideos, index;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            try {
                                ;
                                if (((ref = p.track) === null || ref === void 0 ? void 0 : ref.kind) === "video") {
                                    reelVideos = (0,_to_consumable_array/* default */.Z)(_this57.state.reelVideos);
                                    index = reelVideos.findIndex(function(i) {
                                        return i.sid === p.sid;
                                    });
                                    if (index >= 0) {
                                        reelVideos[index] = Object.assign(reelVideos[index], p);
                                    } else {
                                        reelVideos.push(p);
                                    }
                                    _this57.setState({
                                        reelVideos: reelVideos
                                    });
                                }
                            } catch (e) {
                                console.error(e);
                            }
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(p) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this58 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.removeVideoReel = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sid) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            console.log("Removing ".concat(sid, " from reel"));
                            _this58.setState({
                                reelVideos: _this58.state.reelVideos.filter(function(i) {
                                    return i.sid !== sid;
                                })
                            });
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this59 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addPinnedVideo = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(p) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            addPinnedVideoFunc(p, _this59.state.pinnedVideos, function(pinnedVideos) {
                                _this59.setState({
                                    pinnedVideos: pinnedVideos
                                }, function() {
                                    if (!p.pinned) _this59.removeVideoReel(p.sid);
                                });
                            });
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(p) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this60 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.removePinnedVideo = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sid) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _this60.setState({
                                pinnedVideos: _this60.state.pinnedVideos.filter(function(i) {
                                    return i.sid !== sid;
                                })
                            });
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this61 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.toggleFullscreenVideo = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(participant) {
                var pinned, fullscreenVideo, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            pinned = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                            fullscreenVideo = _this61.state.fullscreenVideo;
                            if ((fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.sid) === participant.sid) {
                                // close fullscreen video
                                if (fullscreenVideo.pinned) {
                                    _this61.addPinnedVideo(fullscreenVideo);
                                } else {
                                    _this61.addVideoReel(fullscreenVideo);
                                }
                                _this61.setState({
                                    fullscreenVideo: null
                                });
                                document.removeEventListener("keydown", _this61.exitFullscreenVideo);
                            } else {
                                // open fullscreen video
                                if (fullscreenVideo) {
                                    // first close old one, then add the new one
                                    if (fullscreenVideo.pinned) {
                                        _this61.addPinnedVideo(fullscreenVideo);
                                    } else {
                                        _this61.addVideoReel(fullscreenVideo);
                                    }
                                }
                                _this61.setState({
                                    fullscreenVideo: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, participant), {
                                        pinned: pinned
                                    })
                                });
                                _this61.removePinnedVideo(participant.sid);
                                _this61.removeVideoReel(participant.sid);
                                document.addEventListener("keydown", _this61.exitFullscreenVideo);
                            }
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(participant) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.exitFullscreenVideo = function(event) {
            if (event.key === "Escape") {
                event.preventDefault();
                if (_this.state.fullscreenVideo) {
                    _this.toggleFullscreenVideo(_this.state.fullscreenVideo);
                }
            }
        };
        var _this62 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initAvatar = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _state, tour, room, avatar;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _state = _this62.state, tour = _state.tour, room = _state.room;
                        if (tour.enableAvatar) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.prev = 3;
                        avatar = (0,storage/* storage */.t)("avatar").get();
                        if (avatar) {
                            _ctx.next = 9;
                            break;
                        }
                        {
                            _this62.setState({
                                avatar: null,
                                chatParticipant: null
                            });
                        }
                        _ctx.next = 12;
                        break;
                    case 9:
                        if (room) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 12;
                        return _this62.setAvatar(avatar);
                    case 12:
                        _ctx.next = 16;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](3);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    14
                ]
            ]);
        }));
        var _this63 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.toggleMuteParticipants = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sid) {
                var audioEl, mute;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            audioEl = document.querySelectorAll("[data-cy-audio-track-sid=".concat(sid, "]"));
                            mute = false;
                            if (audioEl && audioEl.length > 0) {
                                if (audioEl[0].playing) {
                                    audioEl[0].pause();
                                    mute = true;
                                } else {
                                    audioEl[0].play();
                                    mute = false;
                                }
                                if (_this63.state.host) {
                                    socket/* default.emit */.Z.emit("mute_participant", {
                                        participantId: sid,
                                        mute: mute
                                    });
                                }
                            }
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this64 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getAvatarImage = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(url) {
                var id, response, json;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            if (url.includes(".glb")) {
                                _ctx.next = 3;
                                break;
                            }
                            throw new Error("No GLB");
                        case 3:
                            id = url.split("/").pop().split(".glb")[0];
                            _ctx.next = 6;
                            return fetch("https://models.readyplayer.me/".concat(id, ".json"));
                        case 6:
                            response = _ctx.sent;
                            _ctx.next = 9;
                            return response.json();
                        case 9:
                            json = _ctx.sent;
                            _ctx.next = 12;
                            return new Promise(function(resolve) {
                                var imageUrl = "https://api.readyplayer.me/v1/avatars/".concat(id, ".png?scene=").concat(json.bodyType, "-portrait-v1-transparent");
                                _this64.setState({
                                    avatarImage: imageUrl
                                }, function() {
                                    return resolve(imageUrl);
                                });
                            });
                        case 12:
                            return _ctx.abrupt("return", _ctx.sent);
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                            return _ctx.abrupt("return", "");
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }));
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this65 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.setAvatar = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var ref, ref1, _state, tour, room, avatarImage, avatarId, avatar, user;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _state = _this65.state, tour = _state.tour, room = _state.room, avatarImage = _state.avatarImage;
                            _this65.setState({
                                chatParticipant: Object.assign(data, {
                                    imageUrl: avatarImage
                                })
                            });
                            console.log("Avatars enabled?", tour.enableAvatar);
                            if (tour.enableAvatar) {
                                _ctx.next = 6;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 6:
                            avatarId = (0,v4/* default */.Z)();
                            avatar = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                uuid: avatarId,
                                imageUrl: avatarImage
                            });
                            (0,storage/* storage */.t)("avatar").set(avatar);
                            _this65.setState({
                                avatar: avatar
                            });
                            user = {
                                name: data.name,
                                room: room || tour.id,
                                avatarUrl: data.url,
                                avatarId: avatarId,
                                avatarImage: avatarImage,
                                model: data.model,
                                pose: {
                                    rotation: (ref = _this65.camera) === null || ref === void 0 ? void 0 : ref.rotation,
                                    quaternion: (ref1 = _this65.camera) === null || ref1 === void 0 ? void 0 : ref1.quaternion,
                                    position: _this65.pose.position
                                },
                                sweep: _this65.pose.sweep
                            };
                            socket/* default.emit */.Z.emit("user_joining", user);
                            console.log("Joining avatar to room ".concat(room));
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.toggleSketchfabPopup = function(state) {
            return function() {
                _this.setState({
                    showSketchfabPopup: state
                });
            };
        };
        _this.onCloseIntro = function() {
            var _state = _this.state, tour = _state.tour, _$tourType = _state.tourType;
            if (_$tourType === Tour/* TourType.Game */.v.Game) {
                _this.setState({
                    showIntro: false
                }, function() {
                    if (tour === null || tour === void 0 ? void 0 : tour.autoplayMusic) {
                        _this.processTourMusic(tour);
                        _this.playAudio();
                    }
                });
            } else {
                _this.setState({
                    showIntro: false,
                    forcePlayGameIntro: true
                }, function() {
                    _this.processTourMusic(tour);
                    _this.playAudio();
                });
            }
        };
        _this.getCurrentLanguage = function() {
            var ref;
            return (ref = _this.state.initialDuplicates) === null || ref === void 0 ? void 0 : ref.find(function(duplicate) {
                var ref, ref1;
                return duplicate.slug === ((ref = _this.state) === null || ref === void 0 ? void 0 : (ref1 = ref.tour) === null || ref1 === void 0 ? void 0 : ref1.slug);
            });
        };
        _this.unlockChapter = function(targetObj, type) {
            var _state = _this.state, _game = _state.game, book = _game.book, gameBookOn = _game.gameBookOn, unlockedChapterIds = _state.unlockedChapterIds, clickedElements = _state.clickedElements;
            var value = targetObj === null || targetObj === void 0 ? void 0 : targetObj.id;
            _this.setState({
                clickedElements: (0,_to_consumable_array/* default */.Z)(clickedElements).concat([
                    {
                        type: type,
                        value: value
                    }, 
                ])
            });
            if (!gameBookOn || !book) return;
            var chapters = sortBy_default()(book === null || book === void 0 ? void 0 : book.chapters, "order");
            var chapter = chapters.find(function(item) {
                return item.order === unlockedChapterIds.length + 1;
            });
            var unblock = false;
            switch(type){
                case GameBook/* ChapterType.Tag */._U.Tag:
                    {
                        var tag = targetObj;
                        unblock = chapter && chapter.type === GameBook/* ChapterType.Tag */._U.Tag && (chapter.value === String(tag.id) || chapter.value === tag.sid);
                        break;
                    }
                case GameBook/* ChapterType.Polygon */._U.Polygon:
                    var polygon = targetObj;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.Polygon */._U.Polygon && chapter.value === String(polygon.id);
                    break;
                case GameBook/* ChapterType.VSItem */._U.VSItem:
                    var vsItem = targetObj;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.VSItem */._U.VSItem && chapter.value === String(vsItem.id);
                    break;
                case GameBook/* ChapterType.VSImage */._U.VSImage:
                    var vsImage = targetObj;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.VSImage */._U.VSImage && chapter.value === String(vsImage.id);
                    break;
                case GameBook/* ChapterType.VSVideo */._U.VSVideo:
                    var vsVideo = targetObj;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.VSVideo */._U.VSVideo && chapter.value === String(vsVideo.id);
                    break;
                default:
                    break;
            }
            if (unblock) {
                _this.tryButtonPlaySound();
                _this.setState({
                    unlockedChapterIds: (0,_to_consumable_array/* default */.Z)(unlockedChapterIds).concat([
                        chapter.id
                    ])
                });
            }
        };
        var _this66 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onPathAction = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(element, type) {
                var data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(type === GameBook/* ChapterType.Tag */._U.Tag)) {
                                _ctx.next = 4;
                                break;
                            }
                            {
                                _this66.openTagIframe(element.sid);
                            }
                            _ctx.next = 21;
                            break;
                        case 4:
                            if (!(type === GameBook/* ChapterType.VSItem */._U.VSItem)) {
                                _ctx.next = 8;
                                break;
                            }
                            {
                                _this66.openVsObjectIframe(element);
                            }
                            _ctx.next = 21;
                            break;
                        case 8:
                            if (!(type === GameBook/* ChapterType.VSVideo */._U.VSVideo)) {
                                _ctx.next = 12;
                                break;
                            }
                            {
                                _this66.openVsVideoIframe(element);
                            }
                            _ctx.next = 21;
                            break;
                        case 12:
                            if (!(type === GameBook/* ChapterType.Polygon */._U.Polygon)) {
                                _ctx.next = 18;
                                break;
                            }
                            data = (element === null || element === void 0 ? void 0 : element.polygonsActions) ? element.polygonsActions[0] : element;
                            _ctx.next = 16;
                            return _this66.handlePolygonAction(data);
                        case 16:
                            _ctx.next = 21;
                            break;
                        case 18:
                            if (!(type === GameBook/* ChapterType.VSImage */._U.VSImage)) {
                                _ctx.next = 21;
                                break;
                            }
                            _ctx.next = 21;
                            return _this66.handleImageAction(element);
                        case 21:
                            _this66.setState({
                                clickedElement: {
                                    id: element.id,
                                    type: type
                                }
                            });
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(element, type) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.state = {
            iframeId: "iframe_".concat(randomNumberId()),
            showcaseLoaded: false,
            showSketchfabPopup: false,
            tour: null,
            floors: [],
            allowGuestBeforeHost: false,
            changeMenu: false,
            showIntroScreen: true,
            showIntroScreenSpinner: false,
            menus: [],
            menuSettings: {},
            reelVideos: [],
            pinnedVideos: [],
            reel: [],
            sweeps: [],
            deprecatedSweeps: [],
            mpFloors: [],
            mpLabels: [],
            translation: {},
            tourEmail: null,
            sweepGroups: [],
            host: props.rule === "host",
            audioOnly: props.videoType === "audio",
            minimaps: [],
            allTags: new Map(),
            interacted: false,
            selectedMinimap: 0,
            menuOpened: false,
            iframeUrl: null,
            menuOpen: false,
            overlayOn: false,
            mainPlaying: false,
            otherPlaying: false,
            videoPlaying: false,
            externalPopupOn: false,
            contactPopupOn: false,
            panoramas: [],
            polygons: [],
            agents: [],
            tagPopOn: false,
            panoPopOn: false,
            gameLockPopOn: false,
            openedLock: null,
            userAnswerForGameLock: null,
            videoChatTagPopOn: false,
            vsActionPopOn: false,
            panoramaOn: false,
            openedTag: null,
            openedPanoHotspot: null,
            openedVSAction: new VSObject/* TourImage */.oP(),
            externalPopupUrl: null,
            minimapOn: false,
            minimapVisible: false,
            mesurementsOn: false,
            markerPopupOn: false,
            sharePopupOn: false,
            tourPlaying: false,
            mapWalkerRotation: 0,
            reelStep: 0,
            mapWalkerX: null,
            mapWalkerY: null,
            activeSweepGroup: null,
            dominantSpeaker: null,
            // user: null,
            selectedMarker: {
                url: null,
                external: null
            },
            tokenRemainingTime: -1,
            tokenExpiresAt: null,
            // createdAt: null,
            // clock: false,
            ticketingOpen: false,
            activePano: null,
            appointmentsModal: false,
            appointmentsHintOn: true,
            getInTouchHintOn: true,
            MenuHintOn: true,
            lock: false,
            room: props.room,
            whiteLabelData: null,
            showHelpModal: false,
            showTermsModal: false,
            showCollectLeadsModal: false,
            activeMenu: null,
            products: [],
            tourType: tourType,
            vsSettings: new VSSettings/* VSSettings */.E(),
            isVSReady: false,
            containerId: "public",
            loadingTags: true,
            game: null,
            currentFloor: null,
            panoPose: {
                yaw: 0,
                pitch: 0,
                hfov: 0
            },
            isVSEnabled: true,
            isVSVisible: true,
            loadedOnce: false,
            showPathFinderPopup: false,
            ticketTimeLeftMs: null,
            tourMode: null,
            experiencePopUpIsOpen: false,
            onExperienceCloseCallback: function() {
                return undefined;
            },
            currentSweep: null,
            experiencePopUpData: null,
            closedElementPopup: true,
            isEnableNextPathLock: true,
            initialDuplicates: null,
            isChangeIframe: false,
            tourMusicWasPaused: false,
            avatar: {},
            chatParticipant: {},
            infoModalData: null,
            gameTrialErr: null,
            crashScreen: false,
            unlockedChapterIds: [],
            clickedElements: [],
            hideSubtitlesGroupId: null,
            showBottomBar: true,
            isShowNearestProducts: true,
            nearestProducts: [],
            waitLoadingPolygons: false
        };
        _this.loadingQueue = LoadingQueue/* default.getInstance */.Z.getInstance();
        _this.loadingQueue.subscribe(function(loaded) {
            if (loaded === true) {
                _this.setState({
                    loaded: true
                });
            }
        });
        _this.renderButtonBg = renderButtonBg.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.calculateLocation = calculateLocation.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.buildLink = util_all/* buildLink.bind */.DF.bind((0,_assert_this_initialized/* default */.Z)(_this)); // need this code ??
        _this.openTagIframe = sdk/* openTagIframe.bind */.$O.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openVsObjectIframe = sdk/* openVsObjectIframe.bind */.BY.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openVsImageIframe = sdk/* openVsImageIframe.bind */.IW.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openVsVideoIframe = sdk/* openVsVideoIframe.bind */.O7.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.loadModel = sdk/* loadModel.bind */.u7.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.moveToMPLabels = sdk/* moveToMPLabels.bind */.QO.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.setWhiteLabel = util_all/* setWhiteLabel.bind */.Jw.bind((0,_assert_this_initialized/* default */.Z)(_this));
        document.addEventListener("keydown", _this.takePosition);
        _this.toggleExternalPopup = popups/* toggleExternalPopup.bind */.J.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.toggleExternalPopupNull = popups/* toggleExternalPopup.bind */.J.bind((0,_assert_this_initialized/* default */.Z)(_this), null);
        _this.toggleContactPopup = popups/* toggleContactPopup.bind */.O.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.takeScreenshot = sdk/* takeScreenshot.bind */.ss.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.takePano = sdk/* takePano.bind */.Zy.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openedPanoHotspot = sdk/* openedPanoHotspot.bind */.Z4.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.login = util_all/* login.bind */.x4.bind((0,_assert_this_initialized/* default */.Z)(_this));
        var room = _this.state.room;
        _this.animate();
        socket/* default.on */.Z.on("move_avatar", function(data) {
            var ref, ref1, ref2, ref3;
            var tour = _this.state.tour;
            var THREE = (0,_assert_this_initialized/* default */.Z)(_this).THREE;
            if (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar)) return;
            var avatar = _this.avatarNodes.get(data.avatarId);
            // Is the avatar moving into my sweep? (sweep id...)
            // if it does, use relative position, avatar.relative
            var ref4 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, 180 + _this.avatarDegree, data === null || data === void 0 ? void 0 : (ref = data.pose) === null || ref === void 0 ? void 0 : (ref1 = ref.position) === null || ref1 === void 0 ? void 0 : ref1.x, (ref2 = data.pose) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.position) === null || ref3 === void 0 ? void 0 : ref3.z), 2), myX = ref4[0], myZ = ref4[1];
            var ref5 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, data.degree, myX, myZ), 2), x = ref5[0], z = ref5[1];
            if (avatar && avatar[1] && avatar[1].outputs.loadingState === VSObject/* LoadingState.Loaded */.Gu.Loaded) {
                if (avatar[1].inputs.bodyType === "fullbody") {
                    if (data.pose.sweep.sid !== "") {
                        // check if avatar sweep has changed
                        var shouldAnimationPlay = _this.didAvatarSweepChange(avatar[1].id, data.pose.sweep.id);
                        if (shouldAnimationPlay) {
                            var targetPosVec3 = new THREE.Vector3(data.degree && _this.avatarDegree ? x : data.pose.sweep.position.x, data.pose.sweep.position.y, data.degree && _this.avatarDegree ? z : data.pose.sweep.position.z);
                            _this.moveAvatarToPoint(avatar, targetPosVec3, THREE);
                        }
                        avatar[0].obj3D.children[0].children[0].rotation.set(-Math.PI / 2, 0, 0);
                    }
                    var vec3 = new THREE.Vector3(0, 0, 1);
                    var quaternion = new THREE.Quaternion(data.pose.quaternion._x, data.pose.quaternion._y, data.pose.quaternion._z, data.pose.quaternion._w);
                    vec3.applyQuaternion(quaternion);
                    var vec3Projected = vec3.clone();
                    vec3Projected.projectOnPlane(_this.yAxisVec3);
                    vec3Projected.negate().normalize();
                    var mx = new THREE.Matrix4().lookAt(vec3Projected, new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 1, 0));
                    var qt = new THREE.Quaternion().setFromRotationMatrix(mx);
                    avatar[1].rotateTo(qt, function(tween) {
                        // If there is active tween, stops it. Replaces/adds this tween to avatarId
                        var avatarTweenData = _this.connectedAvatarsTweens.find(function(el) {
                            return el.avatarId === avatar[1].id;
                        });
                        if (avatarTweenData) {
                            if (avatarTweenData.activeRotationTween) avatarTweenData.activeRotationTween.stop();
                            if (avatarTweenData.activeTween) tween.stop();
                            avatarTweenData.activeRotationTween = tween;
                        } else _this.connectedAvatarsTweens.push({
                            avatarId: avatar[1].id,
                            activeTween: null,
                            activeRotationTween: tween
                        });
                    }, function() {
                        var avatarTweenData = _this.connectedAvatarsTweens.find(function(el) {
                            return el.avatarId === avatar[1].id;
                        });
                        avatarTweenData.activeRotationTween = null;
                    });
                // uncomment if performance is bad due to rotation smoothing
                // avatar[0].obj3D.children[0].quaternion.set(qt.x, qt.y, qt.z, qt.w);
                // avatar[0].obj3D.children[0].rotateX(-Math.PI / 2);
                } else {
                    var ref6;
                    avatar[1].avatarHasMoved = true;
                    avatar[1].root.visible = true;
                    avatar[0].obj3D.position.set(data.degree && _this.avatarDegree ? x : data.pose.sweep.position.x, data.pose.position.y, data.degree && _this.avatarDegree ? z : data.pose.sweep.position.z);
                    avatar[0].obj3D.children[0].position.set(0, -0.6, 0);
                    avatar[0].obj3D.quaternion.set(data.pose.quaternion._x, data.pose.quaternion._y, data.pose.quaternion._z, data.pose.quaternion._w);
                    (ref6 = avatar[0].obj3D.children[0]) === null || ref6 === void 0 ? void 0 : ref6.rotation.set(0, Math.PI, 0);
                }
            }
        });
        socket/* default.on */.Z.on("move_avatar_face", function(data) {
            console.log("move avatar face");
            var tour = _this.state.tour;
            if (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar)) return;
            var avatar = _this.avatarNodes.get(data.avatarId);
            if (avatar) {
                avatar[1].updateFromResults(data.pose);
            }
        });
        socket/* default.on */.Z.on("all_users", function(users) {
            var tour = _this.state.tour;
            if (tour.enableAvatar) {
                // first we set our degree
                if (_this.avatarDegree === null) {
                    var myself = users.find(function(user) {
                        return user.socketId === socket/* default.id */.Z.id;
                    });
                    _this.avatarDegree = myself.degree;
                    console.log("Assigned degree", _this.avatarDegree);
                }
                // then we add all avatars
                users.forEach(function(user, i) {
                    if (user.socketId !== socket/* default.id */.Z.id) {
                        // user.degree = (i+1)*7;
                        _this.addAvatar(user);
                    }
                });
            }
        });
        var _this67 = (0,_assert_this_initialized/* default */.Z)(_this);
        socket/* default.on */.Z.on("user_leave", function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var tour;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            tour = _this67.state.tour;
                            if (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar)) {
                                _ctx.next = 4;
                                break;
                            }
                            _ctx.next = 4;
                            return _this67.onRemoveAvatar(data.avatarId);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }());
        socket/* default.on */.Z.on("move", function(pose) {
            if (_this.state.lock) {
                _this.moveToSweepIO(pose);
            }
        });
        if (room) {
            socket/* default.on */.Z.on("menu", function(menu) {
                _this.loadModel(menu.name, menu.url, menu.type);
            });
            socket/* default.on */.Z.on("tag", function(tag) {
                if (_this.state.lock) {
                    _this.moveToTagIO(tag, tag.action === "click");
                }
            });
            socket/* default.on */.Z.on("vs", function(data) {
                if (_this.state.lock) {
                    var vsImageId = data.vsImageId, vsVideoId = data.vsVideoId, vsObjectId = data.vsObjectId, eventData = data.eventData, type = data.type;
                    var instance = null;
                    var searchId = vsImageId;
                    if (vsImageId) {
                        instance = _this.showCaseTemp.scene.sceneImage;
                        searchId = vsImageId;
                    } else if (vsVideoId) {
                        instance = _this.showCaseTemp.scene.sceneVideo;
                        searchId = vsVideoId;
                    } else if (vsObjectId) {
                        instance = _this.showCaseTemp.scene.sceneObject;
                        searchId = vsObjectId;
                    }
                    if (instance && (instance === null || instance === void 0 ? void 0 : instance.assets)) {
                        instance.assets.forEach(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), assetKey = _param[0], node = _param[1];
                            if (assetKey.id === searchId) {
                                var _node = (0,_sliced_to_array/* default */.Z)(node, 2), component = _node[1];
                                component.onEvent(type, eventData);
                            }
                        });
                    }
                }
            });
            socket/* default.on */.Z.on("lock", function(_lock) {
                if (_this.state.lock !== _lock) {
                    _this.setState({
                        lock: _lock
                    });
                }
            });
            socket/* default.on */.Z.on("close-tag", function() {
                _this.setState({
                    tagPopOn: false
                });
            });
            socket/* default.on */.Z.on("close-pano-pop", function() {
                _this.setState({
                    panoPopOn: false
                });
            });
            socket/* default.on */.Z.on("toggle-pano", function(data) {
                _this.setState(data);
            });
            socket/* default.on */.Z.on("move-pano", function(data) {
                _this.setState({
                    panoPose: data.panoPose,
                    activePano: data.currentPanorama.id
                });
            });
            socket/* default.on */.Z.on("pano-hotspot-click", function(data) {
                _this.setState({
                    panoramaOn: false,
                    activePano: null
                }, function() {
                    _this.getTour({
                        id: data.id,
                        changeMenu: data.changeMenu,
                        changeMinimap: data.changeMinimap,
                        changePanorama: data.changePanorama,
                        url: data.url,
                        tourData: props.tourData
                    });
                });
            });
        }
        socket/* default.on */.Z.on("disconnect", function(reason) {
            console.error("Socket disconnected", reason);
        });
        socket/* default.io.on */.Z.io.on("reconnect", function() {
            console.log("Reconnecting socket.. enabling avatar again");
            _this.initAvatar().catch(function(e) {
                console.error("Error enabling avatar", e);
            });
        });
        window.addEventListener("beforeunload", function() {
            var ref, ref1, ref2;
            return logoutHandler({
                ticket: (ref = _this.state) === null || ref === void 0 ? void 0 : (ref1 = ref.tour) === null || ref1 === void 0 ? void 0 : ref1.ticket,
                ticketingOrderedTicket: (ref2 = _this.state.ticketing) === null || ref2 === void 0 ? void 0 : ref2.ticketingOrderedTicket
            });
        });
        (0,styles/* calculateMobileHeight */.U_)();
        window.addEventListener("resize", styles/* calculateMobileHeight */.U_);
        return _this;
    }
    var _proto = BaseTour.prototype;
    _proto.moveAvatarToPoint = function moveAvatarToPoint(avatar, targetPosVec3, THREE) {
        var _this = this;
        // Make avatar look at direction of target sweep while in animation
        var qt = getProjectedQuaternion(avatar[0].obj3D.position, targetPosVec3, this.yAxisVec3, THREE);
        avatar[1].moveToPos(targetPosVec3, qt, function(tween) {
            // If there is active tween, stops it. Replaces/adds this tween to avatarId
            var avatarTweenData = _this.connectedAvatarsTweens.find(function(el) {
                return el.avatarId === avatar[1].id;
            });
            if (avatarTweenData) {
                if (avatarTweenData.activeTween) avatarTweenData.activeTween.stop();
                avatarTweenData.activeTween = tween;
            } else _this.connectedAvatarsTweens.push({
                avatarId: avatar[1].id,
                activeTween: tween,
                activeRotationTween: null
            });
        }, function() {
            var avatarTweenData = _this.connectedAvatarsTweens.find(function(el) {
                return el.avatarId === avatar[1].id;
            });
            avatarTweenData.activeTween = null;
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener("resize", styles/* calculateMobileHeight */.U_);
    };
    _proto.setParentState = function setParentState(attr, val) {
        this.setState((0,src_define_property/* default */.Z)({}, attr, val));
    };
    _proto.loadedShowcaseHandler = function loadedShowcaseHandler() {
        var cb = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _state, tour, room, isEcommerceTour, isOpticalCenter, reel;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _state = _this.state, tour = _state.tour, room = _state.room;
                        isEcommerceTour = tour.mode === Tour/* TourType.ECommerce */.v.ECommerce;
                        isOpticalCenter = _this.state.externalProvider === types/* ExternalProvider.OPTICAL_CENTER */.FX.OPTICAL_CENTER;
                        if ((tour === null || tour === void 0 ? void 0 : tour.enableAvatar) || room) {
                            socket/* default.open */.Z.open();
                        }
                        _ctx.next = 6;
                        return _this.showCaseTemp.showcase.Tour.getData().catch(function() {
                            return [];
                        });
                    case 6:
                        reel = _ctx.sent;
                        if (reel === null || reel === void 0 ? void 0 : reel.length) _this.setState({
                            reel: reel
                        });
                        _this.showCaseTemp.showcase.Settings.update("highlight_reel", false);
                        _this.showCaseTemp.showcase.Settings.update("tour_buttons", false);
                        if (tour.hidePucks) {
                            _this.showCaseTemp.showcase.Settings.update("features/sweep_pucks", false);
                        }
                        _this.showCaseTemp.showcase.Mode.current.subscribe(function(mode) {
                            if (mode === _this.showCaseTemp.showcase.Mode.Mode.OUTSIDE) {
                                _this.stopVS();
                            }
                            _this.setState({
                                tourMode: mode
                            });
                            // hide models from other floors on view change
                            if (_this.showCaseTemp.scene.sceneObject && _this.showCaseTemp.scene.sceneObject.assets.length) {
                                if (mode === _this.showCaseTemp.showcase.Mode.Mode.FLOORPLAN || _this.showCaseTemp.showcase.Mode.Mode.TRANSITIONING) {
                                    _this.showCaseTemp.scene.sceneObject.assets.forEach(function(asset) {
                                        if (asset[0].floor !== _this.state.currentFloor) asset[0].node.pivot.visible = false;
                                    });
                                }
                                if (mode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE) {
                                    _this.showCaseTemp.scene.sceneObject.assets.forEach(function(asset) {
                                        asset[0].node.pivot.visible = true;
                                    });
                                }
                            }
                        });
                        _this.showCaseTemp.showcase.Camera.pose.subscribe(debounce_default()(function(p) {
                            _this.pose = (0,_object_spread/* default */.Z)({}, p);
                            cb();
                        }, 50));
                        _this.showCaseTemp.showcase.Sweep.current.subscribe(function(currentSweep) {
                            if (isEcommerceTour) {
                                _this.handleShowNearestProduct(false);
                            }
                            if (currentSweep.sid !== "") {
                                if (!_this.defaultSweep) _this.defaultSweep = structuredClone(currentSweep);
                                _this.updateSweepLoc(currentSweep);
                                _this.renderVS(currentSweep);
                                _this.setState({
                                    currentSweep: currentSweep
                                }, function() {
                                    if (isEcommerceTour && !isOpticalCenter) {
                                        _this.handleShowNearestProduct(true);
                                    }
                                });
                            }
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Camera.Event.MOVE, function() {
                            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(p) {
                                var _state, showcaseLoaded, host, room, tour, panoramaOn, ref, ref1, pose;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _state = _this.state, showcaseLoaded = _state.showcaseLoaded, host = _state.host, room = _state.room, tour = _state.tour, panoramaOn = _state.panoramaOn;
                                            if (showcaseLoaded) {
                                                _ctx.next = 3;
                                                break;
                                            }
                                            return _ctx.abrupt("return");
                                        case 3:
                                            if (socket/* default */.Z && socket/* default.connected */.Z.connected && (room || tour.enableAvatar)) {
                                                ;
                                                pose = {
                                                    walking: p.mode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE,
                                                    position: p.position,
                                                    rotation: (ref = _this.camera) === null || ref === void 0 ? void 0 : ref.rotation,
                                                    quaternion: (ref1 = _this.camera) === null || ref1 === void 0 ? void 0 : ref1.quaternion,
                                                    mode: p.mode,
                                                    degree: _this.avatarDegree,
                                                    sweep: _this.state.currentSweep
                                                };
                                                _this.lastAvatarCameraPose = pose;
                                                if (room) {
                                                    if (host) {
                                                        socket/* default.emit */.Z.emit("move", {
                                                            pose: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                                                                walking: p.mode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE
                                                            })
                                                        });
                                                    }
                                                }
                                                if (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) {
                                                    socket/* default.emit */.Z.emit("move_avatar", {
                                                        pose: pose
                                                    });
                                                }
                                            }
                                            if (tour.minimap) {
                                                if (p.mode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE && !panoramaOn) {
                                                    _this.setState({
                                                        mapWalkerRotation: p.rotation.y * -1
                                                    });
                                                }
                                            }
                                        case 5:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(p) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _this.showCaseTemp.showcase.Sweep.current.subscribe(function(sweep) {
                            var pose = _this.lastAvatarCameraPose;
                            if (pose) socket/* default.emit */.Z.emit("move_avatar", {
                                pose: pose
                            });
                        });
                        _this.showCaseTemp.showcase.Floor.current.subscribe(function(floor) {
                            // hide models from other floors on floor change
                            if (floor && typeof floor.sequence === "number" && _this.showCaseTemp.scene.sceneObject && _this.showCaseTemp.scene.sceneObject.assets.length) {
                                if (_this.state.tourMode === _this.showCaseTemp.showcase.Mode.Mode.FLOORPLAN) {
                                    _this.showCaseTemp.scene.sceneObject.assets.forEach(function(asset) {
                                        asset[0].node.pivot.visible = asset[0].floor === floor.sequence;
                                    });
                                }
                                if (_this.state.tourMode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE) {
                                    _this.showCaseTemp.scene.sceneObject.assets.forEach(function(asset) {
                                        asset[0].node.pivot.visible = true;
                                    });
                                }
                            }
                            if (floor.sequence !== -1 && floor.sequence !== undefined && floor.sequence !== _this.state.selectedMinimap) {
                                var minimaps = _this.state.minimaps;
                                if (minimaps.length > 0 && minimaps[floor.sequence]) {
                                    _this.setState({
                                        selectedMinimap: floor.sequence
                                    });
                                }
                            }
                            if (floor.sequence !== -1 && floor.sequence !== undefined && _this.state.currentFloor !== floor.sequence) {
                                _this.setState({
                                    currentFloor: floor.sequence
                                }, function() {
                                    if (!_this.state.showIntro && !_this.state.showIntroScreen && _this.state.showcaseLoaded) {
                                        _this.processTourMusic(tour);
                                    }
                                });
                            }
                        });
                        _this.showCaseTemp.showcase.Measurements.mode.subscribe(function(measurementModeState) {
                            _this.setState({
                                mesurementsOn: measurementModeState.active
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.STEPPED, function(i) {
                            _this.setState({
                                reelStep: i,
                                panoramaOn: false
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.STARTED, function() {
                            _this.setState({
                                tourPlaying: true,
                                panoramaOn: false,
                                tourMode: _this.pose.mode
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.STOPPED, function() {
                            _this.setState({
                                tourPlaying: false,
                                panoramaOn: false
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.ENDED, function() {
                            _this.setState({
                                tourPlaying: false,
                                panoramaOn: false,
                                reelStep: 0
                            });
                        });
                        _this.showcase.on(_this.showcase.Mattertag.Event.CLICK, function(tagId) {
                            var _state = _this.state, room = _state.room, host = _state.host, showcaseLoaded = _state.showcaseLoaded, tour = _state.tour;
                            var tags = Array.from(_this.state.allTags.values());
                            var tag = tags.find(function(t) {
                                return t.sid === tagId || t.defaultSid === tagId;
                            });
                            if (tour.hideMPTagSwitcher) {
                                _this.hideTagsNavigationButtons();
                            }
                            if (room && socket/* default */.Z && socket/* default.connected */.Z.connected && host && showcaseLoaded) {
                                socket/* default.emit */.Z.emit("tag", {
                                    tag: {
                                        id: tag.defaultSid || tag.sid,
                                        action: "click"
                                    }
                                });
                            }
                            _this.openTagIframe(tagId);
                            var watchTagPanelElem = _this.iframe.contentWindow.document.body.querySelector(".side-panel-right");
                            if (!tag.mpTooltip && deviceManager/* default.isMobile */.Z.isMobile()) {
                                (0,util/* closeTagPanelObserver */.zx)(watchTagPanelElem);
                            } else if (tag.mpTooltip && deviceManager/* default.isMobile */.Z.isMobile()) {
                                (0,util/* setTagPanelObserver */.p$)(watchTagPanelElem, function(isTagPanelOpen, observer) {
                                    _this.setState({
                                        showBottomBar: !isTagPanelOpen
                                    });
                                    if (!isTagPanelOpen) {
                                        observer.disconnect();
                                    }
                                });
                            }
                            if (tag && tag.title) {
                                (0,analytic/* sendToGA */.o$)("event", {
                                    eventCategory: "Mattertag",
                                    eventAction: "click",
                                    eventLabel: tag.title
                                });
                            }
                        });
                        _this.showcase.on(_this.showcase.Mattertag.Event.HOVER, function(tagId) {
                            var _state = _this.state, room = _state.room, host = _state.host, showcaseLoaded = _state.showcaseLoaded, tour = _state.tour;
                            var tags = Array.from(_this.state.allTags.values());
                            var tag = tags.find(function(t) {
                                return t.sid === tagId || t.defaultSid === tagId;
                            });
                            if (tour.hideMPTagSwitcher) {
                                _this.hideTagsNavigationButtons();
                            }
                            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host && _this.pose.mode === _this.showcase.Mode.Mode.INSIDE) {
                                if (tag) {
                                    socket/* default.emit */.Z.emit("tag", {
                                        tag: {
                                            id: tag.defaultSid || tag.sid
                                        }
                                    });
                                }
                            }
                            if (tag && tag.enabled && tag.embedMedia && tag.type === "video") {
                                _this.pauseTourMusic();
                            }
                            if (tag && tag.title) {
                                (0,analytic/* sendToGA */.o$)("event", {
                                    eventCategory: "Mattertag",
                                    eventAction: "hover",
                                    eventLabel: tag.title
                                });
                            }
                        });
                        _this.showCaseTemp.showcase.Floor.data.subscribe({
                            // Get floor data
                            onCollectionUpdated: function(collection) {
                                var mpFloors = [];
                                Object.keys(collection).forEach(function(o) {
                                    var floor = collection[o];
                                    if (!floor.name || floor.name.length === 0) return;
                                    mpFloors.push(floor);
                                });
                                _this.setState({
                                    mpFloors: mpFloors
                                });
                            }
                        });
                        _this.showCaseTemp.showcase.Label.getData().then(function(labels) {
                            if (labels === null || labels === void 0 ? void 0 : labels.length) _this.setState({
                                mpLabels: labels
                            });
                        }).catch(function() {
                            return console.error("Error to load MP labels");
                        });
                        _this.showCaseTemp.showcase.Mattertag.data.subscribe({
                            onAdded: function(sid, item) {
                                if (tour === null || tour === void 0 ? void 0 : tour.addon_hidetags) {
                                    _this.showCaseTemp.showcase.Mattertag.remove(sid);
                                    return;
                                }
                                var room = _this.state.room;
                                if (room && item.media.type === _this.showCaseTemp.showcase.Mattertag.MediaType.VIDEO) {
                                    // ToDo: matterport vimeo video does not support mute
                                    var clone = cloneDeep_default()(item);
                                    var urlC = clone.media.src.split("https://vimeo.com/");
                                    clone.media.src += urlC.length > 1 ? "?muted=1" : "&muted=1";
                                    _this.showCaseTemp.showcase.Mattertag.editBillboard(sid, clone);
                                }
                            }
                        });
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getPolygons = function getPolygons() {
        return this.state.polygons;
    };
    _proto.handlePolygonProduct = function handlePolygonProduct(polygon) {};
    _proto.moveToSweepIO = function moveToSweepIO(p) {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (_this.state.showcaseLoaded) {
                            setTimeout(function() {
                                if (!p.walking) {
                                    _this.showCaseTemp.showcase.Mode.moveTo(p.mode, {
                                        position: p.position,
                                        rotation: p.rotation,
                                        transition: _this.showCaseTemp.showcase.Mode.TransitionType.FLY
                                    }).catch(function(e) {});
                                } else {
                                    _this.showcase.Sweep.moveTo(p.sweep, {
                                        position: p.position,
                                        rotation: p.rotation,
                                        transition: _this.showCaseTemp.showcase.Sweep.Transition.FLY
                                    }).catch(function(e) {});
                                }
                            }, 100);
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.moveToTagIO = function moveToTagIO(tag) {
        var doOpenTag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        if (this.state.showcaseLoaded) {
            var _this = this;
            setTimeout(function() {
                var tags = Array.from(_this.state.allTags.values());
                var foundTag = tags.find(function(t) {
                    return t.sid === tag.id || t.defaultSid === tag.id || t.sid === tag.sid || t.defaultSid === tag.sid;
                });
                if (!foundTag) {
                    return;
                }
                if (_this.pose.mode !== _this.showCaseTemp.showcase.Mode.Mode.OUTSIDE) {
                    var _this1 = _this;
                    _this.showCaseTemp.showcase.Mattertag.navigateToTag(foundTag.sid, _this.showCaseTemp.showcase.Mattertag.Transition.FLY).then(function() {
                        if (doOpenTag) {
                            _this1.openTagIframe(tag.id);
                        }
                    }).catch(function(err) {
                        console.error(err.toString());
                    });
                } else if (doOpenTag) {
                    _this.openTagIframe(foundTag.sid);
                }
            }, 100);
        }
    };
    _proto.getLogoUrl = function getLogoUrl() {
        var ref;
        var tour = this.state.tour;
        return tour && (tour === null || tour === void 0 ? void 0 : tour.client) ? "".concat("https://cdn.treedis.com", "/clients/").concat(tour === null || tour === void 0 ? void 0 : (ref = tour.client) === null || ref === void 0 ? void 0 : ref.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt)) : "";
    };
    _proto.renderMenu = function renderMenu() {
        var ref, ref1;
        var _state = this.state, tour = _state.tour, room = _state.room, tokenRemainingTime = _state.tokenRemainingTime, whiteLabelData = _state.whiteLabelData, menuOpen = _state.menuOpen, changeMenu = _state.changeMenu, translation = _state.translation, tourEmail = _state.tourEmail, menuSettings = _state.menuSettings, menus = _state.menus, tourType = _state.tourType;
        return this.isTourReadyForAudio() && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuWithSidebarState, {
            isEcommerce: tourType === Tour/* TourType.ECommerce */.v.ECommerce,
            tourType: tourType,
            activeMenu: this.state.activeMenu,
            tourMode: tour.mode,
            tourId: tour.id,
            changeMenu: changeMenu,
            menuOpen: menuOpen,
            menuSearch: tour.menuSearch,
            menuCategoryExpand: tour.menuCategoryExpand,
            bookUrl: tour.bookUrl,
            bookText: tour.bookText,
            bookColor: tour.bookColor,
            client: tour.client,
            unbranded: tour.unbranded,
            bookAppointment: tour.appointmentsOn && !room && tokenRemainingTime < 1,
            toggleAppointmentsModal: this.toggleAppointmentsModal,
            contact: tour.contactForm && (((ref = tour.client) === null || ref === void 0 ? void 0 : ref.phone) || ((ref1 = tour.client) === null || ref1 === void 0 ? void 0 : ref1.email) || (tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.contactPhone)),
            whitelabel: whiteLabelData,
            address: tour.address,
            loadModel: this.loadModel,
            moveToMPLabels: this.moveToMPLabels,
            closeMenu: this.toggleNav,
            onClose: this.closeMenu,
            toggleContactPopup: this.toggleContactPopup,
            toggleExternalPopup: this.toggleExternalPopup,
            translation: translation,
            menuSettings: menuSettings,
            menus: menus
        });
    };
    _proto.injectBottomBg = function injectBottomBg() {};
    _proto.hideIframeButtons = function hideIframeButtons() {
        try {
            if (this.iframe) {
                var ref, ref1, ref2;
                var iframeButtons = (ref = this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.document) === null || ref2 === void 0 ? void 0 : ref2.querySelector("#bottom-ui");
                if (iframeButtons && iframeButtons.style.display !== "none") {
                    iframeButtons.style.display = "none";
                }
            }
        } catch (err) {
            console.error(err);
        }
    };
    _proto.hideTagsNavigationButtons = function hideTagsNavigationButtons() {
        var ref, ref1, ref2;
        var iframeTagsNavButtons = (ref = this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.document) === null || ref2 === void 0 ? void 0 : ref2.querySelector(".tags-overlay");
        if (iframeTagsNavButtons) {
            iframeTagsNavButtons.style.display = "none";
        }
    };
    _proto.getOtherAudio = function getOtherAudio() {
        var playing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var tourType = this.state.tourType;
        var audio = this.isPlaying(this.tagAudio) ? this.tagAudio : null;
        // added removing sweepAudio on change sweep, removed check paused sweep audio to
        // not miss paused player on sweep change from same audio groups
        if (!audio && this.isPlaying(this.sweepAudio)) {
            audio = this.sweepAudio;
        }
        if (!audio && this.isPlaying(this.polygonAudio)) {
            audio = this.polygonAudio;
        }
        if (!audio && this.isPlaying(this.panoramaAudio)) {
            audio = this.panoramaAudio;
        }
        if (!audio && this.isPlaying(this.buttonAudio)) {
            audio = this.buttonAudio;
        }
        if (!audio && tourType === Tour/* TourType.Game */.v.Game && this.isPlaying(this.selectItemMusicEffect)) {
            audio = this.selectItemMusicEffect;
        }
        return audio;
    };
    _proto.renderBottomBar = function renderBottomBar(isFullScreen, toggleFullscreen) {
        var _this = this;
        var ref, ref1, ref2, ref3;
        var _state = this.state, tour = _state.tour, room = _state.room, sharePopupOn = _state.sharePopupOn, minimapVisible = _state.minimapVisible, panoramaOn = _state.panoramaOn, mainPlaying = _state.mainPlaying, mesurementsOn = _state.mesurementsOn, whiteLabelData = _state.whiteLabelData, reel = _state.reel, reelStep = _state.reelStep, translation = _state.translation, otherPlaying = _state.otherPlaying, currentFloor = _state.currentFloor, isVSEnabled = _state.isVSEnabled, ticketing = _state.ticketing, mpFloors = _state.mpFloors, host = _state.host, activeSweepGroup = _state.activeSweepGroup, sweepGroups = _state.sweepGroups;
        var audio = this.getOtherAudio();
        var handleSoundControlClose = function() {
            var _this1 = _this;
            _this.setState({
                otherPlaying: false
            }, function() {
                _this1.resumeTourMusic();
            });
        };
        var activeSweepGroupObject = sweepGroups.find(function(g) {
            return g.id === activeSweepGroup;
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                otherPlaying && audio && tour.musicControl && /*#__PURE__*/ (0,jsx_runtime.jsx)(SoundControls["default"], {
                    audio: audio,
                    onClose: handleSoundControlClose
                }),
                !this.state.showIntro && !this.state.showIntroScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomBarWithRecoil, {
                    host: host,
                    activeSweepGroup: activeSweepGroupObject,
                    allowedTours: ticketing === null || ticketing === void 0 ? void 0 : (ref = ticketing.ticketingTourTicket) === null || ref === void 0 ? void 0 : ref.accessTours,
                    showTicketRestrictedAreaPopup: this.showTicketRestrictedAreaPopup,
                    onTicketingReel: this.handleTicketingReel,
                    audio: this.tourAudio,
                    mainPlaying: mainPlaying,
                    otherPlaying: otherPlaying,
                    toggleSketchfabPopup: this.toggleSketchfabPopup,
                    isFull: isFullScreen,
                    translation: translation,
                    vsObjects: this.vsObjects,
                    changeFull: toggleFullscreen,
                    openShare: function() {
                        _this.setState({
                            sharePopupOn: !sharePopupOn
                        });
                    },
                    reelVideos: this.state.reelVideos,
                    reel: reel,
                    mpFloors: mpFloors,
                    room: room,
                    loadModel: this.loadModel,
                    tour: tour,
                    reelStep: reelStep,
                    sharePopupOn: sharePopupOn,
                    isVSEnabled: isVSEnabled,
                    moveToStep: this.moveToStep,
                    playTour: this.playTour,
                    tourPlaying: this.state.tourPlaying,
                    showcase: this.showCaseTemp.showcase,
                    changeViewMode: this.changeViewMode,
                    mesurementsOn: mesurementsOn,
                    panoramaOn: panoramaOn,
                    measurementsMode: this.measurementsMode,
                    changeFloor: this.changeFloor,
                    showPanorama: tour.panorama,
                    toggleExternalPopup: this.toggleExternalPopup,
                    handleToggleMusic: this.handleToggleMusic,
                    takeScreenshot: this.takeScreenshot,
                    takePano: this.takePano,
                    whitelabel: whiteLabelData,
                    showMinimapClick: function() {
                        _this.setState({
                            minimapVisible: !minimapVisible
                        });
                    },
                    showPanoramaClick: this.handleTogglePano,
                    onHelpClick: function() {
                        _this.setState({
                            showHelpModal: true,
                            showTermsModal: false
                        });
                    },
                    onTermsClick: function() {
                        _this.setState({
                            showTermsModal: true,
                            showHelpModal: false
                        });
                    },
                    toggleVS: this.toggleVS,
                    openVR: this.openVR,
                    onStartVideo: function() {
                        _this.setState({
                            videoPlaying: true
                        });
                        _this.pauseAllAudio();
                    },
                    onStopVideo: function() {
                        _this.playContainerAudio("tourAudio");
                        _this.setState({
                            videoPlaying: false,
                            mainPlaying: true,
                            otherPlaying: false
                        });
                    },
                    currentFloor: currentFloor,
                    onMuteClick: this.toggleMuteParticipants,
                    onFullscreenClick: this.toggleFullscreenVideo,
                    onPinClick: this.addPinnedVideo,
                    initialDuplicates: (ref1 = this.props) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.tourData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.tour) === null || ref3 === void 0 ? void 0 : ref3.initialDuplicates,
                    audioOnly: this.state.audioOnly
                })
            ]
        });
    };
    _proto.injectChildComponents = function injectChildComponents() {};
    /** experience handlers * */ _proto.renderGameContent = function renderGameContent() {};
    _proto.hideItemsFromConditions = function hideItemsFromConditions() {};
    _proto.renderEndGameScreen = function renderEndGameScreen() {};
    _proto.handleGameStart = function handleGameStart(username, skipValidation) {};
    _proto.tryButtonPlaySound = function tryButtonPlaySound() {};
    /** experience handlers * */ _proto.isRenderAuth = function isRenderAuth() {
        var tour = this.state.tour;
        var p = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "p");
        if (tour.password && p && atob(decodeURIComponent(p)) === tour.password) return false;
        return tour.password;
    };
    _proto.renderAuth = function renderAuth() {
        var _state = this.state, tour = _state.tour, whiteLabelData = _state.whiteLabelData;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {
            password: tour.password,
            whitelabel: whiteLabelData,
            login: this.login
        });
    };
    _proto.getAudioContainer = function getAudioContainer(type) {
        if (this[type]) {
            return this[type];
        }
        return null;
    };
    _proto.playContainerAudio = function playContainerAudio(type) {
        var _this = this;
        return (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(_this[type] && _this[type].paused)) {
                            _ctx.next = 17;
                            break;
                        }
                        _ctx.prev = 2;
                        ;
                        if (!(_this.mainContainerWaitingForPlay || !_this.isTourReadyForAudio())) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", setTimeout(function() {
                            return _this.playContainerAudio(type);
                        }, 500));
                    case 6:
                        _ctx.next = 8;
                        return _this[type].play();
                    case 8:
                        _this[type].muted = false; // iOS trick
                        // if tour music is playing - pause it, add resume callback
                        if (_this[type] && _this.tourAudio && !((ref1 = _this.tourAudio) === null || ref1 === void 0 ? void 0 : ref1.paused)) {
                            // pause tour music, show sweep audio controls
                            _this.tourAudio.pause();
                            _this.setState({
                                mainPlaying: false,
                                otherPlaying: true,
                                tourMusicWasPaused: true
                            });
                            _this[type].addEventListener("ended", function(event) {
                                if (_this.tourAudio) {
                                    // play tour music
                                    _this.tourAudio.play();
                                    _this.setState({
                                        mainPlaying: true,
                                        otherPlaying: false,
                                        tourMusicWasPaused: false
                                    });
                                }
                            });
                        }
                        return _ctx.abrupt("return", true);
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](2);
                        console.error(_ctx.t0);
                        return _ctx.abrupt("return", setTimeout(function() {
                            return _this.playContainerAudio(type);
                        }, 500));
                    case 17:
                        _ctx.next = 19;
                        return (ref = _this[type]) === null || ref === void 0 ? void 0 : ref.pause();
                    case 19:
                        return _ctx.abrupt("return", false);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    13
                ]
            ]);
        }))();
    };
    _proto.render = function render() {
        var _this = this;
        var ref, ref1, ref2, ref3;
        (0,renderDebug/* dLog */.a)("BaseTour");
        var _state = this.state, tour = _state.tour, game = _state.game, gameStatus = _state.gameStatus, sweepGroups = _state.sweepGroups, mesurementsOn = _state.mesurementsOn, allowGuestBeforeHost = _state.allowGuestBeforeHost, room = _state.room, activeSweepGroup = _state.activeSweepGroup, sharePopupOn = _state.sharePopupOn, overlayOn = _state.overlayOn, showcaseLoaded = _state.showcaseLoaded, currentSweep = _state.currentSweep, tokenRemainingTime = _state.tokenRemainingTime, tokenExpiresAt = _state.tokenExpiresAt, showSketchfabPopup = _state.showSketchfabPopup, whiteLabelData = _state.whiteLabelData, minimapVisible = _state.minimapVisible, minimapOn = _state.minimapOn, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap, mapWalkerX = _state.mapWalkerX, mapWalkerY = _state.mapWalkerY, mapWalkerRotation = _state.mapWalkerRotation, lock = _state.lock, tagPopOn = _state.tagPopOn, panoPopOn = _state.panoPopOn, openedTag = _state.openedTag, openedPanoHotspot = _state.openedPanoHotspot, vsActionPopOn = _state.vsActionPopOn, openedVSAction = _state.openedVSAction, contactPopupOn = _state.contactPopupOn, externalPopupOn = _state.externalPopupOn, externalPopupUrl = _state.externalPopupUrl, panoramaOn = _state.panoramaOn, host = _state.host, selectedMarker = _state.selectedMarker, showHelpModal = _state.showHelpModal, showTermsModal = _state.showTermsModal, showCollectLeadsModal = _state.showCollectLeadsModal, showIntroScreenSpinner = _state.showIntroScreenSpinner, panoramas = _state.panoramas, interacted = _state.interacted, showIntroScreen = _state.showIntroScreen, showIntro = _state.showIntro, containerId = _state.containerId, loadingTags = _state.loadingTags, agents = _state.agents, tourEmail = _state.tourEmail, translation = _state.translation, tourType = _state.tourType, reelVideos = _state.reelVideos, experiencePopUpIsOpen = _state.experiencePopUpIsOpen, initialDuplicates = _state.initialDuplicates, experiencePopUpData = _state.experiencePopUpData, forcePlayGameIntro = _state.forcePlayGameIntro, // --- to add
        ticketingOpen = _state.ticketingOpen, ticketing = _state.ticketing, avatar = _state.avatar, chatParticipant = _state.chatParticipant, iframeUrl = _state.iframeUrl, audioOnly = _state.audioOnly, showBottomBar = _state.showBottomBar, iframeSettings = _state.iframeSettings;
        var _props = this.props, _tour = _props._tour, tourImage = _props.tourImage;
        var preview = !!_tour;
        var loadSweeps = !showIntro && !showIntroScreen && !loadingTags && showcaseLoaded && sweepGroups && sweepGroups.length > 0;
        var isGameTour = tourType === Tour/* TourType.Game */.v.Game;
        var showMinimap = isGameTour ? gameStatus !== types/* GameStatus.NotStarted */.XI.NotStarted : showcaseLoaded;
        var ticketingContentTickets = [];
        if ((ticketing === null || ticketing === void 0 ? void 0 : (ref = ticketing.ticketingOrderedTicket) === null || ref === void 0 ? void 0 : ref.ticketType) === "tourByYourself") ticketingContentTickets = ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingToursByYourself;
        else if ((ticketing === null || ticketing === void 0 ? void 0 : (ref1 = ticketing.ticketingOrderedTicket) === null || ref1 === void 0 ? void 0 : ref1.ticketType) === "gameTour") ticketingContentTickets = ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGameTour;
        else if ((ticketing === null || ticketing === void 0 ? void 0 : (ref2 = ticketing.ticketingOrderedTicket) === null || ref2 === void 0 ? void 0 : ref2.ticketType) === "guidedTour") ticketingContentTickets = ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGuidedTour;
        var isMobile = deviceManager/* default.isMobile */.Z.isMobile();
        var isChrome = deviceManager/* default.isChrome */.Z.isChrome();
        var isIOS = deviceManager/* default.isIOS */.Z.isIOS();
        var tourStarted = this.isTourReadyForAudio();
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreen/* default */.Z, {
            attrs: {
                id: "global-fullscreen",
                class: classnames_default()((tour === null || tour === void 0 ? void 0 : (ref3 = tour.client) === null || ref3 === void 0 ? void 0 : ref3.rtl) && "rtl")
            },
            rootBody: true,
            children: function(param) {
                var isFullScreen = param.isFullScreen, toggleFullscreen = param.toggleFullscreen;
                var _this1 = _this;
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
                var _this2 = _this;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !ticketingOpen && !showIntroScreen && !showCollectLeadsModal && _this.state.tourType !== Tour/* TourType.Game */.v.Game && !_this.isRenderAuth() && !(tour === null || tour === void 0 ? void 0 : tour.mpPasswordActive) && !_this.state.loaded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "intro-screen",
                            style: {
                                backgroundImage: "url(".concat("https://cdn.treedis.com", "/tours/").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : ref.id, "/images/").concat((ref1 = _this.state.tour) === null || ref1 === void 0 ? void 0 : ref1.mainImage, ")")
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    style: {
                                        marginTop: "100px",
                                        fontSize: "50px"
                                    },
                                    children: tour.showTitle && tour.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "shadow"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingProgress/* default */.Z, {
                                    showSpinner: true,
                                    showBar: false
                                })
                            ]
                        }),
                        _this.state.gameTrialErr && _this.state.tourType === Tour/* TourType.Game */.v.Game && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "gameTrialErr",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "gameTrialErr-text",
                                    children: _this.state.gameTrialErr
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(units/* Button */.zx, {
                                    onClick: function() {
                                        return window.close();
                                    },
                                    children: "Close"
                                })
                            ]
                        }),
                        experiencePopUpIsOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperiencePopUp, {
                            isRtl: (ref2 = tour.client) === null || ref2 === void 0 ? void 0 : ref2.rtl,
                            onInit: function() {
                                if (_this1.state.tourType === Tour/* TourType.Game */.v.Game) {
                                    _this1.pauseTourMusic();
                                } else {
                                    _this1.pauseAllAudio();
                                }
                            },
                            tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                            getCurrentLanguage: _this.getCurrentLanguage,
                            tryButtonPlaySound: _this.tryButtonPlaySound,
                            experiencePopUpData: experiencePopUpData,
                            isOpen: experiencePopUpIsOpen,
                            setIsOpen: function(status) {
                                // as I understand this using only for closing experience from itself
                                if (_this1.state.sweepMusicWasPaused && _this1.sweepAudio) {
                                    _this1.sweepAudio.play();
                                    if (_this1.sweepAudio.updateSubs) _this1.sweepAudio.updateSubs();
                                    _this1.setState({
                                        sweepMusicWasPaused: false,
                                        otherPlaying: true
                                    });
                                } else if (_this1.state.tourMusicWasPaused) {
                                    _this1.resumeTourMusic();
                                    _this1.setState({
                                        tourMusicWasPaused: false,
                                        otherPlaying: false
                                    });
                                }
                                _this1.state.onExperienceCloseCallback();
                                _this1.setState({
                                    experiencePopUpIsOpen: status,
                                    closedElementPopup: !status,
                                    onExperienceCloseCallback: function() {
                                        return undefined;
                                    }
                                });
                            }
                        }),
                        ticketingOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketingRouter, {
                            matterId: tour.slug,
                            parentTourId: tour.parentId,
                            tourId: tour.id,
                            gameId: tour.gameId,
                            ticketing: ticketing,
                            reactAppDomain: _this.root,
                            reactAws: _this.props.reactAws,
                            tourImage: tourImage,
                            onTicketLoginSuccess: _this.onTicketLoginSuccess,
                            translation: translation,
                            whiteLabelData: whiteLabelData
                        }),
                        !ticketingOpen && showIntroScreen && tour && !tour.password && _this.state.tourType !== Tour/* TourType.Game */.v.Game && /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroScreen, {
                            rtl: (ref3 = tour.client) === null || ref3 === void 0 ? void 0 : ref3.rtl,
                            tour: tour,
                            initialDuplicates: initialDuplicates,
                            introScreen: tour.introScreen,
                            whiteLabelData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, whiteLabelData), {
                                isWLUser: !!(tour === null || tour === void 0 ? void 0 : (ref4 = tour.user) === null || ref4 === void 0 ? void 0 : ref4.whitelabelId)
                            }),
                            translation: translation,
                            showCollectLeadsModal: showCollectLeadsModal,
                            showIntroScreenSpinner: showIntroScreenSpinner,
                            onStart: _this.onPlayClick,
                            inputs: {
                                name: tour === null || tour === void 0 ? void 0 : tour.collectLeads,
                                phone: (tour === null || tour === void 0 ? void 0 : tour.collectLeads) && (tour === null || tour === void 0 ? void 0 : tour.leadsPhone),
                                email: (tour === null || tour === void 0 ? void 0 : tour.collectLeads) && (tour === null || tour === void 0 ? void 0 : tour.leadsEmail)
                            },
                            checkbox: {
                                legal1: (tour === null || tour === void 0 ? void 0 : tour.collectLeads) ? (tour === null || tour === void 0 ? void 0 : tour.legalBookingBox) || "" : "",
                                legal2: (tour === null || tour === void 0 ? void 0 : tour.collectLeads) ? (tour === null || tour === void 0 ? void 0 : tour.legalBookingBox2) || "" : ""
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "".concat(containerId, "-tour-root"),
                            className: classnames_default()(preview ? "preview base-tour tour-container" : "base-tour tour-container", isMobile && "no-visible-scrollbar", tourType === Tour/* TourType.Game */.v.Game && host && "game-container"),
                            // eslint-disable-next-line no-return-assign
                            ref: function(el) {
                                return _this1.root = el;
                            },
                            children: [
                                tokenRemainingTime > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "countDownWrap",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "countDown",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown, {
                                            date: tokenExpiresAt,
                                            zeroPadDays: 0,
                                            onComplete: function() {
                                                _this1.props.history.push("/");
                                            }
                                        })
                                    })
                                }),
                                showCollectLeadsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectLeadsForm, {
                                    tour: tour,
                                    rtl: (ref5 = tour.client) === null || ref5 === void 0 ? void 0 : ref5.rtl,
                                    translation: translation,
                                    onStart: _this.handleCollectLeadsSubmit
                                }),
                                !ticketingOpen && tour && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: _this.isRenderAuth() ? _this.renderAuth() : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()("inner", {
                                            mobile: isMobile,
                                            isChromeInIOS: isIOS && isChrome
                                        }),
                                        style: showCollectLeadsModal && tour.mainImage ? {
                                            backgroundColor: "#000"
                                        } : {},
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "ui-wrap",
                                                children: [
                                                    tour.messengerLink && tour.messengerGreeting && _this.messenger !== 0 && !room && /*#__PURE__*/ (0,jsx_runtime.jsx)(MessengerCustomerChat, {
                                                        pageId: tour.messengerLink,
                                                        loggedInGreeting: tour.messengerGreeting,
                                                        loggedOutGreeting: tour.messengerGreeting,
                                                        themeColor: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor) || "#ea475c"
                                                    }),
                                                    externalPopupUrl && externalPopupOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalPopup, {
                                                        show: externalPopupUrl && externalPopupOn,
                                                        url: externalPopupUrl,
                                                        onClose: _this.toggleExternalPopupNull,
                                                        logo: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.active) ? whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo : "../../images/logo.svg",
                                                        iframeSettings: iframeSettings
                                                    }),
                                                    _this.injectChildComponents(),
                                                    !isGameTour && (tour === null || tour === void 0 ? void 0 : tour.gameId) && ((ref6 = _this.state) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.game) === null || ref7 === void 0 ? void 0 : ref7.paths) && !_this.state.showIntro && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegularPaths, {
                                                        isRtl: (ref8 = tour.client) === null || ref8 === void 0 ? void 0 : ref8.rtl,
                                                        translationGo: ((ref9 = _this.state.translation) === null || ref9 === void 0 ? void 0 : ref9.next) || "Next",
                                                        gameId: game.id,
                                                        gamePaths: _this.state.game.paths,
                                                        allTags: _this.state.allTags,
                                                        polygons: _this.state.polygons,
                                                        showcase: _this.showCaseTemp,
                                                        vsObjects: _this.vsObjects,
                                                        sweeps: _this.state.sweeps,
                                                        clickedElement: _this.state.clickedElement,
                                                        onAction: _this.onPathAction
                                                    }),
                                                    tagPopOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsPopup, {
                                                        logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo,
                                                        obj: openedTag,
                                                        type: "tags",
                                                        tourId: tour.id,
                                                        closePop: _this.closeTagPop
                                                    }),
                                                    !ticketingOpen && (ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingOrderedTicket) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderTicketingContent, {
                                                        tickets: ticketingContentTickets,
                                                        translation: ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingTranslation,
                                                        tourSlug: tour.slug,
                                                        ticketingOrderedTicket: ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingOrderedTicket,
                                                        ticketTimeLeftMs: _this.state.ticketTimeLeftMs,
                                                        ticketModalInfo: _this.state.ticketModalInfo,
                                                        root: _this.root,
                                                        tourId: tour.id,
                                                        gameId: tour.gameId,
                                                        ticketingGeneral: ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGeneral,
                                                        showTicketModal: _this.state.showTicketModal
                                                    }),
                                                    openedPanoHotspot && panoPopOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(PanoPopup, {
                                                        hotspot: openedPanoHotspot,
                                                        show: panoPopOn,
                                                        onClose: _this.closePanoPop,
                                                        logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo
                                                    }),
                                                    _this.state.showPathFinderPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(PathFinderPopup, {
                                                        open: _this.state.showPathFinderPopup,
                                                        closePopup: _this.closePathFinderPop
                                                    }),
                                                    vsActionPopOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(VSActionsPopup, {
                                                        tourId: tour.id,
                                                        object: openedVSAction,
                                                        onClose: _this.closeActionPop
                                                    }),
                                                    contactPopupOn && showcaseLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactPopup, {
                                                        agents: agents,
                                                        rtl: (ref10 = tour.client) === null || ref10 === void 0 ? void 0 : ref10.rtl,
                                                        translation: translation,
                                                        to: (tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.menuGetInTouch) || (tour === null || tour === void 0 ? void 0 : (ref11 = tour.client) === null || ref11 === void 0 ? void 0 : ref11.email),
                                                        legalBookingBox: tour.legalBookingBox,
                                                        legalBookingBox2: tour.legalBookingBox2,
                                                        userId: tour.userId,
                                                        tourId: tour.id,
                                                        title: tour.title,
                                                        client: tour.client,
                                                        hideClientContact: tour.hideClientContact,
                                                        phone: tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.contactPhone,
                                                        name: tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.contactName,
                                                        toggleContactPopup: _this.toggleContactPopup
                                                    }),
                                                    tour.qualtricsId && showcaseLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Qualtrics, {
                                                        onClick: function() {
                                                            var tour = _this1.state.tour;
                                                            tour.qualtricsId = null;
                                                            _this1.setState({
                                                                tour: tour
                                                            });
                                                        },
                                                        qualtricsId: tour.qualtricsId,
                                                        onKeyPress: function() {}
                                                    }),
                                                    !room && /*#__PURE__*/ (0,jsx_runtime.jsx)(Ad, {
                                                        time: tour.adTime,
                                                        res: deviceManager/* default.isMobile */.Z.isMobile() ? tour.adResMobile : tour.adRes,
                                                        width: deviceManager/* default.isMobile */.Z.isMobile() ? tour.adWidthMobile : tour.adWidth,
                                                        height: deviceManager/* default.isMobile */.Z.isMobile() ? tour.adHeightMobile : tour.adHeight,
                                                        tourId: tour.id,
                                                        matterId: tour.matterId,
                                                        to: tourEmail && tourEmail.leadForms || tour.client && tour.client.email,
                                                        rtl: (ref12 = tour.client) === null || ref12 === void 0 ? void 0 : ref12.rtl,
                                                        updatedAt: tour.updatedAt,
                                                        enabled: tour.ad,
                                                        url: tour.adUrl,
                                                        leads: tour.adLeads,
                                                        userId: tour.userId,
                                                        clientId: tour.clientId,
                                                        translation: translation,
                                                        legalBookingBox: tour.legalBookingBox,
                                                        legalBookingBox2: tour.legalBookingBox2,
                                                        leadsPhone: tour.leadsPhone
                                                    }),
                                                    !isGameTour && panoramaOn && (panoramas === null || panoramas === void 0 ? void 0 : panoramas.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Panorama, {
                                                        panoramas: panoramas,
                                                        markMinimap: _this.markMinimap,
                                                        panoPose: _this.state.panoPose,
                                                        activePano: _this.state.activePano,
                                                        transition: tour.panoramaTransition,
                                                        isChatGuest: room && socket/* default */.Z && socket/* default.connected */.Z.connected && !host,
                                                        defaultPanorama: tour.defaultPanorama,
                                                        updatePanoRotation: _this.updatePanoRotation,
                                                        openHotspot: _this.openedPanoHotspot,
                                                        onSceneChange: _this.handlePanoSceneChange,
                                                        handleTogglePano: _this.handleTogglePano
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "overlay ".concat(overlayOn ? "open" : "")
                                                    }),
                                                    tour.menuEnabled && tourType !== Tour/* TourType.Game */.v.Game && showcaseLoaded && !mesurementsOn && _this.renderMenu(),
                                                    room && _this.showCaseTemp && _this.pose && !showIntroScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoizedVideo, {
                                                        iframeId: _this.state.iframeId,
                                                        sdk: _this.showCaseTemp.showcase,
                                                        tour: tour,
                                                        host: host,
                                                        audioOnly: audioOnly,
                                                        measurementsOn: mesurementsOn,
                                                        room: room,
                                                        slug: tour.slug,
                                                        name: chatParticipant === null || chatParticipant === void 0 ? void 0 : chatParticipant.name,
                                                        avatar: chatParticipant,
                                                        reelVideos: reelVideos,
                                                        endCall: _this.videoEndCall,
                                                        clientId: tour.clientId,
                                                        tourId: tour.id,
                                                        enterprise: tour === null || tour === void 0 ? void 0 : (ref13 = tour.user) === null || ref13 === void 0 ? void 0 : ref13.enterprise,
                                                        translation: translation,
                                                        allowGuestBeforeHost: allowGuestBeforeHost,
                                                        changeTour: _this.videoChangeTour,
                                                        addTrack: _this.addTrack,
                                                        removeTrack: _this.removeTrack,
                                                        pinnedVideos: _this.state.pinnedVideos,
                                                        removePinnedVideo: _this.removePinnedVideo,
                                                        onToggleMute: _this.toggleMuteParticipants,
                                                        onToggleFullscreen: _this.toggleFullscreenVideo,
                                                        dominantSpeaker: _this.state.dominantSpeaker,
                                                        fullscreenVideo: _this.state.fullscreenVideo,
                                                        addVideoReel: _this.addVideoReel,
                                                        enableAvatar: tour === null || tour === void 0 ? void 0 : tour.enableAvatar,
                                                        setAvatar: _this.setAvatar,
                                                        getAvatarImage: _this.getAvatarImage,
                                                        updateAvatarsInList: _this.updateAvatarsInList,
                                                        isWalkieTalkieOn: ((ref14 = _this.props) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.tourData) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.tour) === null || ref16 === void 0 ? void 0 : ref16.isWalkieTalkieOn) && audioOnly
                                                    }),
                                                    _this.showCaseTemp && !_this.state.showIntroScreen && !avatar && !room && (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        id: "video-name-overlay",
                                                        className: "overlay",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroPopup, {
                                                            sdk: _this.showCaseTemp.showcase,
                                                            enableAvatar: tour === null || tour === void 0 ? void 0 : tour.enableAvatar,
                                                            translation: translation,
                                                            setAvatar: _this.setAvatar,
                                                            getAvatarImage: _this.getAvatarImage,
                                                            audioOnly: audioOnly
                                                        })
                                                    }),
                                                    tour.legalNote && !_this.state.showIntroScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "legal-note ".concat(tour.client && tour.client.rtl && "rtl"),
                                                        // eslint-disable-next-line react/no-danger
                                                        dangerouslySetInnerHTML: {
                                                            // eslint-disable-next-line no-control-regex
                                                            __html: tour.legalNote.replace(new RegExp("\r?\n", "g"), "<br />")
                                                        }
                                                    }),
                                                    showcaseLoaded && !tour.unbranded && tour.client && tour.client.logo && !room && !_this.state.showIntroScreen && !_this.state.showNewHintModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: ((ref17 = tour.client) === null || ref17 === void 0 ? void 0 : ref17.website) ? ((ref18 = tour.client.website) === null || ref18 === void 0 ? void 0 : ref18.includes("https://")) ? tour.client.website : "https://".concat(tour.client.website) : "",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: tour.client.widthLogo ? "logo width" : "logo",
                                                            style: {
                                                                display: "block"
                                                            },
                                                            src: "".concat("https://cdn.treedis.com", "/clients/").concat(tour.client.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt)),
                                                            alt: ""
                                                        })
                                                    }),
                                                    showcaseLoaded && _this.renderButtonBg(),
                                                    _this.state.markerPopupOn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "popup",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "btn",
                                                                onClick: function() {
                                                                    _this1.setState({
                                                                        overlayOn: false,
                                                                        markerPopupOn: false
                                                                    });
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fas fa-times"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "What do you want to do?"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                onClick: _this.toggleExternalPopup.bind(_this, _this.state.selectedMarker.external),
                                                                children: "Open Autodesk Viewer"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                onClick: function() {
                                                                    return _this1.moveModel(selectedMarker.url);
                                                                },
                                                                children: "Move to this point"
                                                            })
                                                        ]
                                                    }),
                                                    showMinimap && /*#__PURE__*/ (0,jsx_runtime.jsx)(Minimap, {
                                                        tour: tour,
                                                        minimapOn: minimapOn,
                                                        minimapVisible: minimapVisible,
                                                        minimaps: minimaps,
                                                        selectedMinimap: selectedMinimap,
                                                        mapWalkerX: mapWalkerX,
                                                        mapWalkerY: mapWalkerY,
                                                        mapWalkerRotation: mapWalkerRotation,
                                                        markerClick: _this.markerClick,
                                                        onClick: function() {
                                                            _this1.setState({
                                                                minimapOn: !minimapOn
                                                            });
                                                        }
                                                    }),
                                                    _this.state.appointmentsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Appointment, {
                                                        tour: tour,
                                                        translation: translation,
                                                        tourEmail: tourEmail,
                                                        rtl: tour.client && tour.client.rtl,
                                                        appointmentsModal: _this.state.appointmentsModal,
                                                        toggleAppointmentsModal: _this.toggleAppointmentsModal,
                                                        appointmentTime: tour.appointmentTime
                                                    }),
                                                    sharePopupOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Share, {
                                                        tourType: tourType,
                                                        closeOnOutsideClick: tourType === Tour/* TourType.ECommerce */.v.ECommerce,
                                                        getLocation: _this.getShareLocation,
                                                        onClose: function() {
                                                            _this1.setState({
                                                                sharePopupOn: false
                                                            });
                                                        },
                                                        tour: tour,
                                                        translation: translation,
                                                        onColor: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor) || "#ea475c"
                                                    }),
                                                    showBottomBar && showcaseLoaded && !(window.innerWidth < 1024 && mesurementsOn) && _this.renderBottomBar(isFullScreen, toggleFullscreen),
                                                    loadSweeps && currentSweep && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sweep, {
                                                        tourReadyForAudio: tourStarted,
                                                        tourMusicWasPaused: _this.state.tourMusicWasPaused,
                                                        handleToggleMusic: _this.handleToggleMusic,
                                                        clearSweepAudio: function() {
                                                            if (_this1.sweepAudio) _this1.sweepAudio.pause();
                                                            _this1.sweepAudio = null;
                                                            _this1.setState({
                                                                otherPlaying: false
                                                            });
                                                        },
                                                        playTourAudio: function() {
                                                            var ref;
                                                            (ref = _this1.tourAudio) === null || ref === void 0 ? void 0 : ref.play();
                                                            _this1.setState({
                                                                otherPlaying: false,
                                                                mainPlaying: true
                                                            });
                                                        },
                                                        audioContainer: {
                                                            tourAudio: _this.tourAudio,
                                                            audio: _this.sweepAudio,
                                                            createAudioStream: _this.createAudioStream,
                                                            pause: function() {
                                                                var ref;
                                                                (ref = _this1.sweepAudio) === null || ref === void 0 ? void 0 : ref.pause();
                                                                _this1.setState({
                                                                    otherPlaying: false
                                                                });
                                                            },
                                                            play: function() {
                                                                _this1.playContainerAudio("sweepAudio");
                                                                _this1.setState(function() {
                                                                    return {
                                                                        otherPlaying: true
                                                                    };
                                                                });
                                                            },
                                                            pauseAllAudio: (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                                                return runtime_default().wrap(function _callee$(_ctx) {
                                                                    while(1)switch(_ctx.prev = _ctx.next){
                                                                        case 0:
                                                                            _ctx.next = 2;
                                                                            return _this2.pauseAllAudio("sweepAudio");
                                                                        case 2:
                                                                            _this2.setState({
                                                                                mainPlaying: false,
                                                                                otherPlaying: true
                                                                            });
                                                                        case 3:
                                                                        case "end":
                                                                            return _ctx.stop();
                                                                    }
                                                                }, _callee);
                                                            }))
                                                        },
                                                        videoContainer: {
                                                            pause: _this.pauseTourMusic,
                                                            play: _this.resumeTourMusic
                                                        },
                                                        hideSubtitlesGroupId: _this.state.hideSubtitlesGroupId,
                                                        title: tour.title,
                                                        client: tour.client,
                                                        legalBookingBox: tour.legalBookingBox,
                                                        legalBookingBox2: tour.legalBookingBox2,
                                                        panoramaStart: panoramaOn,
                                                        userId: tour.userId,
                                                        tourId: tour.id,
                                                        email: tourEmail && tourEmail.leadSweeps || tour.client && tour.client.email,
                                                        groups: sweepGroups,
                                                        selectedGroup: _this.state.activeSweepGroup,
                                                        noAudioMode: tour.noAudioMode && room,
                                                        translation: translation,
                                                        showPanoramaClick: function(panoramaId) {
                                                            var pIndex = panoramas.findIndex(function(p) {
                                                                return p.id === panoramaId;
                                                            });
                                                            panoramas[pIndex].default = true;
                                                            _this1.setState({
                                                                panoramas: panoramas,
                                                                panoramaOn: !panoramaOn
                                                            });
                                                        },
                                                        onInteractedChange: function(interacted) {
                                                            _this1.setState({
                                                                interacted: interacted
                                                            });
                                                        },
                                                        logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo
                                                    }),
                                                    showHelpModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Help, {
                                                        translation: translation,
                                                        onClose: function() {
                                                            _this1.setState({
                                                                showHelpModal: false
                                                            });
                                                        }
                                                    }),
                                                    showTermsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Terms, {
                                                        translation: translation,
                                                        tourId: tour.id,
                                                        onClose: function() {
                                                            _this1.setState({
                                                                showTermsModal: false
                                                            });
                                                        }
                                                    }),
                                                    lock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "lock-layer"
                                                    }),
                                                    !showIntro && !showIntroScreen && showcaseLoaded && (tour.music && tour.autoplayMusic || activeSweepGroup) && !room && !interacted && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        id: "music-cover",
                                                        style: {
                                                            zIndex: 2,
                                                            position: "fixed",
                                                            height: "100vh",
                                                            width: "100vw",
                                                            top: 0,
                                                            left: 0
                                                        },
                                                        onClick: function() {
                                                            _this1.setState({
                                                                interacted: true
                                                            });
                                                        }
                                                    }),
                                                    showIntro && !showIntroScreen && (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar) || (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) && avatar) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipScreen/* default */.Z, {
                                                        videoUrl: (game === null || game === void 0 ? void 0 : game.introClipUrl) || "",
                                                        close: function() {
                                                            _this1.onCloseIntro();
                                                        },
                                                        forcePlay: forcePlayGameIntro,
                                                        subtitles: (ref19 = _this.getCurrentLanguage()) === null || ref19 === void 0 ? void 0 : ref19.languageCode,
                                                        onStartEvent: function() {}
                                                    }) : _this.renderGameContent(),
                                                    !isGameTour && (game === null || game === void 0 ? void 0 : game.book) && tourStarted && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameBookHandle/* GameBookHandle */.V, {
                                                        isEcommerce: tourType === Tour/* TourType.ECommerce */.v.ECommerce,
                                                        gameBook: game.book,
                                                        onToggleGameBookModal: function() {
                                                            return _this1.setState(function(state) {
                                                                return {
                                                                    showBook: !state.showBook
                                                                };
                                                            });
                                                        },
                                                        showBook: _this.state.showBook,
                                                        showBookBtn: (game === null || game === void 0 ? void 0 : game.gameBookOn) && (game === null || game === void 0 ? void 0 : game.book) && !_this.state.showBook,
                                                        closeGameBook: function() {
                                                            return _this1.setState({
                                                                showBook: false
                                                            });
                                                        },
                                                        unlockedChapterIds: _this.state.unlockedChapterIds,
                                                        tryButtonPlaySound: _this.tryButtonPlaySound,
                                                        moveToSweep: _this.moveToSweep,
                                                        tourType: tourType
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(loadTourIframe_LoadTourIframe, {
                                                iframeId: _this.state.iframeId,
                                                mesurementsOn: mesurementsOn,
                                                iframeStyle: getIframeStyle({
                                                    tour: _this.state.tour,
                                                    activeSweepGroup: _this.state.activeSweepGroup,
                                                    sweepGroups: _this.state.sweepGroups
                                                }),
                                                cb: function(el) {
                                                    _this1.iframe = el;
                                                    _this1.hideIframeButtons();
                                                },
                                                iframeUrl: iframeUrl,
                                                isFullScreen: isFullScreen
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        tour && !tour.hideCookie && /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieConsent/* CustomCookieConsent */.Le, {
                            tour: tour,
                            loaded: showcaseLoaded,
                            message: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentText),
                            accept: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentAccept),
                            decline: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentDecline)
                        }),
                        showSketchfabPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(SketchfabPopup, {
                            show: showSketchfabPopup,
                            vsObjects: _this.vsObjects,
                            onClose: _this.toggleSketchfabPopup(false)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SetDataToRecoil, {
                            translation: translation,
                            tourConfigsInput: {
                                rtl: tour === null || tour === void 0 ? void 0 : (ref20 = tour.client) === null || ref20 === void 0 ? void 0 : ref20.rtl,
                                tourType: tourType
                            }
                        }),
                        _this.renderCrashScreen()
                    ]
                });
            }
        });
    };
    return BaseTour;
}(react.PureComponent);
BaseTour.whyDidYouRender = true;



/***/ }),

/***/ 82107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ game_ClipScreen; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@vimeo/player/dist/player.es.js
var player_es = __webpack_require__(48333);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/tour/game/ClipScreen/types.ts
var PlayerType;
(function(PlayerType) {
    PlayerType[PlayerType["NONE"] = 0] = "NONE";
    PlayerType[PlayerType["YOUTUBE"] = 1] = "YOUTUBE";
    PlayerType[PlayerType["VIMEO"] = 2] = "VIMEO";
    PlayerType[PlayerType["YOUKU"] = 3] = "YOUKU";
})(PlayerType || (PlayerType = {}));

;// CONCATENATED MODULE: ./components/tour/game/ClipScreen/data.ts

var getPlayerType = function(url) {
    if (url.includes("https://vimeo.com/")) {
        return PlayerType.VIMEO;
    }
    if (url.includes("https://www.youtube.com/") || url.includes("youtu.be")) {
        return PlayerType.YOUTUBE;
    }
    if (url.includes("youku.com")) {
        return PlayerType.YOUKU;
    }
    return PlayerType.NONE;
};
var getVimeoId = function(url) {
    var match = /vimeo.*\/(\d+)/i.exec(url);
    if (match) {
        return match[1];
    }
    return "";
};
var getYoutubeId = function(url) {
    var videoId = url.split("v=")[1] || url.split("youtu.be/")[1];
    var ampersandPosition = videoId.indexOf("&");
    if (ampersandPosition !== -1) {
        videoId = videoId.substring(0, ampersandPosition);
    }
    return videoId;
};
var getYoukuId = function(url) {
    var match = /id_(\w+)/i.exec(url);
    if (match) {
        return match[1];
    }
    return "";
};

// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(94556);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 328 modules
var dist = __webpack_require__(78734);
;// CONCATENATED MODULE: ./components/tour/game/ClipScreen/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  #intro-clip-iframe {\n    background: black;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

/* eslint-disable @typescript-eslint/ban-ts-comment */ 








var PERCENT_AFTER_START_EVENT = 0.7;
var LoaderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ClipScreen__LoaderWrap",
    componentId: "sc-779ff45e-0"
})(_templateObject());
var MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ClipScreen__MainWrap",
    componentId: "sc-779ff45e-1"
})(_templateObject1());
var ClipScreen = function(props) {
    var videoUrl = props.videoUrl, close = props.close, disableAutoplay = props.disableAutoplay, hideBtnGroup = props.hideBtnGroup, forcePlay = props.forcePlay, showControls = props.showControls, noMobile = props.noMobile, subtitles = props.subtitles, onStartEvent = props.onStartEvent, _autoClose = props.autoClose, autoClose = _autoClose === void 0 ? true : _autoClose;
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), muted = ref1[0], setMuted = ref1[1];
    var ref2 = (0,react.useState)(PlayerType.NONE), type = ref2[0], setType = ref2[1];
    var translation = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    var player = (0,react.useRef)(null);
    var isEventStarted = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (!videoUrl) return;
        setType(getPlayerType(videoUrl));
    }, [
        videoUrl
    ]);
    (0,react.useEffect)(function() {
        if (player && forcePlay && disableAutoplay) {
            var ref, ref1, ref2, ref3;
            if (type === PlayerType.VIMEO && typeof ((ref = player.current) === null || ref === void 0 ? void 0 : ref.play) === "function") (ref1 = player.current) === null || ref1 === void 0 ? void 0 : ref1.play();
            else if (typeof ((ref2 = player.current) === null || ref2 === void 0 ? void 0 : ref2.playVideo) === "function") (ref3 = player.current) === null || ref3 === void 0 ? void 0 : ref3.playVideo();
        }
    }, [
        player,
        forcePlay,
        disableAutoplay,
        type
    ]);
    var subtitlesCustomReplace = function(subCode) {
        // vimeo only
        // vimeo have different language codes (non iso) for some languages
        // for more check
        // https://vimeo.zendesk.com/hc/en-us/articles/224968828-Captions-and-subtitles#h_01FH9P8GQJ1ERMDZB2DRHJKAR0
        var subsToReplace = {
            he: "iw"
        };
        return subsToReplace[subCode] || subCode;
    };
    var loadVimeoVideo = (0,react.useCallback)(function() {
        var playerVars = {
            id: getVimeoId(videoUrl),
            autoplay: !disableAutoplay && !deviceManager/* default.isIOS */.Z.isIOS(),
            controls: !!showControls || deviceManager/* default.isIOS */.Z.isIOS()
        };
        if (subtitles) playerVars.texttrack = subtitlesCustomReplace(subtitles);
        player.current = new player_es/* default */.Z("intro-clip-iframe", playerVars);
        player.current.on("timeupdate", function(data) {
            if (onStartEvent && data.percent >= PERCENT_AFTER_START_EVENT && !isEventStarted.current) {
                onStartEvent();
                isEventStarted.current = true;
            }
        });
        player.current.on("loaded", function() {
            setLoading(false);
            if (disableAutoplay) return;
            player.current.play().catch(function() {
            //nothing
            });
        });
        if (close) player.current.on("ended", function() {
            return autoClose && close();
        });
    }, [
        videoUrl,
        disableAutoplay,
        showControls,
        subtitles,
        close,
        onStartEvent,
        autoClose
    ]);
    var loadYKUVideo = (0,react.useCallback)(function() {
        var container = window.document.getElementById("intro-clip-iframe");
        var iframe = document.createElement("iframe");
        iframe.setAttribute("src", "https://player.youku.com/embed/".concat(getYoukuId(videoUrl), "?autoplay=1&controls=0&rel=0&showinfo=0"));
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        setTimeout(function() {
            return setLoading(false);
        }, 2000);
        container.appendChild(iframe);
    }, [
        videoUrl
    ]);
    var loadYTVideo = (0,react.useCallback)(function() {
        // @ts-ignore
        var playerVars = {
            autoplay: disableAutoplay ? 0 : 1,
            controls: showControls ? 1 : 0,
            rel: 0,
            showinfo: 0,
            disablekb: 1,
            fs: 0,
            modestbranding: 1
        };
        if (subtitles) playerVars.hl = subtitles;
        // @ts-ignore
        player.current = new window.YT.Player("intro-clip-iframe", {
            videoId: getYoutubeId(videoUrl),
            playerVars: playerVars,
            events: {
                onStateChange: function(event) {
                    // @ts-ignore
                    if (event.data === window.YT.PlayerState.ENDED && close) {
                        if (autoClose) close();
                    }
                },
                onReady: function(event) {
                    setLoading(false);
                    if (disableAutoplay) return;
                    event.target.playVideo();
                }
            }
        });
    }, [
        disableAutoplay,
        showControls,
        subtitles,
        videoUrl,
        close,
        autoClose
    ]);
    (0,react.useEffect)(function() {
        switch(type){
            case PlayerType.VIMEO:
                loadVimeoVideo();
                break;
            case PlayerType.YOUTUBE:
                // @ts-ignore
                if (!window.YT) {
                    var tag = document.createElement("script");
                    tag.src = "https://www.youtube.com/iframe_api";
                    // @ts-ignore
                    window.onYouTubeIframeAPIReady = loadYTVideo;
                    var firstScriptTag = document.getElementsByTagName("script")[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                } else {
                    loadYTVideo();
                }
                break;
            case PlayerType.YOUKU:
                loadYKUVideo();
                break;
            default:
        }
    }, [
        loadVimeoVideo,
        loadYKUVideo,
        loadYTVideo,
        type
    ]);
    var mute = (0,react.useCallback)(function() {
        if (!player.current) return;
        switch(type){
            case PlayerType.VIMEO:
                player.current.setMuted(true);
                break;
            case PlayerType.YOUTUBE:
                player.current.mute();
                break;
            default:
                break;
        }
        setMuted(true);
    }, [
        type
    ]);
    var unMute = (0,react.useCallback)(function() {
        if (!player.current) return;
        switch(type){
            case PlayerType.VIMEO:
                player.current.setMuted(false);
                break;
            case PlayerType.YOUTUBE:
                player.current.unMute();
                break;
            default:
                break;
        }
        setMuted(false);
    }, [
        type
    ]);
    var isMobile = deviceManager/* default.isMobile */.Z.isMobile();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrap, {
        id: "intro",
        className: classnames_default()("intro", deviceManager/* default.isMobile */.Z.isMobile() && "mobile"),
        children: [
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Loader */.aN, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: loading ? "none" : "initial"
                },
                children: [
                    !hideBtnGroup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "intro-btn-group",
                        children: [
                            type !== PlayerType.YOUKU && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "intro-button",
                                onClick: muted ? unMute : mute,
                                children: muted ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fas fa-volume-off"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fas fa-volume-mute"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "intro-button",
                                onClick: close || function() {
                                    return null;
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    children: (translation === null || translation === void 0 ? void 0 : translation.skip) || "Skip"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "intro-clip-iframe",
                        className: classnames_default()(!noMobile && isMobile && "mobile")
                    })
                ]
            })
        ]
    });
};
function areEqual(prevProps, nextProps) {
    return prevProps.videoUrl !== nextProps.videoUrl;
}
/* harmony default export */ var game_ClipScreen = (/*#__PURE__*/(0,react.memo)(ClipScreen, areEqual));


/***/ }),

/***/ 25406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ GameBookHandle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./components/tour/game/gameBook/types.ts
var types = __webpack_require__(81389);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./units/Icon/index.ts + 45 modules
var Icon = __webpack_require__(34915);
// EXTERNAL MODULE: ./units/Iframe/style.tsx
var style = __webpack_require__(54811);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(94556);
// EXTERNAL MODULE: ./components/util/index.ts + 6 modules
var util = __webpack_require__(66870);
;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Root/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.65);\n  z-index: 120;\n  position: absolute;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  color: white;\n  font-size: 16px;\n  font-family: Roboto;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-4278e250-0"
})(_templateObject(), function(param) {
    var background = param.background, opacity = param.opacity, color = param.color, theme = param.theme;
    var styles = "";
    if (background && opacity) {
        var ref = (0,util/* hexToRgb */.oo)(background), r = ref.r, g = ref.g, b = ref.b;
        styles += "background-color: rgba(".concat(r, ",").concat(g, ",").concat(b, ", ").concat(opacity, ");");
    }
    if (color) {
        styles += "color: ".concat(color, ";");
    }
    if (theme.device.mobile) {
        styles += "";
    }
    return styles;
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Root/index.tsx





var Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Root = (Root);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Header/style.tsx

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1em 2em;\n\n  h2 {\n    font-size: 2em;\n    font-weight: 500;\n    line-height: 0.8em;\n    letter-spacing: 0;\n    text-align: left;\n  }\n\n  .close-modal {\n    position: absolute;\n    right: 35px;\n    cursor: pointer;\n\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ",
        "\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-c647ccb6-0"
})(style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Header/index.tsx





var Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Header = (Header);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/List/style.tsx

function List_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 80vh;\n  overflow-y: auto;\n  font-size: 1em;\n  width: 200px;\n\n  .chapter {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 1em;\n    width: 100%;\n    color: #fff;\n    position: relative;\n    cursor: pointer;\n    padding: 0.5em 1.25em;\n    overflow-wrap: anywhere;\n\n    &.active {\n      background-color: #2055ff;\n      ",
        "\n    }\n\n    &:hover {\n      background-color: #2055ff;\n      ",
        "\n      opacity: 0.7;\n    }\n\n    &.locked {\n      cursor: none;\n      pointer-events: none;\n      opacity: 0.7;\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    List_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ListStyled = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "style__ListStyled",
    componentId: "sc-27471df0-0"
})(List_style_templateObject(), function(param) {
    var buttonColor = param.buttonColor;
    return buttonColor && "background-color: ".concat(buttonColor, ";");
}, function(param) {
    var buttonColor = param.buttonColor;
    return buttonColor && "background-color: ".concat(buttonColor, ";");
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/List/index.tsx





var List = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(ListStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_List = (List);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Content/style.tsx

function Content_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: start;\n  padding: 3em 10em;\n\n  ",
        "\n"
    ]);
    Content_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ContentStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__ContentStyled",
    componentId: "sc-3a0c8cfe-0"
})(Content_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n      padding: 1em 6em;\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Content/index.tsx





var Content = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(ContentStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Content = (Content);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Main/style.tsx

function Main_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    max-height: 70vh;\n    width: 100%;\n  }\n\n  p {\n    max-height: 70vh;\n    width: 30vw;\n    min-height: 50vh;\n    word-wrap: break-word;\n    overflow-y: auto;\n  }\n\n  ",
        "\n"
    ]);
    Main_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MainStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__MainStyled",
    componentId: "sc-9195c60f-0"
})(Main_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n    p {\n      width: 50vw;\n    }\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Main/index.tsx





var Main = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(MainStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Main = (Main);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Footer/style.tsx

function Footer_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n\n  button {\n    font-size: 1em;\n    background-color: #2055ff;\n    padding: 0.4em 1em;\n    color: white;\n\n    &:hover {\n      opacity: 0.7;\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    Footer_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FooterStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__FooterStyled",
    componentId: "sc-d65b2058-0"
})(Footer_style_templateObject(), function(param) {
    var buttonColor = param.buttonColor, color = param.color;
    return buttonColor && color && "\n      background-color: ".concat(buttonColor, ";\n      color: ").concat(color, "\n    ");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Footer/index.tsx





var Footer = function(_param) {
    var show = _param.show, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "show",
        "children"
    ]);
    return show && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Footer = (Footer);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/index.ts







// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Root/style.tsx

function Root_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100vw;\n  height: 100vh;\n  height: 100%;\n  background: rgba(0, 0, 0, 1);\n  z-index: 1200;\n  position: absolute;\n  top: 0;\n  font-family: WorkSans;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n\n  .game-book-no-content {\n    padding: 70px 60px 30px 60px;\n    font-family: WorkSans;\n    font-size: 28px;\n    font-weight: 600;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.36;\n    letter-spacing: -0.56px;\n    text-align: center;\n    color: var(--white);\n  }\n"
    ]);
    Root_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-7d6a60d3-0"
})(Root_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Root/index.tsx





var Root_Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(style_RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var BannerHorizontalViewOnly_styled_Root = (Root_Root);

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Header/style.tsx

function Header_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .close-modal {\n    right: 10px;\n    position: absolute;\n    color: white;\n  }\n"
    ]);
    Header_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-881094ed-0"
})(Header_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Header/index.tsx





var Header_Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(style_HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var BannerHorizontalViewOnly_styled_Header = (Header_Header);

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/index.ts



;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/BannerHorizontalViewOnly.tsx






var BannerHorizontalViewOnly = function(param) {
    var show = param.show, onClose = param.onClose;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    if (!show) return null;
    var isMobile = deviceManager/* default.isMobile */.Z.isMobile();
    var isHorMob = deviceManager/* default.isHorizontalMobileView */.Z.isHorizontalMobileView();
    if (isMobile && !isHorMob) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerHorizontalViewOnly_styled_Root, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerHorizontalViewOnly_styled_Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                        className: "close-modal",
                        onClick: onClose,
                        fontSize: "large"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "game-book-no-content",
                    children: (translation === null || translation === void 0 ? void 0 : translation.expGbNoContent) || "Available only for horizontal view"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "game-book-gif",
                    src: "/experience/mobile.gif",
                    alt: "Screen orientation"
                })
            ]
        });
    }
    return null;
};

// EXTERNAL MODULE: ./_helpers/base.tsx
var base = __webpack_require__(41154);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
// EXTERNAL MODULE: ./_helpers/renderDebug.ts
var renderDebug = __webpack_require__(66725);
;// CONCATENATED MODULE: ./components/tour/game/gameBook/index.tsx















var GameBook = function(param) {
    var onClose = param.onClose, book = param.book, unlockedChapterIds = param.unlockedChapterIds, tryButtonPlaySound = param.tryButtonPlaySound, show = param.show, moveToSweep = param.moveToSweep, tourType = param.tourType;
    var backgroundColor = book.backgroundColor, backgroundOpacity = book.backgroundOpacity, textColor = book.textColor, buttonColor = book.buttonColor, chapterLocked = book.chapterLocked;
    if (!show) return null;
    var ref = (0,react.useState)(), activePage = ref[0], setActivePage = ref[1];
    var ref1 = (0,react.useState)([]), pages = ref1[0], setPages = ref1[1];
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    (0,react.useEffect)(function() {
        var ref;
        if ((book === null || book === void 0 ? void 0 : (ref = book.chapters) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var data = sortBy_default()(book.chapters, "order").reduce(function(acc, chapter) {
                acc.push({
                    id: chapter.id,
                    title: chapter.title,
                    description: chapter.description,
                    url: chapter.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/chapter/").concat(chapter.id, "/").concat(chapter.img) : undefined,
                    moveToSweepUuid: chapter.sweepUuid,
                    locationType: chapter === null || chapter === void 0 ? void 0 : chapter.locationType,
                    locationTourLink: chapter === null || chapter === void 0 ? void 0 : chapter.locationTourLink
                });
                return acc;
            }, [
                {
                    id: 0,
                    title: (translation === null || translation === void 0 ? void 0 : translation.experienceCover) || "Cover",
                    description: book.description,
                    url: book.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/").concat(book.img) : undefined,
                    moveToSweepUuid: undefined,
                    locationType: undefined,
                    locationTourLink: undefined
                }, 
            ]);
            setPages(data);
            setActivePage(data[0]);
        }
    }, [
        book
    ]);
    (0,react.useEffect)(function() {
        handleMoveToSweep(true);
    }, [
        activePage
    ]);
    var isPageLocked = function(chapterId) {
        if (chapterId === 0 || !chapterLocked) return false;
        return !unlockedChapterIds.includes(chapterId);
    };
    var changePage = function(page) {
        if (!isPageLocked(page.id)) {
            tryButtonPlaySound();
            setActivePage(page);
        }
    };
    var handleMoveToSweep = function() {
        var first = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        try {
            if (activePage && (first && !activePage.url || !first)) {
                if (activePage.locationType === types/* GameBookLocationType.sweep */.d.sweep && activePage.moveToSweepUuid) {
                    moveToSweep(activePage.moveToSweepUuid);
                } else if (activePage.locationType === types/* GameBookLocationType.tourLink */.d.tourLink && activePage.locationTourLink) {
                    var parsedLink = (0,base/* parseTourLink */.Qs)(activePage.locationTourLink);
                    if (parsedLink) {
                        moveToSweep(parsedLink.s, {
                            x: parsedLink.x,
                            y: parsedLink.y
                        });
                    }
                } else if (activePage.id !== 0) {
                    onClose();
                }
            }
        } catch (err) {
            console.error("gameBook handleMoveToSweep error");
        }
    };
    //timeout will prevent reopen configs closed by sidebar configs icon
    var handleClickAway = function(ev) {
        if (tourType === Tour/* TourType.ECommerce */.v.ECommerce) {
            window.setTimeout(function() {
                onClose();
            }, 100);
        }
    };
    (0,renderDebug/* dLog */.a)("GameBook");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerHorizontalViewOnly, {
                onClose: onClose,
                show: show
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                mouseEvent: "onMouseUp",
                onClickAway: handleClickAway,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "handleClickAwayNotWorksWithoutThisWrap",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Root, {
                        background: backgroundColor,
                        opacity: backgroundOpacity,
                        color: textColor,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Header, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: (book === null || book === void 0 ? void 0 : book.description) || (translation === null || translation === void 0 ? void 0 : translation.expJournBook) || "Journey book"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                                        className: "close-modal",
                                        onClick: onClose,
                                        fontSize: "large"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Content, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Main, {
                                        children: [
                                            activePage ? activePage.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "book",
                                                src: activePage.url,
                                                alt: ""
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "page-description",
                                                children: activePage.description
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Loader */.aN, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Footer, {
                                                show: !!(activePage === null || activePage === void 0 ? void 0 : activePage.moveToSweepUuid),
                                                buttonColor: buttonColor,
                                                color: textColor,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    onClick: function() {
                                                        return handleMoveToSweep();
                                                    },
                                                    children: [
                                                        (translation === null || translation === void 0 ? void 0 : translation.experienceTeleport) || "Take me there",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.ArrowRight */.Z.ArrowRight, {
                                                            fontSize: "inherit"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_List, {
                                        color: textColor,
                                        buttonColor: buttonColor,
                                        children: (pages || []).map(function(page) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: classnames_default()("chapter", isPageLocked(page.id) && "locked", !isPageLocked(page.id) && activePage.id === page.id && "active"),
                                                onClick: function() {
                                                    return changePage(page);
                                                },
                                                children: [
                                                    page.title,
                                                    isPageLocked(page.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Lock */.Z.Lock, {
                                                        fontSize: "inherit"
                                                    })
                                                ]
                                            }, page.id);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var game_gameBook = (/*#__PURE__*/(0,react.memo)(GameBook));

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Root/style.tsx

function styled_Root_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 999;\n  top: 20px;\n  right: 260px;\n  color: #ffffff;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(15px);\n  border-radius: 15px;\n  display: flex;\n  flex-direction: column;\n  padding: 1.25em;\n  justify-content: space-between;\n  max-width: 60%;\n  min-width: 320px;\n  min-height: 320px;\n\n  ",
        "\n"
    ]);
    styled_Root_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Root_style_RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-2405e9d5-0"
})(styled_Root_style_templateObject(), function(param) {
    var background = param.background, opacity = param.opacity, color = param.color, withFooter = param.withFooter, theme = param.theme;
    var styles = "";
    if (!withFooter) {
        styles += "justify-content: flex-start;";
    }
    if (background && opacity) {
        var ref = (0,util/* hexToRgb */.oo)(background), r = ref.r, g = ref.g, b = ref.b;
        styles += "background-color: rgba(".concat(r, ",").concat(g, ",").concat(b, ", ").concat(opacity, ");");
    }
    if (color) {
        styles += "color: ".concat(color, ";");
    }
    if (theme.device.mobile) {
        styles += "";
    }
    return styles;
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Root/index.tsx





var styled_Root_Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Root_style_RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var ChapterDetails_styled_Root = (styled_Root_Root);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Header/style.tsx

function styled_Header_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n\n  h2 {\n    font-size: 1.25em;\n  }\n\n  ",
        "\n"
    ]);
    styled_Header_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Header_style_HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-87aa418e-0"
})(styled_Header_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Header/index.tsx





var styled_Header_Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Header_style_HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var ChapterDetails_styled_Header = (styled_Header_Header);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Body/style.tsx

function Body_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1em 0;\n\n  img {\n    max-height: 70vh;\n    width: 100%;\n  }\n\n  p {\n    overflow-wrap: anywhere;\n  }\n\n  ",
        "\n"
    ]);
    Body_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var BodyStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__BodyStyled",
    componentId: "sc-d3e442b0-0"
})(Body_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n    img {\n      max-height: 60vh;\n    }\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Body/index.tsx





var Body = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(BodyStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Body = (Body);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Footer/style.tsx

function styled_Footer_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n\n  button {\n    font-size: 1em;\n    background-color: #2055ff;\n    padding: 0.4em 1em;\n    color: white;\n\n    &:hover {\n      opacity: 0.7;\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    styled_Footer_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_FooterStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__FooterStyled",
    componentId: "sc-1575e035-0"
})(styled_Footer_style_templateObject(), function(param) {
    var buttonColor = param.buttonColor, color = param.color;
    return buttonColor && color && "\n      background-color: ".concat(buttonColor, ";\n      color: ").concat(color, "\n    ");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Footer/index.tsx





var Footer_Footer = function(_param) {
    var show = _param.show, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "show",
        "children"
    ]);
    return show && /*#__PURE__*/ (0,jsx_runtime.jsx)(style_FooterStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var ChapterDetails_styled_Footer = (Footer_Footer);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/index.ts





;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/ChapterDetails.tsx









var ChapterDetails = /*#__PURE__*/ (0,react.memo)(function(param) {
    var book = param.book, chapter = param.chapter, onClose = param.onClose, moveToSweep = param.moveToSweep;
    if (!chapter || !(chapter.locationType === types/* GameBookLocationType.sweep */.d.sweep && chapter.moveToSweepUuid)) return null;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    var backgroundColor = book.backgroundColor, backgroundOpacity = book.backgroundOpacity, textColor = book.textColor, buttonColor = book.buttonColor;
    var showFooter = !!chapter.moveToSweepUuid;
    var handleMoveToSweep = function() {
        try {
            if (chapter) {
                if (chapter.locationType === types/* GameBookLocationType.sweep */.d.sweep && chapter.moveToSweepUuid) {
                    moveToSweep(chapter.moveToSweepUuid);
                } else if (chapter.locationType === types/* GameBookLocationType.tourLink */.d.tourLink && chapter.locationTourLink) {
                    var parsedLink = (0,base/* parseTourLink */.Qs)(chapter.locationTourLink);
                    if (parsedLink) {
                        moveToSweep(parsedLink.s, {
                            x: parsedLink.x,
                            y: parsedLink.y
                        });
                    }
                }
                onClose();
            }
        } catch (err) {
            console.error("gameBook ChapterDetails handleMoveToSweep error");
        }
    };
    return /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ChapterDetails_styled_Root, {
        background: backgroundColor,
        opacity: backgroundOpacity,
        color: textColor,
        withFooter: showFooter,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChapterDetails_styled_Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: chapter.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Body, {
                children: chapter.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: chapter.url,
                    alt: ""
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: chapter.description
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChapterDetails_styled_Footer, {
                show: showFooter,
                buttonColor: buttonColor,
                color: textColor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    onClick: handleMoveToSweep,
                    children: [
                        (translation === null || translation === void 0 ? void 0 : translation.experienceTeleport) || "Take me there",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.ArrowRight */.Z.ArrowRight, {
                            fontSize: "inherit"
                        })
                    ]
                })
            })
        ]
    }), document.getElementById("page-root"));
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/index.ts

/* harmony default export */ var components_ChapterDetails = (ChapterDetails);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Root/style.tsx

function OpenGameBook_styled_Root_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 200px;\n  top: 210px;\n  right: 50px;\n  z-index: 110;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(15px);\n  border-radius: 15px;\n  padding: 0.5em 0;\n  color: white;\n  font-size: 16px;\n  font-family: Roboto;\n\n  ",
        "\n"
    ]);
    OpenGameBook_styled_Root_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var styled_Root_style_RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-1da506d6-0"
})(OpenGameBook_styled_Root_style_templateObject(), function(param) {
    var background = param.background, opacity = param.opacity, color = param.color, customTop = param.customTop, theme = param.theme;
    var styles = "";
    if (background && opacity) {
        var ref = (0,util/* hexToRgb */.oo)(background), r = ref.r, g = ref.g, b = ref.b;
        styles += "background-color: rgba(".concat(r, ",").concat(g, ",").concat(b, ", ").concat(opacity, ");");
    }
    if (color) {
        styles += "color: ".concat(color, ";");
    }
    if (theme.device.mobile) {
        styles += "";
    }
    if (customTop) {
        styles += "top: ".concat(customTop, ";");
    }
    return styles;
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Root/index.tsx





var OpenGameBook_styled_Root_Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(styled_Root_style_RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var OpenGameBook_styled_Root = (OpenGameBook_styled_Root_Root);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Header/style.tsx

function OpenGameBook_styled_Header_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5em 1.25em;\n\n  h2 {\n    font-size: 0.8em;\n    font-weight: 500;\n    line-height: 0.8em;\n    letter-spacing: 0;\n    text-align: left;\n  }\n\n  ",
        "\n"
    ]);
    OpenGameBook_styled_Header_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var styled_Header_style_HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-9a2c996e-0"
})(OpenGameBook_styled_Header_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Header/index.tsx





var OpenGameBook_styled_Header_Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(styled_Header_style_HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var OpenGameBook_styled_Header = (OpenGameBook_styled_Header_Header);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/List/style.tsx

function styled_List_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 80vh;\n  overflow-y: auto;\n  font-size: 1em;\n  ",
        "\n\n  .chapter {\n    display: block;\n    font-size: ",
        ";\n    width: 100%;\n    color: #fff;\n    position: relative;\n    cursor: pointer;\n    overflow: hidden;\n    padding: 0.5em 1.25em;\n    overflow-wrap: anywhere;\n\n    &:hover {\n      background-color: #2055ff;\n      ",
        "\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    styled_List_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_ListStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__ListStyled",
    componentId: "sc-dcf0b53e-0"
})(styled_List_style_templateObject(), function(param) {
    var isHorizontalMobileView = param.isHorizontalMobileView;
    return isHorizontalMobileView && "height: 100px; overflow-y: scroll;";
}, function(param) {
    var isHorizontalMobileView = param.isHorizontalMobileView;
    return isHorizontalMobileView ? "0.8em" : "1em";
}, function(param) {
    var buttonColor = param.buttonColor;
    return buttonColor && "background-color: ".concat(buttonColor, ";");
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/List/index.tsx





var List_List = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(style_ListStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var OpenGameBook_styled_List = (List_List);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/index.ts




;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/OpenGameBook.tsx














var OpenGameBook = function(param) {
    var book = param.book, show = param.show, unlockedChapterIds = param.unlockedChapterIds, onClose = param.onClose, moveToSweep = param.moveToSweep, tourType = param.tourType;
    if (!show) return null;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    var sbIsOpen = (0,recoil/* useRecoilValue */.sJ)(store/* sidebarOpenState */.eo);
    var backgroundColor = book.backgroundColor, backgroundOpacity = book.backgroundOpacity, textColor = book.textColor, buttonColor = book.buttonColor, chapterLocked = book.chapterLocked;
    var ref = (0,react.useState)(), activeData = ref[0], setActiveData = ref[1];
    var isEcommerce = tourType === Tour/* TourType.ECommerce */.v.ECommerce;
    var isHorizontalMobileView = deviceManager/* default.isHorizontalMobileView */.Z.isHorizontalMobileView();
    var isChapterLocked = function(chapterId) {
        if (!chapterLocked) return false;
        return !unlockedChapterIds.includes(chapterId);
    };
    var openChapter = function(chapterId) {
        var data;
        if (chapterId === 0) {
            data = {
                title: (translation === null || translation === void 0 ? void 0 : translation.experienceCover) || "Cover",
                description: book.description,
                url: book.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/").concat(book.img) : undefined,
                moveToSweepUuid: undefined
            };
        } else if (!isChapterLocked(chapterId)) {
            var chapter = book.chapters.find(function(x) {
                return x.id === chapterId;
            });
            data = {
                // ...chapter,
                locationType: chapter.locationType,
                locationTourLink: chapter.locationTourLink,
                title: chapter.title,
                description: chapter.description,
                url: chapter.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/chapter/").concat(chapter.id, "/").concat(chapter.img) : undefined,
                moveToSweepUuid: chapter.sweepUuid
            };
        }
        if (data) {
            setActiveData(data);
        }
    };
    (0,react.useEffect)(function() {
        try {
            if (activeData) {
                if (activeData.locationType === types/* GameBookLocationType.sweep */.d.sweep && activeData.moveToSweepUuid) {
                    moveToSweep(activeData.moveToSweepUuid);
                } else if (activeData.locationType === types/* GameBookLocationType.tourLink */.d.tourLink && activeData.locationTourLink) {
                    var parsedLink = (0,base/* parseTourLink */.Qs)(activeData.locationTourLink);
                    if (parsedLink) {
                        moveToSweep(parsedLink.s, {
                            x: parsedLink.x,
                            y: parsedLink.y
                        });
                    }
                }
                setActiveData(undefined);
            }
        } catch (err) {
            console.error("gameBook ChapterDetails handleMoveToSweep error");
        }
    }, [
        activeData,
        moveToSweep,
        onClose
    ]);
    var eCommerceStyle = {
        top: "100px",
        marginTop: 0,
        right: sbIsOpen ? "180px" : "50px"
    };
    //timeout will prevent reopen configs closed by sidebar configs icon
    var handleClickAway = function(ev) {
        if (isEcommerce) {
            window.setTimeout(function() {
                onClose();
            }, 100);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerHorizontalViewOnly, {
                show: show,
                onClose: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                mouseEvent: "onMouseUp",
                onClickAway: handleClickAway,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "handleClickAwayNotWorksWithoutThisWrap",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OpenGameBook_styled_Root, {
                        background: backgroundColor,
                        opacity: backgroundOpacity,
                        color: textColor,
                        style: isEcommerce ? eCommerceStyle : undefined,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OpenGameBook_styled_Header, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: (book === null || book === void 0 ? void 0 : book.description) || (translation === null || translation === void 0 ? void 0 : translation.expJournBook) || "Journey book"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                                        onClick: onClose
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OpenGameBook_styled_List, {
                                buttonColor: buttonColor,
                                color: textColor,
                                isHorizontalMobileView: isHorizontalMobileView,
                                children: [
                                    book.img && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "chapter",
                                        onClick: function() {
                                            return openChapter(0);
                                        },
                                        children: (translation === null || translation === void 0 ? void 0 : translation.experienceCover) || "Cover"
                                    }, "0"),
                                    sortBy_default()(book.chapters || [], "order").map(function(chapter) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "d-flex justify-content-between align-center chapter",
                                            onClick: function() {
                                                return openChapter(chapter.id);
                                            },
                                            children: [
                                                chapter.title,
                                                isChapterLocked(chapter.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Lock */.Z.Lock, {
                                                    fontSize: "inherit"
                                                })
                                            ]
                                        }, chapter.id);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ChapterDetails, {
                                book: book,
                                chapter: activeData,
                                onClose: function() {
                                    return setActiveData(undefined);
                                },
                                moveToSweep: moveToSweep
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/index.ts

/* harmony default export */ var game_OpenGameBook = (OpenGameBook);

// EXTERNAL MODULE: ./_models/game/GameBook.ts
var game_GameBook = __webpack_require__(97741);
;// CONCATENATED MODULE: ./components/tour/game/GameBookHandle/index.tsx

// import GameBookBtn from '../gameBookBtn';



// import { TourType } from '@/_models/Tour';
var GameBookHandle = function(param) {
    var isEcommerce = param.isEcommerce, gameBook = param.gameBook, showBook = param.showBook, tourType = param.tourType, closeGameBook = param.closeGameBook, unlockedChapterIds = param.unlockedChapterIds, moveToSweep = param.moveToSweep, tryButtonPlaySound = param.tryButtonPlaySound;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (gameBook === null || gameBook === void 0 ? void 0 : gameBook.type) === game_GameBook/* GameBookType.Close */.u6.Close && showBook && /*#__PURE__*/ (0,jsx_runtime.jsx)(game_gameBook, {
                tourType: tourType,
                show: showBook,
                onClose: closeGameBook,
                book: gameBook,
                unlockedChapterIds: unlockedChapterIds,
                tryButtonPlaySound: tryButtonPlaySound,
                moveToSweep: function(sweepUuid, rotation) {
                    moveToSweep(sweepUuid, rotation);
                    closeGameBook();
                }
            }),
            (gameBook === null || gameBook === void 0 ? void 0 : gameBook.type) === game_GameBook/* GameBookType.Open */.u6.Open && showBook && /*#__PURE__*/ (0,jsx_runtime.jsx)(game_OpenGameBook, {
                show: showBook,
                onClose: closeGameBook,
                book: gameBook,
                unlockedChapterIds: unlockedChapterIds,
                moveToSweep: moveToSweep,
                tourType: tourType
            })
        ]
    });
};


/***/ }),

/***/ 56703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ GameLockPathModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./utils/index.ts + 7 modules
var utils = __webpack_require__(58104);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(94556);
;// CONCATENATED MODULE: ./components/tour/game/GameLockPathModal/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.path-lock-panel-wrap {\n    position: absolute;\n    bottom: 50px;\n    width: 100%;\n    position: absolute;\n    z-index: 2;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    flex-direction: column-reverse;\n    height: auto;\n    z-index: 31;\n    pointer-events: none;\n\n    &.regular.mobile {\n      z-index: 16;\n      align-items: end;\n\n      .path-lock-panel {\n        border-radius: 50px;\n        max-width: 90vw;\n      }\n    }\n\n    .bt-audio-subs {\n      position: initial;\n      margin-bottom: 5px;\n      bottom: initial;\n    }\n  }\n\n  .path-lock-panel {\n    background: rgba(255, 255, 255, 0.75);\n    box-shadow: 0px 5px 6px -3px rgba(0, 0, 0, 0.25);\n    backdrop-filter: blur(7.5px);\n\n    border-radius: 35px;\n    pointer-events: all;\n    animation: 1s ease 0s 1 normal forwards running alert-toast-appear;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5px;\n    height: 60px;\n    border-radius: 50px;\n    font-size: 17px;\n    line-height: 20px;\n    letter-spacing: -0.02em;\n    z-index: 1;\n    width: 800px;\n    max-width: 100%;\n\n    .avatar {\n      object-fit: cover;\n      border-radius: 50%;\n      width: auto;\n      height: 50px;\n    }\n\n    .prev-btn {\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n      align-items: center;\n      height: 50px;\n      width: 70px;\n      border-radius: 50%;\n      font-weight: bold;\n\n      font-size: 17px;\n      line-height: 20px;\n      letter-spacing: -0.02em;\n      cursor: pointer;\n\n      background: transparent;\n      width: 55px;\n      height: 41px;\n      padding: 8px 15px 8px 16px;\n      border-radius: 34px;\n      margin-left: 11px;\n\n      &:hover {\n        box-shadow: inset 0px 0px 100px 0 #0000001c;\n      }\n\n      i {\n        font-size: 20px;\n      }\n    }\n    .path-lock-description + .prev-btn {\n      margin-right: 11px;\n    }\n    .next-btn {\n      font-family: 'Roboto';\n      font-style: normal;\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 26px;\n      align-items: center;\n      text-align: center;\n      letter-spacing: 0.46px;\n      color: #ffffff;\n\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n      align-items: center;\n      height: 50px;\n      max-width: 150px;\n      min-width: 100px;\n      background: var(--color-secondary);\n      border-radius: 50px;\n      font-weight: bold;\n      font-size: 17px;\n\n      line-height: 20px;\n      letter-spacing: -0.02em;\n      cursor: pointer;\n\n      &:hover {\n        box-shadow: inset 0px 0px 100px 0 #0000001c;\n      }\n\n      span {\n        margin-right: 13px;\n        align-items: center;\n        display: flex;\n        font-family: 'Roboto';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 26px;\n        text-transform: uppercase;\n      }\n\n      i {\n        font-size: 20px;\n      }\n    }\n\n    .path-lock-description {\n      width: 100%;\n      padding: 0 10px;\n      font-family: 'Roboto';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 105%;\n      align-items: center;\n      letter-spacing: 0.15px;\n      color: #333333;\n    }\n    @media screen and (orientation: portrait) {\n      &.mobile {\n        height: auto;\n        .prev-btn,\n        .next-btn {\n          height: 30px;\n          width: 35px;\n          min-width: 35px;\n          min-height: initial;\n        }\n      }\n    }\n  }\n\n  @keyframes alert-toast-appear {\n    from {\n      transform: translate(0px, 100px);\n      opacity: 0;\n    }\n\n    to {\n      transform: translate(0px, 0px);\n      opacity: 1;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__MainWrap",
    componentId: "sc-3e2446df-0"
})(_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/GameLockPathModal/index.tsx

function GameLockPathModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: -4px;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n"
    ]);
    GameLockPathModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var StyledImg = emotion_styled_browser_esm/* default.img */.Z.img(GameLockPathModal_templateObject());
var GameLockPathModal = function(param) {
    var pathSettings = param.pathSettings, handleNextStep = param.handleNextStep, handlePreviousStep = param.handlePreviousStep, translationGo = param.translationGo, description = param.description, isEnablePreviousStep = param.isEnablePreviousStep, gameId = param.gameId, pathLockId = param.pathLockId, isRtl = param.isRtl;
    var colorBackground = pathSettings.colorBackground, opacityBackground = pathSettings.opacityBackground, colorButton = pathSettings.colorButton, opacityButton = pathSettings.opacityButton, colorButtonText = pathSettings.colorButtonText, opacityButtonText = pathSettings.opacityButtonText, colorText = pathSettings.colorText, opacityText = pathSettings.opacityText;
    var isBbOpen = (0,recoil/* useRecoilValue */.sJ)(store/* bottomBarOpenState */.DF);
    var tourType = (0,recoil/* useRecoilValue */.sJ)(store/* tourConfigsState */.Uq).tourType;
    var device = (0,styled_components_browser_esm/* useTheme */.Fg)().device;
    var ref = device || {}, mobile = ref.mobile, landscape = ref.landscape;
    var hideConfigsBlock = document.querySelector(".ec-bb-main .hideConfigs");
    var bbOpenBottom = tourType === Tour/* TourType.ECommerce */.v.ECommerce ? "262px" : "235px";
    var bbClosedBottom = hideConfigsBlock && !landscape || tourType !== Tour/* TourType.ECommerce */.v.ECommerce && tourType !== Tour/* TourType.Game */.v.Game ? "76px" : "55px";
    if (mobile && landscape && tourType === Tour/* TourType.ECommerce */.v.ECommerce) {
        bbOpenBottom = "187px";
    }
    if (mobile && landscape && tourType !== Tour/* TourType.ECommerce */.v.ECommerce && tourType !== Tour/* TourType.Game */.v.Game && !isBbOpen) {
        bbOpenBottom = "52px";
    }
    if (tourType === Tour/* TourType.Game */.v.Game) {
        bbOpenBottom = "155px";
        if (mobile) {
            bbClosedBottom = "0px";
        } else {
            bbClosedBottom = "55px";
        }
    }
    var BackBtn = function() {
        return isEnablePreviousStep && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "prev-btn",
            onClick: handlePreviousStep,
            style: {
                background: colorButtonText || "none",
                opacity: opacityButtonText,
                border: "1px solid ".concat(colorButton)
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "btn-text",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fas fa-arrow-left",
                    style: {
                        color: colorButton,
                        opacity: opacityButton
                    }
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrap, {
        className: classnames_default()("path-lock-panel-wrap", mobile && "mobile", landscape && "landscape", isBbOpen ? "bbOpen" : "bbClosed", tourType !== Tour/* TourType.ECommerce */.v.ECommerce && tourType !== Tour/* TourType.Game */.v.Game && "regular", tourType === Tour/* TourType.Game */.v.Game && "game", tourType === Tour/* TourType.ECommerce */.v.ECommerce && "eCommerce", hideConfigsBlock && "hideConfigsBlock"),
        style: {
            //for regular tour mobile landscape bottom will be 52
            bottom: isBbOpen ? bbOpenBottom : bbClosedBottom
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("path-lock-panel", mobile && "mobile"),
                style: {
                    backgroundColor: utils/* color.hexToRgbA */.$_.hexToRgbA(colorBackground, opacityBackground),
                    direction: isRtl ? "rtl" : "initial"
                },
                children: [
                    (pathSettings === null || pathSettings === void 0 ? void 0 : pathSettings.icon) && (!mobile || landscape) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImg, {
                        src: "".concat("https://cdn.treedis.com", "/games/").concat(gameId, "/locks/").concat(pathLockId, "/").concat(pathSettings === null || pathSettings === void 0 ? void 0 : pathSettings.icon),
                        alt: "path_image"
                    }),
                    mobile && !landscape && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackBtn, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "path-lock-description",
                        dangerouslySetInnerHTML: {
                            __html: description
                        },
                        style: {
                            color: colorText,
                            opacity: opacityText
                        }
                    }),
                    (!mobile || landscape) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackBtn, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: "next-btn",
                        onClick: handleNextStep,
                        style: {
                            background: colorButton || "none",
                            opacity: opacityButton
                        },
                        children: [
                            (!mobile || landscape) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "btn-text",
                                style: {
                                    color: colorButtonText,
                                    opacity: opacityButtonText
                                },
                                children: translationGo
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa-solid fa-arrow-right"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pl-subtitles-space"
            })
        ]
    });
};


/***/ }),

/***/ 67644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12781);
/* harmony import */ var _helpers_renderDebug__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66725);






var lastTimestamp = 0;
var SoundControls = function(param) {
    var audio = param.audio, onClose = param.onClose;
    var ref;
    (0,_helpers_renderDebug__WEBPACK_IMPORTED_MODULE_4__/* .dLog */ .a)("SoundControls");
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), soundTime = ref1[0], setSoundTime = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowVolumeRange = ref2[0], toggleVolumeRange = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_store__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilState */ .FV)(_store__WEBPACK_IMPORTED_MODULE_3__/* .captionsEnabledState */ .b_), 2), captionsEnabled = ref3[0], setCaptionsEnabled = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timeupdate = function() {
            if (!audio.currentTime || !audio.duration) {
                return;
            }
            setSoundTime(audio.currentTime / audio.duration * 100);
        };
        audio.addEventListener("timeupdate", timeupdate);
        return function() {
            audio.removeEventListener("timeupdate", timeupdate);
        };
    }, [
        audio
    ]);
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), volume = ref4[0], setVolume = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (audio) {
            // eslint-disable-next-line no-param-reassign
            audio.volume = volume;
        }
        return function() {
            var ref;
            if (audio) audio === null || audio === void 0 ? void 0 : (ref = audio.closeReceivers) === null || ref === void 0 ? void 0 : ref.dispatchEvent(new Event("close"));
        };
    }, [
        audio,
        volume
    ]);
    var getSoundTime = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var ONE_MINUTE = 60;
        if (audio) {
            var duration = !Number.isNaN(audio.duration) ? audio.duration : 0;
            var hour = parseInt(String(duration / ONE_MINUTE), 10);
            var minutes = Math.round(duration % ONE_MINUTE);
            return "".concat(hour, ":").concat(String(minutes).length === 1 ? "0".concat(minutes) : minutes);
        }
        return "00:00";
    }, [
        audio
    ]);
    var setCurrentTime = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(time, data) {
        if (data.timeStamp - lastTimestamp > 300) {
            lastTimestamp = data.timeStamp;
            var duration = audio.duration;
            if (audio && !Number.isNaN(duration)) {
                // eslint-disable-next-line no-param-reassign
                audio.currentTime = time * duration / 100;
            }
        }
    }, [
        audio
    ]);
    var setTogglePlay = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (!(audio === null || audio === void 0 ? void 0 : audio.paused)) {
            audio.pause();
        } else {
            audio.play();
        }
    }, [
        audio
    ]);
    var handleClose = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(mode) {
        return function() {
            if (mode === "close") {
                audio === null || audio === void 0 ? void 0 : audio.pause();
                audio.src = null;
                if (audio === null || audio === void 0 ? void 0 : audio.closeReceivers) {
                    var ref;
                    audio === null || audio === void 0 ? void 0 : (ref = audio.closeReceivers) === null || ref === void 0 ? void 0 : ref.dispatchEvent(new Event("close"));
                }
            }
            if (onClose && typeof onClose === "function") {
                onClose();
            }
        };
    }, [
        audio,
        onClose
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "sounds",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container-controls",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-minus",
                        onClick: handleClose("hide")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-times",
                        onClick: handleClose("close")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sound-range",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    type: "range",
                    step: "0.1",
                    min: "0",
                    max: "100",
                    value: soundTime,
                    onChange: function(data) {
                        return setCurrentTime(parseFloat(data.target.value), data);
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sound-controls",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "left-side",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "play",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("fas", !(audio === null || audio === void 0 ? void 0 : audio.paused) ? "fa-pause" : "fa-play"),
                                    onClick: setTogglePlay
                                })
                            }),
                            (audio === null || audio === void 0 ? void 0 : (ref = audio.textTracks) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(captionsEnabled ? "fas fa-closed-captioning" : "fal fa-closed-captioning"),
                                    onClick: function() {
                                        return setCaptionsEnabled(!captionsEnabled);
                                    }
                                })
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "volume",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fas fa-volume-up",
                                        onClick: function() {
                                            return toggleVolumeRange(!isShowVolumeRange);
                                        }
                                    }),
                                    isShowVolumeRange && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        type: "range",
                                        step: "0.1",
                                        min: "0",
                                        max: "1",
                                        value: volume,
                                        onChange: function(data) {
                                            return setVolume(parseFloat(data.target.value));
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "right-side",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "time",
                            children: getSoundTime()
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SoundControls));


/***/ }),

/***/ 44:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FullScreen; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71418);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);








/* eslint-disable prefer-promise-reject-errors,class-methods-use-this */ // noinspection TypeScriptValidateTypes

var FullScreenContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isFullScreen: false,
    toggleFullscreen: function() {
        return null;
    }
});
var FullScreenStateProvider = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(FullScreenStateProvider, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(FullScreenStateProvider);
    function FullScreenStateProvider(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, FullScreenStateProvider);
        var _this;
        _this = _super.call(this, props);
        _this.targetRef = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createRef)();
        _this.state = {
            isFullScreen: false,
            // eslint-disable-next-line react/no-unused-state
            toggleFullscreen: _this.toggleFullscreen.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this))
        };
        return _this;
    }
    var _proto = FullScreenStateProvider.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        var targetElem = this.getTargetElement();
        targetElem.onfullscreenchange = function(event) {
            var isTargetElem = targetElem === event.target;
            if (!isTargetElem) {
                // Need to sync state when fullscreen mode turned off but isFullScreen is true
                // Case when more than one fullscreen mode is active and user closed mode by ESC tab
                if (_this.state.isFullScreen === true && !document.fullscreenElement) {
                    _this.setState({
                        isFullScreen: false
                    });
                }
                return;
            }
            var isFullScreen = document.fullscreenElement === event.target;
            _this.setState({
                isFullScreen: isFullScreen
            });
        };
        // eslint-disable-next-line react/destructuring-assignment
        if (this.props.startFullscreen) {
            this.toggleFullscreen();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var targetElem = this.getTargetElement();
        targetElem.onfullscreenchange = null;
    };
    _proto.toggleFullscreen = function toggleFullscreen() {
        if (!this.state.isFullScreen) {
            var ref;
            (ref = this.openFullscreen()) === null || ref === void 0 ? void 0 : ref.catch(console.error);
        } else {
            var ref1;
            (ref1 = this.exitFullscreen()) === null || ref1 === void 0 ? void 0 : ref1.catch(console.error);
        }
        // noinspection TypeScriptValidateTypes
        this.setState({
            isFullScreen: !this.state.isFullScreen
        });
    };
    _proto.exitFullscreen = function exitFullscreen() {
        if (document.exitFullscreen) {
            return document.exitFullscreen();
        }
        if (document.webkitExitFullscreen) {
            return document.webkitExitFullscreen();
        }
        if (document.msExitFullscreen) {
            return document.msExitFullscreen();
        }
        return Promise.reject("API does not response");
    };
    _proto.openFullscreen = function openFullscreen() {
        var elem = this.getTargetElement();
        if (elem.requestFullscreen) {
            return elem.requestFullscreen();
        }
        if (elem.webkitRequestFullscreen) {
            return elem.webkitRequestFullscreen();
        }
        if (elem.msRequestFullscreen) {
            return elem.msRequestFullscreen();
        }
        return Promise.reject("API does not response");
    };
    _proto.getTargetElement = function getTargetElement() {
        var rootBody = this.props.rootBody;
        return rootBody ? window.document.body : this.targetRef.current;
    };
    _proto.render = function render() {
        var _props = this.props, children = _props.children, attrs = _props.attrs;
        var attr = {
            id: attrs === null || attrs === void 0 ? void 0 : attrs.id,
            className: attrs === null || attrs === void 0 ? void 0 : attrs.class
        };
        var customStyles = (attrs === null || attrs === void 0 ? void 0 : attrs.styles) || {};
        var styles = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            height: "100%",
            width: "100%",
            background: "#fff"
        }, customStyles);
        return(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FullScreenContext.Provider, {
            value: this.state,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                ref: this.targetRef
            }, attr), {
                style: styles,
                children: children
            }))
        }));
    };
    return FullScreenStateProvider;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
function FullScreen(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FullScreenStateProvider, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FullScreenContext.Consumer, {
            children: children
        })
    }));
};


/***/ }),

/***/ 45019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ fetchMenuData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _util_all__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40488);



var fetchMenuData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tourId) {
        var ref, menus, menuSettings, productTypes;
        return _Users_boazkerengil_treedis_public_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return _util_all__WEBPACK_IMPORTED_MODULE_1__/* .fetchData */ .rQ("public/getMenu", "POST", {
                        id: tourId
                    });
                case 3:
                    ref = _ctx.sent;
                    menus = ref.menus;
                    menuSettings = ref.menuSettings;
                    productTypes = ref.productTypes;
                    return _ctx.abrupt("return", {
                        menus: menus,
                        menuSettings: menuSettings,
                        productTypes: productTypes
                    });
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error(_ctx.t0.message);
                    return _ctx.abrupt("return", []);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return function fetchMenuData(tourId) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 19004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G$": function() { return /* reexport */ hooks_useGame; },
  "AG": function() { return /* reexport */ useGlobalDOMEvents; },
  "ZK": function() { return /* reexport */ hooks_useLanguage; },
  "OT": function() { return /* reexport */ hooks_useToggle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./hooks/useGlobalDOMEvents.ts

/* eslint-disable @typescript-eslint/ban-ts-comment,no-restricted-syntax */ 
function useGlobalDOMEvents(props) {
    var deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    (0,react.useEffect)(function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(props)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], func = _value[1];
                // @ts-ignore
                window.addEventListener(key, func, false);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(props)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], func = _value[1];
                    // @ts-ignore
                    window.removeEventListener(key, func, false);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};

;// CONCATENATED MODULE: ./hooks/useToggle.tsx

var initialDefault = false;
var useToggle = function(initial) {
    var ref = (0,react.useState)(initial !== null && initial !== void 0 ? initial : initialDefault), isOpen = ref[0], setIsOpen = ref[1];
    var set = (0,react.useCallback)(function(value) {
        return setIsOpen(value);
    }, [
        setIsOpen
    ]);
    var open = (0,react.useCallback)(function() {
        return setIsOpen(true);
    }, [
        setIsOpen
    ]);
    var close = (0,react.useCallback)(function() {
        return setIsOpen(false);
    }, [
        setIsOpen
    ]);
    var toggle = (0,react.useCallback)(function() {
        return setIsOpen(function(prev) {
            return !prev;
        });
    }, [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        set: set,
        open: open,
        close: close,
        toggle: toggle
    };
};
/* harmony default export */ var hooks_useToggle = (useToggle);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
;// CONCATENATED MODULE: ./hooks/useLanguage.ts




var useLanguage = function(param) {
    var initialDuplicates = param.initialDuplicates, tourSlug = param.tourSlug;
    var languageOptions = (0,react.useMemo)(function() {
        return initialDuplicates === null || initialDuplicates === void 0 ? void 0 : initialDuplicates.map(function(duplicate) {
            return {
                label: (duplicate === null || duplicate === void 0 ? void 0 : duplicate.language) || (duplicate === null || duplicate === void 0 ? void 0 : duplicate.languageEn),
                value: duplicate.slug
            };
        }).filter(function(o) {
            return !!o.label;
        });
    }, [
        initialDuplicates
    ]);
    var defaultLanguage = (0,react.useMemo)(function() {
        return languageOptions === null || languageOptions === void 0 ? void 0 : languageOptions.find(function(o) {
            return o.value === tourSlug;
        });
    }, [
        languageOptions,
        tourSlug
    ]);
    var handleChange = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(lang) {
            var ref, ref1, tourRes, gameId, slug;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return TreedisPublicDAO/* default.getTourBySlug */.Z.getTourBySlug({
                            slug: lang.value
                        });
                    case 3:
                        tourRes = _ctx.sent;
                        gameId = tourRes === null || tourRes === void 0 ? void 0 : (ref = tourRes.tour) === null || ref === void 0 ? void 0 : ref.gameId;
                        slug = tourRes === null || tourRes === void 0 ? void 0 : (ref1 = tourRes.tour) === null || ref1 === void 0 ? void 0 : ref1.slug;
                        if (gameId && slug && slug !== (defaultLanguage === null || defaultLanguage === void 0 ? void 0 : defaultLanguage.value)) {
                            window.location.replace("".concat(window.location.origin, "/experience/").concat(gameId, "/").concat(slug));
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(lang) {
            return _ref.apply(this, arguments);
        };
    }(), [
        defaultLanguage === null || defaultLanguage === void 0 ? void 0 : defaultLanguage.value
    ]);
    return {
        languageOptions: languageOptions,
        defaultLanguage: defaultLanguage,
        handleChange: handleChange
    };
};
/* harmony default export */ var hooks_useLanguage = (useLanguage);

// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./store/index.ts + 7 modules
var store = __webpack_require__(12781);
// EXTERNAL MODULE: ./components/types.ts
var types = __webpack_require__(31828);
;// CONCATENATED MODULE: ./hooks/useGame.ts





var useGame = function(param) {
    var game = param.game, analytic = param.analytic, gameStatus = param.gameStatus, onEndExperience = param.onEndExperience;
    var ref = (0,react.useState)(0), gameTime = ref[0], setGameTime = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,recoil/* useRecoilState */.FV)(store/* lockTimerState */.bG), 2), lockTimer = ref1[0], setLockTimer = ref1[1];
    // 2nd level
    var initGameData = function() {
        var limitTime = game.limitTime * 60 * 1000;
        var currentGameTime = game.timerType === "stopwatch" ? 1 : limitTime;
        setGameTime(currentGameTime);
        analytic.setTime(game.timerType === "stopwatch" ? 1 : 0);
    };
    var mainGameTimer = function() {
        if (gameStatus === types/* GameStatus.SuccessfullyEndedWithoutFinalScreen */.XI.SuccessfullyEndedWithoutFinalScreen || gameStatus === types/* GameStatus.NotStarted */.XI.NotStarted) {
            return;
        }
        if ((lockTimer === null || lockTimer === void 0 ? void 0 : lockTimer.running) && (lockTimer === null || lockTimer === void 0 ? void 0 : lockTimer.value)) {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setLockTimer(function(lockTimer) {
                if ((lockTimer === null || lockTimer === void 0 ? void 0 : lockTimer.running) && (lockTimer === null || lockTimer === void 0 ? void 0 : lockTimer.value)) return {
                    running: lockTimer.running,
                    value: lockTimer.value - 1
                };
                return lockTimer;
            });
        }
        var currentGameTime = gameTime;
        if (game.timerType === "stopwatch") currentGameTime += 1000;
        else currentGameTime -= 1000;
        analytic.setTime(game.timerType === "stopwatch" ? currentGameTime : game.limitTime * 60 * 1000 - currentGameTime);
        if (currentGameTime > 0 && (!game.limitTime || currentGameTime < game.limitTime * 60 * 1000)) {
            setGameTime(currentGameTime);
        } else {
            // end experience setstate result screen
            onEndExperience();
        }
    };
    (0,react.useEffect)(function() {
        if (gameStatus === types/* GameStatus.Started */.XI.Started) {
            initGameData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        gameStatus
    ]);
    (0,react.useEffect)(function() {
        var timerInterval = setTimeout(mainGameTimer, 1000);
        return function cleanup() {
            clearTimeout(timerInterval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        gameTime
    ]);
    return {
        gameTime: gameTime
    };
};
/* harmony default export */ var hooks_useGame = (useGame);

;// CONCATENATED MODULE: ./hooks/index.ts






/***/ }),

/***/ 12978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ units_Iframe; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./units/Iframe/style.tsx
var style = __webpack_require__(54811);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
;// CONCATENATED MODULE: ./units/Iframe/IframeStyledHOC.tsx




var IframeStyledHOC = function(_param) {
    var onLoad = _param.onLoad, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "onLoad"
    ]);
    var playerRef = (0,react.useRef)();
    var getPlayerInstanceAndTryToPlay = function() {
        try {
            if (rest.autoplay) {
                var ref;
                // youtube autoplay fix
                var ytPlayer = (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.getInternalPlayer();
                if (typeof (ytPlayer === null || ytPlayer === void 0 ? void 0 : ytPlayer.playVideo) === "function") {
                    ytPlayer === null || ytPlayer === void 0 ? void 0 : ytPlayer.playVideo();
                }
            }
            onLoad();
        } catch (err) {
            console.error(err);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
        width: "100%",
        height: "100%",
        controls: true,
        url: rest.url,
        onReady: getPlayerInstanceAndTryToPlay,
        playing: rest.autoplay,
        muted: rest.mute,
        ref: playerRef
    });
};
/* harmony default export */ var Iframe_IframeStyledHOC = (/*#__PURE__*/(0,react.memo)(IframeStyledHOC));

;// CONCATENATED MODULE: ./units/Iframe/index.tsx






var Iframe = function(_param) {
    var src = _param.src, logoSrc = _param.logoSrc, useModernPlayer = _param.useModernPlayer, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "logoSrc",
        "useModernPlayer"
    ]);
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var hideSpinner = function() {
        setLoading(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* Root */.fC, {
        children: [
            loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* Loader */.aN, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Spinner */.$j, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Logo */.TR, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: logoSrc,
                            alt: ""
                        })
                    })
                ]
            }),
            useModernPlayer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe_IframeStyledHOC, (0,_object_spread/* default */.Z)({
                width: "100%",
                height: "100%",
                src: src,
                onLoad: hideSpinner
            }, rest)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* IframeStyled */.C, (0,_object_spread/* default */.Z)({
                width: "100%",
                height: "100%",
                src: src,
                allow: "geolocation;camera;microphone",
                onLoad: hideSpinner
            }, rest))
        ]
    });
};
/* harmony default export */ var units_Iframe = (Iframe);


/***/ }),

/***/ 54811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$j": function() { return /* binding */ Spinner; },
/* harmony export */   "C": function() { return /* binding */ IframeStyled; },
/* harmony export */   "TR": function() { return /* binding */ Logo; },
/* harmony export */   "aN": function() { return /* binding */ Loader; },
/* harmony export */   "fC": function() { return /* binding */ Root; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94556);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100% !important;\n  height: 100% !important;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  pointer-events: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 115px;\n  height: 115px;\n  object-fit: contain;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n\n  & img {\n    object-fit: contain;\n    height: 100%;\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 150px;\n  min-height: 150px;\n  width: 150px;\n  height: 150px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n\n  &::after {\n    content: ' ';\n    display: block;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    position: absolute;\n    border-radius: 50%;\n    border: 3px solid #fff;\n    border-color: var(--color-secondary) transparent var(--color-secondary) transparent;\n    animation: ",
        " 1.2s linear infinite;\n    top: 0;\n    left: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  html body img {\n    height: 100%;\n    width: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var spinner = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject());
var Root = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Root",
    componentId: "sc-5c3f9880-0"
})(_templateObject1());
var Loader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Loader",
    componentId: "sc-5c3f9880-1"
})(_templateObject2());
var Logo = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Logo",
    componentId: "sc-5c3f9880-2"
})(_templateObject3());
var Spinner = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Spinner",
    componentId: "sc-5c3f9880-3"
})(_templateObject4(), spinner);
var IframeStyled = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].iframe.withConfig */ .ZP.iframe.withConfig({
    displayName: "style__IframeStyled",
    componentId: "sc-5c3f9880-4"
})(_templateObject5());


/***/ }),

/***/ 99151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94556);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  position: absolute;\n  bottom: 70px;\n  left: ",
        ";\n  z-index: 100;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  transition: all 0.25s ease;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  right: -10px;\n  top: -10px;\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 50%;\n  color: #fff;\n  padding: 8px;\n  font-size: 14px;\n  line-height: 10px;\n  z-index: 2;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "VideoBox__Container",
    componentId: "sc-ccea8b1d-0"
})(_templateObject(), function(param) {
    var width = param.width, isMobile = param.isMobile, landscape = param.landscape;
    return isMobile ? !landscape ? "95vw" : "70vw" : "".concat(width || 350, "px");
}, function(param) {
    var height = param.height, isMobile = param.isMobile;
    return isMobile ? "auto" : "".concat(height || 200, "px");
}, function(param) {
    var isMobile = param.isMobile, landscape = param.landscape;
    return isMobile && !landscape ? "10px" : "60px";
});
var Iframe = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].iframe.withConfig */ .ZP.iframe.withConfig({
    displayName: "VideoBox__Iframe",
    componentId: "sc-ccea8b1d-1"
})(_templateObject1());
var Icon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].i.withConfig */ .ZP.i.withConfig({
    displayName: "VideoBox__Icon",
    componentId: "sc-ccea8b1d-2"
})(_templateObject2());
/* harmony default export */ __webpack_exports__["Z"] = ({
    Container: Container,
    Iframe: Iframe,
    Icon: Icon
});


/***/ }),

/***/ 19326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ units_Button; },
  "XZ": function() { return /* reexport */ units_Checkbox; },
  "PZ": function() { return /* reexport */ units_CloseButton; },
  "gN": function() { return /* reexport */ units_Field; },
  "l0": function() { return /* reexport */ units_Form; },
  "dY": function() { return /* reexport */ units_FullscreenButton; },
  "JO": function() { return /* reexport */ units_Icon/* default */.Z; },
  "II": function() { return /* reexport */ units_Input; },
  "xv": function() { return /* reexport */ units_Text; },
  "c6": function() { return /* reexport */ VideoBox/* default */.Z; }
});

// UNUSED EXPORTS: Alert, Collapse, DatePicker, Iframe, Watermark

// EXTERNAL MODULE: ./units/Alert/index.tsx + 1 modules
var Alert = __webpack_require__(47835);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./units/Button/defaultProps.ts
var defaultProps = {
    palette: "default",
    size: "medium",
    variant: "solid",
    flow: "auto",
    type: "button",
    borderRadius: "small"
};
/* harmony default export */ var Button_defaultProps = (defaultProps);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(94556);
;// CONCATENATED MODULE: ./units/Button/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr auto;\n  grid-template-rows: 1fr;\n  align-items: center;\n  overflow: hidden;\n\n  height: ",
        ";\n\n  min-width: ",
        ";\n\n  width: ",
        ";\n\n  color: ",
        ";\n\n  border-style: solid;\n\n  border-radius: ",
        ";\n\n  border-width: ",
        ";\n\n  border-color: ",
        ";\n\n  --background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  height: inherit;\n  background: var(--background);\n\n  width: ",
        ";\n\n  text-decoration: ",
        ";\n\n  font-size: ",
        ";\n\n  font-family: 'Lato', sans-serif;\n  font-weight: normal;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  gap: ",
        ";\n\n  padding: 0 1rem;\n\n  &[disabled] {\n    opacity: 0.6;\n  }\n\n  & > svg {\n    font-size: inherit;\n  }\n\n  transition: 0.3s background ease-in;\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  & + & {\n    border-left: 1px solid currentColor;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  to {\n    transform: rotate(1turn);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 1s linear infinite;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var SIZES = {
    // XXSMALL: 20,
    XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Root",
    componentId: "sc-7c7d2c4-0"
})(_templateObject(), function(param) {
    var size = param.size, variant = param.variant;
    switch(variant){
        case "link":
            {
                return "auto";
            }
        default:
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
    }
}, function(param) {
    var flow = param.flow, size = param.size;
    switch(flow){
        case "square":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
        case "fluid":
            {
                return "unset";
            }
        default:
            {
                return "80px";
            }
    }
}, function(param) {
    var flow = param.flow, size = param.size;
    switch(flow){
        case "square":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
        case "fluid":
            {
                return "100%";
            }
        default:
            {
                return "initial";
            }
    }
}, function(param) {
    var palette = param.palette, variant = param.variant;
    switch(variant){
        case "transparent":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    case "secondary":
                        {
                            return "#fff";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        case "ghost":
        case "soft":
        case "link":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        // case "solid"
        default:
            {
                return "#fff";
            }
    }
}, function(param) {
    var borderRadius = param.borderRadius;
    switch(borderRadius){
        case "large":
            {
                return "15px";
            }
        case "medium":
            {
                return "10px";
            }
        case "small":
            {
                return "5px";
            }
        case "none":
            {
                return "0px";
            }
        default:
            {
                return "4px";
            }
    }
}, function(param) {
    var variant = param.variant, size = param.size;
    switch(variant){
        case "ghost":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "1px";
                        }
                    case "small":
                        {
                            return "1px";
                        }
                    default:
                        {
                            return "2px";
                        }
                }
            }
        default:
            {
                return "0";
            }
    }
}, function(param) {
    var palette = param.palette, variant = param.variant;
    switch(variant){
        case "ghost":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        case "soft":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        // case "transparent"
        // case "solid"
        // case "link"
        default:
            {
                return "transparent";
            }
    }
}, function(param) {
    var palette = param.palette, variant = param.variant;
    switch(variant){
        case "transparent":
        case "ghost":
        case "link":
            {
                return "transparent";
            }
        case "soft":
            {
                switch(palette){
                    case "primary":
                        {
                            // TODO: add opacity
                            return "rgb(234 71 92 / .2)";
                        }
                    default:
                        {
                            // TODO: add opacity
                            return "rgb(41 41 41 / .2)";
                        }
                }
            }
        // case "solid"
        default:
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(--color-secondary)";
                        }
                    default:
                        {
                            return "var(--color-primary)";
                        }
                }
            }
    }
});
var ButtonStyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__ButtonStyled",
    componentId: "sc-7c7d2c4-1"
})(_templateObject1(), function(param) {
    var flow = param.flow, size = param.size;
    switch(flow){
        case "square":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
        case "fluid":
            {
                return "100%";
            }
        default:
            {
                return "initial";
            }
    }
}, function(param) {
    var variant = param.variant;
    switch(variant){
        case "link":
            {
                return "underline";
            }
        // case "solid"
        // case "link"
        default:
            {
                return "none";
            }
    }
}, function(param) {
    var size = param.size;
    switch(size){
        case "xsmall":
            {
                return "14px";
            }
        case "small":
            {
                return "16px";
            }
        default:
            {
                return "20px";
            }
    }
}, function(param) {
    var size = param.size;
    switch(size){
        case "xsmall":
            {
                return "4px";
            }
        case "small":
            {
                return "6px";
            }
        default:
            {
                return "10px";
            }
    }
}, function(param) {
    var variant = param.variant;
    switch(variant){
        case "transparent":
            {
                return "rgba(0, 0, 0, .2)";
            }
        default:
            {
                return "var(--background)";
            }
    }
});
var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject2());
var Rotate = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__Rotate",
    componentId: "sc-7c7d2c4-2"
})(_templateObject3(), rotate);

;// CONCATENATED MODULE: ./units/Button/index.tsx







var Button = function(_param) /*#__PURE__*/ {
    var _palette = _param.palette, palette = _palette === void 0 ? Button_defaultProps.palette : _palette, _size = _param.size, size = _size === void 0 ? Button_defaultProps.size : _size, _variant = _param.variant, variant = _variant === void 0 ? Button_defaultProps.variant : _variant, _flow = _param.flow, flow = _flow === void 0 ? Button_defaultProps.flow : _flow, _type = _param.type, type = _type === void 0 ? Button_defaultProps.type : _type, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? Button_defaultProps.borderRadius : _borderRadius, disabled = _param.disabled, loading = _param.loading, className = _param.className, onClear = _param.onClear, onClick = _param.onClick, onMouseDown = _param.onMouseDown, children = _param.children, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette",
        "size",
        "variant",
        "flow",
        "type",
        "borderRadius",
        "disabled",
        "loading",
        "className",
        "onClear",
        "onClick",
        "onMouseDown",
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(Root, {
        palette: palette,
        size: size,
        variant: variant,
        flow: flow,
        borderRadius: borderRadius,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                palette: palette,
                size: size,
                variant: variant,
                flow: flow,
                borderRadius: borderRadius,
                type: type,
                onClick: onClick,
                onMouseDown: onMouseDown,
                disabled: disabled || loading,
                className: className
            }, restProps), {
                children: [
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Rotate, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Loading */.Z.Loading, {})
                    }),
                    children
                ]
            })),
            onClear && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonStyled, {
                palette: palette,
                size: size,
                flow: "square",
                variant: "transparent",
                borderRadius: borderRadius,
                type: "button",
                disabled: disabled || loading,
                onClick: onClear,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Close */.Z.Close, {})
            })
        ]
    });
};
/* harmony default export */ var units_Button = (Button);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-checkbox/es/index.js
var es = __webpack_require__(50132);
// EXTERNAL MODULE: ./node_modules/rc-util/lib/omit.js
var omit = __webpack_require__(18475);
;// CONCATENATED MODULE: ./units/Checkbox/Group/index.tsx









var GroupContext = /*#__PURE__*/ (0,react.createContext)(null);
var CheckboxGroup = function(_param) {
    var defaultValue = _param.defaultValue, children = _param.children, _options = _param.options, options = _options === void 0 ? [] : _options, _prefixCls = _param.prefixCls, prefixCls = _prefixCls === void 0 ? "checkbox" : _prefixCls, className = _param.className, style = _param.style, onChange = _param.onChange, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "defaultValue",
        "children",
        "options",
        "prefixCls",
        "className",
        "style",
        "onChange"
    ]);
    var ref = (0,react.useState)(restProps.value || defaultValue || []), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)([]), registeredValues = ref1[0], setRegisteredValues = ref1[1];
    (0,react.useEffect)(function() {
        if ("value" in restProps) {
            setValue(restProps.value || []);
        }
    }, [
        restProps
    ]);
    var getOptions = function() {
        return options.map(function(option) {
            if (typeof option === "string") {
                return {
                    label: option,
                    value: option
                };
            }
            return option;
        });
    };
    var cancelValue = function(val) {
        setRegisteredValues(function(prevValues) {
            return prevValues.filter(function(v) {
                return v !== val;
            });
        });
    };
    var registerValue = function(val) {
        setRegisteredValues(function(prevValues) {
            return (0,_to_consumable_array/* default */.Z)(prevValues).concat([
                val
            ]);
        });
    };
    var toggleOption = function(option) {
        var optionIndex = value.indexOf(option.value);
        var newValue = (0,_to_consumable_array/* default */.Z)(value);
        if (optionIndex === -1) {
            newValue.push(option.value);
        } else {
            newValue.splice(optionIndex, 1);
        }
        if (!("value" in restProps)) {
            setValue(newValue);
        }
        var opts = getOptions();
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue.filter(function(val) {
            return registeredValues.indexOf(val) !== -1;
        }).sort(function(a, b) {
            var indexA = opts.findIndex(function(opt) {
                return opt.value === a;
            });
            var indexB = opts.findIndex(function(opt) {
                return opt.value === b;
            });
            return indexA - indexB;
        }));
    };
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var domProps = (0,omit/* default */.Z)(restProps, [
        "value",
        "disabled"
    ]);
    if (options && options.length > 0) {
        children = getOptions().map(function(option) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox, {
                prefixCls: prefixCls,
                disabled: "disabled" in option ? option.disabled : restProps.disabled,
                value: option.value,
                checked: value.indexOf(option.value) !== -1,
                onChange: option.onChange,
                className: "".concat(groupPrefixCls, "-item"),
                style: option.style,
                children: option.label
            }, option.value.toString());
        });
    }
    var context = {
        toggleOption: toggleOption,
        value: value,
        disabled: restProps.disabled,
        name: restProps.name,
        // https://github.com/ant-design/ant-design/issues/16376
        registerValue: registerValue,
        cancelValue: cancelValue
    };
    var classString = classnames_default()(groupPrefixCls, className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: classString,
        style: style
    }, domProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupContext.Provider, {
            value: context,
            children: react.Children.map(children, function(child) {
                return /*#__PURE__*/ (0,react.cloneElement)(child, {
                    value: value,
                    toggleOption: toggleOption
                });
            })
        })
    }));
};
/* harmony default export */ var Group = (/*#__PURE__*/(0,react.memo)(CheckboxGroup));

;// CONCATENATED MODULE: ./units/Checkbox/Checkbox/style.tsx

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n\n  & .checkbox {\n    width: 20px;\n    height: 20px;\n    display: block;\n    border-radius: 2px;\n    position: relative;\n    overflow: hidden;\n\n    & .checkbox-input {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: block;\n      height: 100%;\n      width: 100%;\n      margin: 0;\n      padding: 0;\n      opacity: 0;\n    }\n\n    & .checkbox-inner {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: block;\n      height: 100%;\n      width: 100%;\n      border: 2px solid #2c2c2c;\n      transition: background 0.2s ease-in;\n\n      border-color: ",
        ";\n    }\n\n    &.checkbox-checked {\n      & .checkbox-inner {\n        background: #2c2c2c;\n\n        &:after {\n          // eslint-disable-next-line max-len\n          content: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden='true'%3E%3Cpath fill='%23fff' d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'%3E%3C/path%3E%3C/svg%3E\");\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n        }\n      }\n    }\n\n    &.checkbox-indeterminate {\n      & .checkbox-inner {\n        background: #2c2c2c;\n        opacity: 0.8;\n\n        &:after {\n          // eslint-disable-next-line max-len\n          content: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden='true'%3E%3Cpath fill='%23fff' d='M19 13H5v-2h14v2z'%3E%3C/path%3E%3C/svg%3E\");\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n        }\n      }\n    }\n  }\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_SIZES = {
    // XXSMALL: 20,
    // XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var style_Root = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "style__Root",
    componentId: "sc-7b231797-0"
})(style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        default:
            {
                return "#292929";
            }
    }
});

;// CONCATENATED MODULE: ./units/Checkbox/Checkbox/index.tsx











var InternalCheckbox = function(_param, ref) {
    var _prefixCls = _param.prefixCls, prefixCls = _prefixCls === void 0 ? "checkbox" : _prefixCls, className = _param.className, children = _param.children, _indeterminate = _param.indeterminate, indeterminate = _indeterminate === void 0 ? false : _indeterminate, style = _param.style, onMouseEnter = _param.onMouseEnter, onMouseLeave = _param.onMouseLeave, _skipGroup = _param.skipGroup, skipGroup = _skipGroup === void 0 ? false : _skipGroup, palette = _param.palette, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "prefixCls",
        "className",
        "children",
        "indeterminate",
        "style",
        "onMouseEnter",
        "onMouseLeave",
        "skipGroup",
        "palette"
    ]);
    var checkboxGroup = (0,react.useContext)(GroupContext);
    var prevValue = (0,react.useRef)(restProps.value);
    (0,react.useEffect)(function() {
        checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
    }, [
        checkboxGroup,
        restProps.value
    ]);
    (0,react.useEffect)(function() {
        if (skipGroup) {
            return;
        }
        if (restProps.value !== prevValue.current) {
            checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(prevValue.current);
            checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
        }
        // eslint-disable-next-line consistent-return
        return function() {
            return checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
        };
    }, [
        checkboxGroup,
        restProps.value,
        skipGroup
    ]);
    var checkboxProps = (0,src_object_spread/* default */.Z)({}, restProps);
    if (checkboxGroup && !skipGroup) {
        checkboxProps.onChange = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (restProps.onChange) {
                var _restProps;
                (_restProps = restProps).onChange.apply(_restProps, (0,_to_consumable_array/* default */.Z)(args));
            }
            if (checkboxGroup.toggleOption) {
                checkboxGroup.toggleOption({
                    label: children,
                    value: restProps.value
                });
            }
        };
        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.indexOf(restProps.value) !== -1;
        checkboxProps.disabled = restProps.disabled || checkboxGroup.disabled;
    }
    var _obj;
    var classString = classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, "".concat(prefixCls, "-wrapper"), true), (0,_define_property/* default */.Z)(_obj, "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), (0,_define_property/* default */.Z)(_obj, "".concat(prefixCls, "-wrapper-disabled"), checkboxProps.disabled), _obj), className);
    var checkboxClass = classnames_default()((0,_define_property/* default */.Z)({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
    return(// eslint-disable-next-line jsx-a11y/label-has-associated-control
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Root, {
        palette: palette,
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, checkboxProps), {
                prefixCls: prefixCls,
                className: checkboxClass,
                // @ts-ignore
                ref: ref
            })),
            children
        ]
    }));
};
// @ts-ignore
var Checkbox = /*#__PURE__*/ (0,react.forwardRef)(InternalCheckbox);
Checkbox.displayName = "Checkbox";
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);

// EXTERNAL MODULE: ./node_modules/rc-collapse/assets/index.css
var assets = __webpack_require__(29969);
// EXTERNAL MODULE: ./node_modules/rc-collapse/es/index.js + 3 modules
var rc_collapse_es = __webpack_require__(16538);
;// CONCATENATED MODULE: ./units/Collapse/Panel/style.tsx

function Panel_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.rc-collapse-item {\n    padding: 0;\n    color: #666;\n    transition: 0.2s background ease-in;\n\n    & > .rc-collapse-header {\n      --background: ",
        ";\n\n      background: var(--background);\n      display: grid;\n      grid-template-columns: 1fr auto;\n      grid-template-areas: 'content arrow';\n      align-items: center;\n      overflow: hidden;\n      line-height: 1;\n      padding: 0;\n\n      &:hover {\n        background: ",
        ";\n      }\n\n      & .arrow {\n        grid-area: arrow;\n        border: none;\n        display: block;\n        width: 40px;\n        margin: 0;\n        position: relative;\n        top: 0;\n        background: transparent;\n        transition: 0.2s transform ease-in;\n        transform: rotate(180deg);\n        padding-bottom: 100%;\n\n        &:before {\n          content: url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Ctitle%3EChevron Up%3C/title%3E%3Cpath fill='none' stroke='%23727272' stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M112 328l144-144 144 144'/%3E%3C/svg%3E\");\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n          padding: 10px;\n        }\n      }\n\n      & .arrow + * {\n        grid-area: content;\n      }\n    }\n\n    &.rc-collapse-item-active {\n      & > .rc-collapse-header {\n        & .arrow {\n          transform: rotate(0deg);\n        }\n      }\n    }\n  }\n"
    ]);
    Panel_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PanelStyled = (0,styled_components_browser_esm/* default */.ZP)(rc_collapse_es/* default.Panel */.Z.Panel).withConfig({
    displayName: "style__PanelStyled",
    componentId: "sc-e8df8a15-0"
})(Panel_style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        default:
            {
                return "#292929";
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475ccc";
            }
        default:
            {
                return "#292929cc";
            }
    }
});

;// CONCATENATED MODULE: ./units/Collapse/Panel/index.tsx






var Panel = function(_param) /*#__PURE__*/ {
    var // custom
    palette = _param.palette, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette"
    ]);
    return (0,jsx_runtime.jsx)(PanelStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, restProps), {
        // custom
        palette: palette
    }));
};
/* harmony default export */ var Collapse_Panel = (Panel);

;// CONCATENATED MODULE: ./units/Collapse/style.tsx

function Collapse_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 0;\n  border: none;\n  margin-bottom: 12px;\n  background: transparent;\n\n  & .rc-collapse-content {\n    padding: 0;\n    background: transparent;\n\n    & .rc-collapse-content-box {\n      margin: 8px 0;\n    }\n  }\n"
    ]);
    Collapse_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CollapseStyled = (0,styled_components_browser_esm/* default */.ZP)(rc_collapse_es/* default */.Z).withConfig({
    displayName: "style__CollapseStyled",
    componentId: "sc-ffd29dd0-0"
})(Collapse_style_templateObject());

;// CONCATENATED MODULE: ./units/Collapse/index.tsx






var Collapse = function(_param) /*#__PURE__*/ {
    var palette = _param.palette, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette"
    ]);
    return (0,jsx_runtime.jsx)(CollapseStyled, (0,src_object_spread/* default */.Z)({
        // custom
        palette: palette
    }, rest));
};
Collapse.Panel = Collapse_Panel;
/* harmony default export */ var units_Collapse = (Collapse);

;// CONCATENATED MODULE: ./units/Checkbox/Collapsable/style.tsx

function Collapsable_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  height: 100%;\n  display: grid;\n  justify-content: inherit;\n\n  & > label {\n    padding-left: 25px;\n  }\n"
    ]);
    Collapsable_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Header",
    componentId: "sc-f04741cd-0"
})(Collapsable_style_templateObject());

;// CONCATENATED MODULE: ./units/Checkbox/Collapsable/index.tsx






var defaultCheckedList = [];
var Collapsable_CheckboxGroup = function(param) {
    var name = param.name, label = param.label, children = param.children, onChangeAll = param.onChangeAll;
    var optionsAll = (0,react.useMemo)(function() {
        return children.map(function(e) {
            return e.props.name;
        });
    }, [
        children
    ]);
    var ref = (0,react.useState)(defaultCheckedList), checkedList = ref[0], setCheckedList = ref[1];
    var ref1 = (0,react.useState)(false), indeterminate = ref1[0], setIndeterminate = ref1[1];
    var ref2 = (0,react.useState)(false), checkAll = ref2[0], setCheckAll = ref2[1];
    var handleChange = (0,react.useCallback)(function(list) {
        setCheckedList(list);
        setIndeterminate(!!list.length && list.length < optionsAll.length);
        setCheckAll(list.length === optionsAll.length);
    }, [
        optionsAll
    ]);
    var onCheckAllChange = (0,react.useCallback)(function(e) {
        setCheckedList(e.target.checked ? optionsAll : []);
        setIndeterminate(false);
        setCheckAll(e.target.checked);
        // sorting out nodes with the same state as group checkbox
        var list = children.filter(function(node) {
            return node.props.checked !== e.target.checked;
        });
        onChangeAll === null || onChangeAll === void 0 ? void 0 : onChangeAll(e.target.checked, list.map(function(event) {
            return event.props.name;
        }));
    }, [
        children,
        onChangeAll,
        optionsAll
    ]);
    var header = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox, {
                indeterminate: indeterminate,
                onChange: onCheckAllChange,
                checked: checkAll,
                name: name,
                palette: "primary",
                children: label
            })
        });
    }, [
        name,
        label,
        indeterminate,
        onCheckAllChange,
        checkAll
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Collapse, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Collapse.Panel, {
            header: header,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group, {
                name: name,
                value: checkedList,
                onChange: handleChange,
                children: children
            })
        })
    });
};
/* harmony default export */ var Collapsable = (/*#__PURE__*/(0,react.memo)(Collapsable_CheckboxGroup));

;// CONCATENATED MODULE: ./units/Checkbox/index.tsx




var units_Checkbox_Checkbox = Checkbox_Checkbox;
units_Checkbox_Checkbox.Collapsable = Collapsable;
units_Checkbox_Checkbox.Group = Group;
/* harmony default export */ var units_Checkbox = (units_Checkbox_Checkbox);

;// CONCATENATED MODULE: ./units/CloseButton/style.tsx

function CloseButton_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  z-index: 3;\n  top: ",
        ";\n  right: ",
        ";\n  border-radius: 50%;\n  background-color: var(--color-primary);\n\n  cursor: pointer;\n\n  svg,\n  i {\n    color: #fff;\n    font-size: 14px;\n    transition: all 0.3s ease;\n  }\n\n  &:hover {\n    svg,\n    i {\n      color: var(--color-secondary);\n    }\n  }\n\n  @media screen and (max-width: 425px) and (orientation: portrait) {\n    right: ",
        ";\n  }\n"
    ]);
    CloseButton_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CloseButtonStyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__CloseButtonStyled",
    componentId: "sc-2535d2b1-0"
})(CloseButton_style_templateObject(), function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "15px" : "68px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-33px" : "18px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-15px" : "18px";
});

;// CONCATENATED MODULE: ./units/CloseButton/index.tsx


var CloseButton = function(param) {
    var onClick = param.onClick, isFullscreen = param.isFullscreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButtonStyled, {
        onClick: onClick,
        isFullscreen: isFullscreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: "fas fa-times"
        })
    });
};
/* harmony default export */ var units_CloseButton = (CloseButton);

// EXTERNAL MODULE: ./node_modules/rc-field-form/es/index.js + 13 modules
var rc_field_form_es = __webpack_require__(54216);
;// CONCATENATED MODULE: ./units/Field/Group/style.tsx

function Group_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-auto-flow: column;\n  gap: ",
        ";\n"
    ]);
    Group_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Content",
    componentId: "sc-1d2645c-0"
})(Group_style_templateObject(), function(param) {
    var gap = param.gap;
    return "".concat(gap !== null && gap !== void 0 ? gap : 0, "px");
});

;// CONCATENATED MODULE: ./units/Field/style.tsx

function Field_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n"
    ]);
    Field_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Lato', sans-serif;\n  font-size: 12px;\n  margin: 0 0 6px;\n  display: grid;\n  grid-template-areas: 'icon label lock';\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n\n  color: ",
        ";\n\n  font-weight: ",
        ";\n\n  & svg {\n    font-size: 15px;\n    margin-right: 9px;\n  }\n"
    ]);
    style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: icon;\n"
    ]);
    style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: label;\n"
    ]);
    style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: lock;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #ea475c;\n  margin-top: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Field_style_SIZES = {
    // XXSMALL: 20,
    // XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Label",
    componentId: "sc-4f2f6e14-0"
})(Field_style_templateObject(), function(param) {
    var labelInline = param.labelInline;
    if (labelInline) {
        return "flex";
    }
    return "block";
});
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Title",
    componentId: "sc-4f2f6e14-1"
})(style_templateObject1(), function(param) {
    var labelPalette = param.labelPalette;
    switch(labelPalette){
        case "primary":
            {
                return "#fff";
            }
        default:
            {
                return "#888";
            }
    }
}, function(param) {
    var labelPalette = param.labelPalette;
    switch(labelPalette){
        case "primary":
            {
                return "normal";
            }
        default:
            {
                return "bolder";
            }
    }
});
var Icon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Icon",
    componentId: "sc-4f2f6e14-2"
})(style_templateObject2());
var Name = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Name",
    componentId: "sc-4f2f6e14-3"
})(style_templateObject3());
var Lock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Lock",
    componentId: "sc-4f2f6e14-4"
})(_templateObject4());
var Error = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Error",
    componentId: "sc-4f2f6e14-5"
})(_templateObject5());

;// CONCATENATED MODULE: ./units/Field/Group/index.tsx



var Group_Group = function(param) {
    var label = param.label, labelIcon = param.labelIcon, labelPalette = param.labelPalette, gap = param.gap, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                labelPalette: labelPalette,
                children: [
                    labelIcon,
                    label
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                gap: gap,
                children: children
            })
        ]
    });
};
/* harmony default export */ var Field_Group = (Group_Group);

;// CONCATENATED MODULE: ./units/Field/index.tsx








var Field = function(_param) {
    var name = _param.name, label = _param.label, labelIcon = _param.labelIcon, labelPalette = _param.labelPalette, noStyle = _param.noStyle, labelInline = _param.labelInline, lockable = _param.lockable, isLocked = _param.isLocked, isLockedByDefault = _param.isLockedByDefault, children = _param.children, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "labelIcon",
        "labelPalette",
        "noStyle",
        "labelInline",
        "lockable",
        "isLocked",
        "isLockedByDefault",
        "children"
    ]);
    var ref;
    var ref1 = (0,react.useState)((ref = isLocked !== null && isLocked !== void 0 ? isLocked : isLockedByDefault) !== null && ref !== void 0 ? ref : false), locked = ref1[0], setLocked = ref1[1];
    (0,react.useEffect)(function() {
        if (typeof isLocked === "boolean") {
            setLocked(isLocked);
        }
    }, [
        isLocked
    ]);
    if (noStyle) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(rc_field_form_es/* Field */.gN, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            name: name
        }, restProps), {
            children: function(control, meta, form) {
                var childNode = typeof children === "function" ? children((0,src_object_spread/* default */.Z)({}, lockable ? {
                    disabled: locked
                } : {}, control), meta, form) : /*#__PURE__*/ (0,react.cloneElement)(children, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, control), {
                    name: name
                }));
                return childNode;
            }
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(rc_field_form_es/* Field */.gN, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        name: name
    }, restProps), {
        children: function(control, meta, form) {
            var error = name && form.getFieldError(name)[0] || "";
            var childNode = typeof children === "function" ? children((0,src_object_spread/* default */.Z)({}, lockable ? {
                disabled: locked
            } : {}, control), meta, form) : /*#__PURE__*/ (0,react.cloneElement)(children, (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, control), {
                name: name
            }), lockable ? {
                disabled: locked
            } : {}));
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                labelInline: labelInline,
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                        labelPalette: labelPalette,
                        children: [
                            labelIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                children: labelIcon
                            }),
                            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                children: label
                            })
                        ]
                    }),
                    childNode,
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
                        children: error
                    })
                ]
            });
        }
    }));
};
Field.Group = Field_Group;
/* harmony default export */ var units_Field = (Field);

;// CONCATENATED MODULE: ./units/Form/style.tsx

function Form_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n\n  /* global override */\n  max-height: unset !important;\n  overflow: unset !important;\n"
    ]);
    Form_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Form = (0,styled_components_browser_esm/* default */.ZP)(rc_field_form_es/* default */.ZP).withConfig({
    displayName: "style__Form",
    componentId: "sc-a03062af-0"
})(Form_style_templateObject());

;// CONCATENATED MODULE: ./units/Form/index.tsx

/* harmony default export */ var units_Form = (Form);

;// CONCATENATED MODULE: ./units/FullscreenButton/style.tsx

function FullscreenButton_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  z-index: 3;\n  border-radius: 50%;\n  top: ",
        ";\n  right: ",
        ";\n  background-color: var(--color-secondary);\n\n  cursor: pointer;\n\n  svg,\n  i {\n    color: #fff;\n    font-size: 14px;\n    transition: all 0.3s ease;\n  }\n\n  &:hover {\n    svg,\n    i {\n      color: var(--color-primary);\n    }\n  }\n\n  @media screen and (max-width: 425px) and (orientation: portrait) {\n    top: ",
        ";\n    right: ",
        ";\n  }\n"
    ]);
    FullscreenButton_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FullscreenButtonStyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__FullscreenButtonStyled",
    componentId: "sc-17a6388c-0"
})(FullscreenButton_style_templateObject(), function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "48px" : "100px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-33px" : "18px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "52px" : "100px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-15px" : "18px";
});
/* harmony default export */ var style = (FullscreenButtonStyled);

// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
;// CONCATENATED MODULE: ./units/FullscreenButton/index.tsx



var FullscreenButton = function(param) {
    var onClick = param.onClick, isFullscreen = param.isFullscreen;
    return !deviceManager/* default.isMobile */.Z.isMobile() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(style, {
        onClick: onClick,
        isFullscreen: isFullscreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: isFullscreen ? "fas fa-compress" : "fas fa-expand"
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var units_FullscreenButton = (FullscreenButton);

// EXTERNAL MODULE: ./units/Iframe/index.tsx + 1 modules
var Iframe = __webpack_require__(12978);
// EXTERNAL MODULE: ./node_modules/rc-textarea/es/index.js + 2 modules
var rc_textarea_es = __webpack_require__(57239);
;// CONCATENATED MODULE: ./units/Input/TextArea/style.tsx

function TextArea_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n\n  color: ",
        ";\n\n  font-size: ",
        ";\n\n  font-family: 'Lato', sans-serif;\n  font-weight: normal;\n  border-radius: 4px;\n  border: none;\n  margin: 0;\n  line-height: 1.2;\n\n  &[disabled] {\n    opacity: 0.6;\n  }\n"
    ]);
    TextArea_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TextArea_style_SIZES = {
    // XXSMALL: 20,
    XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var TextAreaStyled = (0,styled_components_browser_esm/* default */.ZP)(rc_textarea_es/* default */.Z).withConfig({
    displayName: "style__TextAreaStyled",
    componentId: "sc-ea1cbca6-0"
})(TextArea_style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        case "secondary":
            {
                return "rgba(255, 255, 255, 0.5)";
            }
        case "tertiary":
            {
                return "rgba(255, 255, 255, 1)";
            }
        default:
            {
                return "rgba(136, 136, 136, 0.1)";
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#fff";
            }
        default:
            {
                return "#292929";
            }
    }
}, function(param) {
    var xsize = param.xsize;
    switch(xsize){
        case "xsmall":
            {
                return "14px";
            }
        case "small":
            {
                return "16px";
            }
        default:
            {
                return "20px";
            }
    }
});

;// CONCATENATED MODULE: ./units/Input/TextArea/index.tsx




var autoSizeDefault = {
    minRows: 3,
    maxRows: 5
};
var TextArea = function(_param) /*#__PURE__*/ {
    var palette = _param.palette, design = _param.design, size = _param.size, _autoSize = _param.autoSize, autoSize = _autoSize === void 0 ? autoSizeDefault : _autoSize, _value = _param.value, value = _value === void 0 ? "" : _value, placeholder = _param.placeholder, name = _param.name, disabled = _param.disabled, onChange = _param.onChange, _prefixCls = _param.prefixCls, prefixCls = _prefixCls === void 0 ? "textarea" : _prefixCls, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette",
        "design",
        "size",
        "autoSize",
        "value",
        "placeholder",
        "name",
        "disabled",
        "onChange",
        "prefixCls"
    ]);
    return (0,jsx_runtime.jsx)(TextAreaStyled, (0,src_object_spread/* default */.Z)({
        palette: palette,
        design: design,
        xsize: size,
        autoSize: autoSize,
        value: value,
        placeholder: placeholder,
        name: name,
        disabled: disabled,
        onChange: onChange,
        prefixCls: prefixCls
    }, props));
};
/* harmony default export */ var Input_TextArea = (TextArea);

;// CONCATENATED MODULE: ./units/Input/style.tsx

function Input_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n\n  background: ",
        ";\n\n  color: ",
        ";\n\n  font-size: ",
        ";\n\n  font-family: 'Lato', sans-serif;\n  font-weight: normal;\n  min-width: 60px;\n  border-radius: 4px;\n  border: none;\n  margin: 0;\n\n  &[disabled] {\n    opacity: 0.6;\n  }\n"
    ]);
    Input_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Input_style_SIZES = {
    // XXSMALL: 20,
    XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var InputStyled = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "style__InputStyled",
    componentId: "sc-60cb3ca-0"
})(Input_style_templateObject(), function(param) {
    var xsize = param.xsize;
    switch(xsize){
        case "xsmall":
            {
                return "".concat(Input_style_SIZES.XSMALL, "px");
            }
        case "small":
            {
                return "".concat(Input_style_SIZES.SMALL, "px");
            }
        default:
            {
                return "".concat(Input_style_SIZES.MEDIUM, "px");
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        case "secondary":
            {
                return "rgba(255, 255, 255, 0.5)";
            }
        case "tertiary":
            {
                return "rgba(255, 255, 255, 1)";
            }
        default:
            {
                return "rgba(136, 136, 136, 0.1)";
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#fff";
            }
        default:
            {
                return "#292929";
            }
    }
}, function(param) {
    var xsize = param.xsize;
    switch(xsize){
        case "xsmall":
            {
                return "14px";
            }
        case "small":
            {
                return "16px";
            }
        default:
            {
                return "20px";
            }
    }
});

;// CONCATENATED MODULE: ./units/Input/index.tsx





var Input = function(_param) /*#__PURE__*/ {
    var palette = _param.palette, design = _param.design, size = _param.size, value = _param.value, min = _param.min, max = _param.max, step = _param.step, onChange = _param.onChange, onBlur = _param.onBlur, placeholder = _param.placeholder, name = _param.name, disabled = _param.disabled, onKeyDown = _param.onKeyDown, tabIndex = _param.tabIndex, type = _param.type, className = _param.className, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette",
        "design",
        "size",
        "value",
        "min",
        "max",
        "step",
        "onChange",
        "onBlur",
        "placeholder",
        "name",
        "disabled",
        "onKeyDown",
        "tabIndex",
        "type",
        "className"
    ]);
    return (0,jsx_runtime.jsx)(InputStyled, (0,src_object_spread/* default */.Z)({
        palette: palette,
        design: design,
        xsize: size,
        value: value,
        min: min,
        max: max,
        step: step,
        onChange: onChange,
        onBlur: onBlur,
        placeholder: placeholder,
        name: name,
        disabled: disabled,
        onKeyDown: onKeyDown,
        tabIndex: tabIndex,
        type: type,
        className: className
    }, restProps));
};
Input.TextArea = Input_TextArea;
/* harmony default export */ var units_Input = (Input);

;// CONCATENATED MODULE: ./units/Text/style.tsx

function Text_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  font-weight: ",
        ";\n\n  text-transform: ",
        ";\n  text-decoration: ",
        ";\n  overflow-wrap: anywhere;\n"
    ]);
    Text_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Text_style_Root = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__Root",
    componentId: "sc-51413b4b-0"
})(Text_style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        case "secondary":
            {
                return "#888";
            }
        default:
            {
                return "#fff";
            }
    }
}, function(param) {
    var weight = param.weight;
    switch(weight){
        case "regular":
            {
                return "bolder";
            }
        case "strong":
            {
                return "bold";
            }
        // case "weak"
        default:
            {
                return "normal";
            }
    }
}, function(param) {
    var uppercase = param.uppercase;
    return uppercase ? "uppercase" : "none";
}, function(param) {
    var underline = param.underline;
    return underline ? "underline" : "none";
});

;// CONCATENATED MODULE: ./units/Text/index.tsx


var Text = function(param) {
    var size = param.size, weight = param.weight, align = param.align, truncate = param.truncate, underline = param.underline, uppercase = param.uppercase, palette = param.palette, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_style_Root, {
        size: size,
        weight: weight,
        align: align,
        truncate: truncate,
        underline: underline,
        uppercase: uppercase,
        palette: palette,
        children: children
    });
};
/* harmony default export */ var units_Text = (Text);

// EXTERNAL MODULE: ./units/Icon/index.ts + 45 modules
var units_Icon = __webpack_require__(34915);
// EXTERNAL MODULE: ./units/VideoBox/index.tsx
var VideoBox = __webpack_require__(99151);
;// CONCATENATED MODULE: ./units/Watermark/style.tsx

function Watermark_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  width: 100%;\n  top: 30%;\n  text-align: center;\n  opacity: 0.5;\n  z-index: 99999;\n  color: white;\n  transform: rotate(-30deg);\n  font-size: 30vh;\n  pointer-events: none;\n  @media (orientation: portrait) {\n    transform: rotate(-45deg);\n    font-size: 22vh;\n  }\n"
    ]);
    Watermark_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_WatermarkStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__WatermarkStyled",
    componentId: "sc-74f85d7c-0"
})(Watermark_style_templateObject());
/* harmony default export */ var Watermark_style = ((/* unused pure expression or super */ null && (style_WatermarkStyled)));

;// CONCATENATED MODULE: ./units/Watermark/index.tsx





var Watermark = function(_param) {
    var id = _param.id, show = _param.show, children = _param.children, restProps = _object_without_properties(_param, [
        "id",
        "show",
        "children"
    ]);
    if (show) {
        return /*#__PURE__*/ _jsx(WatermarkStyled, _object_spread_props(_object_spread({
            id: id
        }, restProps), {
            children: children
        }));
    }
    return null;
};
/* harmony default export */ var units_Watermark = ((/* unused pure expression or super */ null && (Watermark)));

// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(39828);
;// CONCATENATED MODULE: ./units/DatePicker/index.tsx



var DatePickerCreator = function(param) {
    var dateFormat = param.dateFormat, startDate = param.startDate, handleDateChange = param.handleDateChange;
    return /*#__PURE__*/ _jsx(DatePicker, {
        dateFormat: dateFormat,
        selected: startDate,
        onChange: handleDateChange,
        autoComplete: "disable_autocomplete"
    });
};
/* harmony default export */ var units_DatePicker = ((/* unused pure expression or super */ null && (DatePickerCreator)));

;// CONCATENATED MODULE: ./units/index.ts

















/***/ }),

/***/ 75410:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 48628:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31601:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 67792:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 52007:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 75042:
/***/ (function() {

/* (ignored) */

/***/ })

}]);